/* BUILD STAMP, 2026-08-15. Read by AoamCartIntegrity/kb-integrity.mjs so a run can tell "the Kit
   Builder cart is broken" apart from "this Chrome was served a stale cached render of the page".
   Shopify's full-page cache is UA-bucketed and headless Chrome sits in its own bucket, so for hours
   after a push a probe is served pre-push HTML while curl gets the new copy. Without a stamp that
   reads as a FAIL against a theme that already carries the fix - it produced one flat-out false
   failure on the site cart on 2026-08-14, which is why the stamp exists there too.
   BUMP THIS on every edit to this file, and raise KB_BUILD_MIN in kb-integrity.mjs to match. */
window.AOAM_KB_BUILD = '2026-11-03.w2kbfix3, was 2026-11-03.w2kbfix, was 2026-10-25.intlband, was 2026-10-20.kbdata-salerevert, was 2026-10-19.audit2, was 2026-10-19.audit, was 2026-10-13.kblen, was 2026-10-13.kbchips, was 2026-10-13.kbcards, was 2026-10-13.siliconecap, was 2026-10-12.contactlen, was 2026-10-12.kbcoring, was 2026-10-11.kbrigurl, was 2026-10-11.kbslowsave, was 2026-10-11.kbcofail, was 2026-10-10.seo-canonical, was 2026-10-10.kbfont600, was 2026-10-10.kbdataprices, was 2026-10-09.cmpctsheet, was 2026-10-08.nobag, was 2026-10-07.search-track, was 2026-10-06.heropill, was 2026-10-06.lpkit-dusters, was 2026-10-06.starter22, was 2026-10-05.kbaudit-x6, was 2026-10-05.ship2bd, was 2026-09-28.lowkb-lfix, was 2026-09-28.kblater-lfix, was 2026-09-28.kbmoney-mfix, was 2026-09-26.kblines-cartfix'; /* was 2026-09-25.warrsteps2 */ /* was 2026-09-24.warrantyoptin */
/* 2026-09-25 (Claude, international cart check): every cart WRITE in this file goes through kbMkt().
   A POST to ROOT /cart/add.js on an empty cart re-homes the cart to the PRIMARY market, so an AU, GB, CA
   or EU shopper's first Kit Builder add turned their cart into USD and /checkout then opened in en-us at
   US prices. Measured over curl the same day: /en-au cart AUD, root add -> cart USD 1995; root /checkout
   -> en-us $19.95, against en-au $29.00 for the same line added via /en-au/cart/add.js. Live headless runs
   at /en-au and /en-gb both ended with /cart.js reading USD after one pick. Shopify.routes.root is
   "/en-au/" on a market subfolder and "/" in the US, so the US path is unchanged byte for byte.
   Reads (/cart.js) are left at root on purpose: they never re-home a cart. Roll back: return u. */
function kbMkt(u){
  try {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r === '/' || typeof u !== 'string' || u.indexOf('/cart') !== 0) return u;
    return r.replace(/\/$/, '') + u;
  } catch (e) { return u; }
} /* was 2026-09-16.arriveby */
const DATA = window.KB_DATA || {};
/* 2026-08-06 dead-click audit (fix 7). When kit-builder-data.js failed to load, DATA fell back to {}
   and every view rendered the ordinary "NO MATCHES - Try whip, blade, battery..." card: a permanently
   empty catalog presented to the shopper as a normal empty search, with no retry and no signal to us.
   KB_DATA_OK is the single flag the grid and the boot sequence branch on. Delete it, kbDataFail /
   kbDataFailHTML and their two call sites to roll back. */
const KB_DATA_OK = !!(window.KB_DATA && Object.keys(window.KB_DATA).length);
const KBA = window.KB_ASSETS || {};
/* 2026-07-31 - Shopify product renamed: handle feather-light-painting-blade is now flower-flames-blade (same product 8881633132769). Key renamed in OPTS, RATINGS and PIDS below to keep option buttons, stars and Judge.me reviews wired to the KB_DATA key. Rename the keys back to roll back. */
const OPTS = {"uchiwa-pro-light-painting-blade":["Blade Holder"],"double-bitwhip-light-whip":["Size","Fiber Type"],"jump-rope-for-flow-artists":["Length"],"world-peace-light-painting-blade":["Blade Holder"],"the-millennium-star-light-painting-blade":["Blade Holder"],"the-jubilee-light-painting-blade":["Blade Holder"],"the-idols-eye-light-painting-blade":["Blade Holder"],"great-mogul-pro-light-painting-blade":["Blade Holder"],"tendril-pro-light-painting-blade":["Blade Holder"],"solar-flare-pro-light-painting-blade":["Blade Holder"],"rectangle-pro-light-painting-blade":["Blade Holder"],"primal-flames-pro-light-painting-blade":["Blade Holder"],"palladian-pro-light-painting-blade":["Blade Holder"],"oncrist-pro-light-painting-blade":["Blade Holder"],"masamune-light-painting-blade":["Blade Holder"],"kunai-light-painting-blade":["Blade Holder"],"hypnotic-light-painting-blade":["Blade Holder"],"halo-light-painting-blade":["Blade Holder"],"foglia-light-painting-blade":["Blade Holder"],"flower-flames-light-painting-blade":["Blade Holder"],"flame-of-tongue-light-painting-blade":["Blade Holder"],"feather-quill-light-painting-blade":["Blade Holder"],"feather-tartan-light-painting-blade":["Blade Holder"],"feather-lissome-light-painting-blade":["Blade Holder"],"excelsior-light-painting-blade":["Blade Holder"],"circle-light-painting-blade":["Blade Holder"],"babinski-pro-light-painting-blade":["Blade Holder"],"aurora-light-painting-blade":["Blade Holder"],"spade-light-painting-blade":["Blade Holder"],"saw-3000-light-painting-blade":["Blade Holder"],"rectangle-light-painting-blade":["Blade Holder"],"light-painting-blades-set-rectangle-triangle-wedge":["Blade Holder"],"lightning-light-painting-blade":["Blade Holder"],"katana-light-painting-blade":["Blade Holder"],"flower-flames-blade":["Blade Holder"],"feather-blade":["Blade Holder"],"digital-feather-light-painting-blade-long":["Blade Holder"],"digital-feather-blade":["Blade Holder"],"crown-jewel-light-painting-blade":["Blade Holder"],"circle":["Blade Holder"],"baby-circle":["Blade Holder"],"butcher-sword-light-painting-blade":["Blade Holder"],"crab-claw":["Blade Holder"],"heart-light-painting-blade":["Blade Holder"],"slugger-long-light-painting-blade":["Blade Holder"],"solar-flare-light-painting-blade":["Blade Holder"],"led-staff":["Saber Type","Length"],"dots-combo-light-painting-tube":["Length"],"spiral-dots-light-painting-tube":["Length"],"honeycomb-light-painting-tube":["Length"],"honeycomb-saber-accessory":["Length"],"stellar-saber-accessory":["Length"],"butterfly-light-painting-tube":["Length"],"butterfly-saber-accessory":["Length"],"sol-saber-accessory":["Length"],"t8-modular-adapter":["Size"],"bitwhip-fiber-optic-whip-prop":["Size","Fiber Type"],"fiber-optic-costume-kit-app-controllable":["Fiber Type","Size","Length"],"tube-to-critter-back":["Black Tube (attached to adapter)"],"t8-tube-cap-light-painting":["Size"],"t8-tube-holder-light-painting-tool":["Size"],"light-painting-tube":["Length and Variation"],"rgb-critter-silicone-shell":["Shell Color"],"usb-charging-cable":["Cable Type"],"o-ring":["O-Ring Size"],"jupiter-jump-rope-accessory":["Length"],"gift-card":["GIFT CARD AMOUNT"],"acrylic-writers":["Size"],"bitwhip-accessory":["Type","Size","Length"],"jupiter-rope-accessory":["Length","Version"],"fiber-optic-costume-accessory":["Fiber Type","Size","Length"]};
const CRITTER = 'rgb-critter-bt-color-changing-flashlight';
const CRITTER_IMG = 'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/Product_Image.png?v=1781811689';
/* r39: Saber Builder is a sibling prototype (served by the other account on :8621). One constant, referenced by
   the header pill, the saber door tile, and the sheet link. The theme build swaps this for the real sibling-page URL. */
const SABER_URL = '';
/* 2026-08-08 - Joel, screenshot circling the arrow on VIEW FULL PRODUCT PAGE: "this blue arrow does
   not match our style". U+2197 has EMOJI presentation by default on iOS, so Safari drew Apple's blue
   rounded-square arrow next to lime-on-black type. EXT_ARROW is a stroked SVG in currentColor, so it
   takes the link's own colour and its hover, on every platform. Replace EXT_ARROW with the bare
   character to roll back. */
const EXT_ARROW = '<svg class="extarw" viewBox="0 0 12 12" width="11" height="11" aria-hidden="true" focusable="false"><path d="M3.2 8.8 8.8 3.2M4.4 3.2h4.4v4.4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
/* 2026-08-08: the post-add exit rendered up front, see sdShowBackToBuilder below. */
const BACK_BTN = '<button type="button" class="sd-back" aria-label="Back to the builder, keep shopping" onclick="closeStageUI(false)"><span aria-hidden="true">&lsaquo;</span> BACK TO THE BUILDER</button>';
const WARR1 = 'rgb-critter-flashlight-extended-warranty', WARR2 = 'lifetime-warranty-protection-x2';
/* r42: blade-holder dependency. Every 'blades' product ships two variants ONLY, 'Blade Only' (assumes you
   own the holder) and 'Blade + Holder Bundle' (ships one). The Blade Holder is a single-variant $19.95 mount.
   HOLDER_KITS = kits whose DATA description states they include (nearly) all light-painting accessories, which
   covers the holder, currently just the Deluxe/Pro kit ("nearly all of our light painting accessories"). */
const HOLDER = 'light-painting-blade-holder';
const HOLDER_KITS = ['light-painting-kit-deluxe-rgb-critter-photography'];
/* 2026-08-15 (Claude) INTERNATIONAL SHIPPING GATE. The $99 free-shipping threshold below is US
   ONLY - the intl zones are flat rates from $22.95 to $109.95 and are left to checkout - but every
   shipping string on this page applied SHIP_FREE with no country test at all, so a shopper in
   Germany at $99+ was told "FREE" outright and the meter read "Free shipping unlocked". That is a
   refund conversation, not a cosmetic bug. The site drawer fixed the same class of thing in
   snippets/drawer-cart.liquid on 2026-08-14; this is the Kit Builder half.
   kit-builder.js is a plain asset with no Liquid access, so the country and the zone label are
   printed once into window.KB_GEO by templates/page.kit-builder.liquid, which owns the zone table
   (copied from drawer-cart.liquid so the two cannot drift).
   Falls back to US so a missing or blocked KB_GEO can never HIDE free shipping from a US shopper:
   the failure mode is exactly the pre-2026-08-15 behaviour, never worse.
   Delete this block, the KB_GEO script in the template, and the IS_US reads in shipLineHTML,
   shipMeterHTML, renderRig, renderBar and renderDrawer to roll back. */
/* The const is KB_GEO_CFG, NOT KB_GEO, and the two names must stay different. A top-level const may
   not share its name with a NON-CONFIGURABLE property already on the global object: that is an
   outright SyntaxError, and it would take down the WHOLE builder, not just the shipping label. The
   template creates window.KB_GEO by plain assignment, which is configurable and therefore safe, but
   one defineProperty from any other script would be fatal. Measured 2026-08-15: a probe that locked
   window.KB_GEO with configurable:false killed hydration outright. */
const KB_GEO_CFG = window.KB_GEO || {};
const IS_US = (KB_GEO_CFG.country || 'US') === 'US';
const INTL_SHIP_LABEL = KB_GEO_CFG.intlShipLabel || 'Calculated at next step';
/* 2026-10-25 (Claude, checkout audit INTL-1 on the Kit Builder; Joel picked "Ship mockup A" 2026-10-23): outside the US the
   Shipping row read the zone's LOW band ("From $27.95 USD") while every kit pays the upper band at checkout. It now names
   the band THIS cart pays, from the real cart weight (window.KB_CARTWT, kept by kbCartLvlFrom off every /cart.js read) and
   the drawer's own zone table (window.AOAM_INTL, layout/kit-builder.liquid renders snippets/aoam-intl-ship table_only).
   In USD with no "From", like every other price on this page. Carrier-quoted zones read "Calculated at next step".
   No weight yet (empty cart, first paint) or no table: the old label. Roll back: return INTL_SHIP_LABEL here. */
window.KB_CARTWT = window.KB_CARTWT || 0;
function kbIntlShipLabel(extraG){
  /* 2026-11-03 (Claude, cart audit C-003): extraG = grams the cart does not hold yet (kb6 passes the provisional RGB Critter BT, which
     mirror() keeps out of the Shopify cart), so the band is the one checkout will charge. Roll back: drop extraG. */
  var T = window.AOAM_INTL, g = (+window.KB_CARTWT || 0) + Math.max(0, +extraG || 0);
  if (!T || !(g > 0) || !KB_GEO_CFG.country) return INTL_SHIP_LABEL;
  var u = T.usd(KB_GEO_CFG.country, g);
  return u ? T.fmt({ amt: u, code: 'USD' }) : 'Calculated at next step';
}
window.kbIntlShipLabel = kbIntlShipLabel;
/* 2026-08-18: two different numbers, see the comment beside KB_GEO in templates/page.kit-builder.liquid */
const US_SHIP_CENTS = +KB_GEO_CFG.usShipCents || 0;        /* what a US shopper PAYS under $99 */
const US_SHIP_WAS_CENTS = +KB_GEO_CFG.usShipWasCents || 0; /* what free shipping SAVES at $99+ */
const SHIP_FREE = +KB_GEO_CFG.freeShip > 0 ? +KB_GEO_CFG.freeShip : 99, BONUS_N = 2,   /* 2026-11-03 (Claude, cart audit C-010): Theme settings > free-ship-amount via KB_GEO.freeShip, the site drawer's source; 99 is the fallback. Roll back: SHIP_FREE = 99 */ BONUS_PCT = 0.10; /* bundle any 2 gear → 10% off gear. bonus DISPLAY ONLY until Shopify automatic discount exists (#verify) */
const BONUS_ON = false; /* Joel r4 2026-07-09: 10% bundle discount HIDDEN for now (banner + math + savings lines). Flip true to restore. */
const GEAR_ON = false; /* Joel r37 2026-07-15: "Fits my gear" filter chip + owner picker HIDDEN for now ("we dont need that for now"). Flip true to restore the chip, popup, filtering, and ?own=1 deep link. */
const GUARD_ON = false; /* Joel r37 2026-07-15: reverse-guard banner ("YOU ALREADY HAVE A LIGHT · SWAP & SAVE / KEEP BOTH") removed ("remove this"). Flip true to restore the r28 stacking-guard on all surfaces. */
const SHEET_UPSELL_ON = false; /* Joel r44 2026-07-16: "remove this upsell" — the DETAIL SHEET's Complete-your-kit list (.ucard rows). One kill point: upsellHTML() returns '' so the sheet, both post-add re-render timers and sdSync all go inert (each is already guarded on the #sd-upsell node existing). The r42 cart-column strip is a DIFFERENT component (.cystrip) and stays; it only borrows UPSELL_MAP/UPSELL_FALLBACK, which is why the data stays wired. Flip true to restore. */
const STRIP_MAX = 8; /* r44: how many picks the now-scrollable cart-column strip may offer (~3 visible, rest scroll in). */

const KIT_LIGHTS = {
  'bitwhip-fiber-optic-whip-prop':1,'fiber-optic-costume-kit-app-controllable':1,
  /* 2026-07-28 (Joel: no old product images on the site): the Stellar/Butterfly/Honeycomb Saber Kits
     are archived, they are Pattern variants of the one Saber Kit now. Both Contact Saber Kits are
     single-Critter kits. Delete this line and restore the four old handles to roll back. */
  'sol-light-saber-flow-arts':1,'contact-saber-kit':1,'contact-saber-kit-forward-balance':1,
  'jupiter-rope-led-glow-prop':1,'light-painting-photography-kit-for-beginners':1,'light-painting-kit-starter-rgb-critter-photography':1,
  'jump-rope-for-flow-artists':2,'double-bitwhip-light-whip':2,'led-staff':2,'light-painting-kit-deluxe-rgb-critter-photography':2
};
/* r30: a kit missing from KIT_LIGHTS silently corrupts lightsInCart(), warranty X2 and the r28 guard */
Object.keys(DATA).forEach(h => { if (DATA[h].sub === 'kits' && !KIT_LIGHTS[h]) console.error('KIT_LIGHTS missing entry: ' + h); });
/* 2026-08-15: same shape of guard for the warranty-title map printed by page.kit-builder.liquid. A
   kit missing there falls back to KB_DATA's display title, which is exactly the drift that split the
   BitWhip into two coverage buckets - silent, and only visible as a warranty price that will not
   update. Fail loudly instead. */
Object.keys(KIT_LIGHTS).concat([CRITTER]).forEach(h => { if (!(window.KB_WARR_TITLE && window.KB_WARR_TITLE[h])) console.error('KB_WARR_TITLE missing entry: ' + h + ' (add it to templates/page.kit-builder.liquid)'); });   /* 2026-08-18: + CRITTER, now that a standalone Critter is warranty-eligible. Its bucket key must be Shopify's real title, not KB_DATA's display name, or the same product occupies two coverage buckets across the two surfaces. */
/* r30: WHAT'S IN THE KIT rows for kits WITHOUT a live-priced accessory twin. Transcribed VERBATIM from
   each kit product's live Shopify "What's included" list (Admin API pull 2026-07-15) — never invented.
   Entry: [label, thumbHandle?, defer?]; defer rows point at the full description instead of naming parts.
   The 3 KIT_MATCH kits (BitWhip / Costume / Jupiter Rope) derive a PRICED accessory row live instead. */
const WIK_X = {
  'double-bitwhip-light-whip': [['2× BitWhips','bitwhip-accessory'],['Critter Connector','critter-connector-flow-arts-staffs-double-sided-light-whips']],
  'jump-rope-for-flow-artists': [['Jump Rope side-glow accessory · dual rotating bearings']],
  'led-staff': [['2× twist-on sabers'],['Critter Connector','critter-connector-flow-arts-staffs-double-sided-light-whips']],
  /* 2026-07-28 (Joel: no old product images on the site): the three patterned Saber Kits are archived,
     the Saber Kit carries them as Pattern variants now. Contact Saber rows transcribed from each PDP's
     live "What is in the box" list. Delete this block to roll back. */
  /* 2026-09-16 (Joel, from the saber-kit-rows mockup: "do it"): all three saber kits now list their full box per each
     PDP's "What's included". Saber Kit was one row called a "twist-on accessory"; all three were missing the Tube
     Adapter (Long) that holds the tube on the Critter. Roll back: restore the three old rows and drop the WIK_IMG entry. */
  'sol-light-saber-flow-arts': [['Saber tube, your pattern and length','sol-saber-accessory'],['Tube Adapter (Long)','rgb-critter-tube-adapter-long'],['Saber Hilt Extension','saber-hilt-extension'],['Silicone Saber Cap','flow-cap']],
  'contact-saber-kit': [['Sol Saber Tube · 24 inch','sol-saber-accessory'],['Tube Adapter (Long)','rgb-critter-tube-adapter-long'],['2× Saber Hilt Extension','saber-hilt-extension'],['2× Silicone Saber Cap','flow-cap'],['Silicone Cap Counterweight Kit','flow-cap-counterweight-kit']],
  /* 2026-09-16: the Forward Balance box ships a Silicone Cap MOUNT (no steel weight), per its PDP "What is in the box";
     this row said Counterweight Kit, which is the full Contact Saber's part. */
  'contact-saber-kit-forward-balance': [['Sol Saber Tube','sol-saber-accessory'],['Tube Adapter (Long)','rgb-critter-tube-adapter-long'],['Saber Hilt Extension','saber-hilt-extension'],['2× Silicone Saber Cap','flow-cap'],['Silicone Cap Mount','flow-cap-mount']],
  'light-painting-photography-kit-for-beginners': [['Acrylic Writer','acrylic-writers'],['Fiber Optic Duster','fiber-optic-dusters'],['Light Painting Tube','light-painting-tube']],
  'light-painting-kit-starter-rgb-critter-photography': [['Full set of starter light painting accessories',null,1]],
  'light-painting-kit-deluxe-rgb-critter-photography': [['Nearly all AOAM light painting accessories',null,1]],
};


/* 2026-08-18 (Joel: "whats in the kit is missing images for some prodcuts in the kit builder").
   A WIK_X row draws its thumb from the BUILDER catalog (DATA), not from the store, so a part that is
   a live Shopify product but NOT in the builder's curated catalog rendered the empty .wik-ph well -
   a black 40px square that reads as a broken image. Both Contact Saber kits lost three rows that way
   (Saber Hilt Extension, Silicone Saber Cap, Silicone Cap Counterweight Kit): all three are ACTIVE products with
   images, they are simply not builder-buyable parts. This is thumbs ONLY - adding them to DATA would
   put them in the part tray, which is a merchandising call, not an image fix.
   URLs are each product's featured image (Admin API pull 2026-08-18), black hero to match the
   surrounding rows. Delete this map and wikThumb to roll back. */
const WIK_IMG = {
  'saber-hilt-extension':      'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/saber-hilt-extension-black.png?v=1784843856',
  'flow-cap':                  'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/flow-cap-black.png?v=1784843851',
  'flow-cap-counterweight-kit':'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/flowcap-kit-assembled-blk-v3.png?v=1785196286',
  'flow-cap-mount':            'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/flowcap-mount-hero-blk-v2.png?v=1785279331',   /* 2026-09-16 */
  'rgb-critter-tube-adapter-long':'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/rgb-critter-tube-adapter-long-hero-screws-v3.png?v=1785267251',   /* 2026-09-16 */
};
/* Fail loudly the same way KB_WARR_TITLE does: a WIK_X row naming a handle with no thumb anywhere is
   silent on screen (it just looks like a broken image), so say it in the console instead. */
function wikThumb(handle){
  if (!handle) return null;
  if (DATA[handle] && DATA[handle].imgs && DATA[handle].imgs[0]) return DATA[handle].imgs[0];
  if (WIK_IMG[handle]) return WIK_IMG[handle];
  console.error('WIK thumb missing for handle: ' + handle + ' (add it to WIK_IMG in kit-builder.js)');
  return null;
}

/* 2026-08-06 kit-overlap gap - follow-up to the 2026-07-31 fix, NOT a new mechanism. Those two WIK_X
   rows above are `defer` rows: they carry a label and no handle, so kitIncludes() returned an empty
   handles list for the Starter and Pro light-painting kits and ovMatch() could never fire on them.
   Measured, not guessed: the LIVE file was run against LIVE KB_DATA in node and 10 of 12 kits warned
   correctly while these two stayed silent - and they are the two biggest baskets ($397.95 / $992.95),
   exactly where a shopper is most likely to re-add something already in the box.
   Both PDPs now enumerate their contents in full (they did not when r30 wrote the defer rows), so this
   is transcribed VERBATIM from each product's live Shopify "What's included" list (Admin API pull
   2026-08-06) - never invented, same rule as WIK_X.
   HANDLES ONLY, deliberately: the on-screen contents line stays the deferred WIK_X label, because
   spelling out 20 and 50 components in a cart row is a worse cart, not a better one.
   Entry is 'handle' (every variant of it collides) or ['handle','<variant title prefix>'] where the kit
   ships ONE specific variant and another is a legitimate separate buy - tube lengths and writer size.
   Blades stay handle-wide on purpose: 'Blade Only' and 'Blade + Holder Bundle' both duplicate the blade
   itself, and the banner is advisory with a Keep both.
   DELIBERATE OMISSIONS, do not "fix" them by adding rows:
     - RGB Critter BT itself - light stacking belongs to the r37 guard that is off (see GUARD_ON).
     - 2500mAh 18650 Battery and USB Charging Cable - both PDPs mark them "ships with the flashlight",
       and a spare battery or a second cable is a normal deliberate add, not a mistake.
     - RGB Critter Tube Adapter (Long) and Modular Saber Tube Connector - live store products but NOT in
       the builder catalog, so they cannot be double-added here. kitIncludes filters on DATA anyway.
   Delete WIK_COVERS, the out.covers line in kitIncludes and covHit in ovMatch to roll back. */
const WIK_COVERS = {
  'light-painting-kit-starter-rgb-critter-photography': [
    ['acrylic-writers','Length: 1/2" - Width: 1/4"'],
    'fiber-optic-dusters',
    ['light-painting-tube','23 Inch'], ['light-painting-tube','11 Inch'],
    ['honeycomb-light-painting-tube','11 Inch'],
    'modular-saber-tube-adapter',
    'tripod-mount-adapter',
    'light-painting-blade-holder',
    'light-painting-blades-set-rectangle-triangle-wedge',
    'crown-jewel-light-painting-blade',
    'solar-flare-light-painting-blade',
    'the-orb-light-diffuser-rgb-critter-flashlight',
    'illuminator',
    'small-tube-holder-light-painting',
    'rgb-critter-travel-case',
  ],
  'light-painting-kit-deluxe-rgb-critter-photography': [
    'critter-connector-flow-arts-staffs-double-sided-light-whips',
    'inverse-critter-connector-dual-rgb-critters-modular-sabers',
    ['acrylic-writers','Length: 1/2" - Width: 1/4"'],
    'fiber-optic-dusters', 'fiber-optic-duster-blue',
    'fiber-optic-duster-green', 'fiber-optic-duster-pink',
    ['light-painting-tube','36 Inch'], ['light-painting-tube','23 Inch'], ['light-painting-tube','11 Inch'],
    ['butterfly-light-painting-tube','11 Inch'],
    ['honeycomb-light-painting-tube','11 Inch'],
    ['dots-combo-light-painting-tube','11 Inch'],
    'modular-saber-tube-adapter',
    'modular-cap',
    'light-painting-blade-holder',
    'light-painting-blades-set-rectangle-triangle-wedge',
    'crown-jewel-light-painting-blade', 'solar-flare-light-painting-blade',
    'spade-light-painting-blade', 'butcher-sword-light-painting-blade',
    'digital-feather-light-painting-blade-long', 'katana-light-painting-blade',
    'flower-flames-blade', 'circle', 'lightning-light-painting-blade',
    'the-orb-light-diffuser-rgb-critter-flashlight',
    'illuminator',
    'sparkler-holder',
    'small-tube-holder-light-painting',
    'diy-connector',
    'tripod-mount-adapter',
    'critter-to-lpb-adapter',
    'rgb-critter-travel-case',
  ],
};
/* every WIK_COVERS handle must be a real builder product, or the row is silently dead - same class of
   bug as the r30 KIT_LIGHTS check right below the kits map */
Object.keys(WIK_COVERS).forEach(k => WIK_COVERS[k].forEach(x => {
  const h = typeof x === 'string' ? x : x[0];
  if (!DATA[h]) console.error('WIK_COVERS handle not in DATA: ' + k + ' -> ' + h);
}));
/* 2026-08-06 dead-click audit (fix 7). This is the line that actually fired when the catalog failed,
   and the real behaviour was WORSE than "an empty catalog rendered as an empty search": with DATA = {}
   these four top-level dereferences threw `TypeError: Cannot read properties of undefined (reading
   'vid')` at module scope, so kit-builder.js aborted here and NOTHING after it ever executed - no
   grid, no tabs, no hub, no message, a permanently blank page. Confirmed against the LIVE file in
   headless Chrome with kit-builder-data.js blocked: one pageerror at this statement, #grid empty,
   renderAll() defined only because function declarations hoist. Null-coalescing each lookup lets the
   script survive to the boot guard, which is what puts the explicit failure card on screen. This is
   the only top-level DATA dereference in the file that can throw - COMPAT below iterates
   Object.keys(DATA), which is simply empty. Restore the four bare `DATA[...].vid` reads to roll back. */
const FAMVID = {
  whip:  {src: (DATA['bitwhip-fiber-optic-whip-prop']||{}).vid},
  saber: {src: (DATA['sol-light-saber-flow-arts']||{}).vid},
  rope:  {src: (DATA['jupiter-rope-accessory']||{}).vid},
  tubes: {src: (DATA['light-painting-tube']||{}).vid},
};
const CATS = [
  {id:'kits',    ttl:'Kits',          subs:[['all','All Kits']]}, /* r43 (Joel: "ready made is a bit confusing... we like the word kits") REVERSES r15's kit-inside-kit rule. r15 stripped "kits" from the tab label only, while the band header ("Complete kits"), this sub label and the copy all kept it, so the one wayfinding surface was the only place the word was missing. "Ready-Made" also implied a contrast (vs made-to-order) that the tab row never offered. The r39 bands do the disambiguating now: "Just the light" vs "Complete kits". Measured: "Kits" spills LESS than "Ready-Made" at every width (1180: 39px vs 87px); "Complete Kits" was rejected, it re-clipped the row at 1366/1280, the widths r39 just fixed. */
  {id:'flow',    ttl:'Flow Arts',      subs:[['all','All'],['whip','Whip'],['saber','Sabers'],['rope','Ropes'],['extras','Extras']]},
  {id:'paint',   ttl:'Light Painting', subs:[['all','All'],['writers','Writers'],['blades','Blades'],['tubes','Tubes'],['mounts','Holders']]},
  {id:'costume', ttl:'Costume',        subs:[['all','All']]},
  {id:'power',   ttl:'Power & Cases',  subs:[['all','All']]},
];
/* r29 (Joel): "no way to add an rgb critter from here" — the core light was findable ONLY as the
   last tile of Power & Cases. 'core' now rides in every accessory tab's "All" view, pinned first.
   Kits tab stays core-free on purpose: every kit already includes the light. */
const CATSUBS = {kits:['kits','core'], flow:['whip','saber','rope','extras','core'], paint:['writers','blades','tubes','mounts','core'], costume:['costume','core'], power:['power','core']};

/* COMPAT / housing-size system (mirrors the metafield spec)
   small = whip fiber heads · medium = 360-fiber, Acrylic Writers, Dusters · large = 500-fiber, Jellyfish
   saber = saber family · universal = battery/cases/cables/mounts (fits every Critter) · core = the light itself
   kit = complete kit, light included. Covers every handle in DATA. */
const SUB_COMPAT = {whip:'small', writers:'medium', costume:'large', saber:'saber',
  blades:'universal', tubes:'universal', mounts:'universal', extras:'universal', rope:'universal',
  power:'universal', warranty:'universal', core:'core', kits:'kit'};
const COMPAT = (() => { const m = {};
  Object.keys(DATA).forEach(h => m[h] = SUB_COMPAT[DATA[h].sub] || 'universal');
  return m; })();
const COMPAT_LBL = {small:'Small housing · fits BitWhip', medium:'Medium housing', large:'Large housing',
  saber:'Saber family', universal:'Fits every Critter', core:'Core light · powers 200+ tools', kit:'Complete kit · light included'};
/* variant-aware size: the costume line carries both 360 (medium) and 500 (large) fiber heads */
function sizeFor(h, vi){
  let c = COMPAT[h];
  if (h === 'fiber-optic-costume-accessory' && vi != null && P(h).vars[vi] && /360/.test(P(h).vars[vi].t)) c = 'medium';
  return c;
}
/* needs an RGB Critter to function (drives the completes-your-rig prompt; power/cases/cables excluded) */
const requiresLight = h => !isKit(h) && h !== CRITTER && P(h).cat !== 'power' && P(h).sub !== 'warranty';

/* kit-vs-a-la-carte arbitration (computed from live DATA, never hardcoded) */
const KIT_MATCH = [
  {kit:'bitwhip-fiber-optic-whip-prop', acc:'bitwhip-accessory',
   map:t => { const p = t.split(' / '); return (p.length===3 && p[2].indexOf('Standard')===0) ? p[1]+' / '+p[0] : null; }},
  {kit:'fiber-optic-costume-kit-app-controllable', acc:'fiber-optic-costume-accessory', map:t => t},
  {kit:'jupiter-rope-led-glow-prop', acc:'jupiter-rope-accessory',
   map:t => t === '6 Feet (183cm) / Single-Sided' ? 'Default Title' : null},
];

/* state */
const S = { cart:[], warranty:false, cat:'kits', sub:'all', bladeF:'all', sel:null, ax:{},
  own:{on:false, gear:[]}, gift:null, kmDismiss:'', km2Dismiss:'', nlDismiss:false, ovDismiss:[] /* 2026-07-31 kit-overlap */ };
let addingLock=false, addedTimer, sdCloseTimer;
/* 2026-08-15: declared up here with the other sheet locks, NOT beside sdAdd, because openDrawer reads
   it and `let` leaves a temporal dead zone - a restore-path add running before sdAdd's line would
   throw. See sdAdd for what it does. */
let sdAddArmed = false;
let sdM = [], sdIdx = 0;
const $ = id => document.getElementById(id);
/* 2026-08-15: the '$' is DELIBERATE and must NOT be routed through Shopify.money_format the way the
   site cart formats. Every price in this builder comes from assets/kit-builder-data.js, which bakes
   plain USD numbers at build time with no currency conversion anywhere in the file. Applying another
   market's format string would relabel an unchanged USD figure as EUR or GBP, which is worse than
   an honest dollar sign. The real fix is a market-aware price pass over the data file; until that
   exists, leave this alone.
   2026-08-15 (Claude) WHAT THAT COMMENT DOES NOT COVER, and it is the live half. "Leave money()
   alone" is right; leaving the SHOPPER uninformed is not. Five secondary markets ship and four of
   them present a non-USD currency (AUD, CAD, EUR, GBP - Admin API, 2026-08-15), and CAD and AUD
   both spell their currency '$'. So a Canadian reads $99.95 here as C$99.95, sees the same product
   priced in real CAD on its own PDP, and is charged the converted USD figure at checkout. The site
   drawer has no such gap: every number there runs through theme.Currency.formatMoney, and a
   hardcoded '$' that slipped into ONE fallback path was itself treated as a bug and fixed today
   (see the 2026-08-15 note by aoamFbMoney in snippets/aoam-cart-fix.liquid).
   The fix is disclosure, not conversion: name the currency instead of relabelling the number.
   KB_CUR is the shopper's PRESENTMENT currency, printed into window.KB_GEO by
   templates/page.kit-builder.liquid off cart.currency, beside the country the shipping gate reads.
   It changes NOTHING for a US shopper (IS_USD short-circuits every use), and money() itself is
   still bare at all 59 call sites - suffixing there would overflow the tile chips and the ADD TO
   CART buttons, and buys nothing the Total row and the footer note do not already say.
   Same fallback discipline as IS_US: an absent or blocked KB_GEO reads as USD, i.e. exactly the
   pre-2026-08-15 behaviour, never a wrong currency name.
   Delete KB_CUR, IS_USD, usdNoteHTML and its two callers to roll back. */
/* 2026-08-18: the site renders every cart figure through money_without_trailing_zeros / formatMoney,
   which groups thousands. This printed $1296.50 where the site drawer printed $1,296.50 on the same
   kit. Sub-$1000 output is byte-identical to before. The '$' stays hardcoded on purpose - see the
   USD disclosure note (usdNoteHTML) for why this must NOT go through Shopify.money_format. */
const money = n => { const p = n.toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return '$' + p.join('.'); };
/* Sanitised to A-Z at the declaration rather than escaped at each use: it is interpolated into
   innerHTML, and esc() is declared LATER in this file, so a call-time dependency on it would be a
   TDZ trap waiting for the first caller that runs early. Three letters, uppercase, or 'USD'. */
const KB_CUR = (String(KB_GEO_CFG.currency || 'USD').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3)) || 'USD';
const IS_USD = KB_CUR === 'USD';
/* One quiet line under Total, drawer and rig dock alike. Not shown to a USD shopper at all.
   DELIBERATELY NOT a .cart__item-row, and this was caught in adversarial review before it shipped.
   That class is `display:flex; justify-content:space-between`, which is right for a label/value pair
   (Subtotal | $x, Shipping | FREE) and wrong for a sentence: two spans in it get flung to opposite
   edges with 140-260px of void between them, so the second clause parks under the Total figure and
   reads as that row's VALUE rather than as the tail of the sentence it belongs to. One block, one
   continuous sentence, left aligned - the same shape .dock-ride already uses for the footnote
   emitted on the very next line in both call sites. */
const usdNoteHTML = () => IS_USD ? '' :
  `<div class="kb-usd">Prices shown in USD, charged in ${KB_CUR} at&nbsp;checkout.</div>`;
/* 2026-08-17 (Claude) THE BROWSE PATH NAMED NO CURRENCY AT ALL, and that is the half the
   2026-08-15 block above did not close. usdNoteHTML() rendered in the two cart footers only, so a
   non-USD shopper read the 22px lime sheet price, picked a variant and tapped ADD TO CART having
   never been told the figure is USD - on a page that is 73% mobile, where neither footer is on
   screen. The sheet is where a price is READ at decision size and where the add is committed, so
   the note renders there too now, directly under the price it qualifies.
   TILES STAY BARE ON PURPOSE, do not 'finish the job' by suffixing them: you cannot buy from a
   tile, a suffix overflows the chip and the ADD TO CART button (measured, see above), and every
   tile opens this sheet. Same for #cartprice and #bb-tot - neither reaches checkout, both open
   the drawer, and the drawer's Total row is disclosed.
   usdMoney() is for figures that LEAVE the page, where no later note can ever reach them. The
   label is USD, NOT KB_CUR: the number is a baked USD figure and the shopper's own currency is
   the other one. nbsp so 'USD' can never widow off its number.
   Delete usdMoney, the ${usdNoteHTML()} line in stageDetailHTML and usdMoney's call sites in
   kbEmailKit / emailMeKit to roll back. */
const usdMoney = n => IS_USD ? money(n) : money(n) + '\u00a0USD';
const CDN = (u,w) => u ? u + (u.includes('?')?'&':'?') + 'width=' + (w||420) : '';
const HERO_IMG = 'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/rgb-critter-bt-flashlight-app-hero-centered.png?v=1784586682'; // core hero cell only; drawer/hub/upsell thumbs stay imgs[0]
const P = h => DATA[h];
const lv = l => P(l.h).vars[l.vi];
const esc = s => s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
const isKit = h => P(h).cat === 'kits';
const isMobile = () => matchMedia('(max-width:900px)').matches;
const gearQty = () => S.cart.reduce((s,l)=>s+l.qty,0);
const keyQty = h => S.cart.filter(l=>l.h===h).reduce((s,l)=>s+l.qty,0);
/* a "light" = anything that bears an RGB Critter: kit lights + the standalone Critter */
const lightUnits = h => (KIT_LIGHTS[h]||0) + (h===CRITTER ? 1 : 0);
const lightsInCart = () => S.cart.reduce((s,l)=> s + lightUnits(l.h)*l.qty, 0);
const gearLines = () => S.cart.filter(l=>!isKit(l.h));   /* kits excluded from gear bonus */
const gearCount = () => gearLines().reduce((s,l)=>s+l.qty,0);
const tileVid = h => P(h).vid || (FAMVID[P(h).sub] ? FAMVID[P(h).sub].src : null);
const lineIdx = (h,vi) => S.cart.findIndex(l=>l.h===h&&l.vi===vi);

/* math (verbatim v12 semantics) */
function warrProd(){ return lightsInCart() >= 2 ? P(WARR2) : P(WARR1); }
/* 2026-08-12 (Claude), Joel approved. COVER NOW SCALES. It used to cap at ONE unit however many
   lights the kit held, so four lights were quoted $39.95 here against $79.80 through the product
   pages and $79.90 through the Saber Lab - while the row's own copy said "Covers your entire
   order", which was the part that was actually untrue. This is the Saber Lab's formula verbatim
   (src/js/10-panels-and-compat.js, warrCost): one X2 per PAIR of lights, which is what that SKU
   exists for, plus one single for the odd light out. warrProd() is kept because the row's title
   and the X2 label still read from it.
   TO ROLL BACK: delete warrCost and warrUnits, and restore the four call sites named in the
   comments below. Rollback copy of this whole file:
   OneDrive\Documents\AOAM-Theme-Rollback\2026-08-12-kb-warranty-scaling\ */
function warrCost(n){
  if (!(n > 0)) return 0;
  const w2 = P(WARR2), w1 = P(WARR1);
  const p2 = (w2 && w2.vars[0] && w2.vars[0].p) || 0, p1 = (w1 && w1.vars[0] && w1.vars[0].p) || 0;
  return Math.floor(n / 2) * p2 + (n % 2) * p1;
}
/* The line items behind that price. Availability is checked per tier for the same reason the single
   push did it (defect 16): a sold-out warranty variant 422s the whole batch, and the recovery in
   kbGoCheckout has nothing to remove. A tier that cannot be bought is simply left out rather than
   silently substituted, so the customer is never charged for a tier they did not see. */
function warrUnits(n){
  const out = [];
  if (!(n > 0)) return out;
  const pairs = Math.floor(n / 2), odd = n % 2;
  const v2 = P(WARR2) && P(WARR2).vars[0], v1 = P(WARR1) && P(WARR1).vars[0];
  if (pairs && v2 && v2.id && v2.a) out.push({ id: v2.id, quantity: pairs });
  if (odd   && v1 && v1.id && v1.a) out.push({ id: v1.id, quantity: odd });
  return out;
}
/* 2026-08-18 (Joel: "the kit builder cart does not match the main site... how do we get them to be
   completely linked so any changes we make to the main site cart apply here?")
   WHAT THIS COST IS. The site put shipping into the drawer TOTAL on 2026-08-16, after Joel sent a
   screenshot and said "thbis cart math is wrong": every row was right and only the sum was wrong,
   because TOTAL was merchandise-only while the row directly above it printed a real .95. The Kit
   Builder never got that fix, so a one-item US cart at 9.95 read TOTAL 9.95 here and 6.90 on
   the site - and 6.90 is what checkout charges. Reading down this column now gives the number at
   the bottom, on both surfaces.
   THE RULE ITSELF IS NOT WRITTEN HERE. It lives once in snippets/aoam-cart-summary.liquid, which
   both this page and the main site load, so the next change to it moves both carts. That snippet is
   the whole point of this change: hand-copying the site's cart logic into this file is exactly how
   the two drifted apart, and every copy that stays is a copy that drifts again.
   The US gate and the empty-kit gate stay HERE, matching shipValueText/shipWasHTML above: the site
   deliberately leaves an international TOTAL merchandise-only, because an intl row shows a FLOOR
   ("From 2.95 USD") and duties sit outside anything a cart can know.
   Falls back to 0 if the snippet is missing, i.e. exactly the old behaviour, never a wrong number. */
function kbShipCost(shipBase){
  if (!IS_US || !S.cart.length) return 0;
  const fn = window.aoamCartShipCents;
  if (typeof fn !== 'function') return 0;
  const cents = fn(Math.round(shipBase * 100), US_SHIP_CENTS, SHIP_FREE * 100);
  return (typeof cents === 'number' && cents > 0) ? cents / 100 : 0;
}
function calc(){
  const gearSub = S.cart.reduce((s,l)=> s + lv(l).p*l.qty, 0);
  const gearOnly = gearLines().reduce((s,l)=> s + lv(l).p*l.qty, 0);
  const bonus = BONUS_ON && gearCount() >= BONUS_N ? gearOnly * BONUS_PCT : 0;
  /* 2026-08-15 (Joel: "the warranty price is not properly updating... especially when carts merge").
     This was `KB_APPWARR > 0 ? KB_APPWARR : ...`, which treated any warranty already in the cart as
     COMPLETE coverage rather than PARTIAL. Measured live: add a BitWhip on the main site (the site
     auto-adds one $19.95 unit), come to the builder and step it to 2 lights - warrTotalCost() read
     $39.90 while calc().warr stayed pinned at $19.95 and Total read $339.85 against a real $359.80.
     Every extra light after the first was quoted at zero, forever, on every kit.
     KB_APPWARR is coverage the cart ALREADY holds; warrCost is what this rig NEEDS. The shopper owes
     the larger of the two, never whichever happens to exist. Defect 14 (do not price a second
     warranty on top of the app's) is still honoured, because max() never adds them together.
     2026-08-13: warrTotalCost (per-kit-bucket), not warrCost(lightsInCart()) - see warrTotalCost.
     TO ROLL BACK: restore the single `KB_APPWARR > 0 ? ...` line. */
  const warrWant = (S.warranty && lightsInCart() > 0) ? warrTotalCost() : 0;
  const warr = Math.max(warrWant, kbAppWarrComparable());   /* 2026-08-15: never across currencies, see kbAppWarrComparable */
  const sub = gearSub - bonus;
  /* shipBase: the 10% bonus is DISPLAY ONLY (no Shopify automatic discount yet, #verify),
     so free-shipping progress must use the undiscounted amount Shopify actually sees */
  const shipBase = gearSub + warr;
  const shipCost = kbShipCost(shipBase);
  /* total stays MERCHANDISE (GA4 value, the Klaviyo KitTotal and the email subtitle all mean that);
     totalDue is what the shopper owes and is what every visible TOTAL prints, matching the site. */
  return {gearSub, bonus, warr, sub, total: sub + warr, shipCost, totalDue: sub + warr + shipCost, shipBase};
}
/* find the cheapest-savings kit match in the current rig; banner suppressed when the kit saves nothing
   (e.g. Costume Kit 500-fiber 6 Ft prices $0.05 above a-la-carte) */
function kitMatch(){
  const cl = S.cart.find(l => l.h === CRITTER && l.qty >= 1);
  if (!cl) return null;
  for (const d of KIT_MATCH){
    const al = S.cart.find(l => l.h === d.acc && l.qty >= 1);
    if (!al) continue;
    const kt = d.map(lv(al).t); if (!kt) continue;
    const kvi = P(d.kit).vars.findIndex(v => v.t === kt);
    if (kvi < 0 || !P(d.kit).vars[kvi].a) continue;
    const save = P(CRITTER).vars[cl.vi].p + lv(al).p - P(d.kit).vars[kvi].p;
    if (save <= 0.009) continue;   /* no-savings combos: banner suppressed */
    return {kit:d.kit, kvi, acc:d.acc, avi:al.vi, save, key:d.kit+'|'+kvi};
  }
  return null;
}
function swapToKit(){
  const m = kitMatch(); if (!m) return;
  /* r41: kit goes IN before the light comes out — the cart must never transiently hit zero
     lights or renderAll's legal warranty auto-drop fires mid-swap and a paid warranty
     silently vanishes. Coverage continues across the swap (the kit contains the light);
     the no-silent-re-arm rule is untouched because the flag never drops. */
  addItem(m.kit, m.kvi, 1, null);
  decVar(CRITTER, S.cart.find(l=>l.h===CRITTER).vi);
  decVar(m.acc, m.avi);
  toast('Swapped to ' + P(m.kit).title + '. You saved ' + money(m.save));
}
function kmDismissNow(){ const m = kitMatch(); if (m) S.kmDismiss = m.key; renderAll(); }
/* r28 (Joel-approved critique S1): the REVERSE guard — stacking a complete kit on a rig that already
   has a light silently buys a second $129.95 Critter. Offer the accessory-only version of the kit,
   with "Keep both" as an explicit escape hatch (2nd light = pairing + Warranty X2). Dismissal is
   sticky per kit+variant (a "keep both" choice shouldn't re-nag on every later cart change). */
function kitMatchRev(){
  if (!GUARD_ON) return null;   /* r37: reverse-guard banner removed — one kill point makes every surface (rig panel, drawer, ktoast) and the stacking toast inert */
  if (lightsInCart() < 2) return null;
  let best = null;
  for (const d of KIT_MATCH){
    const kl = S.cart.find(l => l.h === d.kit && l.qty >= 1);
    if (!kl) continue;
    const kt = P(d.kit).vars[kl.vi].t;
    const avi = P(d.acc).vars.findIndex(v => v.a && d.map(v.t) === kt);
    if (avi < 0) continue;
    const save = P(d.kit).vars[kl.vi].p - P(d.acc).vars[avi].p;
    if (save <= 0.009) continue;
    if (!best || save > best.save) best = {kit:d.kit, kvi:kl.vi, acc:d.acc, avi, save, key:'rev|'+d.kit+'|'+kl.vi};
  }
  return best;
}
function swapToAcc(){
  const m = kitMatchRev(); if (!m) return;
  decVar(m.kit, m.kvi);
  addItem(m.acc, m.avi, 1, null);
  toast('Swapped to ' + P(m.acc).title + '. You saved ' + money(m.save));
}
function km2DismissNow(){ const m = kitMatchRev(); if (m) S.km2Dismiss = m.key; renderAll(); }
function nlDismissNow(){ S.nlDismiss = true; renderAll(); }
function needsLight(){ return lightsInCart() === 0 && S.cart.some(l => requiresLight(l.h)); }
function addCritter(el){
  const had = S.cart.some(l => requiresLight(l.h));   /* r29: "kit is complete" only fits when gear was waiting on a light */
  addItem(CRITTER, 0, 1, el);
  toast(had ? 'RGB Critter BT added. Your kit is complete' : 'RGB Critter BT added. Now pick what it powers');
}

/* mutations */
/* 2026-08-16 (Claude) - the Kit Builder half of the report Joel made about the MAIN SITE on
   2026-08-14: "after adding an upsell item, the added product correctly loads in the cart and is
   removed from the upsell list, but the issue is the next product in the list has the + button
   highlighted. check this in all carts on desktop and mobile and fix."

   COMPLETE YOUR KIT has always had the same shape and was never fixed here, because until today its
   chip only GLOWED under a stationary cursor. The chip now FILLS solid lime on hover, so the
   replacement card reads as a second add, which is exactly the complaint. It is worse here than on
   the site rail: stripPicks() re-keys the pool off the item just added, so the card that lands in
   slot one is a DIFFERENT product rather than the same list shifted along by one.

   Same treatment as axcMute() in assets/aoam-upsell-card.js, and it wakes on the next GENUINE
   pointer event rather than after a fixed delay for the same reason: on iOS Safari :hover latches at
   the last touch point and never clears on its own. pointermove alone is not enough on touch, where
   a finger can leave and come back with no move in between, hence pointerdown as well. The 2500ms
   timer is the backstop, so a pointer that never returns cannot leave the strip muted.

   TWO THINGS THAT LOOK OPTIONAL AND ARE NOT. It runs AFTER renderAll(), because renderAll rewrites
   the rig panel and the drawer wholesale and a class set on the old .cygrid is thrown away with it.
   And wake() re-queries rather than closing over the nodes, because renderAll can run again inside
   the mute window and would otherwise leave the class stuck on a node nobody can reach.

   Scoped to a press that came FROM the strip. An add from the grid or the detail sheet rebuilds the
   strip too, but the cursor is nowhere near it, so muting there would only cost a real hover.
   Delete this function, its call in addItem and the .cy-nohover block in assets/kit-builder.css to
   roll back. */
function cyMuteIfFromStrip(fromEl){
  /* 2026-08-18: repointed to the site's card classes with the markup swap. Was .cyadd / .cygrid. */
  if (!fromEl || !fromEl.classList || !fromEl.classList.contains('axc-add')) return;
  const grids = document.querySelectorAll('.axc-strip');
  if (!grids.length) return;
  grids.forEach(g => g.classList.add('cy-nohover'));
  let t;
  const wake = () => {
    document.querySelectorAll('.axc-strip.cy-nohover').forEach(g => g.classList.remove('cy-nohover'));
    document.removeEventListener('pointermove', wake, true);
    document.removeEventListener('pointerdown', wake, true);
    clearTimeout(t);
  };
  t = setTimeout(wake, 2500);
  requestAnimationFrame(() => {
    document.addEventListener('pointermove', wake, true);
    document.addEventListener('pointerdown', wake, true);
  });
}
function addItem(h, vi, qty, fromEl){
  vi = vi ?? P(h).vars.findIndex(v=>v.a);
  if (vi < 0 || !P(h).vars[vi] || !P(h).vars[vi].a){ toast('Sold out. Tap Notify Me on the item'); return; }
  const hadLight = lightsInCart() > 0;
  const ex = S.cart.find(l => l.h === h && l.vi === vi);
  if (ex) ex.qty += (qty||1); else S.cart.push({h, vi, qty: qty||1});
  S.kmDismiss = '';
  if (fromEl) flyTo(fromEl);
  renderAll(); persist();
  cyMuteIfFromStrip(fromEl);   /* 2026-08-16, see cyMuteIfFromStrip - must run AFTER renderAll */
  pulseBadge();
  kbGA('kit_builder_add', { item: P(h).title, num_items: kbUnits() });   // [kb-track]
  /* 2026-07-31 kit-overlap heads-up: fires only when THIS add created a non-dismissed pair
     (see the kitIncludes/ovMatch block). The banner itself is already rendered by renderAll. */
  const ovNew = ovMatch();
  if (ovNew && (ovNew.acc.h === h || ovNew.kit.h === h)){
    toast('Heads up: ' + P(ovNew.kit.h).title + ' already includes ' + P(ovNew.acc.h).title + '. See the note in your kit');
    if (!isMobile() && $('stagedetail').hidden) focusRig();
    /* keep the r9 one-time drawer intro for a restored-cart first add that happens to overlap */
    else if (isMobile() && !drawerIntro){ drawerIntro = true; openDrawer(); }
  }
  /* completes-your-rig prompt: accessory that needs a light landed in a light-less rig */
  else if (!hadLight && requiresLight(h) && lightsInCart() === 0){
    S.nlDismiss = false;   /* the toast below points at the prompt, so bring it back */
    if (isMobile()) openDrawer(); else focusRig();   /* r9: scroll+flash the prompt into view instead of just mentioning it */
    toast('Added. This needs a light. See the prompt to complete your kit.');
  } else if (hadLight && lightUnits(h) > 0 && (m2 => m2 && S.km2Dismiss !== m2.key)(kitMatchRev())){
    /* r28: this add put a 2nd Critter in the rig and a cheaper accessory version exists —
       the banner is already rendered (rig panel / drawer / ktoast); the toast points at it.
       Grid adds also scroll the rig into view; adds from an open detail sheet don't (no yanking
       the product out from under the customer mid-look — they see the banner on close). */
    toast('Heads up: your kit now has 2 lights. See the save option in your kit');
    if (!isMobile() && $('stagedetail').hidden) focusRig();
  } else if (isMobile()){
    /* r9: the drawer auto-opens only on the FIRST add (teaches where the rig lives); later adds
       keep browsing momentum — toast + fly-dot + bottom-bar pulse already confirm the add.
       Drawer stays the only cart surface (never /cart). */
    if (!drawerIntro){ drawerIntro = true; openDrawer(); }
    /* 2026-07-28: this pulsed #bb-tot, a node inside the .bbar that has been display:none since
       7-20, so the confirmation for every add after the first was invisible. It now pulses the
       header cart price, which is the surface that actually shows the running total on mobile. */
    else { const bt = $('cartprice') || $('bb-tot'); if (bt){ bt.classList.remove('pulse'); void bt.offsetWidth; bt.classList.add('pulse'); } }
  }
}
let drawerIntro = false;
function decItem(i){ const l = S.cart[i]; if(!l) return; l.qty--; if (l.qty<=0) S.cart.splice(i,1); S.kmDismiss=''; renderAll(); persist(); }
function incItem(i){ const l = S.cart[i]; if(!l) return; l.qty++; S.kmDismiss=''; renderAll(); persist(); }
function dropLine(i){ S.cart.splice(i,1); S.kmDismiss=''; renderAll(); persist(); }
function decVar(h,vi){ const i=lineIdx(h,vi); if(i>=0) decItem(i); }
/* 2026-07-28. This used to be a stub that toasted "Noted. We'll email you when X is back" while
   collecting nothing and recording nothing anywhere: a promise the site could not keep, on the one
   screen a shopper reaches only because we have already disappointed them. Now it asks for the
   address and files a real Klaviyo back-in-stock subscription against the variant.
   See the KLAVIYO block at the end of this file. Delete that block to roll back to the stub. */
function notifyMe(h){
  const p = P(h); if (!p) return;
  /* subscribe against the exact variant they are looking at, not just the first one */
  const vi = selVi(h);
  const v = p.vars[vi >= 0 ? vi : 0] || p.vars[0];
  kbMailPop({
    title: 'Email me when this is back',
    sub: p.title + (v && v.t && v.t !== 'Default Title' ? ' · ' + v.t : ''),
    cta: 'Notify me',
    /* 2026-08-18 (Claude): the old bare .then() could only run if the client-API POST
       succeeded, and that POST cannot leave a browser at all today (CORS, see klLegacyTrack),
       so this toasted NOTHING and captured NOBODY - silence in both directions. Now the send
       reports true/false and the shopper is told either way. */
    send: email => kbNotifyRequest(email, v, p)
      .then(ok => toast(ok
        ? 'Done. We\'ll email you the moment ' + p.title + ' is back'
        : 'Sorry, that did not go through. Try again in a moment.'))
  });
}
function pulseBadge(){
  const cc = $('cartcnt'); if (!cc) return;
  cc.classList.remove('pulse'); void cc.offsetWidth; cc.classList.add('pulse');
}
function flyTo(el){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const tgt = $('cartbtn'); // 7-20: bbar removed on mobile - fly-dot lands on the header cart button; a hidden $('bbar') rect is 0x0 at origin. Desktop unchanged.
  const r = el.getBoundingClientRect(), t = tgt.getBoundingClientRect();
  const dot = document.createElement('div'); dot.className='fly';
  dot.style.left=(r.left+r.width/2)+'px'; dot.style.top=(r.top+r.height/2)+'px';
  document.body.appendChild(dot);
  dot.animate([{transform:'translate(0,0) scale(1)',opacity:1},
    {transform:`translate(${t.left+t.width/2-r.left-r.width/2}px, ${t.top+t.height/2-r.top-r.height/2}px) scale(.3)`,opacity:.2}],
    {duration:480,easing:'cubic-bezier(.22,1,.36,1)'}).onfinish=()=>dot.remove();
}

/* variant axes (from OPTS + " / " titles)
   single-axis handles use the whole title as the value — ' / ' can legally appear INSIDE a value
   (e.g. Acrylic Writer "…(1.27 / 1.59cm)"), which would otherwise break the split */
const _axc = {};   /* r9: axes() is pure over static DATA/OPTS — memoized, it runs many times per render */
function axes(h){
  if (h in _axc) return _axc[h];
  const p = P(h), names = OPTS[h];
  if (!names || p.vars.length < 2) return _axc[h] = null;
  const split = p.vars.map(v => names.length === 1 ? [v.t] : v.t.split(' / '));
  if (!split.every(s => s.length === names.length)) return _axc[h] = null;
  return _axc[h] = names.map((n,i) => ({name:n, vals:[...new Set(split.map(s=>s[i]))]}));
}
function findVar(h, sel){ return P(h).vars.findIndex(v => v.t === sel.join(' / ')); }
function defaultSel(h){
  const ax = axes(h); if (!ax) return null;
  const vi = P(h).vars.findIndex(v=>v.a);
  const t = P(h).vars[Math.max(0,vi)].t;
  return ax.length === 1 ? [t] : t.split(' / ');
}
function selVi(h){
  const ax = axes(h);
  if (!ax) return P(h).vars.length===1 ? 0 : (P(h).vars.findIndex(v=>v.a));
  return findVar(h, S.ax[h]);
}

/* r13 (Joel): entry doors removed — door* functions deleted; the builder is the page from the first frame.
   The gift budget bands + outcome kit-band logic downstream stay dormant (S.gift / S.doorFrom are never set). */
/* Back closes the topmost open layer (drawer → owner picker → sheet); at the base state it just tidies strays */
window.addEventListener('popstate', e => {
  backPending = false;
  if (!$('leavepop').hidden) closeLeavePop();   /* no pushed state of its own — just don't leave it stranded */
  if (!$('warrpop').hidden){ closeWarrPop(); return; }
  if ($('header_minicart').classList.contains('js-drawer-open')){ closeDrawer(); return; }
  if (!$('opicker').hidden){ closeOwnPicker(); return; }
  if (document.body.classList.contains('sheet-open')){ const rf = pendRefocus; pendRefocus = false; closeStage(rf); return; }
  if (!(e.state && (e.state.cfg || e.state.layer))){ closeOwnPicker(); closeDrawer(); if (S.sel) closeStage(false); }
});
/* r27 (critique W5, mobile back-trap): UI closes (X / Esc / backdrop / GOT IT) CONSUME the history
   entry their open pushed, by routing through history.back() so the popstate above performs the real
   close. Before this, every open+close left a dead entry and Back visibly did nothing — measured
   history.length 2→6 over four open/close cycles. backPending debounces double-activations so a
   second click can never pop past the builder's base entry. */
let backPending = false, pendRefocus = false;
function layerBack(layer, closeFn){
  if (backPending) return;
  if (history.state && history.state.layer === layer){ backPending = true; history.back(); }
  else closeFn();
}
function closeStageUI(refocus){ pendRefocus = !!refocus; layerBack('sheet', () => closeStage(refocus)); }
function closeDrawerUI(){ layerBack('drawer', closeDrawer); }
function closeOwnPickerUI(){ layerBack('own', closeOwnPicker); }
function closeWarrPopUI(){ layerBack('warrpop', closeWarrPop); }

/* owner mode: page-scoped toggle, ?own=1 deep link */
const OWN_OPTS = [['bitwhip','BitWhip'],['critter','Critter BT'],['kit','Any Kit'],['saber','Saber']];
let ownDraft = [];
function openOwnPicker(){
  if (!GEAR_ON) return;   /* r37: gear filter hidden for now */
  if ($('opicker').hidden) history.pushState({layer:'own'}, '');   /* Back closes the picker, not the page under it */
  ownDraft = S.own.gear.slice();
  $('ochips').innerHTML = OWN_OPTS.map(([k,n]) =>
    `<button class="ochip ${ownDraft.includes(k)?'on':''}" data-k="${k}" aria-pressed="${ownDraft.includes(k)}" onclick="ownToggle('${k}',this)">${n}</button>`).join('');
  $('opicker').hidden = false; $('opback').classList.add('open');
  const first = $('ochips').querySelector('.ochip'); if (first) first.focus();
}
function ownToggle(k, el){
  const i = ownDraft.indexOf(k);
  if (i>=0) ownDraft.splice(i,1); else ownDraft.push(k);
  el.classList.toggle('on', ownDraft.includes(k));
  el.setAttribute('aria-pressed', ownDraft.includes(k));
}
function ownApply(){
  S.own = {on: ownDraft.length>0, gear: ownDraft.slice()};
  closeOwnPickerUI(); renderAll(); persist();
  if (S.own.on){ const names = OWN_OPTS.filter(([k])=>S.own.gear.includes(k)).map(([,n])=>n).join(', ');
    toast('Showing gear that fits your '+names); }
}
function ownOff(){ S.own = {on:false, gear:[]}; renderAll(); persist(); }
function ownCancel(){ closeOwnPickerUI(); }
function closeOwnPicker(){ $('opicker').hidden = true; $('opback').classList.remove('open'); }
/* the chip: off → open the gear picker; on → clear the filter (the ✕ affordance) */
function gearChipClick(){ if (S.own.on) ownOff(); else openOwnPicker(); }
/* does product h fit the declared gear? (drives the filter — kits, universal, and a second light always qualify) */
function fitsGear(h){
  if (isKit(h)) return true;
  const c = COMPAT[h];
  if (c === 'universal' || c === 'core') return true;
  return ownedSizes().has(c);
}
/* owned housing sizes from declared gear.
   'critter' deliberately adds nothing — a bare light owns no housings, so the +HOUSING paths stay correct.
   'kit' is size-ambiguous (which kit?) — conservative: adds nothing, but the near-fit badge softens below. */
const ownedSizes = () => { const s = new Set();
  if (S.own.gear.includes('bitwhip')) s.add('small');
  if (S.own.gear.includes('saber')) s.add('saber');
  return s; };
/* re-badge relative to declared gear — incompatible tiles never vanish, they get the path */
/* r44: the sheet overline's trailing type segment repeated what the title already said one line below
   ("COMPLETE KIT · LIGHT INCLUDED · LIGHT PAINTING KIT" over "LIGHT PAINTING PHOTOGRAPHY KIT FOR BEGINNERS").
   Drop it only when the title ALREADY contains every word of the type; keep it when it still adds a fact.
   Word tokens, not substring: "Light Painting Kit" is not a substring of that title but is fully contained
   word-wise, so a substring test would have kept the repeat. */
function olType(p){
  if (!p.type) return '';
  const title = p.title.toUpperCase();
  const words = p.type.toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
  if (words.length && words.every(w => new RegExp('\\b' + w + '\\b').test(title))) return '';
  return ' · ' + esc(p.type.toUpperCase());
}
function fitBadge(h){
  if (isKit(h)) return [badgeText(h, null), false];   /* kits keep their normal badge — 'NEW TOOL, SAME LIGHT' on every kit read as noise (Joel) */
  if (P(h).sub === 'blades') return ['FITS YOURS · MOUNTS TO BLADE HOLDER', false];
  const c = COMPAT[h];
  if (c === 'core') return ['SECOND LIGHT · UNLOCKS X2 WARRANTY', false];
  if (c === 'universal') return ['FITS YOURS', false];
  if (ownedSizes().has(c)) return ['FITS YOURS', false];
  const path = {small:'+ SMALL HOUSING', medium:'+ MEDIUM HOUSING', large:'+ LARGE HOUSING', saber:'+ SABER HANDLE'}[c] || '+ ADAPTER';
  if (S.own.gear.includes('kit')) return [path + ' IF YOUR KIT LACKS IT', true];   /* every kit ships a housing; size unknown */
  return [path + ' · SAME LIGHT', true];
}
/* badges (compat system replaces price-tier signaling) */
function badgeText(h, vi){
  /* r30: pluralized via KIT_LIGHTS — a chip saying "2 LIGHTS" above an overline saying "LIGHT" contradicts itself */
  if (isKit(h)) return S.gift ? 'COMPLETE KIT · NOTHING ELSE NEEDED' : 'COMPLETE KIT · ' + (KIT_LIGHTS[h] === 2 ? '2 LIGHTS' : 'LIGHT') + ' INCLUDED';
  if (P(h).sub === 'blades') return 'MOUNTS TO BLADE HOLDER';
  return COMPAT_LBL[sizeFor(h, vi)].toUpperCase();
}
function tileBadge(h){
  /* r9: in the kits tab every tile carried the identical lime line — suppress when redundant
     (same precedent as the rejected 'NEW TOOL, SAME LIGHT' on every kit) */
  if (isKit(h) && S.cat==='kits' && !S.gift && !S.own.on && !($('search').value||'').trim()) return '';
  const c = COMPAT[h];
  const cue = '';   /* r38: RUNS ON THE CRITTER tile cue removed (Joel); the detail sheet's needslight note still states it */
  /* r30: on TILES the kitchip carries the light fact — the body badge states it once, not twice.
     (The sheet overline keeps the full pluralized phrase; gift keeps its distinct reassurance.) */
  const txt = isKit(h) && !S.gift ? 'COMPLETE KIT' : badgeText(h,null);
  return `<span class="cb ${(c==='kit'||c==='core')?'':'dim'}">${txt}</span>${cue}`;
}

/* header / tabs / grid */
function renderTabs(){
  $('tabs').innerHTML = CATS.map(c=>`<button class="tab ${S.cat===c.id&&!S.gift?'on':''}" onclick="setCat('${c.id}')">${c.ttl}</button>`).join('');
  const on = $('tabs').querySelector('.tab.on');
  if (on) on.scrollIntoView({behavior:'smooth', inline:'nearest', block:'nearest'});
  tabClipSync();
}
/* r28: clip-state cues for the tab row. The scrollbar is hidden by design, so without these a
   clipped "POWER & CASES" simply doesn't exist for mouse users (no horizontal wheel either). */
function tabClipSync(){
  const t = $('tabs'), sh = $('tabshell'); if (!t || !sh) return;
  const max = t.scrollWidth - t.clientWidth;
  sh.classList.toggle('clipL', t.scrollLeft > 4);
  sh.classList.toggle('clipR', max > 4 && t.scrollLeft < max - 4);
}
function tabNudge(){ const t = $('tabs'); t.scrollBy({left: Math.max(120, t.clientWidth*.6), behavior:'smooth'}); }
$('tabs').addEventListener('scroll', tabClipSync, {passive:true});
$('tabs').addEventListener('wheel', e => { const t = $('tabs');
  if (t.scrollWidth - t.clientWidth > 4 && Math.abs(e.deltaY) > Math.abs(e.deltaX)){ e.preventDefault(); t.scrollLeft += e.deltaY; } }, {passive:false});
addEventListener('resize', tabClipSync);
/* r30: the embedded font widens the row AFTER the first render-time sync — at ~1180px that left a
   clipped row with no cue until a resize. Re-sync when fonts settle (and on load as a belt). */
if (document.fonts && document.fonts.ready) document.fonts.ready.then(tabClipSync);
addEventListener('load', tabClipSync);
/* 2026-08-10 - Joel, on a 393px screenshot: "there is a lot of wasted space below it with an
   awkwardly placed search icon". On mobile the .vaulthead band exists only to hold the collapsed
   44px search icon on kits, costume and power (those tabs have no sub-filter chips, and GEAR_ON is
   false so the gear chip is display:none), so it read as 62px of dead black directly under the hero
   on the landing tab. The icon docks into the sticky header's tab row instead - see the matching CSS
   block, which pins it absolutely inside .tabshell so it cannot re-wrap that row - and renderSubchips
   collapses the band on the tabs that then have nothing in them. Desktop is untouched: above 900px
   the input goes back into .vaulthead, which is where the base 200px rule expects it. A dead script
   leaves the 7-28 layout exactly as it was. Delete this function, its two calls and the .vh-empty
   toggle in renderSubchips to roll back. */
function kbSearchHome(){
  const sw = document.querySelector('.searchwrap'); if (!sw) return;
  const home = isMobile() ? $('tabshell') : document.querySelector('.vaulthead');
  if (home && sw.parentElement !== home) home.appendChild(sw);
}
kbSearchHome();
addEventListener('resize', kbSearchHome);
function setCat(id){
  S.gift=null; S.cat=id; S.sub='all'; S.doorFrom=null; closeStage(false); renderVault(); renderTabs(); }
function setSub(s){ S.sub=s; S.doorFrom=null; closeStage(false); renderVault(); }
function renderSubchips(){
  const c = CATS.find(c=>c.id===S.cat);
  /* r9: a lone always-on ALL chip is a dead control styled as a filter — skip single-sub categories */
  let chips = c.subs.length > 1 ? c.subs.map(([k,n])=>`<button class="chip ${S.sub===k?'on':''}" onclick="setSub('${k}')">${n}</button>`).join('') : '';
  if (S.cat==='paint' && (S.sub==='blades'||S.sub==='all'))
    chips += `<span style="width:1px;height:20px;background:var(--line2);margin:0 3px"></span>` +
      ['all','standard','pro'].map(f=>`<button class="chip ${S.bladeF===f?'on':''}" onclick="S.bladeF='${f}';renderVault()">${f==='all'?'All blades':f}</button>`).join('');
  $('subchips').innerHTML = chips;
  /* 2026-08-10: collapse the whole .vaulthead band on the tabs that render no chips (see kbSearchHome
     above). Guarded on GEAR_ON so flipping the gear filter back on restores the band with its chip. */
  { const vh = document.querySelector('.vaulthead');
    if (vh) vh.classList.toggle('vh-empty', !chips && !GEAR_ON); }
  const onc = $('subchips').querySelector('.chip.on');
  if (onc) onc.scrollIntoView({behavior:'smooth', inline:'nearest', block:'nearest'});
}
function renderModeBars(){
  const gchip = $('gearchip'), glbl = $('gearchip-lbl');
  if (gchip){
    gchip.classList.toggle('on', S.own.on);
    gchip.setAttribute('aria-pressed', String(S.own.on));
    if (S.own.on){
      const names = OWN_OPTS.filter(([k])=>S.own.gear.includes(k)).map(([,n])=>n).join(' · ');
      glbl.innerHTML = `Fits: ${esc(names)} <span class="gc-x" aria-hidden="true">✕</span>`;
    } else glbl.textContent = 'Fits my gear';
  }
  const gb = $('giftbar');
  gb.hidden = !S.gift;
  if (S.gift) gb.innerHTML = `<span class="mb-t">Gift mode · complete kits only</span>
    <span class="mb-list">Ships from Oregon within 2 business days. Free US shipping $99+.</span>
    <span class="mb-act"><button class="mb-btn" onclick="setCat('kits')">Exit</button></span>`;
}
const minPrice = h => Math.min(...P(h).vars.map(v=>v.p));
/* 2026-07-28 - Joel: sink sold-out products to the end of whatever run they are in, rather than
   letting a wall of SOLD OUT badges lead the aisle. The 07-28 availability regeneration corrected 68
   stale flags, and without this the flagship Kits tab opens on dead stock at its top price points.
   Applied as the LAST comparator everywhere so every existing ordering rule (hero families, the
   pinned core light, price within a band) still decides the order among buyable items.
   Delete sinkOOS and its four call sites to roll back. */
function anyAvail(h){ const p = P(h); return !!(p && (p.vars||[]).some(v => v.a)); }
function sinkOOS(hs){
  return hs.sort((a,b) => (anyAvail(a)?0:1) - (anyAvail(b)?0:1));   /* stable in every engine we ship to */
}
function gridProducts(){
  const q = ($('search').value||'').trim().toLowerCase();
  let hs = Object.keys(DATA).filter(h => P(h).sub !== 'warranty');
  if (q){
    let r = hs.filter(h => P(h).title.toLowerCase().includes(q) || (P(h).type||'').toLowerCase().includes(q) || P(h).vars.some(v=>v.t.toLowerCase().includes(q)));
    if (S.gift) r = r.filter(isKit);   /* gift mode guarantee: kits ONLY, even through search */
    if (S.own.on) r = r.filter(fitsGear);   /* fits-my-gear filter also applies through search */
    return sinkOOS(r);
  }
  const subs = CATSUBS[S.cat];
  hs = hs.filter(h => subs.includes(P(h).sub));
  if (S.sub !== 'all') hs = hs.filter(h => P(h).sub === S.sub);
  if (S.cat==='paint') hs = hs.filter(h => P(h).sub!=='blades' || S.bladeF==='all' || (/pro/i.test(P(h).title)) === (S.bladeF==='pro'));
  if (S.own.on) hs = hs.filter(fitsGear);   /* fits-my-gear filter */
  /* r28 (Joel): Flow Arts "All" led with $5 DIY connectors — the pure price sort buried the hero
     whips/sabers/ropes 10+ swipes deep. Hero families first, extras last, price within each. */
  if (S.cat === 'flow' && S.sub === 'all'){
    const fo = {core:-1, whip:0, saber:1, rope:2, extras:3};   /* r29: the light leads every aisle */
    return sinkOOS(hs.sort((a,b) => (fo[P(a).sub] - fo[P(b).sub]) || (minPrice(a) - minPrice(b))));
  }
  const cf = h => P(h).sub === 'core' ? 0 : 1;   /* r29: the light leads every aisle */
  return sinkOOS(hs.sort((a,b) => cf(a) - cf(b) || minPrice(a) - minPrice(b)));
}
/* r42: tile rating line: one star glyph + rating + (count), from the same live RATINGS map and the
   same 3+ review gate as the sheet's .rtag (r20). Purely informational; the tile's single onclick
   stays the only action (a 2nd tile click target was rejected in r39). */
function tileStars(h){
  const r = RATINGS[h];
  if (!r || r[1] < 3) return '';
  return `<span class="tstars"><span class="tstar" aria-hidden="true">★</span>${(+r[0]).toFixed(1)} <span class="tct">(${r[1]})</span></span>`;
}
function tileHTML(h, extra=''){   /* r47: extra = band-scoped modifier class (only 'hero' today) */
  const p = P(h);
  const minP = minPrice(h), maxP = Math.max(...p.vars.map(v=>v.p));
  const anyA = p.vars.some(v=>v.a), q = keyQty(h), vid = tileVid(h), multi = p.vars.length>1;
  /* r30: kit chip = the light fact on the photo, once. 1-light chips only earn their keep in MIXED
     contexts (r9 wallpaper rule: all-kit views suppress them); "2 Lights" differentiates anywhere.
     Hidden while the In Kit chip is up (corner collision at mobile widths); .oos(z4) covers it. */
  const kl = isKit(h) ? (KIT_LIGHTS[h]||0) : 0;
  const kitsCtx = S.gift || (S.cat==='kits' && !S.own.on && !($('search').value||'').trim());
  const kchip = kl && !q && (kl===2 || !kitsCtx) ? `<span class="kitchip">${kl===2?'2 Lights':'Light'} Included</span>` : '';
  return `<button class="tile ${extra?extra+' ':''}${p.sub==='core'?'is-core ':''}${S.sel===h?'sel':''}"
    data-h="${h}" ${vid?`data-vid="${vid}"`:''} onclick="openStage('${h}', this)" aria-label="Preview ${esc(p.title)}${p.sub==='core'?', the core light by itself, no accessories included':''}${kl?(kl===2?', complete kit, 2 lights included':', complete kit, light included'):''}">
    <span class="in">
    <span class="ph"><img loading="lazy" src="${p.sub==="core"?CDN(HERO_IMG,840):CDN(p.imgs[0],420)}" alt="${esc(p.title)}">
      ${q?`<span class="qn"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>In Kit${q>1?` ×${q}`:''}</span>`:''}
      ${p.sub==='core'?'<span class="corechip">THE LIGHT</span>':''}${kchip}
      ${vid?`<span class="vb"><svg width="10" height="10" viewBox="0 0 24 24" fill="#fff"><path d="M6 4l14 8-14 8z"/></svg></span>`:''}
      ${(!multi&&anyA)?`<span class="qadd" role="button" tabindex="0" aria-label="Add ${esc(p.title)} to kit" onclick="event.stopPropagation();addItem('${h}',null,1,this)" onkeydown="if(event.key==='Enter'||event.key===' '){event.stopPropagation();event.preventDefault();addItem('${h}',null,1,this)}">+ Add</span>`:''}
      ${anyA?'':'<span class="oos">SOLD OUT</span>'}</span>
    <span class="bd">${tileBadge(h)}<span class="nm">${esc(p.title)}</span>
      <span class="pline"><span class="pr money">${minP===maxP?money(minP):money(minP)+'+'}</span>
      ${multi?`<span class="opt">${p.vars.length} options</span>`:''}</span>${tileStars(h)}</span>
    </span>
  </button>`;
}
/* 2026-08-06 dead-click audit (fix 7). The explicit data-failure card. Deliberately a different class
   from the plain .nores empty-search card so a broken catalog can never again be read as "no results",
   and it carries the retry the old path had no way to offer. */
function kbDataFailHTML(){
  return `<div class="nores dataerr" role="alert" style="grid-column:1/-1"><b>CATALOG FAILED TO LOAD</b>`
    + `We couldn&rsquo;t load the product catalog. That&rsquo;s on us, not you. Check your connection and try again.`
    + `<button type="button" class="kb-reload" onclick="if(window.AOAM_LOAD)window.AOAM_LOAD.show();location.reload()">Reload the builder</button></div>`;
}
function kbDataFail(){
  window.kbDataFailed = true;
  const g = $('grid'); if (g){ lastGridHTML = kbDataFailHTML(); g.innerHTML = lastGridHTML; }
  const gw = $('gridwrap'); if (gw) gw.removeAttribute('aria-busy');
  const kg = $('kbguide'); if (kg){ kg.hidden = true; kg.innerHTML = ''; }
  const hb = $('hub'); if (hb) hb.hidden = true;
  document.documentElement.classList.remove('kb-booting');
  document.documentElement.classList.add('kb-datafail');
  kbGA('kb_data_missing');   // [kb-track]
}
function renderGrid(){
  if (!KB_DATA_OK){ const f = kbDataFailHTML(); if (f === lastGridHTML) return; lastGridHTML = f; $('grid').innerHTML = f; return; }
  const q = ($('search').value||'').trim();
  let html = '';
  if (S.gift && !q){
    /* gift door: kits only, grouped in budget bands, complete-kit reassurance on every tile */
    const kits = sinkOOS(Object.keys(DATA).filter(h=>isKit(h)).sort((a,b)=>minPrice(a)-minPrice(b)));
    const bands = [['150','Around $150', p=>p<170], ['200','Around $200', p=>p>=170&&p<290], ['300','$300 and up', p=>p>=290]];
    bands.forEach(([id,lbl,fn])=>{
      const hs = kits.filter(h=>fn(minPrice(h)));
      if (hs.length) html += `<div class="bandh" id="band-${id}">${lbl}<small>complete kits · light included</small></div>` + hs.map(tileHTML).join('');
    });
  } else if (S.cat==='kits' && !q && !S.gift && !S.own.on){
    /* r39: Ready-Made leads with the bare light in its own one-tile band, then the price-sorted kit run.
       core is pinned first by gridProducts (cf), so it never drops into the price sort and reads as the cheapest kit.
       Band 1's small line does double duty: names the bare light AND states the light-fact once for the whole kit wall. */
    const hs = gridProducts();
    const core = hs.filter(h => P(h).sub === 'core');
    const kits = hs.filter(h => isKit(h));
    html = `<div class="bandh">Just the light<small>the system core, sold alone · every kit below includes it</small></div>`
      + core.map(h=>tileHTML(h,'hero')).join('')   /* r47: full-row hero, kills the dead space beside the lone core tile */
      + `<div class="bandh" id="band-kits">Complete kits<small>light included · nothing else needed</small></div>`
      + kits.map(tileHTML).join('')
      /* 2026-07-28 audit: GA4 says only 34 of 136 users ever switch category, so ~3 in 4 see this
         tab and nothing else, and the kit wall simply ended here. The "One light powers this entire
         wall" endcap below is gated to flow/paint/costume, so the tab everyone lands on was the one
         with no route into the aisles. Same aisle chips lightReadyHTML already uses in the dock. */
      + aisleBandHTML();
  } else {
    const hs = gridProducts();
    html = hs.map(h => tileHTML(h)).join('');
    let doorBand = false;
    /* r9: outcome doors used to land on accessory-only grids with no light anywhere —
       lead with the matching complete kits, then the piece-by-piece gear */
    if (!q && !S.gift && S.doorFrom === S.cat && S.sub === 'all' && !S.own.on){
      const m = {flow:/whip|saber|rope|staff|jump|totem/i, paint:/light painting/i, costume:/costume/i}[S.cat];
      const kits = m ? sinkOOS(Object.keys(DATA).filter(h=>isKit(h)&&m.test(P(h).title)).sort((a,b)=>minPrice(a)-minPrice(b))) : [];
      if (kits.length){ html = `<div class="bandh">Start with a complete kit<small>light included · nothing else needed</small></div>`
        + kits.map(tileHTML).join('')
        + `<div class="bandh">Build it piece by piece<small>these snap onto the RGB Critter BT light</small></div>` + html;
        doorBand = true; }
    }
    /* r39: aisle endcap — one band above the r29-pinned Critter in flow/paint/costume "All" views. NEVER in
       Power & Cases (chargers/batteries/cases support the light, they don't run on it, so the claim would be false),
       and never stacked on the r9 doorFrom bands (which already open with their own two). */
    if (!doorBand && !q && !S.gift && !S.own.on && S.sub==='all' && (S.cat==='flow'||S.cat==='paint'||S.cat==='costume')){
      const endcap = {flow:'every whip, saber and rope below twists onto the RGB Critter BT · buy the light once',
        paint:'every writer, blade and tube below twists onto the RGB Critter BT · buy the light once',
        costume:'every costume piece below runs on the RGB Critter BT · buy the light once'}[S.cat];
      html = `<div class="bandh">One light powers this entire wall<small>${endcap}</small></div>` + html;
    }
    /* r39: the Sabers subcategory ends with the DESIGN YOUR OWN door tile → the sibling Saber Builder (leave-gated). */
    if (S.cat==='flow' && S.sub==='saber' && !q && !S.gift && !S.own.on){
      if(SABER_URL) html += `<a class="tile saberdoor" href="${SABER_URL}" aria-label="Open the Saber Lab, leaves the Kit Builder"><span class="in"><span class="ph"></span><span class="bd"><span class="cb">DESIGN YOUR OWN</span><span class="nm">SABER LAB</span><span class="pline"><span class="pr">Open the lab ${EXT_ARROW}</span></span></span></span></a>`;
    }
  }
  html = html ||
    `<div class="nores" style="grid-column:1/-1"><b>NO MATCHES</b>Try “whip”, “blade”, “battery”…</div>`;
  /* 2026-07-28 audit: every add, +, − and trash tap runs renderAll, which unconditionally rebuilt
     this whole grid (innerHTML reparse plus a full hover-video rewire) even when nothing in it had
     changed, e.g. a quantity tap in the open drawer, a banner dismiss, the warranty toggle or the
     pageshow re-render. The r9 note above already records that a full grid rebuild per keystroke was
     janky on mid-range phones, which are 83% of this store's traffic; the mutation path never got
     the same treatment. The string build is cheap, the DOM swap is not, so compare and skip.
     Delete lastGridHTML and this guard to roll back. */
  if (html === lastGridHTML) return;
  lastGridHTML = html;
  $('grid').innerHTML = html;
  wireHoverVideos();
}
let lastGridHTML = null;
/* tile hover videos (v12 feature, restored per Joel): inline muted loop while the cursor is on the tile */
function wireHoverVideos(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover:hover)').matches) return;
  document.querySelectorAll('[data-vid]').forEach(el => {
    el.addEventListener('mouseenter', () => {
      if (el.querySelector('video')) return;
      const v = document.createElement('video');
      v.src = el.dataset.vid; v.muted = true; v.loop = true; v.playsInline = true;
      el.querySelector('.ph').appendChild(v); v.play().catch(()=>{});
    });
    el.addEventListener('mouseleave', () => { const v = el.querySelector('video'); if (v) v.remove(); });
  });
}

/* hub-and-spoke stage (Critter never leaves center) */
function buildHub(){
  /* r11 (Joel: "this doesn't look good"): the floating rig-item orbs + near-invisible spoke lines read
     as random disconnected circles, white product shots glared against the black, and the caption
     duplicated the YOUR RIG title directly below. The stage is now a clean clickable hero: one render,
     one constant caption. The rig list below already tells the items story. */
  /* 2026-08-06 dead-click audit (fix 1). This band is the page's top dead-click source: 57 dead
     clicks across 75 mobile sessions. Only the .hub-core img and the .hub-go chip carried a handler.
     The .hub-anim starburst is stretched over the whole band and is pointer-events:none, so taps fell
     through to div.hub, which had nothing bound; the .hub-intro logo overlay does the same on desktop.
     Measured with a 12x8 elementFromPoint grid inside the band: 48 of 96 points dead at 390x844 (50%,
     matching the session data exactly) and 94 of 96 dead at 1280x800 (98%, the intro overlay).
     The handler now lives on #hub itself, so any point in the band opens the same stage. The two
     inner onclick attributes are REMOVED rather than kept, so a tap on the chip fires openStage
     exactly once - a <button> activation (mouse OR keyboard) bubbles to the container, which is also
     what preserves the keyboard path. .hub-go stays a real button and remains the single accessible
     named control, so the container needs no role/tabindex of its own and screen readers still see
     one control, not three. Restore the two onclick attributes plus role/tabindex/onkeydown on
     .hub-core, and delete the wiring below, to roll back. */
  /* 2026-08-09 - Joel, on a 390px screenshot with the hero circled: "there is some shitty overlapping
     parts here". The tag line and the product name were wrapped in one .hc-txt column so the mobile
     caption strip could put them BESIDE the View the light chip on a single row (54px) instead of
     stacking three lines (94px), which is what was covering the bottom 46% of the render. */
  /* 2026-08-10 - Joel, on a screenshot with the band's lower area circled: "when you first load the
     page it has RGB CRITTER BT and view the light button located where the red circle is. remove
     this." The whole .hub-cap lockup (tag line, lime product name, View the light chip) is gone, so
     the caption above is now history only. The chip was the hero's single NAMED control for screen
     readers and keyboards (2026-08-06 dead-click audit fix 1), so the band itself takes that role
     here: role/tabindex/aria-label plus an Enter/Space handler, one control where there was one
     control. The mobile 54px strip reservation is zeroed in kit-builder.css (--hubcap-h) so its
     space does not survive as dead black. Restore the .hub-cap markup above, drop the four
     attribute lines and the onkeydown below, and put --hubcap-h back to 54px to roll back. */
  $('hub').innerHTML = `
    <img class="hub-core" src="${CDN(CRITTER_IMG,500)}" alt="RGB Critter BT, the core light">
    <video class="hub-anim" id="hubanim" muted loop playsinline preload="none" aria-hidden="true">
      ${KBA.sysWebm ? `<source src="${KBA.sysWebm}" type="video/webm">` : ''}
      ${KBA.sysMp4 ? `<source src="${KBA.sysMp4}" type="video/mp4">` : ''}</video>
    <img class="hub-att" id="hubatt" alt="">`;
  const hb = $('hub');
  hb.dataset.kbClickable = '1';
  hb.setAttribute('role','button');
  hb.setAttribute('tabindex','0');
  hb.setAttribute('aria-label','RGB Critter BT, one light with 200 plus creative tools. View the light');
  hb.onclick = () => openStage(CRITTER);
  hb.onkeydown = e => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){ e.preventDefault(); openStage(CRITTER); } };
}
/* r24 (Joel): play the 2019 logo animation once over the hub on load. Sidecar aoam-logo-anim.webm
   (VP9 with alpha, converted from D:\KICKSTARTER CLIPS\LOGO ANIMATION\AOAM-ANIMATION-TRANSPARENT-MOV.mov,
   indexed in the vault's Brand Assets Index). Any failure (file missing, autoplay blocked, decode stall)
   reveals the hero right away so the stage can never stick empty; reduced-motion skips it entirely */
function playHubIntro(){
  /* 2026-08-06: PREMISE CORRECTED, behaviour deliberately kept. r38's reason for this line was "a
     restored cart owns the desktop column, so the hub boots hidden and the logo intro would play into
     a hidden slot". That is no longer true - the cart no longer takes the column, so on a returning
     desktop visit with a saved cart the hub IS visible now. The skip stays anyway, on its own merit:
     a shopper coming back to a cart they already built has seen the 6s logo once, wants to get on with
     it, and does not need another 1098KB decorative download to do it. startHubAnim still arms the
     starburst loop. Delete this line to play the intro on every desktop load instead. */
  if (!isMobile() && S.cart.length){ startHubAnim(); return; }
  /* 2026-07-23, Joel asked: "how can we make the kit builder faster loading?". aoam-logo-anim.webm is 1098KB
     (VP9 960x540 @ 1.5Mbps) for a decorative 6s intro that plays once. Measured page weight was 2107KB
     total, of which the two hub videos were 2007KB; every other asset combined is 64KB over the wire.
     Store traffic is 92% mobile, and mobile is exactly where a 1.1MB decorative download hurts most, so
     phones now skip straight to the hero. Also honours Save-Data / 2g-3g on any width. Desktop is
     unchanged. Delete this block to roll back. */
  if (isMobile()){ startHubAnim(); return; }
  { const c = navigator.connection;
    if (c && (c.saveData === true || /(^|-)2g$|^3g$/.test(c.effectiveType || ''))){ startHubAnim(); return; } }
  if (matchMedia('(prefers-reduced-motion: reduce)').matches){ startHubAnim(); return; }
  const hub = $('hub'), v = document.createElement('video');
  v.className = 'hub-intro'; v.muted = true; v.autoplay = true; v.playsInline = true;
  v.setAttribute('muted',''); v.setAttribute('playsinline','');
  if(!KBA.logoWebm){ startHubAnim(); return; } v.src = KBA.logoWebm;
  let over = false;
  const done = () => { if (over) return; over = true;
    hub.classList.remove('intro'); v.classList.add('out'); setTimeout(() => v.remove(), 550);
    startHubAnim(); };
  v.onended = done; v.onerror = done;
  setTimeout(() => { if (!v.currentTime) done(); }, 1600);  /* never started: bail early */
  setTimeout(done, 8000);                                   /* hard cap: clip is 6s */
  hub.classList.add('intro');
  hub.appendChild(v);
  const p = v.play(); if (p && p.catch) p.catch(done);
}
/* r25: the starburst loop starts only after the logo intro hands off (every intro path, success or
   failure, lands in done). Reduced-motion removes it outright; a dead sidecar or blocked autoplay
   removes it too, leaving the static hero — the stage can never stick empty */
function startHubAnim(){
  const v = $('hubanim'); if (!v) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches){ v.remove(); return; }
  /* 2026-07-28 audit: the Save-Data / 2g-3g guard in playHubIntro only ever skipped the LOGO intro,
     because the isMobile() branch returns before it and because every branch then calls this
     function, which had no connection check of its own. So the phones least able to afford it still
     downloaded the full starburst loop. The guard belongs here, on the file that actually costs
     900KB, and it leaves the static hub hero in place. Delete these two lines to roll back. */
  { const c = navigator.connection;
    if (c && (c.saveData === true || /(^|-)2g$|^3g$/.test(c.effectiveType || ''))){ v.remove(); return; } }
  /* 2026-07-23, Joel asked: "how can we make the kit builder faster loading?". The starburst loop
     (aoam-system-anim, 909KB webm / 999KB mp4) carried preload="auto", so it downloaded in full at
     t=0 even though it cannot play until the 6s logo intro hands off. It competed with the JS, the
     data file and the first product images for bandwidth during the only window that matters. The
     tag is now preload="none" and the fetch is armed here, after the load event and on an idle
     callback, so decoration never races the critical path. Same visuals, just later. On mobile the
     logo intro is skipped entirely (see playHubIntro), which is why this deferral matters most
     there: without it the starburst would simply take the intro's place at boot.
     Delete this block to roll back (restore preload="auto" in buildHub and call play() directly). */
  /* 2026-08-10: tell the layout, synchronously and before first paint, that the starburst is going to
     run - which means .hub-cap will be faded out for the whole session (base :has rule) and the band
     must not reserve 54px for it. See the .anim-armed rules in kit-builder.css. Every path that gives
     up on the sidecar disarms it again, because that is exactly when the strip becomes visible. */
  if (!KBA.sysWebm && !KBA.sysMp4){ v.remove(); return; }   /* 2026-09-28 cart-fix-l low-kb C117: kb6 is the builder, the hidden legacy hub has no loop to play. Roll back: delete this line and restore the two <source src="${KBA.sysWebm||''}"> tags in buildHub. */
  const hb = $('hub'); if (hb) hb.classList.add('anim-armed');
  const disarm = () => { v.remove(); if (hb) hb.classList.remove('anim-armed'); };
  const go = () => {
    v.addEventListener('error', disarm, true);
    /* 2026-08-06 dead-click audit (fix 11). assets/aoam-system-anim.webm reported net::ERR_ABORTED on
       EVERY load at both widths. The asset is NOT corrupt and the source is NOT wrong: ffprobe reads a
       valid matroska/webm, one VP9 video stream, 1280x720, 8.30s, 345,629 bytes, and headless Chrome
       confirms the webm is the source that actually plays (currentSrc ends .webm, videoWidth 1280,
       readyState 4, currentTime advancing) - the mp4 fallback is never reached.
       The abort was ours. Assigning preload='auto' to a preload="none" element already resumes the
       resource selection algorithm and issues the Range: bytes=0- fetch; the v.load() on the very next
       line restarted that algorithm and cancelled the request in flight. Measured four ways with the
       HTTP cache disabled and a per-case cache-buster: with load() 1 abort + 1 retry, without load()
       0 aborts, playback identical in all four. load() is still required if selection never started
       at all, so it is kept behind a NETWORK_EMPTY guard rather than deleted.
       Noted but deliberately not "fixed": Shopify's CDN serves this file as Content-Type audio/webm
       with X-Content-Type-Options: nosniff. It is harmless (media loads sniff the container, not the
       header) and it is not changeable from the theme.
       Restore the unconditional v.load() to roll back. */
    v.preload = 'auto';
    if (v.networkState === 0 /* HTMLMediaElement.NETWORK_EMPTY */){ try { v.load(); } catch(e){} }
    const p = v.play();
    if (p && p.then) p.then(() => v.classList.add('on')).catch(disarm);
    else v.classList.add('on');
  };
  const idle = fn => (window.requestIdleCallback ? requestIdleCallback(fn, {timeout:2000}) : setTimeout(fn, 200));
  if (document.readyState === 'complete') idle(go);
  else addEventListener('load', () => idle(go), {once:true});
}
function renderHub(){
  const hub = $('hub'), ha = $('hubatt');
  const att = (S.sel && S.sel !== CRITTER) ? CDN(P(S.sel).imgs[0],500) : '';
  if (att && ha.getAttribute('src') !== att) ha.src = att;
  if (att) ha.alt = P(S.sel).title + ' attached to the RGB Critter BT';
  hub.classList.toggle('has-att', !!att);
}

/* stage detail */
/* 2026-08-06 dead-click audit (fix 3). openStage() opened with `if (S.sel === h) return;`. On desktop
   the selected tile stays on screen right beside the already-open detail panel, so every repeat click
   on it was a silent no-op and read as dead - the shopper has no way to tell "already showing" from
   "broken". Re-selection now replays the panel's enter animation, returns it to the top of the column
   and takes focus, so a click always produces a visible result. Restore the bare `return` to roll
   back (sdPulse then becomes unused). */
function sdPulse(){
  const sd = $('stagedetail'); if (!sd || sd.hidden) return;
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches){
    sd.classList.remove('enter'); void sd.offsetWidth; sd.classList.add('enter');
    sd.addEventListener('animationend', ()=>sd.classList.remove('enter'), {once:true});
  }
  const lw = document.querySelector('.leftscroll'); if (lw) lw.scrollTop = 0;
  try { sd.scrollIntoView({behavior:'smooth', block:'nearest'}); } catch(e){}
  sd.focus();
}
function openStage(h, tileEl){
  if (S.sel === h){ sdPulse(); return; }
  S.sel = h; S.ax[h] = S.ax[h] || defaultSel(h);
  renderHub(); renderStage(); renderGrid();
  const sd = $('stagedetail');
  if (sd){
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches){
      sd.classList.add('enter'); sd.addEventListener('animationend', ()=>sd.classList.remove('enter'), {once:true});
    }
    sd.focus();
  }
  const lw = document.querySelector('.leftscroll'); if (lw) lw.scrollTop = 0;   /* r27: a fresh detail starts at the top of the column */
  if (isMobile()){
    if (!document.body.classList.contains('sheet-open')) history.pushState({layer:'sheet'}, '');   /* swipe-back closes the sheet */
    document.body.classList.add('sheet-open'); setSheetA11y(true);
  }
  renderBar();   /* 2026-08-06 fix 5: the sticky bottom bar hides behind the sheet */
}
function closeStage(refocus){
  const h = S.sel; S.sel = null;
  document.body.classList.remove('sheet-open');
  setSheetA11y(false);
  renderHub(); renderStage(); renderGrid(); renderBar();   /* 2026-08-06 fix 5: bar comes back with the sheet gone */
  if (refocus && h){ const t = document.querySelector(`.tile[data-h="${h}"]`); if (t) t.focus(); }
}
function setSheetA11y(on){
  const sd = $('stagedetail'); if (!sd) return;
  /* r45: $('ktoast') added. renderKtoast() hides the toast when body.sheet-open is set, but openStage()
     never calls it (it renders hub/stage/grid, THEN sets the class), so on mobile the toast is left
     live behind the sheet. It is not VISIBLE — the sheet is z:30 over the toast's z:20, verified by
     elementFromPoint — but its two buttons stayed keyboard-reachable inside an aria-modal dialog, and
     one of them (SWAP TO THE KIT) mutates the cart. Inerting it with the rest of the background closes
     the focus leak without depending on render order, same reasoning as the r45 strip gate. */
  const bg = [document.querySelector('header.hdr'), $('hub'), $('rigpanel'), document.querySelector('.vault'), $('bbar'), $('ktoast')];
  if (on){ sd.setAttribute('role','dialog'); sd.setAttribute('aria-modal','true'); bg.forEach(el=>el&&el.setAttribute('inert','')); }
  else { sd.setAttribute('role','region'); sd.removeAttribute('aria-modal'); bg.forEach(el=>el&&el.removeAttribute('inert')); }
}
function renderStage(){
  const sd = $('stagedetail');
  /* 2026-08-06 (Joel, designer feedback round 2) - this REVERSES r38's "a restored cart owns the
     desktop column" rule, deliberately and with Joel's explicit go-ahead in the popup this session.
     r38 read: hubHide = !!S.sel || (S.cart.length > 0 && !isMobile()).
     The designer's strongest and most accurate complaint (verified in the 2026-07-31 assessment) was
     that this right column is TRIPLE-state: marketing hub when empty, product sheet when an item is
     selected, live cart the moment the cart is non-empty. Two of those are a considered swap; the
     third fires on a state change the shopper did not ask for, and it is the one that reads as the
     page rearranging itself.
     The column now swaps between exactly TWO things: the hub, and the product sheet. The cart keeps
     its rows where they always were (.rigpanel, below, in the same scroller) and surfaces its state
     in the new always-visible sticky #kitbar at the top of .leftscroll instead. That bar is what
     answers r38's actual concern - that a shopper on a short window would lose sight of the kit - so
     nothing is given up by letting the hub stay.
     Restore the r38 line above, and delete #kitbar / renderKitBar / kbJumpToKit / the .kitbar CSS,
     to roll back. Mobile is untouched either way: the hub is the page hero there and .rigpanel is
     display:none. */
  const hubHide = !!S.sel;
  $('hub').hidden = hubHide;
  /* 2026-08-06, pre-push review blockers 1 and 2, both measured on stage before fixing:
     1. .stagedetail is height:100% of .leftscroll, so the kit bar sitting above it as a flex sibling
        shortened the sheet's box by the bar's height while the sheet's own content did not shrink -
        at 1280x900 that put ADD TO KIT 37px BELOW the scrollport with a non-empty cart, where the
        same page with an empty cart had it fully visible. That is the r27 critique-W1 regression, on
        the page's core repeat-add loop. The bar now yields whenever a sheet is open, which hands the
        sheet back the exact full-height column it had before this change.
     2. the 900px matchMedia handler calls renderStage but NOT renderRig, so crossing 375 -> 1280 with
        a non-empty cart left #kitbar.hidden=true from its mobile pass and the bar never came back
        until the next cart edit (reproduced: hidden stayed true through the resize, recovered only on
        an add). Rendering the bar from renderStage fixes that crossing for free, since the handler
        already calls renderStage.
     Called BEFORE the early returns below, so a no-op sheet re-render cannot skip it. */
  renderKitBar();
  const hv = $('hubanim');     /* r25/r38: don't burn decode cycles while the hub slot is hidden (under either rule) */
  if (hv && hv.classList.contains('on')){
    if (hubHide) hv.pause();
    else { const hp = hv.play(); if (hp && hp.catch) hp.catch(()=>{}); }
  }
  if (!S.sel){ sd.hidden = true; sd.innerHTML = ''; sd.dataset.h = ''; return; }
  if (sd.dataset.h === S.sel && !sd.hidden) return;   /* video-preservation guard */
  sd.hidden = false; sd.dataset.h = S.sel; sd.innerHTML = stageDetailHTML(S.sel);
  sdInitRail();    /* r14: loop rail opens centered on the real first slide (a clone sits to its left) */
  const sc = sd.querySelector('.sd-scroll'); if (sc) sdScrollFade(sc);
  sdDescCheck();   /* r9: reveal the More toggle only when the 2-line clamp actually clipped the description */
}
/* 2026-08-18 - Joel's call, "Pull all three". usb-charging-cable, rgb-critter-silicone-shell and
   o-ring are all on the SITE's upsell deny list (snippets/aoam-upsell-list.liquid:95 aoam_deny), so
   they can never appear in any rail on the rest of the store, and this builder was the one surface
   still offering them. usb-charging-cable also carries 1.0 stars off a single review in this file's
   own RATINGS map. Every pool that lost an entry gained a replacement from the same aisle rather
   than being left short, because stripPicks() needs 2 picks minimum before the strip renders at all.
   ROLLBACK: the pre-2026-08-18 pools are in
   OneDrive\Documents\AOAM-Theme-Rollback\2026-08-18-kb-cart-matches-site-cart\before\. */
const UPSELL_DENY = ['usb-charging-cable','rgb-critter-silicone-shell','o-ring','battery-door','gift-card'];
const UPSELL_MAP = {
  whip:   ['rgb-critter-18650-battery','bitwhip-travel-case','rgb-critter-travel-case'],
  saber:  ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'],
  tubes:  ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'],
  blades: ['light-painting-blade-holder','rgb-critter-18650-battery','rgb-critter-travel-case'],
  writers:['rgb-critter-18650-battery','rgb-critter-travel-case','light-painting-blade-holder'],
  mounts: ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'],
  kits:   ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'], /* 7-20 (Joel): battery-door OUT of upsells - low-converting spare. 2026-08-18: the sleeve went the same way, it is on the site deny list. */
  power:  ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'],
  costume:['rgb-critter-18650-battery','rgb-critter-travel-case','light-painting-blade-holder'],
  core:   ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap'],
};
/* broad fallback so the upsell block always fills 3 cards even when the category picks are already in the rig (Joel: upsells disappeared) */
/* r20: REAL Judge.me ratings pulled from the live PDP JSON-LD on 2026-07-14 (no fake stars, r9 rule).
   [rating, reviewCount] per handle; products without live data render nothing. Stars show only at 3+
   reviews, a uniform minimum so a single review (good or bad) does not read as a track record. */
const RATINGS = {'acrylic-writers':[5.0,7],'aurora-light-painting-blade':[4.76,42],'babinski-pro-light-painting-blade':[4.76,42],'baby-circle':[4.76,42],'battery-door':[4.2,5],'bitwhip-accessory':[4.68,38],'bitwhip-fiber-optic-whip-prop':[4.66,167],'butcher-sword-light-painting-blade':[4.76,42],'butterfly-light-painting-tube':[4.52,21],'butterfly-light-saber-flow-arts':[4.52,21],'butterfly-saber-accessory':[4.52,21],'circle':[4.76,42],'circle-light-painting-blade':[4.76,42],'crab-claw':[4.76,42],'critter-connector-flow-arts-staffs-double-sided-light-whips':[5.0,2],'critter-to-lpb-adapter':[5.0,7],'crown-jewel-light-painting-blade':[4.76,42],'digital-feather-blade':[4.76,42],'digital-feather-light-painting-blade-long':[4.76,42],'diy-connector':[4.75,12],'double-bitwhip-light-whip':[4.94,17],'excelsior-light-painting-blade':[4.76,42],'feather-blade':[4.76,42],'flower-flames-blade':[4.76,42],'feather-lissome-light-painting-blade':[4.76,42],'feather-quill-light-painting-blade':[4.76,42],'feather-tartan-light-painting-blade':[4.76,42],'fiber-optic-costume-accessory':[4.75,28],'fiber-optic-costume-kit-app-controllable':[4.75,28],'fiber-optic-duster-blue':[5.0,10],'fiber-optic-duster-green':[5.0,10],'fiber-optic-duster-pink':[5.0,10],'fiber-optic-duster-white':[5.0,10],'fiber-optic-dusters':[5.0,10],'flame-of-tongue-light-painting-blade':[4.76,42],'flower-flames-light-painting-blade':[4.76,42],'foglia-light-painting-blade':[4.76,42],'great-mogul-pro-light-painting-blade':[4.76,42],'halo-light-painting-blade':[4.76,42],'heart-light-painting-blade':[4.76,42],'honeycomb-light-painting-tube':[4.64,28],'honeycomb-light-saber-flow-arts':[4.64,28],'honeycomb-saber-accessory':[4.64,28],'hypnotic-light-painting-blade':[4.76,42],'illuminator':[5.0,7],'inverse-critter-connector-dual-rgb-critters-modular-sabers':[5.0,2],'jump-rope-for-flow-artists':[5.0,5],'jupiter-jump-rope-accessory':[5.0,5],'jupiter-rope-accessory':[4.82,11],'jupiter-rope-led-glow-prop':[4.82,11],'katana-light-painting-blade':[4.76,42],'kunai-light-painting-blade':[4.76,42],'led-staff':[5.0,9],'light-painting-blade-holder':[4.0,12],'light-painting-blades-set-rectangle-triangle-wedge':[4.76,42],'light-painting-kit-deluxe-rgb-critter-photography':[4.9,10],'light-painting-kit-starter-rgb-critter-photography':[5.0,3],'light-painting-photography-kit-for-beginners':[4.81,21],'light-painting-tube':[4.83,46],'lightning-light-painting-blade':[4.76,42],'masamune-light-painting-blade':[4.76,42],'modular-cap':[5.0,2],'oncrist-pro-light-painting-blade':[4.76,42],'palladian-pro-light-painting-blade':[4.76,42],'primal-flames-pro-light-painting-blade':[4.76,42],'rectangle-light-painting-blade':[4.76,42],'rectangle-pro-light-painting-blade':[4.76,42],'rgb-critter-18650-battery':[3.93,15],'rgb-critter-bt-color-changing-flashlight':[4.65,111],'rgb-critter-flashlight-extended-warranty':[5.0,6],'rgb-critter-silicone-shell':[4.57,7],'rgb-critter-travel-case':[5.0,1],'saw-3000-light-painting-blade':[4.76,42],'slugger-long-light-painting-blade':[4.76,42],'small-tube-holder-light-painting':[5.0,6],'sol-light-saber-flow-arts':[4.83,46],'sol-saber-accessory':[4.83,46],'solar-flare-light-painting-blade':[4.76,42],'solar-flare-pro-light-painting-blade':[4.76,42],'spade-light-painting-blade':[4.76,42],'sparkler-holder':[5.0,2],'spiral-dots-light-painting-tube':[5.0,1],'stellar-light-saber-flow-arts':[3.5,2],'stellar-saber-accessory':[3.5,2],'t8-tube-holder-light-painting-tool':[5.0,3],'tendril-pro-light-painting-blade':[4.76,42],'the-idols-eye-light-painting-blade':[4.76,42],'the-jubilee-light-painting-blade':[4.76,42],'the-millennium-star-light-painting-blade':[4.76,42],'the-orb-light-diffuser-rgb-critter-flashlight':[3.67,6],'tube-to-critter-back':[4.0,1],'usb-charging-cable':[1.0,1],'world-peace-light-painting-blade':[4.76,42]};
function starsInner(r){
  const pct = Math.round(r[0]/5*1000)/10;
  return `<span class="st" aria-hidden="true">★★★★★<span style="width:${pct}%">★★★★★</span></span>`+
    `<span class="sn">${(+r[0]).toFixed(1)}</span><span class="rtag">${r[1]} Reviews <span class="dn">▾</span></span>`;
}
function starsHTML(h){
  const r = RATINGS[h]; if (!r || r[1] < 3) return '';
  /* r26 (Joel): stars are an IN-PAGE toggle now, never a new window. Opens the sd-rev block below. */
  return `<button type="button" class="sd-stars" onclick="toggleReviews('${h}')" aria-expanded="false" aria-controls="sdrev"
    aria-label="Rated ${r[0].toFixed(1)} out of 5 from ${r[1]} reviews. Show the reviews">${starsInner(r)}</button>`;
}
/* r26 (Joel: "these reviews should not open a new window"): reviews render INSIDE the product detail,
   fetched live from Judge.me's public widget endpoint, the exact data the live PDP widget shows
   (CORS is open, verified 2026-07-14; same call works on the theme page at port, or swap for the
   native Judge.me Liquid widget there). PIDS maps every RATED handle to its Shopify product id;
   at port this comes free from Liquid. Counts stay per Judge.me review GROUP, matching the PDP. */
const PIDS = {'acrylic-writers':4324896571444,'aurora-light-painting-blade':8881683300577,'babinski-pro-light-painting-blade':8881683759329,'baby-circle':8881628741857,'battery-door':7694645362913,'bitwhip-accessory':4324487430196,'bitwhip-fiber-optic-whip-prop':8427386470625,'butcher-sword-light-painting-blade':8881627267297,'butterfly-light-painting-tube':8703333433569,'butterfly-light-saber-flow-arts':8882285641953,'butterfly-saber-accessory':8703317967073,'circle':8881629429985,'circle-light-painting-blade':8881684185313,'crab-claw':8881624908001,'critter-connector-flow-arts-staffs-double-sided-light-whips':4173649608756,'critter-to-lpb-adapter':8278863806689,'crown-jewel-light-painting-blade':8881629921505,'digital-feather-blade':8881631264993,'digital-feather-light-painting-blade-long':8881631592673,'diy-connector':4324862951476,'double-bitwhip-light-whip':8900584341729,'excelsior-light-painting-blade':8881684807905,'feather-blade':8881632739553,'flower-flames-blade':8881633132769,'feather-lissome-light-painting-blade':8881685889249,'feather-quill-light-painting-blade':8881692246241,'feather-tartan-light-painting-blade':8881688346849,'fiber-optic-costume-accessory':4173630341172,'fiber-optic-costume-kit-app-controllable':8419534110945,'fiber-optic-duster-blue':8881749623009,'fiber-optic-duster-green':8881749786849,'fiber-optic-duster-pink':8881749917921,'fiber-optic-duster-white':8881749426401,'fiber-optic-dusters':7232520159395,'flame-of-tongue-light-painting-blade':8881692541153,'flower-flames-light-painting-blade':8881693622497,'foglia-light-painting-blade':8881698341089,'great-mogul-pro-light-painting-blade':8881729568993,'halo-light-painting-blade':8881702273249,'heart-light-painting-blade':8881622221025,'honeycomb-light-painting-tube':8703544525025,'honeycomb-light-saber-flow-arts':8882283151585,'honeycomb-saber-accessory':8703372427489,'hypnotic-light-painting-blade':8881705124065,'illuminator':7908771365089,'inverse-critter-connector-dual-rgb-critters-modular-sabers':8026901774561,'jump-rope-for-flow-artists':8900461723873,'jupiter-jump-rope-accessory':7200714555555,'jupiter-rope-accessory':4173645447220,'jupiter-rope-led-glow-prop':8838555893985,'katana-light-painting-blade':8881633591521,'kunai-light-painting-blade':8881710006497,'led-staff':8836912283873,'light-painting-blade-holder':8026082902241,'light-painting-blades-set-rectangle-triangle-wedge':8881634476257,'light-painting-kit-deluxe-rgb-critter-photography':8428077449441,'light-painting-kit-starter-rgb-critter-photography':8428060311777,'light-painting-photography-kit-for-beginners':8858431095009,'light-painting-tube':7808230752481,'lightning-light-painting-blade':8881633951969,'masamune-light-painting-blade':8881713283297,'modular-cap':8237103022305,'oncrist-pro-light-painting-blade':8881716527329,'palladian-pro-light-painting-blade':8881719509217,'primal-flames-pro-light-painting-blade':8881723474145,'rectangle-light-painting-blade':8881634705633,'rectangle-pro-light-painting-blade':8881726390497,'rgb-critter-18650-battery':6078153326755,'rgb-critter-bt-color-changing-flashlight':8240243900641,'rgb-critter-flashlight-extended-warranty':8692806451425,'rgb-critter-silicone-shell':7430114738401,'rgb-critter-travel-case':9451057053921,'saw-3000-light-painting-blade':8881635000545,'slugger-long-light-painting-blade':8881621795041,'small-tube-holder-light-painting':8025609208033,'sol-light-saber-flow-arts':8837284004065,'sol-saber-accessory':4173646659636,'solar-flare-light-painting-blade':8880620994785,'solar-flare-pro-light-painting-blade':8881728913633,'spade-light-painting-blade':8881635295457,'sparkler-holder':8026752811233,'spiral-dots-light-painting-tube':8703573524705,'stellar-light-saber-flow-arts':8882286985441,'stellar-saber-accessory':8703361614049,'t8-tube-holder-light-painting-tool':8025169559777,'tendril-pro-light-painting-blade':8881729208545,'the-idols-eye-light-painting-blade':8881729667297,'the-jubilee-light-painting-blade':8881730552033,'the-millennium-star-light-painting-blade':8881730945249,'the-orb-light-diffuser-rgb-critter-flashlight':4173647544372,'tube-to-critter-back':8053753151713,'usb-charging-cable':6078154047651,'world-peace-light-painting-blade':8881731141857};
const REV_PP = 5, REV_CACHE = {}, REV_INFLIGHT = {}, REV_FILTER = {};
const revKey = h => h + '|' + (REV_FILTER[h] || 0);
function revText(s){ const t = document.createElement('textarea'); t.innerHTML = String(s||'').replace(/<[^>]*>/g,' '); return t.value.replace(/\s+/g,' ').trim(); }
function revName(s){ const p = String(s||'').trim().split(/\s+/); if (!p[0]) return 'Anonymous';
  /* r26b: initial = first LETTER of the last word; "Anh (Anna)" was rendering as "Anh (." */
  const li = p.length > 1 ? (p[p.length-1].match(/[A-Za-z]/) || [])[0] : '';
  return li ? p[0]+' '+li.toUpperCase()+'.' : p[0]; }
function revDate(iso){ const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString('en-US',{month:'short',year:'numeric'}); }
function revStars(n){ return `<span class="st" aria-hidden="true">★★★★★<span style="width:${Math.max(0,Math.min(100,n/5*100))}%">★★★★★</span></span>`; }
async function revFetch(h, page, f){
  const ac = new AbortController(), t = setTimeout(() => ac.abort(), 8000);   /* r26b: a hung cell connection must not spin forever */
  try{
    const r = await fetch(`https://judge.me/reviews/reviews_for_widget?url=antsonamelon.myshopify.com&shop_domain=antsonamelon.myshopify.com&platform=shopify&page=${page}&per_page=${REV_PP}&product_id=${PIDS[h]}${f ? `&filter_rating=${f}` : ''}`, {signal: ac.signal});
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return await r.json();
  } finally { clearTimeout(t); }
}
function toggleReviews(h){
  const el = $('sdrev'), btn = document.querySelector('.sd-stars');
  if (!el || !PIDS[h]) return;
  const open = el.hidden;
  el.hidden = !open;
  if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open){
    if (REV_CACHE[revKey(h)]) renderReviews(h); else loadReviews(h, 1);
    requestAnimationFrame(() => el.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest'}));
  }
}
function hideReviews(h){
  const el = $('sdrev'), btn = document.querySelector('.sd-stars');
  if (el) el.hidden = true;
  if (btn) btn.setAttribute('aria-expanded','false');
  const inf = document.querySelector('.sd-info');
  if (inf) inf.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
}
function revFilter(h, n){
  if ((REV_FILTER[h] || 0) === n) n = 0;    /* tapping the active row clears it */
  REV_FILTER[h] = n;
  if (REV_CACHE[revKey(h)]) renderReviews(h); else loadReviews(h, 1);
}
async function loadReviews(h, page){
  const el = $('sdrev'); if (!el) return;
  const f = REV_FILTER[h] || 0, k = revKey(h);
  if (REV_INFLIGHT[k] === page) return;     /* r26b: impatient re-taps were double-concatenating page 1 */
  REV_INFLIGHT[k] = page;
  if (page === 1 && !REV_CACHE[k]) el.innerHTML = `<div class="rv-load" role="status" aria-label="Loading reviews">
    <span class="sk" style="width:42%"></span><span class="sk" style="width:92%"></span><span class="sk" style="width:74%"></span><span class="sk" style="width:38%"></span><span class="sk" style="width:86%"></span></div>`;
  const mb = $('rv-more'); if (mb){ mb.disabled = true; mb.textContent = 'LOADING…'; }
  try{
    const d = await revFetch(h, page, f);
    const c = REV_CACHE[k] || (REV_CACHE[k] = {n:d.number_of_reviews, avg:d.average_rating, hist:d.histogram||[], pages:(d.pagination && d.pagination.total_pages) || 1, page:0, list:[]});
    if (c.page >= page){ renderReviews(h); return; }          /* a duplicate in-flight response must not double the list */
    if (page > 1) c.focusIdx = c.list.length;                 /* keyboard/SR users keep their place at the first new card */
    c.page = page; c.list = c.list.concat(d.reviews || []);
    if (!(d.reviews || []).length) c.pages = c.page;          /* filtered pagination can overreport; an empty page IS the end */
    if (page === 1 && !f && c.list.length > 1 && !c.list[0].pinned){
      /* best-foot-forward: most shoppers read only the first review; promote the highest-signal one unless the shop pinned its own pick */
      let bi = 0, bs = -1;
      c.list.forEach((r, i) => { const s = (r.rating === 5 ? 2 : 0) + (r.verified_buyer ? 1 : 0) + Math.min(revText(r.body_html).length/400, 1) + ((r.pictures_urls||[]).length ? 1 : 0); if (s > bs){ bs = s; bi = i; } });
      if (bi > 0) c.list.unshift(c.list.splice(bi, 1)[0]);
    }
    if (!f && c.n){   /* r26b: the header button self-heals from the live numbers so the two counts can never disagree */
      RATINGS[h] = [+c.avg || RATINGS[h][0], c.n];
      const b = document.querySelector('.sd-stars');
      if (b && S.sel === h){ b.innerHTML = starsInner(RATINGS[h]); b.setAttribute('aria-label', `Rated ${RATINGS[h][0].toFixed(1)} out of 5 from ${RATINGS[h][1]} reviews. Show the reviews`); b.setAttribute('aria-expanded', $('sdrev') && !$('sdrev').hidden ? 'true' : 'false'); }
    }
    renderReviews(h);
  }catch(e){
    if (S.sel !== h) return;
    if (page === 1 || !REV_CACHE[k]){
      el.innerHTML = `<div class="rv-load" style="min-height:0">Reviews could not load right now.</div>
        <button type="button" class="rv-more" onclick="loadReviews('${h}',1)">Try again</button>`;
    } else {
      renderReviews(h);   /* r26b: a failed page-2 must not wipe the reviews already on screen */
      const rb = $('rv-more'); if (rb){ rb.disabled = false; rb.textContent = 'COULD NOT LOAD. TAP TO RETRY'; }
    }
  } finally { delete REV_INFLIGHT[k]; }
}
function renderReviews(h){
  if (S.sel !== h) return;   /* a slow fetch must not paint into another product's detail */
  const el = $('sdrev'), f = REV_FILTER[h] || 0, c = REV_CACHE[revKey(h)]; if (!el || !c) return;
  const openIds = Array.from(el.querySelectorAll('.rv-b:not(.clamp)')).map(p => p.id);   /* user-expanded reviews survive a Show More re-render */
  const hist = c.hist.map(x => `<button type="button" class="rv-hr" aria-pressed="${f === x.rating}"
      aria-label="Show only ${x.rating}-star reviews (${x.frequency})" onclick="revFilter('${h}',${x.rating})">
      <span class="lab">${x.rating}★</span><span class="trk"><span class="fill" style="width:${x.percentage||0}%"></span></span><span class="ct">${x.frequency}</span></button>`).join('');
  const cards = c.list.map((r, i) => {
    const txt = revText(r.body_html);
    const ttl = revText(r.title || ''), b40 = txt.toLowerCase().slice(0, 40);
    /* Judge.me auto-titles are the body's opening resnipped; printing both reads as a glitch */
    const showTitle = ttl && !(ttl.length > 40 && b40.length >= 20 && ttl.toLowerCase().includes(b40));
    const pics = (r.pictures_urls || []).map(pu => { const u = typeof pu === 'string' ? pu : (pu && (pu.compact || pu.small || pu.original || pu.huge)); const big = typeof pu === 'string' ? pu : (pu && (pu.huge || pu.original || pu.small || pu.compact)); /* 2026-07-28: esc() on both, matching every neighbouring review field. These are the only strings
   in the sheet that reached an HTML attribute raw, so a double quote in a Judge.me picture URL
   could close the attribute and inject others (onerror=) into the product sheet. */
return u ? `<img class="rv-ph" src="${esc(u)}" data-big="${esc(big)}" alt="Customer photo" loading="lazy" onclick="revPhoto(this.dataset.big)" role="button" tabindex="0" onkeydown="if(event.key==='Enter'){revPhoto(this.dataset.big)}">` : ''; }).join('');
    const rep = revText(r.reply_content);   /* r26b: AOAM answers nearly every review; that conversation is trust, show it folded */
    return `<div class="rv-card" id="rvc-${i}" tabindex="-1">
      <div class="rv-top">${revStars(r.rating)}${showTitle ? `<b class="rv-t">${esc(ttl)}</b>` : ''}</div>
      <div class="rv-meta">${esc(revName(r.reviewer_name))}${r.verified_buyer ? '<span class="rv-vb">✓ Verified buyer</span>' : ''}<span>${revDate(r.created_at)}</span></div>
      <p class="rv-b clamp" id="rvb-${i}">${esc(txt)}</p>
      <button type="button" class="rv-x" onclick="rvMore(this,'rvb-${i}')">More +</button>
      ${pics ? `<div class="rv-phs">${pics}</div>` : ''}
      ${rep ? `<div class="rv-rep"><button type="button" class="rv-rx" aria-expanded="false"
        onclick="const b=this.nextElementSibling;b.hidden=!b.hidden;this.setAttribute('aria-expanded',!b.hidden);this.classList.toggle('on',!b.hidden)">${esc(revText(r.shop_reply_name) || 'Ants on a Melon')} replied <span class="dn">▾</span></button><p class="rv-rb" hidden>${esc(rep)}</p></div>` : ''}
    </div>`;
  }).join('');
  el.innerHTML = `
    <div class="rv-head">
      <span class="rv-avg">${(+c.avg).toFixed(1)}</span>
      <span class="rv-agg">${revStars(+c.avg)}<span class="rv-n">${c.n} reviews</span></span>
      <div class="rv-hist">${hist}</div>
    </div>
    ${f ? `<button type="button" class="rv-clear" onclick="revFilter('${h}',0)">Showing ${f}-star reviews only · ✕ Clear</button>` : ''}
    ${c.list.length ? '' : `<div class="rv-load" style="min-height:0">No ${f ? f + '-star ' : ''}reviews yet.</div>`}
    ${cards}
    ${c.page < c.pages ? `<button type="button" class="rv-more" id="rv-more" onclick="loadReviews('${h}',${c.page+1})">Show more reviews</button>` : ''}
    <button type="button" class="rv-x rv-hide" onclick="hideReviews('${h}')">Hide reviews −</button>
    <span class="rv-src">Verified reviews via Judge.me</span>`;
  openIds.forEach(id => { const p = $(id); if (p){ p.classList.remove('clamp'); const x = p.nextElementSibling; if (x && x.classList.contains('rv-x')) x.textContent = 'Less −'; } });
  requestAnimationFrame(() => {   /* r26b: More buttons by MEASUREMENT, not character count — no dead toggles, no unreachable text */
    el.querySelectorAll('.rv-b.clamp').forEach(p => {
      const x = p.nextElementSibling;
      if (x && x.classList.contains('rv-x') && p.scrollHeight <= p.clientHeight + 1) x.hidden = true;
    });
    if (c.focusIdx != null){ const t = $('rvc-' + c.focusIdx); if (t) t.focus(); c.focusIdx = null; }
  });
}
function rvMore(btn, id){ const b = $(id); if (!b) return; const open = !b.classList.toggle('clamp'); btn.textContent = open ? 'Less −' : 'More +'; }
function revPhoto(u){
  if (!u) return;
  let o = $('revlb');
  if (!o){
    o = document.createElement('div'); o.id = 'revlb'; o.className = 'rv-lb';
    o.onclick = () => { o.hidden = true; };
    o.innerHTML = '<img alt="Customer photo, full size">';
    document.body.appendChild(o);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !o.hidden){ o.hidden = true; e.stopPropagation(); } }, true);
  }
  o.querySelector('img').src = u; o.hidden = false;
}
const UPSELL_FALLBACK = ['rgb-critter-18650-battery','rgb-critter-travel-case','modular-cap',
  'bitwhip-travel-case','critter-connector-flow-arts-staffs-double-sided-light-whips',
  'light-painting-blade-holder','small-tube-holder-light-painting','t8-tube-holder-light-painting-tool']; /* 7-20 (Joel): battery-door removed - never upsell it */
function pillsHTML(h){
  const ax = axes(h);
  if (!ax) return '';
  if (!S.ax[h]) S.ax[h] = defaultSel(h) || [];
  return `<div class="sd-variants" id="sd-variants">${ax.map((a,i)=>`
    <div class="sd-axis">
      <div class="sd-axlabel">Choose <b>${esc(a.name)}</b></div>
      <div class="sd-pills">${a.vals.map(val=>{
        const sel = S.ax[h][i]===val;
        const test = S.ax[h].slice(); test[i]=val;
        const tvi = findVar(h,test);
        const avail = tvi>=0 && P(h).vars[tvi] && P(h).vars[tvi].a;
        const note = noteForVar(h, tvi>=0?P(h).vars[tvi]:null, val);
        /* r6 (Joel): "i" buttons removed — the note rides the pill itself as a hover/focus tooltip */
        return `<button class="sd-pill ${sel?'on':''} ${avail?'':'un'}" data-v="${esc(val)}"${note?` data-note="${esc(note)}"`:''} aria-label="${esc(val)}${avail?'':'. Sold out'}${note?'. '+esc(note):''}" onclick="setAxis('${h}',${i},this.dataset.v)">${esc(val)}</button>`;
      }).join('')}</div>
    </div>`).join('')}
    ${variantNote(h)?`<div class="sd-varnote"><span class="vn-i">i</span><span>${esc(variantNote(h))}</span></div>`:''}
    ${selVi(h)>=0 && P(h).vars[selVi(h)] && !P(h).vars[selVi(h)].a ? `<div class="sd-oos">SOLD OUT · this combo is out of stock${isKit(h) && P(CRITTER).vars[0].a ? ` · <button class="oos-alt" onclick="openStage(CRITTER)">the light alone is in stock · ${money(P(CRITTER).vars[0].p)} →</button>` : ''}</div>` : ''}</div>`;
}
function setAxis(h,i,v){
  if(!S.ax[h]) S.ax[h]=defaultSel(h)||[];
  S.ax[h][i]=v; sdSync(); renderHub();
  /* r6: picking a variant swings the gallery to that variant's photo when we have one */
  const vv = P(h).vars[selVi(h)];
  if (vv && vv.img){ const idx = sdM.findIndex(m=>m.type==='i'&&MBASE(m.src)===MBASE(vv.img)); if (idx>=0) sdSwap(idx); }
}
function upsellHTML(h){
  if (!SHEET_UPSELL_ON) return '';   /* r44 (Joel: "remove this upsell") — single kill point for the sheet's .ucard list. Every consumer (stageDetailHTML, the two post-add re-render timers, sdSync) reads through here and is null-guarded, so this alone makes it inert. */
  const p = P(h);
  let incentive = '';
  if (BONUS_ON){ /* 10% bundle banner hidden for now (Joel r4) — flip BONUS_ON to restore */
    const gc = gearCount(), left = Math.max(0, BONUS_N - gc);
    const unlocked = gc >= BONUS_N;
    const segs = Array.from({length:BONUS_N},(_,i)=>`<span class="inc-seg ${i<Math.min(gc,BONUS_N)?'lit':''}"></span>`).join('');
    let head, sub;
    if (unlocked){ head='10% OFF ALL GEAR: UNLOCKED'; sub='Every gear item in your kit is now 10% off. See the savings in your kit total.'; }
    else if (left===1){ head='1 MORE ITEM UNLOCKS 10% OFF'; sub="You're one gear item away. The discount applies to ALL gear, not just the new item."; }
    else { head=`BUNDLE ANY ${BONUS_N}, SAVE 10%`; sub=`Add any ${BONUS_N} gear items and 10% comes off every gear item in your kit.`; }
    incentive = `<div class="incentive ${unlocked?'on':''}">
      <div class="inc-row1"><span class="inc-head">${head}</span><span class="inc-counter">${Math.min(gc,BONUS_N)} / ${BONUS_N}</span></div>
      <div class="inc-sub">${sub}</div>
      <div class="inc-bar">${segs}</div>
    </div>`;
  }
  const pool = UPSELL_MAP[p.sub] || UPSELL_MAP.core || [];
  const okPick = g => DATA[g] && g!==h && (g===upJustAdded || !S.cart.some(l=>l.h===g));
  const picks = pool.filter(okPick);
  for (const g of UPSELL_FALLBACK){ if (picks.length>=3) break; if (okPick(g) && !picks.includes(g)) picks.push(g); }
  picks.length = Math.min(picks.length, 3);
  const cards = picks.map(g=>{
    const gp = P(g), gmin = minPrice(g), gmax = Math.max(...gp.vars.map(v=>v.p)), multi = gp.vars.length>1;
    const act = g===upJustAdded
      ? `<button class="uadd done" disabled aria-label="${esc(gp.title)} added to kit">✓ Added</button>`
      : multi
      ? `<button class="uadd" data-g="${g}" aria-expanded="false" aria-label="Choose an option for ${esc(gp.title)}" onclick="upOptions('${g}', this)">Options</button>`
      : `<button class="uadd" data-g="${g}" aria-label="Add ${esc(gp.title)} to kit" onclick="upAdd('${g}', this)">+ Add</button>`;
    return `<div class="ucard">
      <div class="uthumb"><img src="${CDN(gp.imgs[0],130)}" alt=""></div>
      <div class="ubody"><div class="utitle">${esc(gp.title)}</div>${UPSELL_WHY[g]?`<div class="uwhy">${UPSELL_WHY[g]}</div>`:''}<div class="uprice">${gmin===gmax?money(gmin):money(gmin)+'+'}</div></div>
      <div>${act}</div>
      ${multi?`<div class="uopts" id="uopts-${g}" hidden></div>`:''}
    </div>`;
  }).join('');
  return `<div class="upsell" id="sd-upsell">
    ${incentive}
    <div class="upsell-head"><h4>Complete Your Kit</h4></div>
    ${cards}
  </div>`;
}
/* one-line 'why' per upsell handle — fills the dead middle of the card (Joel: 'i dont like these gaps') */
const UPSELL_WHY = {
  'rgb-critter-18650-battery':'Spare cell: swap in seconds, glow all night',
  'battery-door':'Spare door so a lost cap never ends the night',
  'rgb-critter-travel-case':'Padded case sized for the Critter + tools',
  'bitwhip-travel-case':'Padded case sized for the whip + light',
  'rgb-critter-silicone-shell':'Grip and drop protection for the Critter',
  'usb-charging-cable':'Charges the Critter from any USB port',
  'light-painting-blade-holder':'The mount every acrylic blade snaps into',
  'modular-cap':'Caps the modular thread when nothing is mounted',
  'o-ring':'Keeps the housing seal tight',
};
/* just-added upsell: renderAll replaces the upsell block, so ✓ state must survive the re-render */
let upJustAdded = null, upJustT;
function upAdd(g, btn){
  const avi = P(g).vars.findIndex(v=>v.a);
  if (avi < 0){ addItem(g, null, 1, btn); return; }   /* sold out: addItem handles the toast */
  upJustAdded = g;
  clearTimeout(upJustT);
  addItem(g, avi, 1, btn);
  upJustT = setTimeout(()=>{ upJustAdded = null;
    const up = $('sd-upsell'); if (up && S.sel) up.outerHTML = upsellHTML(S.sel); }, 1600);
}
/* multi-variant upsell: options expand INSIDE the card — never clobber the product being viewed (Joel) */
function upOptions(g, btn){
  const el = document.getElementById('uopts-'+g); if (!el) return;
  if (el.hidden){
    const gp = P(g), diff = new Set(gp.vars.map(v=>v.p)).size > 1;
    el.innerHTML = gp.vars.map((v,i)=>
      `<button class="uopt ${v.a?'':'un'}" aria-label="${esc(v.t)}${v.a?'':'. Sold out'}" onclick="upPick('${g}',${i},this)">${esc(v.t)}${diff?`<small>${money(v.p)}</small>`:''}</button>`).join('');
    el.hidden = false; btn.setAttribute('aria-expanded','true');
  } else { el.hidden = true; btn.setAttribute('aria-expanded','false'); }
}
function upPick(g, vi, btn){
  upJustAdded = g;
  clearTimeout(upJustT);
  addItem(g, vi, 1, btn);
  upJustT = setTimeout(()=>{ upJustAdded = null;
    const up = $('sd-upsell'); if (up && S.sel) up.outerHTML = upsellHTML(S.sel); }, 1600);
}
/* ---- double-Critter story: 2 lights + connector = double-sided staff / double BitWhip / jump rope.
   The strongest second-light upsell in the catalog (Joel) — shown on the Critter and both connectors. ---- */
const CONN = 'critter-connector-flow-arts-staffs-double-sided-light-whips';
const CONN_INV = 'inverse-critter-connector-dual-rgb-critters-modular-sabers';
function dblHTML(h){
  if (h !== CRITTER && h !== CONN && h !== CONN_INV) return '';
  const conn = h === CONN_INV ? CONN_INV : CONN;
  const cp = P(conn), crit = P(CRITTER);
  if (!cp || !crit) return '';
  const total = 2*crit.vars[0].p + cp.vars[0].p;
  const story = conn === CONN_INV
    ? 'The Inverse Connector joins two Critters face to face: the core of modular sabers and double-sided builds.'
    : 'The Critter Connector joins two Critters back to back: instant double-sided staff, double BitWhip, or jump rope core.';
  return `<div class="dbl">
    <div class="dbl-t">RUN <b>TWO</b>, BACK TO BACK</div>
    <div class="dbl-strip">
      <span class="dth"><img src="${CDN(crit.imgs[0],120)}" alt="RGB Critter BT"></span><span class="dplus">+</span>
      <span class="dth"><img src="${CDN(cp.imgs[0],120)}" alt="${esc(cp.title)}"></span><span class="dplus">+</span>
      <span class="dth"><img src="${CDN(crit.imgs[0],120)}" alt="RGB Critter BT"></span>
      <span class="deq">= DOUBLE-SIDED</span>
    </div>
    <div class="dbl-sub">${story} A second light also unlocks <b style="color:var(--lime)">Lifetime Warranty X2</b>.</div>
    <button class="dbl-add" onclick="dblAdd('${conn}', this)">ADD 2 CRITTERS + CONNECTOR · ${money(total)}</button>
  </div>`;
}
function dblAdd(conn, btn){
  const avi = P(conn).vars.findIndex(v=>v.a);
  /* 2026-07-28: this flipped to the ADDED state unconditionally. With the connector sold out,
     addItem hits its sold-out early return and adds nothing, so two Critters landed in the kit,
     the connector did not, the toast said "Sold out" while the button said everything was in, and
     the buyer could check out an unusable double-sided build. Check first, and say so instead. */
  if (avi < 0){
    const b0 = document.querySelector('.dbl-add');
    if (b0){ b0.textContent = P(conn).title.toUpperCase() + ' IS SOLD OUT'; b0.classList.add('disabled'); b0.style.pointerEvents = 'none'; }   /* textContent, so no esc() (it would double-escape an & in a title) */
    toast(P(conn).title + ' is sold out, so the double-sided build cannot be completed yet');
    return;
  }
  addItem(CRITTER, null, 2, btn);
  addItem(conn, avi, 1, btn);
  const b = document.querySelector('.dbl-add');
  if (b){ b.classList.add('done'); b.textContent = 'ADDED · DOUBLE-SIDED CORE IN YOUR KIT ✓'; b.style.pointerEvents = 'none'; }
}
/* per-variant notes. FACTUAL families (blade-only vs bundle, inch length ladder, USB model) plus the
   fiber-type + fiber-count families, now baked in. End Glow vs Sparkle definition CONFIRMED against the
   live BitWhip page (antsonamelon.com/products/bitwhip-fiber-optic-whip-prop) 2026-07-09:
   End Glow = bright glow at the fiber TIPS, most durable; Sparkle = twinkle along the WHOLE fiber, more delicate. */
const LEN_NOTE = {8:'Shortest size. Compact, lightweight, easiest to control. Great for tight trails and travel.',
  12:'Short-medium length, a versatile everyday size that stays easy to handle.',
  17:'Medium length, more trail and reach while still comfortable to spin.',
  24:'Long size for bigger, bolder light trails. Needs a bit more room.',
  30:'Extra-long for sweeping, dramatic trails. Best with open space around you.',
  36:'Longest size, maximum reach and boldest trails. For experienced, high-impact flow.'};
/* fiber type + count. Count copy is bucketed (not hardcoded to 140/200/300) so 195/360/500 read correctly too. */
function fiberNote(q){
  if (/end\s*glow/i.test(q)) return 'Bright, focused glow at the fiber tips: the cleaner, classic light-whip look, and the most durable choice for regular use.';
  if (/sparkle/i.test(q))    return 'Tiny twinkling lights shimmer along the whole length of the fibers for a star-like, magical texture. More delicate than End Glow, so handle with a little more care.';
  const fm = q.match(/(\d{2,3})\s*Fiber/i);
  if (fm){ const n = +fm[1];
    if (n <= 150) return 'Our lightest fiber count: easiest to handle, with more defined individual strands of light. A great first whip.';
    if (n <= 250) return 'A balanced, fuller density: noticeably brighter than the lowest count without much added weight. The popular middle choice.';
    return 'Our densest, brightest option: the fullest wall of light and the most dramatic look. A touch heavier to spin.';
  }
  return '';
}
/* note for a resolved variant object v of product h. `hint` (the exact option pill the shopper clicked)
   is preferred over the full variant title so a multi-axis variant describes the RIGHT axis. */
function noteForVar(h, v, hint){
  if (!v) return '';
  const tt = (v.t||'');
  const q = (hint != null ? String(hint) : tt);
  if (P(h).sub === 'blades'){
    if (/bundle|holder/i.test(q)) return 'Includes the Blade Holder to attach it to your Critter. Best value and the right first-time choice.';
    if (/blade only|only/i.test(q)) return 'Just the acrylic blade. Pick this if you already own a Blade Holder to mount it.';
  }
  if (h === 'usb-charging-cable'){
    if (/usb-c/i.test(q)) return 'USB-C cable for the RGB Critter BT. Pick this if you have the BT model.';
    if (/micro/i.test(q)) return 'Micro-USB cable for the original Critter 1.0 and 2.0 flashlights.';
  }
  const fn = fiberNote(q);
  if (fn) return fn;
  const lm = q.match(/(\d+)\s*Inch/i);
  if (lm && LEN_NOTE[+lm[1]]) return LEN_NOTE[+lm[1]];
  return '';
}
/* note for the currently-selected variant (the inline sd-varnote strip) */
function variantNote(h){ return noteForVar(h, P(h).vars[selVi(h)]); }
/* (r9: the dead per-variant info popup subsystem from the pre-r6 "i" buttons was removed — notes ride the pills) */
/* r27 pill-note tooltip: one FIXED body-level #ptip element (the old per-pill ::after was clipped by the
   .sd-scroll overflow — Joel's screenshot had "Bright, focused" sliced clean off the END GLOW note).
   Hover + keyboard focus only; touch keeps the inline .sd-varnote. Clamped to the viewport with an 8px
   margin, flips below the pill when there is no room above. Hides on click/scroll/resize/blur. */
let ptipFor = null;
function ptipEl(){
  let t = $('ptip');
  if (!t){ t = document.createElement('div'); t.id = 'ptip'; t.className = 'ptip';
    t.setAttribute('role','tooltip'); document.body.appendChild(t); }
  return t;
}
function ptipShow(pill){
  const note = pill.dataset.note; if (!note) return;
  const t = ptipEl();
  t.textContent = note;
  t.style.left = '0px'; t.style.top = '-9999px';   /* park it so the width measures unclamped */
  const w = t.offsetWidth, h = t.offsetHeight, r = pill.getBoundingClientRect();
  const x = Math.max(8, Math.min(r.left + r.width/2 - w/2, innerWidth - w - 8));
  const y = r.top - h - 9 >= 8 ? r.top - h - 9 : r.bottom + 9;
  t.style.left = Math.round(x) + 'px'; t.style.top = Math.round(y) + 'px';
  t.classList.add('on');
  pill.setAttribute('aria-describedby','ptip');
  ptipFor = pill;
}
function ptipHide(){
  const t = $('ptip'); if (t) t.classList.remove('on');
  if (ptipFor) ptipFor.removeAttribute('aria-describedby');
  ptipFor = null;
}
if (matchMedia('(hover:hover)').matches){
  document.addEventListener('mouseover', e => {
    const p = e.target.closest ? e.target.closest('.sd-pill[data-note]') : null;
    if (p){ if (p !== ptipFor) ptipShow(p); } else if (ptipFor) ptipHide();
  });
  document.addEventListener('mouseleave', () => { if (ptipFor) ptipHide(); });
}
document.addEventListener('focusin', e => {
  const p = e.target.closest ? e.target.closest('.sd-pill[data-note]') : null;
  if (p && p.matches(':focus-visible')) ptipShow(p); else if (ptipFor) ptipHide();
});
document.addEventListener('click', () => { if (ptipFor) ptipHide(); });
/* scrolling: follow the pill (hiding here raced the browser's own hover scroll-into-view and killed the tip);
   hide only once the pill has left the viewport or the DOM (detail re-render) */
addEventListener('scroll', () => {
  if (!ptipFor) return;
  if (!ptipFor.isConnected) return ptipHide();
  const r = ptipFor.getBoundingClientRect();
  if (r.bottom < 0 || r.top > innerHeight) return ptipHide();
  ptipShow(ptipFor);
}, true);
addEventListener('resize', () => { if (ptipFor) ptipHide(); });
/* warranty "?" details — EXACT clone of the live site's protection popup (r6, measured 2026-07-09):
   heading / sub / desc / 4 icon cards / GOT IT!, copy verbatim, icons from the site CDN */
function openWarrInfo(){
  if ($('warrpop').hidden) history.pushState({layer:'warrpop'}, '');
  $('warrpop').hidden = false;
  /* 2026-09-15 (Joel, iPhone): a plain focus() scrolled the box down to GOT IT, so the popup opened
     with its title cut off above. Open at the top and focus without scrolling. */
  const box = $('warrpop').querySelector('.pp-box'); if (box) box.scrollTop = 0;
  $('warrpop').querySelector('.pp-gotit').focus({preventScroll:true});
}
function closeWarrPop(){ $('warrpop').hidden = true; }
/* shared warranty block — byte-matched to the LIVE cart drawer's section (structure, ? icon, copy, toggle) */
/* r27 (critique W3): the 16px "?" now rides inside a 44px button — its old miss zone included the $ toggle */
/* r28 (Joel): warranty scope = "Covers your entire order" EVERYWHERE — the one true statement, matches the ? popup */
const WARR_Q_SVG = `<button type="button" class="warrq" onclick="event.stopPropagation();openWarrInfo()" aria-label="Warranty details"><svg class="warranty_svg_icon" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.35" fill="currentColor" fill-opacity=".16" stroke="currentColor" stroke-width="1.3"/><path d="M6.1 6.04a1.96 1.96 0 0 1 3.81.65c0 1.31-1.9 1.59-1.9 2.71" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="11.75" r="1" fill="currentColor"/></svg></button>`;
/* the whole row extends the manual click target; it mirrors a real click. As of 2026-08-11 the warranty DOES arm on render, when the kit holds a light and the shopper has not declined (see aoamWarrDeclined and the arm in renderAll) — the ? popup and the native switch keep their own handlers */
/* 2026-08-11 - Joel: "not all areas of the site have the warranty automatically added". The main
   site is opt-OUT: snippets/aoam-cart-fix.liquid warrantyInit() auto-adds the warranty for any
   eligible cart unless localStorage warranty_toogle_is_disable_by_user === 'true'. That snippet is
   rendered by snippets/head-scripts.liquid, which ONLY layout/theme.liquid renders - the Kit Builder
   has its own layout, so none of it exists on this page (verified live 2026-08-11: /pages/kit-builder
   contains no __aoamCartFix, no update_protection_products, no warranty_toogle_is_disable_by_user)
   and this builder stayed opt-IN. These two helpers plus the arm in renderAll close that gap.
   aoamWarrDeclined reads BOTH records: the site's own opt-out key, so a decline made anywhere on the
   store is honoured here, and a Kit-Builder-private one.
   aoamWarrSet writes ONLY the private key, deliberately. Writing the site key would make a Kit
   Builder toggle resize existing _protection_product lines to 0 on the shopper's next main-site
   visit (aoam-cart-fix aoamSyncWarranty, the warrantyOff branch resizes every existing warranty line
   whenever that flag is 'true'), which is a cart mutation this builder should not own.
   ORDER IS LOAD-BEARING in aoamWarrSet: the localStorage write happens BEFORE renderAll(), or the
   arm in renderAll re-checks the box the shopper just unchecked.
   Rollback: delete both functions, restore `S.warranty = cb.checked;` below and
   `onchange="aoamWarrSet(this.checked)${extra}"` in warrBlockHTML, and delete
   the arm line in renderAll. */
function aoamWarrDeclined(){
  try{
    if (localStorage.getItem('warranty_toogle_is_disable_by_user') === 'true') return true;
    return localStorage.getItem('aoam-kb-warr-declined') === '1';
  }catch(e){ return false; }
}
function aoamWarrSet(v){
  S.warranty = !!v;
  try{ localStorage.setItem('aoam-kb-warr-declined', v ? '0' : '1'); }catch(e){}
  renderAll(); persist();
}
function warrRowToggle(row, e){
  if (e.target.closest('.warrq, .prot_pro_switch')) return;
  const cb = row.querySelector('.prot_pro_switch input');
  if (!cb) return;
  cb.checked = !cb.checked;
  aoamWarrSet(cb.checked);
}
function warrBlockHTML(lt, wp, inDrawer){
  const extra = '';   /* r9: renderAll already refreshes an open drawer — the old ;renderDrawer() extra double-rendered it */
  /* 2026-07-31 warranty QA (defect 14, display half): the order already carries the site/app's own
     warranty line(s). Show THAT charge as the row - checked, switch disabled, its real price -
     instead of an unchecked "Add for $39.95" inviting a second, differently-tiered opt-in on top.
     Rollback: restore S.warranty for `on`, wp.vars[0].p for `price`, drop the `app` branches here,
     the two (lt>0 || KB_APPWARR>0) render gates, and the appWarrCents block in kbCartSync. */
  /* 2026-08-15: `app` used to be `KB_APPWARR > 0` alone, so ONE site-added warranty unit locked the
     row into "Already on this order", disabled the switch and froze the price at that unit's cost no
     matter how many lights the builder went on to hold. It is now only the fully-covered case: the
     coverage already in the cart meets or exceeds what this rig needs. When the rig needs MORE, the
     row goes back to being a normal, togglable row showing the full amount - which is the number
     checkout charges. Same max() as calc(); the two must never disagree.
     TO ROLL BACK: restore `const app = KB_APPWARR > 0;` and `price = app ? KB_APPWARR : warrTotalCost()`. */
  /* 2026-08-18: `need` is what this rig's cover COSTS, and it is deliberately toggle-INDEPENDENT.
     Folding S.warranty in here zeroed the price on an unchecked row ("Add for $0.00") and made
     `app` below true for any existing cover. See the block note added with this change. */
  const need = (lt > 0) ? warrTotalCost() : 0;
  /* 2026-08-15: read ONCE into a local, so `app` and `price` can never disagree about which
     number they are looking at. See kbAppWarrComparable for why this is not KB_APPWARR. */
  const appWarr = kbAppWarrComparable();
  const app = appWarr > 0 && need <= appWarr;
  const on = app || S.warranty;
  const price = Math.max(need, appWarr);   /* 2026-08-13: per-kit-bucket, matches what checkout actually charges */
  /* 2026-08-18 - Joel: "the kit builder needs to identically match the main site cart".
     This now emits the SAME DOM as snippets/extended-warranty-cartLevel.liquid, wrapper for wrapper,
     because the site's one-line row is built entirely out of those wrappers: widget-minicart.css
     around 1892-1930 sets display:contents on .block-image / .block-content / .block-action and then
     orders .warranty-text (1), label.prot_pro_switch (2) and .protection_total_price_wrapper (3) onto
     a single flex line, and hides .block-details__price.protection_description outright.
     The KB was still rendering the pre-2026-08-16 two-row shape (label+price, then caption+toggle),
     which on a phone is ~45px taller than the site and puts the toggle and the amount on different
     lines. None of those site rules could reach here before, for want of the wrappers AND of the
     .site-header__drawers-container ancestor now added in templates/page.kit-builder.liquid.
     Keeping .protection_description in the DOM rather than deleting it matches the site, whose own
     comment says theme.js writes to it on every cart update; here it is simply never painted.
     ROLLBACK: git, or restore the four-line block this replaced (label+price row, then caption+switch
     row) and put back the .warrq / .protection_* rules deleted from kit-builder.css in the same push. */
  return `<div class="block-extended__warranty custom ${on?'checked':''}"${app?'':' onclick="warrRowToggle(this,event)"'}>
    <div class="block-warranty">
      <div class="block-image">
        <div class="block-content">
          <p class="h5 warranty-text"><span class="warranty_title">${app?'Lifetime Warranty Added':'Lifetime Warranty'+(lt>=2?' X2':'')}</span>${WARR_Q_SVG}</p>
          <div class="protection_total_price_wrapper">${on?'':'<span class="label-add-for">Add for</span>'}<div class="protection_total_price">${money(price)}</div></div>
        </div>
      </div>
      <div class="block-action">
        <div class="block-details__price protection_description">${app?'Already on this order. Manage it at checkout.':'Covers your entire order. Tap ? for details.'}</div>
        <label class="prot_pro_switch"><input type="checkbox" class="protection_product_checkbox" ${on?'checked':''} ${app?'disabled':''} aria-label="Toggle Lifetime Warranty Protection" onchange="aoamWarrSet(this.checked)${extra}"><span class="prot_pro_slider"></span></label>
      </div>
    </div>
  </div>`;
}
const SD_CLOSE = `<button class="sd-close" onclick="closeStageUI(true)" aria-label="Close preview">✕</button>`;
const MBASE = u => u ? u.split('/').pop().split('?')[0] : '';   /* CDN filename key — same image regardless of ?width */
/* r27 (critique W4): 84 of 101 DATA descs were hard-capped mid-word ("…so a dead b…") and mobile
   shows them unclamped — trim to the last complete sentence at render time. Descs without the
   amputation ellipsis pass through untouched; with no real sentence to land on, keep the original.
   Follow-up for the theme port: re-export descs with a sentence-boundary cut instead of a char cap. */
function descClean(d){
  if (!d || !/…\s*$/.test(d)) return d || '';
  const t = d.replace(/\s*\S*…\s*$/, '');
  const m = t.match(/[\s\S]*[.!?](?=\s|$)/);   /* last sentence end NOT inside a number like $129.95 */
  return m && m[0].length > 40 ? m[0] : d;
}
/* r42: the sd-ship line goes free at the $99 threshold (SHIP_FREE), keyed off the CURRENTLY DISPLAYED
   variant's price. Under $99 keeps the original line verbatim. FREE wears the existing <b> lime. */
function shipLineHTML(price){
  return price >= SHIP_FREE && IS_US   /* 2026-08-15: US only, see the KB_GEO block by SHIP_FREE */
    ? 'Ships <b>FREE</b> (US) from Oregon within 2 business days'
    : 'Ships from Oregon within <b>2 business days</b>';
}
function stageDetailHTML(h){
  const p = P(h);
  const vids = p.vids && p.vids.length ? p.vids : [];
  const fam = !vids.length && FAMVID[p.sub] && FAMVID[p.sub].src ? FAMVID[p.sub] : null;
  const media = [];
  vids.forEach(v => media.push({type:'v', src:v, poster:p.imgs[0]}));
  if (fam) media.push({type:'v', src:fam.src, poster:p.imgs[0]});
  p.imgs.forEach(i => media.push({type:'i', src:i}));
  /* r6: variant photos that aren't already product images get their own slides,
     so selecting a variant can always swing the gallery to its photo */
  const seenI = new Set(media.filter(m=>m.type==='i').map(m=>MBASE(m.src)));
  p.vars.forEach(v => { if (v.img && !seenI.has(MBASE(v.img))){ media.push({type:'i', src:v.img}); seenI.add(MBASE(v.img)); } });
  sdM = media.slice(0,10); sdIdx = 0;
  const N = sdM.length;
  const vi = selVi(h), v = vi>=0 ? p.vars[vi] : null, canAdd = !!(v && v.a);
  const anyA = p.vars.some(x=>x.a);
  const overline = badgeText(h, vi);
  const thumbs = N>1 ? `<div class="sd-thumbs">${sdM.map((m,i)=>`
    <button class="sd-th ${i===0?'on':''}" onclick="sdSwap(${i})" aria-label="View media ${i+1}">
      <img src="${CDN(m.type==='i'?m.src:(p.imgs[0]||''),160)}" alt="">
      ${m.type==='v'?'<span class="pv">▶</span>':''}
    </button>`).join('')}</div>` : '';
  const nl = requiresLight(h) && lightsInCart()===0
    ? `<div class="needslight">Runs on the <b>RGB Critter BT</b> (${money(minPrice(CRITTER))}). Buy the light once: every tool here snaps onto it and reuses it.</div>` : '';
  /* 2026-08-08: see sdShowBackToBuilder. Rendered up front when this product is already in the kit,
     so reopening it does not lose the exit the add earned. Mobile only - desktop auto-closes. */
  const inKit = isMobile() && S.cart.some(l => l.h === h);
  const primBtn = canAdd
    ? `<button class="btn btn-p" id="sd-add" onclick="sdAdd(this)">ADD TO CART · ${money(v.p)}</button>`
    : `<button class="btn btn-s" id="sd-add" onclick="notifyMe('${h}')">NOTIFY ME${anyA?' · THIS COMBO':''}</button>`;
  /* r9: on mobile the sticky footer is visible before the pills — show WHICH combo the button adds */
  const cursel = axes(h) && S.ax[h] ? `<button class="sd-cursel" onclick="sdGoPills()">${esc(S.ax[h].join(' · '))}</button>` : '';
  return `
    <div class="sd-scroll" onscroll="sdScrollFade(this)">
      <div class="sd-railwrap" id="sd-railwrap">
        <div class="sd-rail" id="sd-rail" onscroll="sdOnScroll()">
          ${N>1?`<div class="sd-slide clone" data-jump="${N-1}" aria-hidden="true">${cloneHTML(sdM[N-1],p)}</div>`:''}
          ${sdM.map((m,i)=>`<div class="sd-slide${i===0?' cur':''}">${mediaHTML(m,i===0)}</div>`).join('')}
          ${N>1?`<div class="sd-slide clone" data-jump="0" aria-hidden="true">${cloneHTML(sdM[0],p)}</div>`:''}
        </div>
        ${N>1?`<button class="sd-nav prev" onclick="sdSwap(sdIdx-1)" aria-label="Previous media">‹</button>
        <button class="sd-nav next" onclick="sdSwap(sdIdx+1)" aria-label="Next media">›</button>`:''}
        ${SD_CLOSE}
      </div>
      ${thumbs}
      <div class="sd-info">
        <span class="sd-ol">${esc(overline)}${olType(p)}</span>
        <h3>${esc(p.title)}</h3>
        ${starsHTML(h)}
        <div class="sd-priceline"><span class="money" id="sd-price" style="${canAdd?'':'color:var(--ink3)'}">${v?money(v.p):money(minPrice(h))}</span>${sdSaveHTML(h)}</div>
        <div class="sd-ship" id="sd-ship">${shipLineHTML(v?v.p:minPrice(h))}</div>
        ${usdNoteHTML()}
      </div>
      ${wikHTML(h)}
      <p class="sd-desc" id="sd-desc">${esc(descClean(p.desc))}</p>
      <button class="sd-more" id="sd-more" hidden onclick="sdMore()">More +</button>
      ${(p.sub==='saber'&&SABER_URL) ? `<a class="sabersheet" href="${SABER_URL}" aria-label="Open the Saber Lab, leaves the Kit Builder">Want it your way? Design your own in the Saber Lab ${EXT_ARROW}</a>` : ''}
      ${pillsHTML(h)}
      <a class="pdp" href="https://antsonamelon.com/products/${h}" target="_blank" rel="noopener">View full product page ${EXT_ARROW}</a>
      ${nl}
      <div class="sd-rev" id="sdrev" hidden aria-live="polite"></div>
      ${dblHTML(h)}
      ${upsellHTML(h)}
    </div>
    <div class="sd-foot">
      ${inKit ? BACK_BTN : ''}
      ${cursel}
      ${primBtn}
    </div>`;
}
function sdGoPills(){ const el = document.querySelector('.sd-axlabel'); if (el) el.scrollIntoView({behavior:'smooth', block:'center'}); }
function sdMore(){ const d = $('sd-desc'); const open = d.classList.toggle('open'); $('sd-more').textContent = open ? 'Less −' : 'More +'; }
/* r9: show the More toggle only when the 2-line clamp actually cut something off */
function sdDescCheck(){ const d = $('sd-desc'), m = $('sd-more'); if (d && m) m.hidden = d.scrollHeight <= d.clientHeight + 1; }
/* rail carousel (r4): thumbs + arrows scroll the rail; swiping the rail syncs back. Only the active slide's video plays. */
/* r14 (Joel): the rail is a LOOP — a slide peeks on BOTH sides at every position, including slide 1. Image clones of the
   last/first media bookend the rail; settling on a clone instantly re-centers its real slide (identical pixels, seamless). */
function cloneHTML(m, p){ const src = m.type==='i' ? m.src : (m.poster || p.imgs[0] || ''); return `<img src="${CDN(src,500)}" alt="" loading="lazy">`; }
function sdRealChildren(rail){ return Array.from(rail.children).filter(c=>!c.classList.contains('clone')); }
function sdCenter(rail, el, smooth){ rail.scrollTo({left: el.offsetLeft - (rail.clientWidth - el.offsetWidth)/2, behavior: smooth?'smooth':'auto'}); }
function sdInitRail(){ const rail = $('sd-rail'); if (!rail) return; const real = sdRealChildren(rail); if (real.length) sdCenter(rail, real[0], false); }
function sdSwap(idx){
  const rail = $('sd-rail'); if (!rail) return;
  const N = sdM.length, loop = N>1;
  if (loop && idx === -1){ sdCenter(rail, rail.children[0], true); return; }                            /* left clone; scroll-settle jumps to the real last slide */
  if (loop && idx === N){ sdCenter(rail, rail.children[rail.children.length-1], true); return; }        /* right clone; scroll-settle jumps to the real first slide */
  if (idx<0 || idx>=N || idx===sdIdx) return;
  sdCenter(rail, sdRealChildren(rail)[idx], true);
  sdSet(idx);
}
function sdSet(idx){
  sdIdx = idx;
  document.querySelectorAll('.sd-th').forEach((t,i)=>t.classList.toggle('on', i===sdIdx));
  const rail = $('sd-rail');
  if (rail) sdRealChildren(rail).forEach((sl,i)=>{
    sl.classList.toggle('cur', i===sdIdx);   /* r9: peeking neighbors dim — white studio shots stopped outshining the CTA */
    const v = sl.querySelector('video'); if (!v) return;
    if (i===sdIdx) v.play().catch(()=>{}); else v.pause();
  });
}
let sdScrollT = null;
function sdOnScroll(){
  clearTimeout(sdScrollT);
  sdScrollT = setTimeout(()=>{
    const rail = $('sd-rail'); if (!rail) return;
    const mid = rail.scrollLeft + rail.clientWidth/2;
    let best = null, bd = Infinity;
    Array.from(rail.children).forEach(sl=>{ const c = sl.offsetLeft + sl.offsetWidth/2, d = Math.abs(c-mid); if (d<bd){ bd=d; best=sl; } });
    if (!best) return;
    if (best.classList.contains('clone')){
      const real = sdRealChildren(rail)[+best.dataset.jump];
      sdCenter(rail, real, false);   /* instant offscreen jump: the clone and its real slide render identically */
      sdSet(+best.dataset.jump);
      return;
    }
    const i = sdRealChildren(rail).indexOf(best);
    if (i !== sdIdx) sdSet(i);
  }, 90);
}
/* r14 (Joel): no hard-sliced text rows at the bottom of the scroll region — clipped content fades out instead,
   and only while there is actually more below (mask off at scroll end so nothing reads as permanently faded) */
function sdScrollFade(el){ el.classList.toggle('canscroll', el.scrollTop + el.clientHeight < el.scrollHeight - 4); }
/* r30: WHAT'S IN THE KIT — explains a kit's price next to the $129.95 bare light (r29 made that
   comparison unavoidable). Priced rows only where live variant maps PROVE them (the 3 KIT_MATCH kits);
   the accessory lookup is title-only ON PURPOSE: a sold-out twin keeps its listed price (the kit is
   the in-stock way to get the parts), but a sold-out KIT combo never advertises a save. Buying the
   bare light NAVIGATES to the Critter sheet (inherits gallery/reviews/NOTIFY ME) — and the forward
   KIT MATCH banner firing later if someone builds light+accessory a la carte is intentional. */
function sdDescGo(){ const d = $('sd-desc'); if (d) d.scrollIntoView({behavior:'smooth', block:'start'}); }
/* r31 (Joel: "do whats best"): kits whose ENTIRE parts list is store-priced get full itemized math.
   Mappings are exact live variant-title matches, the same trust bar as KIT_MATCH:
   - Double BitWhip "<n> Fibers / <fiber>" = 2× bitwhip-accessory "<fiber> / <n> Fibers / Standard (5.5 Ft)" + Critter Connector
   - LED Staff "<Family> / (2) NN&quot; Sabers…" = 2× <family>-saber-accessory "NN Inch (…)" + Critter Connector
   - Jump Rope "9 Ft"/"10 Ft" = jupiter-jump-rope-accessory, identical titles (the product IS the kit's rope)
   Saber kits stay UNmapped on purpose: their provable save is NEGATIVE (~$15 over parts); the delta
   footer already tells the truth and a struck total below the kit price is banned by the money rules.
   A mapping that fails to resolve (title drift) falls back to the verbatim WIK_X rows. */
const WIK_PRICED = {
  /* 2026-09-16: the kit's options were reordered to Size / Fiber Type ("140 Fibers / End Glow") but the
     accessory stays Type / Size / Length, so the two parts are swapped here, exactly as KIT_MATCH's single
     BitWhip does. Appending the kit title unswapped never matched, and the sheet lost its save line and rows. */
  'double-bitwhip-light-whip': t => { const p = t.split(' / '); if (p.length !== 2) return null;
    return [{h:'bitwhip-accessory', q:2, t: p[1] + ' / ' + p[0] + ' / Standard (5.5 Ft)'}, {h:CONN, q:1, t:'Default Title'}]; },
  'led-staff': t => { const m = t.match(/^(\w+) \/ \(2\) (\d+)"/); if (!m) return null;
    /* prefix match: Sol says '30 Inch (75cm)', the laser-cut sabers say '30 Inch (76cm)' */
    return [{h: m[1].toLowerCase() + '-saber-accessory', q:2, pre: m[2] + ' Inch ('}, {h:CONN, q:1, t:'Default Title'}]; },
  'jump-rope-for-flow-artists': t => [{h:'jupiter-jump-rope-accessory', q:1, t}],
};
/* r48: single source of truth for the bought-separately total. wikHTML (the itemized proof) and
   sdSaveHTML (the price-line claim) MUST never disagree, so both call this. Mirrors the block's
   resolution order exactly: KIT_MATCH twin first, then WIK_PRICED full itemization, else null. */
function wikSep(h, v){
  if (!isKit(h) || !v) return null;
  const lv = (KIT_LIGHTS[h] || 1) * P(CRITTER).vars[0].p;
  const km = KIT_MATCH.find(x => x.kit === h);
  if (km){
    const avi = P(km.acc).vars.findIndex(x => km.map(x.t) === v.t);
    if (avi >= 0) return lv + P(km.acc).vars[avi].p;
  }
  const wpArr = WIK_PRICED[h] ? WIK_PRICED[h](v.t) : null;
  const wpHit = (x, y) => x.t != null ? y.t === x.t : y.t.startsWith(x.pre);
  if (wpArr && wpArr.every(x => DATA[x.h] && P(x.h).vars.some(y => wpHit(x, y))))
    return wpArr.reduce((s, x) => s + x.q * P(x.h).vars.find(z => wpHit(x, z)).p, lv);
  return null;
}
/* r48 (merch lens): the save used to live ONLY at the bottom of the wik block, below the fold — a
   shopper could price-compare a bare $299.95 and bounce without meeting the kit's strongest argument.
   This echoes the claim at the price line; the wik block below remains the itemized proof. Money
   rules hold: renders only under the exact saveOK gate the block uses, never on delta/neutral kits. */
function sdSaveHTML(h){
  if (!isKit(h)) return '<span id="sd-save" hidden></span>';
  const p = P(h);
  let vi = selVi(h); if (vi < 0 || !p.vars[vi]) vi = Math.max(0, p.vars.findIndex(x=>x.a));
  const v = p.vars[vi];
  const sep = v && v.a ? wikSep(h, v) : null;
  return sep != null && sep - v.p > 0.009
    ? `<span class="sd-save" id="sd-save">Kit saves you ${money(sep - v.p)}</span>`
    : `<span id="sd-save" hidden></span>`;
}
function wikHTML(h){
  if (!isKit(h)) return '<span id="sd-wik" hidden></span>';
  const p = P(h);
  let vi = selVi(h); if (vi < 0 || !p.vars[vi]) vi = Math.max(0, p.vars.findIndex(x=>x.a));
  const v = p.vars[vi], canAdd = !!(v && v.a);
  const n = KIT_LIGHTS[h] || 1, cp = P(CRITTER).vars[0].p, lv = n * cp;
  const echo = v.t !== 'Default Title' ? `<button class="wik-echo" onclick="sdGoPills()">${esc(v.t)}</button>` : '';
  const alone = P(CRITTER).vars[0].a
    ? `<button class="wik-alone" onclick="openStage(CRITTER)">${n===2?'or buy 1 light':'or buy just the light'} · ${money(cp)}</button>` : '';
  /* r48 (4-lens panel): "sold separately" everywhere "value" stood — every figure IS a live store
     price, and "value" is the one word that reads as invented infomercial pricing. */
  /* 2026-09-15 (Claude, Clarity dead-tap sweep): about half of Kit Builder's mobile dead taps were
     shoppers tapping these rows expecting to see that part. Each priced part row now opens the part's
     own detail, the same openStage() the "or buy just the light" button already uses from here.
     Taps on a button inside a row (that button) are left alone. Roll back: drop wikGo()/wik-link.
     CAREFUL: wikGo() leaves its last attribute unclosed; the literal `">` right after each
     ${wikGo(...)} call closes it. Keep `${wikGo(x)}"><img` intact at all three call sites. */
  const wikGo = (ph) => ` wik-link" role="button" tabindex="0" onclick="if(!event.target.closest('button'))openStage('${ph}')" onkeydown="if(event.key==='Enter')openStage('${ph}')`;
  let rows = `<div class="wik-r${wikGo(CRITTER)}"><img src="${CDN(DATA[CRITTER].imgs[0],160)}" alt="">
    <div class="wik-n"><b>${n}× RGB Critter BT Flashlight</b><span>${n===2?'Two full lights · pair &amp; sync in the app':'The light · powers this kit and everything you add later'}</span></div>
    <div class="wik-vw"><span class="wik-v">${money(lv)} sold separately</span>${alone}</div></div>`;
  const sep = wikSep(h, v);   /* r48: shared helper — same total the price-line echo uses */
  const km = KIT_MATCH.find(x => x.kit === h);
  if (km){
    /* map() takes an ACC variant title and returns its KIT twin — walk acc vars, match the selected kit title */
    const avi = P(km.acc).vars.findIndex(x => km.map(x.t) === v.t);
    if (avi >= 0){
      const av = P(km.acc).vars[avi];
      rows += `<div class="wik-r${wikGo(km.acc)}"><img src="${CDN(P(km.acc).imgs[0],160)}" alt="">
        <div class="wik-n"><b>1× ${esc(P(km.acc).title)}</b><span>${esc(av.t)}</span></div>
        <div class="wik-vw"><span class="wik-v">${money(av.p)} sold separately</span></div></div>`;
    }
  }
  /* r31: full itemized math where every part is store-priced (falls back to WIK_X on any title miss) */
  let priced = '';
  const wpArr = WIK_PRICED[h] ? WIK_PRICED[h](v.t) : null;
  const wpHit = (x, y) => x.t != null ? y.t === x.t : y.t.startsWith(x.pre);
  if (wpArr && wpArr.every(x => DATA[x.h] && P(x.h).vars.some(y => wpHit(x, y)))){
    priced = wpArr.map(x => { const y = P(x.h).vars.find(z => wpHit(x, z));
      /* r48: the Connector was the block's one pure-jargon row (no sub-line on Default Title) and it's
         the part that explains WHY 2 lights + 2 blades = one staff. Both CONN kits are 2-light kits. */
      return `<div class="wik-r${wikGo(x.h)}"><img src="${CDN(P(x.h).imgs[0],160)}" alt="">
        <div class="wik-n"><b>${x.q}× ${esc(P(x.h).title)}</b><span>${y.t==='Default Title'?(x.h===CONN?'Joins your two lights back-to-back':''):esc(y.t)}</span></div>
        <div class="wik-vw"><span class="wik-v">${money(x.q * y.p)} sold separately</span></div></div>`; }).join('');
    rows += priced;
  }
  /* r48: thumbless rows used to start flush-left AND collapse in height — the end cap read as a
     section header, not an included part. The empty .wik-ph well keeps every row on the 63px text axis. */
  if (!priced) rows += (WIK_X[h] || []).map(x => x[2]
    ? `<button class="wik-r wik-defer" onclick="sdDescGo()">${esc(x[0])} · <b>full contents below</b></button>`
    : `<div class="wik-r">${wikThumb(x[1]) ? `<img src="${CDN(wikThumb(x[1]),160)}" alt="">` : '<span class="wik-ph"></span>'}<div class="wik-n"><b>${esc(x[0])}</b></div></div>`).join('');
  const saveOK = canAdd && sep != null && sep - v.p > 0.009;
  /* r48 (trust lens): when no save is claimed, claim NO per-row prices either — pricing only the rows
     that flatter the kit read as selective disclosure. The footer + buy-alone link carry the one number. */
  if (!saveOK) rows = rows.replace(/<span class="wik-v">[^<]*<\/span>/g, '');
  let foot;
  if (saveOK)
    foot = `<span class="m">Bought separately: <s>${money(sep)}</s></span><span class="sv">Kit saves you ${money(sep - v.p)}</span>`;
  else if (lv / v.p >= 0.5)
    /* r48: attribute the increment to the parts listed above it, not to "the kit" as a surcharge */
    foot = `<span class="m">The ${n===2?'two lights alone are':'light alone is'} ${money(lv)}. Everything else in the kit adds ${money(v.p - lv)}.</span>`;
  else
    /* r48: the defer row directly above already says "full contents below" — say it once */
    foot = `<span class="m">Includes ${n}× RGB Critter BT (${money(lv)} sold separately)</span>`;
  return `<div class="wik" id="sd-wik"><div class="wik-h">What's in the kit ${echo}</div>${rows}
    <div class="wik-f ${saveOK?'':'neutral'}" aria-live="polite">${foot}</div></div>`;
}
function sdSync(){
  const h = S.sel; if (!h) return;
  const vi = selVi(h), v = vi>=0 ? P(h).vars[vi] : null, canAdd = !!(v && v.a);
  const anyA = P(h).vars.some(x=>x.a);
  const pr = $('sd-price'); if (pr){ pr.textContent = v ? money(v.p) : money(minPrice(h)); pr.style.color = canAdd ? '' : 'var(--ink3)'; }
  const ss = $('sd-save'); if (ss) ss.outerHTML = sdSaveHTML(h);   /* r48: save echo follows the selected variant, same gate as the wik footer */
  const sh = $('sd-ship'); if (sh) sh.innerHTML = shipLineHTML(v ? v.p : minPrice(h));   /* r42: free-ships line follows the displayed variant across the $99 line */
  const pw = $('sd-variants'); if (pw) pw.outerHTML = pillsHTML(h);
  const up = $('sd-upsell'); if (up) up.outerHTML = upsellHTML(h);
  const wk = $('sd-wik'); if (wk) wk.outerHTML = wikHTML(h);
  const cs = document.querySelector('.sd-cursel');
  if (cs && S.ax[h]) cs.textContent = S.ax[h].join(' · ');
  const add = $('sd-add');
  if (add && !addingLock){
    if (canAdd){ add.className='btn btn-p'; add.disabled=false; add.textContent='ADD TO CART · '+money(v.p); add.style.pointerEvents=''; add.setAttribute('onclick','sdAdd(this)'); }
    else { add.className='btn btn-s'; add.disabled=false; add.textContent='NOTIFY ME'+(anyA?' · THIS COMBO':''); add.setAttribute('onclick',`notifyMe('${h}')`); }
  }
}
function flashAdded(btn){
  btn.className='btn sd-added'; btn.textContent='ADDED TO KIT ✓'; btn.style.pointerEvents='none'; btn.removeAttribute('onclick');
  clearTimeout(addedTimer);
  addedTimer = setTimeout(()=>{ addingLock=false; btn.style.pointerEvents=''; sdSync(); }, 1600);
}
/* 2026-08-15 - Joel, mobile screenshot circling the sheet's primary button: "i think this add to kit
   button should be add to cart button and when pressed we need spinning wheel. when pressed the cart
   should load and this product page cart should swap out with the actual cart".
   Three parts, all here:
     1. the label is ADD TO CART (renderStage + sdSync), not ADD TO KIT
     2. the press paints the existing .spin wheel and locks the button, instead of the old
        flashAdded() "ADDED TO KIT ✓" flash, which now has nowhere to be seen: the sheet leaves
     3. the sheet CLOSES and the drawer OPENS, so the product page hands over to the real cart
   ORDER MATTERS on mobile and is the whole reason this is not two lines. closeStageUI routes through
   history.back(), so the sheet's own history entry has to be popped BEFORE openDrawer pushes the
   drawer's. Opening first (which is what addItem's own r9 drawer-intro did) strands the sheet entry
   and one Back press then does nothing - the r27 back-trap. sdAddArmed suppresses that intro for the
   duration of this add; openDrawer honours it and still marks drawerIntro done. The close is not
   timed against the open either: afterSheetClosed watches body.sheet-open actually clear, because
   popstate is async and a fixed delay is a race on a slow phone.
   DESKTOP has no drawer - .rigpanel IS its cart and is always on screen - so it keeps the r38
   close-the-viewer behaviour and focusRig() scrolls/flashes the cart, the same "hand over to the
   cart" the drawer gives mobile.
   Restore the body below from git and drop sdAddArmed + afterSheetClosed to roll back. */
function afterSheetClosed(fn){
  let n = 0;
  (function tick(){
    if (!document.body.classList.contains('sheet-open') || ++n > 40){ fn(); return; }
    requestAnimationFrame(tick);
  })();
}
function sdAdd(btnEl){
  const h = S.sel; if (!h) return;
  const vi = selVi(h);
  if (vi<0 || !P(h).vars[vi] || !P(h).vars[vi].a){ toast('That combination is sold out'); return; }
  if (addingLock) return;   /* the button is locked for the whole spin; a second tap must not double the line */
  addingLock = true;
  const rect = btnEl.getBoundingClientRect();
  btnEl.className = 'btn btn-p sd-adding'; btnEl.style.pointerEvents = 'none';
  btnEl.setAttribute('aria-busy','true'); btnEl.removeAttribute('onclick');
  btnEl.innerHTML = '<span class="spin" aria-hidden="true"></span>ADDING';
  sdAddArmed = true;
  addItem(h, vi, 1, {getBoundingClientRect:()=>rect});
  sdAddArmed = false;
  clearTimeout(sdCloseTimer);
  sdCloseTimer = setTimeout(() => {
    if (S.sel !== h){ addingLock = false; return; }   /* they opened something else mid-spin: leave it be */
    if (isMobile()){
      closeStageUI(false);
      afterSheetClosed(() => { openDrawer(); addingLock = false; sdSync(); });
    } else {
      closeStage(false); focusRig(); addingLock = false;
    }
  }, 420);
}
/* 2026-08-08 - Joel: "when you add a product to the kit, i think it should say 'added' or something
   like that on the button then return to the builder or give a button to return to the builder".
   The button half already existed (flashAdded paints ADDED TO KIT and reverts after 1.6s). The way
   OUT did not, on mobile: desktop closes the sheet 650ms after an add, mobile deliberately does not,
   so from the second add onward the shopper was left in a full-screen product sheet whose only exit
   is a 36px round X in the corner of the gallery.
   A button, not an auto-close, because closing has to survive the drawer: the FIRST mobile add opens
   the cart drawer over the sheet, which pushes its own history entry, and an auto-close firing under
   it would leave the sheet's entry stranded and make one Back press do nothing (the r27 back-trap).
   closeStageUI() pops the entry properly whenever they choose to tap it.
   Revealed rather than always-on: before the first add, "back to the builder" is just a second X.
   Delete sdShowBackToBuilder, its call above, BACK_BTN / inKit in renderStage and the .sd-back CSS
   to roll back. */
function sdShowBackToBuilder(){
  const foot = document.querySelector('.stagedetail .sd-foot'); if (!foot) return;
  if (foot.querySelector('.sd-back')) return;
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'sd-back';
  b.innerHTML = '<span aria-hidden="true">&lsaquo;</span> BACK TO THE BUILDER';
  b.setAttribute('aria-label', 'Back to the builder, keep shopping');
  b.onclick = () => { kbGA('kit_builder_sheet', { action:'back_after_add' }); closeStageUI(false); };
  foot.insertBefore(b, foot.firstChild);
}

/* 2026-08-06 (Joel): the sticky kit bar, the cart's own surface now that it no longer takes the
   column. Shows the item count and the running TOTAL (calc().totalDue since 2026-08-18, i.e. what the dock shows, so the
   two can never disagree) and jumps the scroller to the rows.
   HIDDEN in three cases, each for its own reason:
     - empty cart: nothing to summarise, and .rigpanel's own empty state already invites the first add
     - mobile: .bbar and the drawer already own this job there, and .rigpanel is display:none
     - a product sheet is OPEN: .stagedetail is height:100% of .leftscroll, so anything sitting above
       it in that flex column steals height the sheet does not give back, which pushed its ADD button
       below the fold (measured, see renderStage). The sheet gets the whole column, exactly as before.
   Takes no arguments and derives its own state, so any render path can call it safely.
   Guarded on the node existing so an older cached template cannot throw here. */
let kitBarSig = '';
function renderKitBar(){
  const el = $('kitbar'); if (!el) return;
  const c = calc(), items = gearQty();
  if (S.sel){ el.hidden = true; return; }   /* keep the markup: reopening the hub must not repaint */
  /* delete dataset.sig, do not just blank the HTML: caught in headless QA on stage 2026-08-06.
     Emptying the cart and then re-adding a line that prices identically (remove the Critter, add the
     Critter) reproduces the SAME sig, so the "unchanged, skip the rebuild" guard below matched a sig
     left over from before the wipe and the bar rendered as an empty grey box with hidden=false. */
  if (!S.cart.length || isMobile()){ el.hidden = true; el.innerHTML = ''; delete el.dataset.sig; kitBarSig = ''; return; }
  const sig = items + '|' + c.totalDue;   /* 2026-08-18: the bar mirrors what the dock shows, so it moves with totalDue */
  el.hidden = false;
  if (el.dataset.sig !== sig){
    el.innerHTML = `<button type="button" class="kitbar-in" onclick="kbJumpToKit()"
      aria-label="Your kit, ${items} item${items===1?'':'s'}, ${money(c.totalDue)}. Jump to the kit">
      <span class="kb-dot" aria-hidden="true"></span><b>Your Kit</b>
      <em>${items} item${items===1?'':'s'}</em>
      <span class="kb-sub money">${money(c.totalDue)}</span>
      <span class="kb-go" aria-hidden="true">View &rsaquo;</span></button>`;
    /* pulse only on a real change, never on the first paint of a restored cart */
    if (kitBarSig){ el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    el.dataset.sig = sig; kitBarSig = sig;
  }
}
/* scroll the right column to the kit rows. .leftscroll is the scrollport (r27), so scroll THAT, not
   the window - scrollIntoView() on the panel would drag the whole page on a short viewport. */
function kbJumpToKit(){
  const sc = document.querySelector('.leftscroll'), rp = $('rigpanel');
  if (!sc || !rp) return;
  const bar = $('kitbar');
  const top = rp.offsetTop - sc.offsetTop - (bar && !bar.hidden ? bar.offsetHeight : 0) - 4;
  sc.scrollTo({top: Math.max(0, top), behavior: 'smooth'});
  rp.classList.remove('flash'); void rp.offsetWidth; rp.classList.add('flash');
}
/* rig summary panel (desktop) + shared banners */
function kmHTML(m, dismissible){
  const kp = P(m.kit), kv = kp.vars[m.kvi];
  return `<div class="kmatch">
    <div class="km-t">KIT MATCH: <b>= ${esc(kp.title)} ${money(kv.p)}</b> · you save ${money(m.save)}</div>
    <div class="km-sub">Your Critter + ${esc(P(m.acc).title)} equal this kit. One tap swaps the two lines for it.</div>
    <div class="km-acts"><button class="km-swap" onclick="swapToKit()">Swap to the kit</button>
    ${dismissible?'<button class="km-x" onclick="kmDismissNow()" aria-label="Dismiss kit match">✕</button>':''}</div>
  </div>`;
}
/* r28: reverse-guard banner. "Keep both" IS the dismiss — an explicit choice, not an ✕. */
function km2HTML(m){
  const kp = P(m.kit), ap = P(m.acc);
  return `<div class="kmatch km2">
    <div class="km-t">YOU ALREADY HAVE A LIGHT · <b>save ${money(m.save)}</b></div>
    <div class="km-sub">${esc(kp.title)} includes a 2nd RGB Critter. The ${esc(ap.title)} runs on the light already in your kit. Keeping both unlocks pairing + Warranty X2.</div>
    <div class="km-acts"><button class="km-swap" onclick="swapToAcc()">Swap &amp; save ${money(m.save)}</button>
    <button class="km-x km-keep" onclick="km2DismissNow()">Keep both</button></div>
  </div>`;
}
/* pure post-add simulation (no state mutation): the CTA quotes the total the click actually creates,
   including any 10% bonus the added line unlocks and any active warranty charge */
function calcWith(extra){
  const cart = S.cart.concat([extra]);
  const gearSub = cart.reduce((s,l)=> s + P(l.h).vars[l.vi].p*l.qty, 0);
  const gl = cart.filter(l=>!isKit(l.h));
  const gearOnly = gl.reduce((s,l)=> s + P(l.h).vars[l.vi].p*l.qty, 0);
  const gc = gl.reduce((s,l)=>s+l.qty,0);
  const bonus = BONUS_ON && gc >= BONUS_N ? gearOnly * BONUS_PCT : 0;
  const lights = cart.reduce((s,l)=> s + lightUnits(l.h)*l.qty, 0);
  const warr = (S.warranty && lights > 0) ? warrTotalCost(cart) : 0;   /* 2026-08-13: per-kit-bucket over the hypothetical cart */
  return gearSub - bonus + warr;
}
function nlHTML(){
  const after = calcWith({h:CRITTER, vi:0, qty:1});
  if (S.nlDismiss) return '';   /* 2026-09-15: shopper closed it; a new light-needing add re-arms it */
  return `<div class="nlp">
    <button class="nl-x" onclick="nlDismissNow()" aria-label="Dismiss">✕</button>
    <div class="nl-t"><span class="nl-t1">This gear needs a light.</span> <span class="nl-t2"><b>Add the RGB Critter</b> to complete your&nbsp;kit</span></div>
    <div class="nl-sub">Nothing in your kit can glow yet. One Critter powers all of it, and every tool you add later reuses the same light.</div>
    <button class="nl-add" onclick="addCritter(this)">Add RGB Critter BT · kit total ${money(Math.max(0,after))}</button>
  </div>`;
}
/* r42 ITEM 2: accessory-to-accessory guard. A blade in the 'Blade Only' variant assumes the customer owns
   the Blade Holder. This is a NEW guard, deliberately NOT wired through the disabled GUARD_ON reverse-guard.
   A holder is already covered by: the holder product itself, any blade in the 'Blade + Holder Bundle'
   variant (ships one), or a holder-including kit (HOLDER_KITS). */
function cartHasHolder(){
  return S.cart.some(l =>
    l.h === HOLDER ||
    (P(l.h).sub === 'blades' && lv(l).t !== 'Blade Only') ||
    HOLDER_KITS.includes(l.h));
}
function needsHolder(){
  return S.cart.some(l => P(l.h).sub === 'blades' && lv(l).t === 'Blade Only') && !cartHasHolder();
}
function addHolder(el){ addItem(HOLDER, 0, 1, el); }
/* 2026-07-31 - Joel approved (designer feedback): a premade kit rides the cart as one titled line,
   so "I could add something separately, what is already in the Premade Kit" with no warning, and
   the cart row never says what the kit contains. Two additions, advisory only, never blocking:
   1. kitIncludes(h, v): component labels + store handles for a kit line, resolved live in the same
      order the What's-in-the-kit block trusts (KIT_MATCH twin, then WIK_PRICED itemization, then
      verbatim WIK_X rows; light count from KIT_LIGHTS) - never invented.
   2. ovMatch(): first non-dismissed (kit line, separate accessory line) collision; ovHTML renders
      the ALREADY IN YOUR KIT banner (rig panel, drawer, mobile ktoast) with Remove-the-extra and
      Keep-both (the dismiss, sticky per kit+accessory pair, session only, like the r28 guard's).
   The light is deliberately EXCLUDED from the scan: 2-light stacking belongs to the r28 reverse
   guard that r37 turned off (GUARD_ON) - this must not resurrect that banner by a side door.
   Delete this block, the rinc/ov call sites and S.ovDismiss to roll back. */
function kitIncludes(h, v){
  if (!isKit(h) || !v) return null;
  const out = {labels: [(KIT_LIGHTS[h] || 1) + '× RGB Critter BT'], handles: []};
  const km = KIT_MATCH.find(x => x.kit === h);
  /* guard: DATA excludes draft/archived products, and KIT_MATCH handles have been archived before
     (the 2026-07-28 saber-kit sweep) - an unguarded P() here would freeze the whole cart column */
  const kmAvi = km && DATA[km.acc] ? P(km.acc).vars.findIndex(x => km.map(x.t) === v.t) : -1;
  const wpArr = WIK_PRICED[h] ? WIK_PRICED[h](v.t) : null;
  const wpHit = (x, y) => x.t != null ? y.t === x.t : y.t.startsWith(x.pre);
  if (km && kmAvi >= 0){
    out.labels.push('1× ' + P(km.acc).title); out.handles.push(km.acc);
  } else if (wpArr && wpArr.every(x => DATA[x.h] && P(x.h).vars.some(y => wpHit(x, y)))){
    wpArr.forEach(x => { out.labels.push(x.q + '× ' + P(x.h).title); out.handles.push(x.h); });
  } else {
    (WIK_X[h] || []).forEach(x => { out.labels.push(x[0]); if (x[1] && DATA[x[1]]) out.handles.push(x[1]); });
  }
  /* 2026-08-06: display-free overlap coverage for the two kits whose WIK_X row defers (see WIK_COVERS).
     Kept OFF out.labels on purpose so no cart row grows; only ovMatch reads it. Archived/withdrawn
     products are filtered here, so nothing downstream can P() a handle that is not in DATA. */
  out.covers = (WIK_COVERS[h] || []).filter(x => DATA[typeof x === 'string' ? x : x[0]]);
  return out;
}
/* 2026-08-06: does a separately-added cart line land on one of the kit's covered components?
   A bare string covers every variant; a [handle, prefix] pair only the variant the kit actually ships. */
function covHit(covers, l){
  if (!covers || !covers.length) return false;
  const t = (lv(l) || {}).t || '';
  return covers.some(x => typeof x === 'string' ? x === l.h : x[0] === l.h && t.indexOf(x[1]) === 0);
}
function ovMatch(){
  for (const k of S.cart){
    if (!isKit(k.h)) continue;
    const inc = kitIncludes(k.h, lv(k));
    if (!inc || (!inc.handles.length && !(inc.covers && inc.covers.length))) continue;   /* 2026-08-06: covers-only kits count too */
    for (const a of S.cart){
      if (a === k || isKit(a.h) || a.h === CRITTER) continue;
      if (!inc.handles.includes(a.h) && !covHit(inc.covers, a)) continue;   /* 2026-08-06 */
      const key = k.h + '|' + a.h;
      if (S.ovDismiss.includes(key)) continue;
      return {kit: k, acc: a, key};
    }
  }
  return null;
}
function ovDismissNow(){ const m = ovMatch(); if (m) S.ovDismiss.push(m.key); renderAll(); }
function ovRemove(){
  const m = ovMatch(); if (!m) return;
  const i = lineIdx(m.acc.h, m.acc.vi); if (i < 0) return;
  const t = P(m.acc.h).title;
  dropLine(i);
  toast('Removed the extra ' + t + '. The kit still includes one');
}
function ovHTML(m){
  const kp = P(m.kit.h), ap = P(m.acc.h), lineTotal = lv(m.acc).p * m.acc.qty;
  return `<div class="kmatch km2 ovm">
    <div class="km-t">ALREADY IN YOUR KIT · <b>save ${money(lineTotal)}</b></div>
    <div class="km-sub">${esc(kp.title)} already includes ${esc(ap.title)}. Keeping the separate one too means you get it twice.</div>
    <div class="km-acts"><button class="km-swap" onclick="ovRemove()">Remove the extra one</button>
    <button class="km-x km-keep" onclick="ovDismissNow()">Keep both</button></div>
  </div>`;
}
/* 2026-08-15 (Claude) TUBE CONNECTOR GUARD, ported from the site's
   snippets/aoam-tube-connector-guard.liquid + assets/aoam-tube-connector-guard.js. Joel,
   2026-08-11: "we want to make sure customers do not ever buy a light saber tube or a light
   painting tube without the connector to the flashlight." Neither of the site's two layers reaches
   this page - layout/kit-builder.liquid hand-copies the snippets it wants and never renders
   head-scripts.liquid - so the builder checked out a bare tube with nothing to mount it on.
   The lists below are copied verbatim from that snippet so the two surfaces cannot drift; the
   deliberate exclusions are recorded there (T8 parts are a different diameter, the Critter
   Connector and Inverse Critter Connector join two Critters, the Modular Saber Tube Connector
   joins two tubes, the Modular Saber Tube Adapter adds a thread rather than mounting on a light,
   the DIY Connector has no bore).
   TWO rules carried over deliberately: a KIT is skipped, because it ships its own tube and its own
   adapter inside one line item; and the trigger is ZERO connectors in the kit, NOT one per tube,
   because tubes slide in and out of one mount. Do not "fix" that into a per-tube count.
   Joel, 2026-08-14, on the two adapters the site offers being absent from this catalogue: offer
   what is in the catalogue. So this is a BANNER offering the builder's own two mounts, in the same
   grammar as nlHTML/bhHTML, and never the site's modal - a modal fights the builder cart sync.
   Delete this block and the two tcHTML call sites (rigpanel + drawer banners) to roll back. */
const TUBE_HANDLES = ['sol-saber-accessory','butterfly-saber-accessory','stellar-saber-accessory','honeycomb-saber-accessory','light-painting-tube','butterfly-light-painting-tube','honeycomb-light-painting-tube','spiral-dots-light-painting-tube','dots-combo-light-painting-tube'];
const TUBE_TYPES = ['Light Painting Tube'];
const TUBE_PATTERNS = ['-saber-accessory','-light-painting-tube'];
const CONNECTORS = ['rgb-critter-tube-adapter-long','rgb-critter-tube-adapter-short','tube-to-critter-back','small-tube-holder-light-painting'];
/* what THIS catalogue actually carries, in the order the banner offers them. The two
   rgb-critter-tube-adapter-* handles the site offers are not in KB_DATA, so offering one here would
   build a dead row. Add them to this list the day they enter the builder catalogue. */
const CONNECTOR_OFFER = ['tube-to-critter-back','small-tube-holder-light-painting'];
function isTube(h){
  if (CONNECTORS.indexOf(h) !== -1) return false;   /* a mount is never a tube, whatever its handle reads */
  if (!DATA[h]) return false;
  if (TUBE_HANDLES.indexOf(h) !== -1) return true;
  if (TUBE_TYPES.indexOf(P(h).type) !== -1) return true;
  return TUBE_PATTERNS.some(pat => h.indexOf(pat) !== -1);
}
function cartHasConnector(){ return S.cart.some(l => CONNECTORS.indexOf(l.h) !== -1); }
function needsConnector(){
  return !cartHasConnector() && S.cart.some(l => !isKit(l.h) && isTube(l.h));
}
/* first AVAILABLE variant, so a sold-out lead variant never prices or adds a dead row */
function connFirstVar(h){ return DATA[h] ? P(h).vars.findIndex(v => v.a) : -1; }
function addConnector(h, el){ addItem(h, null, 1, el); }
function tcHTML(){
  const btns = CONNECTOR_OFFER.filter(h => connFirstVar(h) >= 0).map(h => {
    const p = P(h), v = p.vars[connFirstVar(h)];
    return `<button class="nl-add" onclick="addConnector('${h}',this)">Add ${esc(p.title)} &middot; ${money(v.p)}</button>`;
  }).join('');
  return `<div class="nlp">
    <div class="nl-t">This tube needs a <b>mount</b> to hold it on the light</div>
    <div class="nl-sub">A tube does not attach to the Critter on its own. Tube To Critter Back bolts it to the back of the light for long swinging trails. The Small Tube Holder twists into the front and grips anything 26mm or under. One mount carries every tube you own.</div>
    ${btns || `<button class="nl-add" onclick="closeDrawer();setCat('paint');setSub('mounts')">See the mounts</button>`}
  </div>`;
}
function bhHTML(){
  const hp = P(HOLDER);
  return `<div class="nlp">
    <div class="nl-t">These blades mount to the <b>Blade Holder</b></div>
    <div class="nl-sub">Your Blade Only pick locks into the Blade Holder to twist onto the Critter. Add one and every acrylic blade you own snaps in.</div>
    <button class="nl-add" onclick="addHolder(this)">Add Blade Holder · ${money(hp.vars[0].p)}</button>
  </div>`;
}
/* r42 ITEM 1b: when the kit holds a light and nothing that runs on it yet, a quiet pointer (dock-nl grammar)
   points at the three accessory aisles. Disappears the instant any light-powered accessory lands. */
function lightReady(){
  /* 2026-08-15 - Joel, mobile screenshot circling it: "remove this 'the light is ready' section from
     the kit builder". Killed at the predicate rather than at the two call sites (the rig dock and the
     drawer banners), so both surfaces drop it in one place and neither can come back on its own.
     Restore the return below to roll back; lightReadyHTML is left intact for that. */
  return false;
  /* was: return S.cart.some(l => l.h === CRITTER) && !S.cart.some(l => requiresLight(l.h)); */
}
function lightReadyHTML(){
  /* 2026-08-10 - Joel, mobile screenshot circling this: "i dont like this section". Same three aisle
     doors, same behaviour, but the card grammar the drawer already uses for nlHTML/bhHTML (title, sub,
     action) instead of a bare line of text with dotted-underline links. Put "dock-nl " back in front of
     lr-nl and collapse lr-lead/lr-sub into one span to roll back. */
  return `<div class="lr-nl"><div class="lr-lead">The light is ready</div>
    <div class="lr-sub">Pick what it powers.</div>
    <span class="lr-links"><button type="button" onclick="closeDrawer();setCat('flow')">Flow Arts</button><button type="button" onclick="closeDrawer();setCat('paint')">Light Painting</button><button type="button" onclick="closeDrawer();setCat('costume')">Costume</button></span>
  </div>`;
}
/* 2026-07-31 - Joel approved (designer feedback): guided 3-step strip above the grid. "This builder
   page should lead new user gently from start ('Add Flashlight first'), then 'What are you looking
   for?' (Flow arts / Light painting / costume), then additional things (cases, batteries)". Steps
   tick off from cart state (a kit completes step 1 AND 2 - it includes the light and declares the
   goal); the strip auto-hides once all three are done, and the X dismisses it for good per browser
   (localStorage aoam-kb-guide-x). On mobile only the CURRENT step shows (CSS). Advisory only: it
   never filters the catalog, never blocks a tab. NOT the r13-removed interstitial - nothing overlays
   the page. Delete this block, the renderGuide() call in renderAll, the #kbguide div in
   templates/page.kit-builder.liquid and the .kbguide CSS to roll back. */
function guideGone(){ try{ return localStorage.getItem('aoam-kb-guide-x') === '1'; }catch(e){ return false; } }
function guideDismiss(){ kbGA('kit_builder_guide', { action:'dismiss' });   // [kb-track]
  try{ localStorage.setItem('aoam-kb-guide-x','1'); }catch(e){} renderGuide(); }
/* 2026-08-05 polish (Joel: "anything else we can do to improve this?"): guide interactions are
   tracked (the 2-week revisit needs them), the goal chips reflect the aisle you chose, and
   completing all 3 steps earns a one-time full-width lit-trace flash before the strip retires.
   Delete kbg-fin/guidePrevAll and the kbGA lines to roll back. */
/* 2026-08-08 - Joel, mobile screenshot circling "or pick a complete kit": "this link doesn't work".
   It was not broken, it was a no-op. S.cat defaults to 'kits' (see the const S), so on a fresh load
   the shopper is ALREADY in the Kits aisle and setCat('kits') changes nothing: no tab moves, no band
   moves, and the guide strip sits above the grid so nothing new comes into view either. A link that
   correctly does nothing is indistinguishable from a dead one.
   The link now also takes them to the aisle it named. Scrolling is unconditional, not "only when the
   category changed", because the whole point is that the tap has to be felt in the case where it did
   not. Delete the gridwrap scroll to roll back. */
function guideGo(cat){ kbGA('kit_builder_guide', { action:'go_' + cat });   // [kb-track]
  guideOpenN = 0; setCat(cat); renderGuide();
  /* the Kits aisle opens with the bare light ("Just the light"), so scrolling to the top of the grid
     would answer "or pick a COMPLETE kit" with the light again. #band-kits is the complete-kit band
     itself; the grid is the fallback for every other aisle, which has no such band. */
  requestAnimationFrame(() => {
    const tgt = $('band-kits') || $('gridwrap') || $('grid');
    if (!tgt) return;
    try{ tgt.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'}); }catch(e){}
  });
}
function guideAdd(el){ kbGA('kit_builder_guide', { action:'add_light' });   // [kb-track]
  guideOpenN = 0; addCritter(el); }
/* 2026-08-06 dead-click audit (fix 2). The numbered circles (.kbg-n) and the step titles carried no
   handler at all - only the chips INSIDE a step did - and kit-builder.css hides those chips on every
   non-current step at <=1320px (which INCLUDES the 1280 desktop test width) and hides the whole label
   block at <=900px. So both test widths shipped bare circled "2" and "3" that look exactly like wizard
   navigation and did nothing. Measured: 0 of 3 steps had a handler on the circle at 1280 and at 390,
   and steps 2 and 3 reported 0 visible chips at both.
   Each step's circle + title is now a real <button class="kbg-open"> that expands that step, which is
   exactly what a circled number promises. It deliberately does NOT auto-fire guideAdd(): step 1's
   action puts a $129.95 light in the cart, and firing that from a tap on a numeral would be a worse
   bug than the dead one it replaces. Expanding reveals that step's own chips (guideAdd / guideGo) at
   EVERY width via .kbg-step.open in the CSS, and focus lands on the first chip. Tapping the open step
   again collapses it back to cart-driven state, and any real chip choice resets guideOpenN so the
   strip returns to following the cart. Delete guideOpenN / guideStep, unwrap the .kbg-open button in
   renderGuide and drop the .kbg-open / .kbg-step.open CSS to roll back. */
let guideOpenN = 0;   /* step the shopper forced open (0 = follow cart state) */
function guideStep(n, el){
  kbGA('kit_builder_guide', { action:'step_' + n });   // [kb-track]
  guideOpenN = (guideOpenN === n) ? 0 : n;
  renderGuide();
  const st = $('kbguide').querySelectorAll('.kbg-step')[n-1];
  if (!st) return;
  const first = st.querySelector('.kbg-b button');
  const tgt = (first && first.getBoundingClientRect().width > 0) ? first : st.querySelector('.kbg-open');
  if (tgt) tgt.focus();
}
let guideFinT = null, guidePrevAll = null;
function renderGuide(){
  const g = $('kbguide'); if (!g) return;
  /* any armed completion-flash timer dies on every render: a cart mutation inside the 1800ms
     window re-renders the strip, and the stale timer must not wipe it afterwards */
  clearTimeout(guideFinT);
  g.classList.remove('mini');   /* 2026-09-16 guide mini: every early-return path (dismissed, all done,
                                   the completion flash) renders full-size; only the normal path below
                                   re-arms it. See the note at the classList.toggle further down. */
  const s1 = lightsInCart() > 0;
  const s2 = S.cart.some(l => isKit(l.h) || requiresLight(l.h));
  const s3 = S.cart.some(l => P(l.h).cat === 'power');
  const all = s1 && s2 && s3;
  if (guideGone()){ g.hidden = true; g.innerHTML = ''; guidePrevAll = all; return; }
  if (all){
    /* transition only (not a restored already-complete cart): one lit trace + line, then retire */
    if (guidePrevAll === false && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      g.hidden = false;
      g.innerHTML = `<div class="kbg-fin"><span class="kbg-n">✓</span><i class="kbg-wire lit" aria-hidden="true"></i><b>All three steps done. Your kit is ready.</b></div>`;
      guideFinT = setTimeout(() => { g.hidden = true; g.innerHTML = ''; }, 1800);
    } else if (g.querySelector('.kbg-fin')){
      /* a render landed INSIDE the 1800ms flash window - the clearTimeout at the top of this
         function has already disarmed the hide, so re-arm it rather than wiping a live flash */
      guideFinT = setTimeout(() => { g.hidden = true; g.innerHTML = ''; }, 1800);
    } else { g.hidden = true; g.innerHTML = ''; }
    guidePrevAll = true; return;
  }
  guidePrevAll = all;
  const cur = !s1 ? 1 : !s2 ? 2 : 3;
  /* 2026-08-06 fix 2: op() marks the step the shopper forced open, ax() reports it to AT */
  const op = n => (guideOpenN === n ? ' open' : '');
  const ax = n => ((guideOpenN === n || (guideOpenN === 0 && cur === n && !s1)) ? 'true' : 'false');   /* 2026-09-16 guide mini: once s1 is done the current step is folded (.mini hides its .kbg-b), so it must not announce itself as expanded. Drop `&& !s1` to roll back with the rest of the mini change. */
  g.hidden = false;
  /* 2026-09-16 (Claude) - Joel, from the Kit Builder UX audit, picking "collapse the guide once step 1
     ticks". MEASURED: on a 390x844 phone the strip is 172px and pushes the first product to y=531, 63%
     of the first screen. Once the light is in the kit, step 2's chips (Flow Arts / Light Painting /
     Costume) repeat the category tabs already in the header, so the full-height strip is taxing every
     scroll to say what the header already says. .mini hides each step's action row (.kbg-b) and keeps
     the circuit path - numbered pods, ticks, lit wires - as ONE compact line, so progress stays visible.
     NOTHING IS LOST: every pod is still the .kbg-open button, and tapping one sets guideOpenN, which
     turns .mini off on this very line and expands that step with its chips exactly as before. Tapping
     it again returns guideOpenN to 0 and the strip folds back.
     NOT on first load: step 1 is the pitch for a complete kit ("Pick a complete kit" / "Light only"),
     and that stays full-size until the light is in. So this shortens every screen AFTER the first add,
     not the very first screen.
     Delete this line, the classList.remove near the top of renderGuide, and the "--- 7." block at the
     end of assets/kit-builder.css to roll back. Either half alone is inert. */
  g.classList.toggle('mini', s1 && guideOpenN === 0);
  g.setAttribute('role','group'); g.setAttribute('aria-label','Kit setup guide, step ' + cur + ' of 3');
  /* 2026-08-05 CIRCUIT PATH markup: pods + two .kbg-wire connectors that light up (.lit) behind
     completed steps. Same state model and handlers as the 07-31 original; 2026-08-06 (fix 2) wraps
     each pod's circle and title in the .kbg-open button so the step itself is a real control.
     2026-08-10 - Joel: "we want them to buy a kit not just the light" - the complete-kit option was
     a 12px underlined text link beside the ADD IT button. The kit path is now the lime PRIMARY
     (.kbg-act, guideGo to the kits aisle) and the light-only add is a bordered secondary button
     (.kbg-alt, same guideAdd handler and price). Restore the old .kbg-act/.kbg-lnk line below and
     drop the .kbg-alt CSS to roll back. */
  g.innerHTML = `
    <div class="kbg-step ${s1?'done':''} ${cur===1?'cur':''}${op(1)}"${cur===1?' aria-current="step"':''}>
      <button type="button" class="kbg-open" onclick="guideStep(1,this)" aria-expanded="${ax(1)}" aria-label="Step 1 of 3, start with the light">
        <span class="kbg-n">${s1?'✓':'1'}</span><b>Start with the light</b></button>
      <div class="kbg-b">
        <span class="kbg-row">${s1 ? '<span>In your kit ✓</span>'
             : `<button class="kbg-act" onclick="guideGo('kits')">Pick a complete kit</button><button class="kbg-alt" onclick="guideAdd(this)">Light only · ${money(P(CRITTER).vars[0].p)}</button>`}</span>
      </div>
    </div>
    <i class="kbg-wire ${s1?'lit':''}" aria-hidden="true"></i>
    <div class="kbg-step ${s2?'done':''} ${cur===2?'cur':''}${op(2)}"${cur===2?' aria-current="step"':''}>
      <button type="button" class="kbg-open" onclick="guideStep(2,this)" aria-expanded="${ax(2)}" aria-label="Step 2 of 3, what are you looking for">
        <span class="kbg-n">${s2?'✓':'2'}</span><b>What are you looking for?</b></button>
      <div class="kbg-b">
        <span class="kbg-chips"><button class="${S.cat==='flow'?'on':''}" onclick="guideGo('flow')">Flow Arts</button><button class="${S.cat==='paint'?'on':''}" onclick="guideGo('paint')">Light Painting</button><button class="${S.cat==='costume'?'on':''}" onclick="guideGo('costume')">Costume</button></span>
      </div>
    </div>
    <i class="kbg-wire ${s2?'lit':''}" aria-hidden="true"></i>
    <div class="kbg-step ${s3?'done':''} ${cur===3?'cur':''}${op(3)}"${cur===3?' aria-current="step"':''}>
      <button type="button" class="kbg-open" onclick="guideStep(3,this)" aria-expanded="${ax(3)}" aria-label="Step 3 of 3, extras">
        <span class="kbg-n">${s3?'✓':'3'}</span><b>Extras</b></button>
      <div class="kbg-b">
        <span class="kbg-chips"><button class="${S.cat==='power'?'on':''}" onclick="guideGo('power')">Batteries, cases &amp; cables</button></span>
      </div>
    </div>
    <button class="kbg-x" onclick="guideDismiss()" aria-label="Hide the guide">✕</button>`;
}
/* 2026-07-28: the same three aisle doors, rendered as a full-width band at the foot of the kits wall.
   Grid bands are direct .grid children, so it reuses .bandh for the heading and carries the chips in
   its own row rather than nesting the dock's flex layout inside a grid cell. */
function aisleBandHTML(){
  return `<div class="bandh">Or build it piece by piece<small>start from the bare light and add only what you want</small></div>
    <div class="aisleband"><span class="lr-links"><button type="button" onclick="setCat('flow')">Flow Arts</button><button type="button" onclick="setCat('paint')">Light Painting</button><button type="button" onclick="setCat('costume')">Costume</button></span></div>`;
}
/* r42 ITEM 1a: COMPLETE YOUR KIT suggestion strip. Reuses the detail-sheet upsell pick logic (UPSELL_MAP
   pool + UPSELL_FALLBACK), keyed off the LAST cart line's category. Never suggests the warranty, never an
   item already in the cart. Quick-add only, NO discount messaging. Quieter than the item rows. */
function stripPicks(){
  if (!S.cart.length) return [];
  const sub = P(S.cart[S.cart.length-1].h).sub;
  const pool = UPSELL_MAP[sub] || UPSELL_MAP.core || [];
  const ok = g => DATA[g] && P(g).sub !== 'warranty' && g !== WARR1 && g !== WARR2
    && !UPSELL_DENY.includes(g)   /* 2026-08-18: enforced here as well as in the pools, so a later pool edit cannot put a denied product back by accident */
    && !S.cart.some(l => l.h === g);
  const picks = pool.filter(ok);
  /* r44: cap lifted 3 -> STRIP_MAX now the row scrolls. A scroller with exactly 3 cards that already fit
     would have nothing to scroll to, so "scrollable" only means anything if more picks can reach it. */
  for (const g of UPSELL_FALLBACK){ if (picks.length >= STRIP_MAX) break; if (ok(g) && !picks.includes(g)) picks.push(g); }
  return picks.slice(0, STRIP_MAX);
}
function stripHTML(){
  const picks = stripPicks();
  if (picks.length < 2) return '';
  /* 2026-08-18 - Joel: "Full markup swap". This emits the SITE's upsell card, class for class -
     .axc / .axc-ph / .axc-name / .axc-foot / .axc-price / .axc-add with the same inline plus SVG -
     from snippets/aoam-upsell-card.liquid, and layout/kit-builder.liquid now loads the site's
     assets/aoam-upsell-card.css beside it. The old .cycard / .cyb / .cyname / .cyprice / .cyadd
     markup and its ~40 rules in kit-builder.css were a parallel implementation of the same control
     that had drifted on every visible axis: ALL-CAPS grey titles against the site's white sentence
     case, a grey price against lime, a full-width "+ ADD" text bar against a 26px plus chip, and a
     two-column wrapping grid on phones against a three-across scroller.
     TWO DELIBERATE DEPARTURES, do not "finish the job" by removing them:
     1. The photo and the name open the KIT BUILDER's own detail sheet (openStage), they are not
        links to the product page. Sending someone out of a half-built kit is the wrong move and is
        the whole reason this page has detail sheets.
     2. The add button calls addItem(), NOT the site's aoamUpsellAdd(). That script posts straight to
        /cart/add.js, which is correct for the site and wrong here - the builder's cart is JS state
        until checkout. assets/aoam-upsell-card.js is deliberately NOT loaded on this page.
     ROLLBACK: this block, plus the .cy* rules still sitting in kit-builder.css, plus the stylesheet
     line in layout/kit-builder.liquid. */
  const cards = picks.map(g => { const gp = P(g), mn = minPrice(g), mx = Math.max(...gp.vars.map(v=>v.p));
    const t = esc(gp.title);
    return `<div class="axc" data-handle="${g}">
      <button type="button" class="axc-ph" tabindex="-1" aria-hidden="true" onclick="openStage('${g}', this)"><img src="${CDN(gp.imgs[0],400)}" alt="" loading="lazy" width="400" height="400" decoding="async"></button>
      <button type="button" class="axc-name" onclick="openStage('${g}', this)">${t}</button>
      <div class="axc-foot">
        <span class="axc-price">${mn===mx?money(mn):'From '+money(mn)}</span>
        <button type="button" class="axc-add" title="Add ${t} to kit" aria-label="Add ${t} to kit" onclick="addItem('${g}',null,1,this)"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5.5v13M5.5 12h13" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round"/></svg></button>
      </div>
    </div>`; }).join('');
  /* 2026-08-10 - Joel, on this strip: "theres no option to navigate those other than the bottom
     scroller. check the main site for more features in this", then, of the first attempt: "i think
     the arrows can be better i dont like the circles, especially that they overlap the box".
     So the arrows are no longer round pucks floating over the first and last card. They are a pair
     of small square chips on the heading row, right-aligned, clear of every card. The pair carries
     hidden until cyWire has measured a rail that actually overflows, so a strip that fits shows
     nothing and JS off shows nothing. Each chip is DISABLED rather than hidden at its end of travel,
     because hiding one of a pair mounted in a header makes the other jump sideways.
     Collapse the head back to bare text and put the two buttons in a .cyscroller around .cygrid to
     roll back. */
  const cynav = d => `<button type="button" class="cynav cynav--${d}" aria-label="Scroll accessories ${d === 'prev' ? 'left' : 'right'}" disabled><svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="${d === 'prev' ? 'M15.5 4.5 8 12l7.5 7.5' : 'M8.5 4.5 16 12l-7.5 7.5'}" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;
  /* 2026-08-18: the site's rail wrapper too - .axc-rail / .axc-rail-top / h4.axc-rail-head /
     .axc-scroller / .axc-strip, from snippets/aoam-upsell-strip.liquid. The prev/next chips are gone
     with it: the site rail has no arrows at any width, and .axc-scroller is a real horizontal
     scroller on both surfaces. cyWire() is left in place but now measures nothing. */
  /* 2026-08-18 wave 7, measured: the site drawer wraps its rail in .accessory-block-pro-list
     (snippets/drawer-cart.liquid:586) and passes hide_rail_top, so it prints NO heading and picks up
     the compact card tier at widget-minicart.css:740-794. Both copied here: without the wrapper the
     card measured 150x207.6 against the site's 120.7x124.6, with a 149px photo square where the site
     has a 74px band. */
  return `<div class="accessory-block-pro-list"><div class="axc-rail">
    <div class="axc-scroller"><div class="axc-strip">${cards}</div></div></div></div>`;
}
/* r38: Saber-style free-shipping meter for the rig panel — a game-like meter that STAYS a meter at
   unlock (Joel's Saber ruling: NO checkmark swap). Scoped under .shipm so it can never touch the live
   drawer's own .block-progress__bar replica. The "$X.XX more" line ticks down like a score counter
   (tickShipLeft, run by renderRig once the panel markup exists). Threshold/base unchanged: SHIP_FREE on c.shipBase. */
/* 2026-08-18 - ONE shipping string for both Kit Builder surfaces, in the site's four branches
   (snippets/drawer-cart.liquid:327-335). Before this the drawer said "Calculated at next step" below
   the threshold and the desktop dock said "$X away from FREE", so the same cart read differently on
   the two halves of the same page and neither matched the site, which names the real rate.
   US_SHIP_CENTS comes from the same Liquid the site uses; it is 0 when the theme cannot price the
   cart exactly, and every branch below falls back to the site's own "Calculated at next step". */
function shipValueText(c){
  if (!IS_US) return kbIntlShipLabel();   /* 2026-10-25 INTL-1, see kbIntlShipLabel. Was: return INTL_SHIP_LABEL; */
  if (c.shipBase >= SHIP_FREE) return 'Free';
  /* the site's gate is "US and cart.total_weight > 4"; the nearest true thing here is a kit that
     actually holds something, because an empty kit has no rate to name either */
  return (S.cart.length && US_SHIP_CENTS > 0) ? money(US_SHIP_CENTS/100) : 'Calculated at next step';
}
/* the struck was-price only ever renders where the rate is EXACT and free shipping has been reached,
   which is the same gate the site uses - see the long note by aoam_show_ship_was in drawer-cart.liquid */
function shipWasHTML(c){
  if (!IS_US || !S.cart.length || US_SHIP_WAS_CENTS <= 0 || c.shipBase < SHIP_FREE) return '';
  return `<s class="aoam-ship-was">${money(US_SHIP_WAS_CENTS/100)}</s>`;
}
function shipMeterHTML(c){
  /* 2026-08-15: the meter is a US-only promise. Non-US shoppers have no $99 threshold, so a
     "$X from free shipping" bar is simply false for them - the site drawer hides its own
     .progress-wrapper the same way. See the KB_GEO block by SHIP_FREE. */
  if (!IS_US) return '';
  const left = Math.max(0, SHIP_FREE - Math.max(0, c.shipBase));
  const pct  = Math.min(100, Math.max(0, c.shipBase) / SHIP_FREE * 100);
  /* 2026-08-18 - Joel: "identically match the main site cart". Two changes, both to match
     snippets/drawer-cart.liquid:
     1. NO "Free shipping unlocked" band. The site deliberately deleted that state on 2026-08-17
        (Joel, on this exact green band: "do you think we can remove this free shipping unlocked if
        it already says free shipping below?") - at or above the threshold it now renders an empty
        wrapper carrying the boolean hidden attribute. This panel was still painting the band, which
        is the first thing in the screenshot Joel sent.
     2. The site's markup, not the Saber Lab's .shipm component. Same .progress-wrapper /
        .block-progress__bar / p[data-message] / .progress + span.dot shape, driven by the same
        --theme-progress-left custom property, so widget-minicart.css styles it rather than a
        hand-copied .shipm block that nothing keeps in sync.
     #rigShipTxt stays on the <p> - tickRigShip()/tickShipLeft() animate that node by id.
     ROLLBACK: restore the .shipm markup below and the .shipm rules in kit-builder.css are still
     there, untouched, ready for it. */
  const full = left <= 0;
  if (full) return '';
  return `<div class="progress-wrapper" data-progress-selector><div class="block-progress__bar">
      <p data-message id="rigShipTxt">Add ${money(left)} more to get <strong>free shipping</strong></p>
      <div class="progress" style="--theme-progress-left:${pct}%" id="rigShipProg"><span class="dot"></span></div>
    </div></div>`;
}
/* score-counter tween ported from the Saber Builder: the displayed "$X more" eases to its new value
   instead of jumping, so adding a part reads as progress filling up. renderRig rewrites the panel's
   innerHTML on every mutation, so the ticker targets the (recreated) #rigShipTxt by id and the
   cancelAnimationFrame guard handles re-entry across renders. */
let shipShown = null, shipRaf = 0;
function tickShipLeft(target){
  cancelAnimationFrame(shipRaf);
  const from = shipShown == null ? target : shipShown;
  const t0 = performance.now(), dur = Math.abs(target - from) < 0.005 ? 0 : 900;
  const step = t => {
    const el = $('rigShipTxt'); if (!el) return;   /* a later render dropped the meter mid-tween */
    const k = dur ? Math.min(1, (t - t0) / dur) : 1;
    const v = from + (target - from) * (1 - Math.pow(1 - k, 3));
    shipShown = v;
    el.innerHTML = `Add $${v.toFixed(2)} more to get <strong>free shipping</strong>`;
    if (k < 1) shipRaf = requestAnimationFrame(step);
  };
  step(performance.now());
}
/* run after renderRig has (re)written the panel: animate the counter while short of the threshold,
   settle cleanly at unlock (the meter stays a meter — the .full class + sheen carry the win). */
function tickRigShip(c){
  if (!S.cart.length || !$('rigShipTxt')){ cancelAnimationFrame(shipRaf); shipShown = null; return; }
  const left = Math.max(0, SHIP_FREE - Math.max(0, c.shipBase));
  if (left > 0) tickShipLeft(left);
  else { cancelAnimationFrame(shipRaf); shipShown = 0; }
}
/* r6: CHECKOUT NOW → the REAL site checkout via a Shopify cart permalink (live variant IDs, incl. warranty) */
/* r10 (Joel): checkout shows an in-flight spinner — the permalink hop to the real checkout takes a beat,
   and a dead-feeling button reads as broken. Spinners stay checkout-only: every other action in the
   builder is instant and has its own feedback (ADDED TO KIT flash, fly-dot, badge pulse). */
/* 2026-07-28 audit fix. The .busy class only ever landed on the ONE element that was clicked
   (kit-builder.css: .btn-cart__checkout.busy{pointer-events:none}), so it locked nothing else:
   the wallet marks are class wgo and never got it, and dock / drawer Secure Checkout are separate
   buttons. GA4 measured buyers clicking checkout ~5 times (30 events from 6 users on 2026-07-27),
   and two overlapping kbSyncCart chains can each read a /cart.js snapshot without the other's
   lines, so both add and the kit doubles at the money step. kbBusy is the single module-level
   gate every entry point now passes through. Delete kbBusy and its three reads to roll back. */
let kbBusy = false;
let kbBusyEl = null, kbBusyHTML = null;
function kbBusyOn(el, label){
  kbBusy = true;
  if (!el) return;
  kbBusyEl = el;
  el.classList.add('busy'); el.setAttribute('aria-busy','true');
  /* the wallet marks are SVG artwork, so they keep their label and only take the busy styling */
  if (label){ kbBusyHTML = el.innerHTML;
    el.innerHTML = '<span class="spin" aria-hidden="true"></span>' + label; }
}
function kbBusyOff(){
  kbBusy = false;
  if (window.aoamKbCoOff) { try { window.aoamKbCoOff(); } catch(e){} }   /* 2026-10-12 audit U: clear kb6's busy ring + words on the stay-on-page exits. Delete this line to roll back. */
  if (kbBusyEl){
    kbBusyEl.classList.remove('busy'); kbBusyEl.removeAttribute('aria-busy');
    if (kbBusyHTML !== null) kbBusyEl.innerHTML = kbBusyHTML;
  }
  kbBusyEl = null; kbBusyHTML = null;
}
function checkoutGo(el, ev){
  /* 2026-08-06 dead-click audit (fix 8). At 0 items the rig dock's SECURE CHECKOUT button was a fully
     visible 463x50 lime bar, styled cursor:pointer, sitting beside three non-interactive wallet badges
     - and it swallowed the click in total silence. It also carried the `disabled` ATTRIBUTE, and a
     disabled <button> dispatches no click event at all, so no hint was even reachable. renderRig and
     renderDrawer now emit aria-disabled instead of disabled, the CSS gives it cursor:not-allowed and
     drops the enabled-looking white hover, and the click is answered with the reason plus a nudge to
     the first thing worth doing. Restore the bare `return` here and the `disabled` attribute in the
     two renderers to roll back. */
  if (!S.cart.length){
    if (ev && ev.preventDefault) ev.preventDefault();
    toast('Add something to your kit first');
    if (el){ el.classList.remove('nudge'); void el.offsetWidth; el.classList.add('nudge');
      setTimeout(() => el.classList.remove('nudge'), 520); }
    kbGA('kit_builder_checkout_empty');   // [kb-track]
    const first = document.querySelector('.rigpanel .empty-add') || document.querySelector('.kbg-act') || document.querySelector('.tile');
    if (first){ try { first.scrollIntoView({behavior:'smooth', block:'center'}); } catch(e){} first.focus(); }
    return;
  }
  if (ev && ev.preventDefault) ev.preventDefault();   // [kb-track] we navigate ourselves after stamping the cart
  if (kbBusy) return;
  kbBusyOn(el, 'Opening Secure Checkout…');
  kbGoCheckout();   // [kb-track]
}
/* back-button return from checkout restores the page from cache with the spinner frozen on — re-render */
/* 2026-07-28: kbBusy MUST be cleared here too. The happy path navigates away without ever calling
   kbBusyOff, and bfcache restores module state verbatim, so a shopper who checked out, hit Back to
   grab a promo code and returned would find a normal-looking Secure Checkout button that silently
   did nothing on every tap (the kbBusy guard swallowing it) until they reloaded the page. The
   comment above is the proof this restore path is real and observed on this page. */
window.addEventListener('pageshow', e => { if (e.persisted){ kbBusyOff(); kbCoNow = false; kbCoGo = false; renderAll(); kbCartTouch(1); } });   /* 2026-07-30 cart-match: a bfcache return from the site/checkout re-arms the sync and re-reads the live cart */
/* 2026-07-24. The kit's line items, shared by the cart-merge path and the permalink fallback so the
   two can never drift out of sync. Delete kbLines and inline the old .map to roll back. */
function kbLines(){
  /* 2026-08-13: every eligible kit line now also carries the site-shaped `_warranty_pro_*`
     properties (warrPropsFor), so the main-site drawer recognises coverage even on a cart that never
     went through this builder's own checkout. TO ROLL BACK the stamping alone: drop the
     `properties: wp` assignment below and keep the bare {id,quantity} line. */
  const out = S.cart.map(l => {
    const v = P(l.h).vars[l.vi];
    const line = { id: v.id, quantity: l.qty };
    const wp = warrPropsFor(l.h, v.id);
    if (wp) line.properties = wp;
    return line;
  });
  /* 2026-08-15: the `&& KB_APPWARR <= 0` arm is gone. It meant that ONE warranty unit already in the
     cart (which the main site adds automatically on any eligible PDP add) suppressed the builder's
     warranty ENTIRELY, however many lights the rig held - so a site add plus a 2-light build checked
     out with one unit of cover for two lights, and the row quoted $19.95 against a real $39.90.
     Double-charging is prevented where it always was, in kbSyncCart: non-_kb warranty units are
     subtracted from this want ACROSS tiers (defect 14), and any remaining shortfall now GROWS the
     existing warranty line rather than adding a second one beside it.
     TO ROLL BACK: restore `&& KB_APPWARR <= 0` here and drop the warrBumps block in kbSyncCart. */
  if (S.warranty && lightsInCart() > 0 && !kbWarrStepsOn()){   /* 2026-09-25: with price steps, kbWarrSettle adds the ONE cover line after the kit lands */
    /* 2026-08-13: one line PER product-description bucket (warrLinesByBucket), replacing the old
       global pair-tiering (warrCost/warrUnits, kept below only as documented rollback). Each bucket
       line also carries `_protection_product`+`Extended Warranty` so the site's drawer resizes it
       instead of adding a second one.
       TO ROLL BACK: restore `warrUnits(lightsInCart()).forEach(u => out.push(u));` */
    warrLinesByBucket().forEach(u => out.push(u));
  }
  return out;
}
/* 2026-07-24: NOTHING CALLS THIS ANY MORE, and that is deliberate rather than an oversight. It is kept
   only because it is the documented rollback path for kbSyncCart below, which is a two-line revert as
   long as this still exists. Do not wire it back into a click handler or an href: building this URL is
   exactly how the cart-wipe bug happened, because a /cart/<id>:<qty> permalink REPLACES the cart. */
function checkoutURL(){
  if (!S.cart.length) return '#';
  const lines = kbLines().map(l => `${l.id}:${l.quantity}`);
  /* 2026-07-23 attribution fix. kbGoCheckout() stamped "Source: Kit Builder" via /cart/update.js and
     THEN sent the buyer to this permalink, but a /cart/<id>:<qty> permalink rebuilds the cart from
     scratch and throws that attribute away. Verified against live orders: of every order since the
     builder launched, ZERO carried the attribute, including order 87313325 which is tagged
     kit-builder. Passing it on the permalink itself survives (verified live: /cart.js came back with
     "attributes":{"Source":"Kit Builder"}). Set here rather than in kbGoCheckout so the wallet
     buttons and the drawer's Secure Checkout, which link straight to this URL and never run
     kbGoCheckout, are attributed too. Delete the attrs const and the template suffix to roll back. */
  const attrs = '?attributes[Source]=Kit%20Builder';
  return `/cart/${lines.join(',')}${attrs}`;
}
/* 2026-07-21 — Joel: "i want to be able to properly track this" (kit-builder usage + checkout attribution).
   Two hooks, both self-contained here — no layout change needed. The page already carries a global,
   consent-aware gtag from Shopify's Google channel (GA4 G-F689VBGBN0), so we reuse it.
     1. kbGA()          → GA4 funnel events (kit_builder_open → _add → _checkout). No-ops if gtag/consent
                           isn't there, and inherits the same consent state as the rest of the site.
     2. kbGoCheckout()  → stamps the cart with note attribute "Source: Kit Builder" via /cart/update.js,
                           THEN hops to the permalink checkout. Every kit-builder order then shows
                           "Source: Kit Builder" in Order → Additional details, and is queryable via
                           order.customAttributes. Navigates whether or not the stamp call succeeds.
   Delete this block + the five call sites tagged [kb-track] to roll back. */
/* 2026-07-31 - Joel: GA4 showed kit_builder_open on only ~12% of pageviews (84 opens vs 704
   page_views over 30 days) while detail_view (314) and add (217) recorded fine, and abandon (85)
   exceeded open. Measured live: this deferred script pushes the open event into dataLayer at
   ~1450ms (index 1), but Shopify's Google channel pushes its config G-F689VBGBN0 command later
   (index 8), and gtag.js silently drops any event it processes before that destination is
   configured. Events fired on user interaction land after the config and survive, which is why
   only the load-time open was starved. Fix: kbGA now holds events in a local queue until the GA4
   destination exists in window.google_tag_manager, then flushes in order, and any funnel event
   always emits kit_builder_open first (once per load) so open >= every other kit_builder_* count.
   pagehide flushes unconditionally so the abandon beacon keeps its old behaviour, and after 20s
   without gtag.js (blocked or absent) it flushes anyway, which is exactly the old behaviour.
   Delete this block down to the blank line before kbUnits and restore the one-line kbGA
   (window.gtag('event', name, params || {}) guarded by typeof) to roll back. */
var kbGAQueue = [], kbGAOpened = false, kbGATimer = null, kbGAStart = Date.now();
function kbGAReady(){
  try {
    var g = window.google_tag_manager;
    if (!g) return false;
    for (var k in g) if (k.indexOf('G-') === 0) return true;
  } catch(_){}
  return false;
}
function kbGAFlush(force){
  try {
    if (!force && !kbGAReady() && Date.now() - kbGAStart < 20000) return;
    if (kbGATimer){ clearInterval(kbGATimer); kbGATimer = null; }
    while (kbGAQueue.length){
      var e = kbGAQueue.shift();
      try { if (typeof window.gtag === 'function') window.gtag('event', e.n, e.p); } catch(_){}
    }
  } catch(_){}
}
function kbGA(name, params){
  try {
    if (name === 'kit_builder_open'){ if (kbGAOpened) return; kbGAOpened = true; }
    else if (!kbGAOpened){ kbGAOpened = true; kbGAQueue.push({ n:'kit_builder_open', p:{} }); }
    kbGAQueue.push({ n:name, p:params || {} });
    if (kbGAReady() || Date.now() - kbGAStart >= 20000){ kbGAFlush(true); return; }
    if (!kbGATimer) kbGATimer = setInterval(kbGAFlush, 250);
  } catch(_){}
}
addEventListener('pagehide', function(){ kbGAFlush(true); }, true);
function kbUnits(){ return S.cart.reduce((s,l)=> s + (l.qty||0), 0); }
/* 2026-07-24. Joel: "make sure no issues going on especially with the new kit builder".
   THE BUG: checkout sent the buyer to a /cart/<id>:<qty> permalink, and a cart permalink REPLACES the
   cart instead of adding to it. Anything the buyer had put in their cart elsewhere on the site was
   silently deleted the moment they checked out from the builder. Reproduced on live: a cart holding
   BitWhip Accessory + Jupiter Rope Kit came back holding only the permalink's one line. A customer had
   already reported it, Zigpoll on order 87313331 (2026-07-22): "Website kept emptying my shopping cart".

   THE FIX: kbSyncCart() merges instead. It removes only the lines this builder added last time (they
   carry the hidden _kb property, and a leading underscore keeps a line property off the cart and
   checkout display, the same convention aoam-cart-fix.liquid already relies on live), re-adds the
   current kit, then stamps the Source attribute. Sweeping our own lines first is what keeps it
   idempotent: back-button to the builder and check out again replaces the kit rather than doubling it.
   The Source attribute survives because the success path no longer hops through a permalink, which was
   the very thing discarding it (see the 2026-07-23 note in checkoutURL).

   FAILURE MUST NEVER BE DESTRUCTIVE, and this is the part that is easy to get wrong. The first version
   of this fix fell back to checkoutURL() on timeout or error, which reintroduced the exact cart-wiping
   bug it was written to remove, silently, on the paths most likely to fire. Shopify's bot mitigation
   really does answer this burst with HTTP 429 "Verifying your connection" (hit repeatedly while testing
   on 2026-07-24), and 92% of this store's traffic is mobile. So every failure path now goes to /cart,
   which is non-destructive: the buyer sees their real cart and can finish by hand. Losing a step is
   recoverable, losing their items is not.

   keepalive is set on every request because a nav can fire mid-flight, and 429 gets one retry since it
   is the observed failure rather than a theoretical one.

   NO PERMALINK IS REACHABLE FROM THE UI ANY MORE. The dock Secure Checkout and the wallet marks used
   to be <a href="<permalink>"> so that a middle-click, or right-click then Open in new tab, bypassed
   the handler and wiped the cart anyway. Modified-click was already covered (the handlers preventDefault
   unconditionally) but middle-click fires auxclick, not click, and open-in-new-tab cannot be intercepted
   from JS at all, so the only complete fix was removing the href. Both are now <button>, matching what
   the mobile drawer footer already did. checkoutURL() is retained but uncalled, purely as the rollback.
   Delete kbSyncCart and restore the old one-line nav to roll back. */
/* 2026-07-28 audit fix, two defects in the order of operations above.

   1. SWEEP-THEN-ADD WAS DESTRUCTIVE, exactly what the block above says must never happen. The old
      lines were deleted first and /cart/add.js ran second, so the 8s timeout could navigate in the
      window between them and land the buyer on a checkout with their kit REMOVED. Adding first and
      sweeping second closes the window: at every instant the cart holds the old kit, the new kit,
      or both. Never neither. The new lines carry a fresh _kb token so Shopify keeps them as separate
      line items from the old ones, and only the keys captured BEFORE the add are swept afterwards.

   2. A SINGLE SOLD-OUT ITEM SILENTLY DESTROYED THE WHOLE KIT. /cart/add.js is atomic: one DENY-policy
      sold-out variant makes the whole batch 422 and nothing is added. Reproduced on live 2026-07-28
      with a 2-item batch: HTTP 422 "The product 'Stellar Saber Kit' is already sold out." The catch
      then navigated to /checkout with the cart already swept, so the buyer lost everything with no
      message. Now a 422 batch retries serially, one item per request, so the good items land and the
      rejected ones are reported back to the caller by handle for a real "removed, it sold out" toast.

   Resolves to an array of the kit lines that could not be added (empty on the happy path).
   Delete this function and restore the previous sweep-then-add body to roll back. */
function kbSyncCart(){
  const J = { 'Content-Type': 'application/json' };
  const req = (url, opts, tries) => fetch(kbMkt(url), Object.assign({ keepalive: true }, opts))
    .then(r => {
      /* 429 is bot mitigation, not a real rejection. One backoff, then give up to the failure exit. */
      if (r.status === 429 && !tries) return new Promise(go => setTimeout(go, 900))
        .then(() => req(url, opts, 1));
      if (!r.ok) { const e = new Error(url + ' ' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
  const post = (url, body) => req(url, { method:'POST', headers:J, body:JSON.stringify(body) });
  /* unique per checkout so a repeat checkout's lines never merge with the ones being replaced */
  const token = 'kb' + Date.now();
  const lines = kbLines();
  let items = [], srcLines = [];
  const warrBumps = {};   /* 2026-08-15: line key -> absolute new qty, for warranty lines we grow rather than duplicate */
  const failed = [];
  /* one item per request: used only after an atomic batch was rejected, so the good lines still land */
  const addSerially = () => items.reduce((chain, it, i) => chain.then(() =>
    post('/cart/add.js', { items: [it] }).catch(err => {
      if (err && err.status === 429) throw err;   /* bot mitigation, not a stock problem */
      failed.push(srcLines[i]);
    })), Promise.resolve());
  let stale = [], cart0 = null, wrote = false;
  return req('/cart.js', { headers:{ 'Accept':'application/json' } })
    .then(cart => {
      cart0 = cart;
      /* 2026-09-26 (Claude, cart-fix kb-cover: kb-code-1 / kb-desktop-3). EVERY kit line already in the cart is
         coverage, whatever its tag. The background sync tags its own lines _kb:'kbsync', and this used to treat them
         as stale: every checkout re-added the whole kit under a new token, then deleted the old copies one serial
         /cart/change.js at a time with failures swallowed, racing the 8s navigation, so the kit could reach checkout
         twice. Now only a real shortfall is added, and only the builder's own (_kb) SURPLUS is cut, in one
         /cart/update.js. Site lines are never cut here (kbGoCheckout's forced kbCartSync reconciles those first).
         Warranty lines keep the old rule (non-_kb only); with price steps kbWarrSettle alone touches them.
         Roll back: restore the stale/have lines from Documents/AOAM-Cart-Audit-2026-09-25/fixes/kb-cover/live-before. */
      const have = {}, own = {};
      (cart.items || []).forEach(i => {
        const v = +i.variant_id, q = +i.quantity || 0, kb = !!(i.properties && i.properties._kb);
        if (kbWarrVid(v)){ if (!kb) have[v] = (have[v]||0) + q; else if (!kbWarrStepsOn()) stale.push({ key: i.key, q: 0 }); return; }
        have[v] = (have[v]||0) + q;
        if (kb) (own[v] = own[v] || []).push({ key: i.key, q: q });
      });
      /* 2026-08-15: the SAME non-_kb warranty lines, kept as records rather than a total, so a
         shortfall can grow the line that already exists instead of stacking a second one beside it.
         That matters because snippets/aoam-cart-fix.liquid keys its `existing` warranty map by the
         `Extended Warranty` description and takes LAST-WRITE-WINS (its line ~957): two lines sharing
         one description leave the earlier one invisible to the site's writer, so it is never resized
         and never zeroed. Growing the existing line keeps the one-line-per-coverage invariant the
         whole warranty system is built on. */
      const warrLines = (cart.items || [])
        .filter(i => !(i.properties && i.properties._kb) && kbWarrVid(+i.variant_id) && (+i.quantity||0) > 0)
        .map(i => ({ key: i.key, vid: +i.variant_id, qty: +i.quantity||0 }));
      lines.forEach(l => {
        let cover;
        if (kbWarrVid(l.id)){
          /* defect 14: ANY non-_kb warranty line covers the warranty want, ACROSS tiers. The app
             tiers per light (e.g. 2x WARR1) where the builder wants 1x WARR2; id-exact coverage
             saw no overlap and stacked the second warranty at checkout. */
          let need = l.quantity;
          Object.keys(have).forEach(v => { if (need > 0 && have[v] > 0 && kbWarrVid(+v)){ const c = Math.min(need, have[v]); have[v] -= c; need -= c; } });
          cover = l.quantity - need;
        } else {
          cover = Math.min(l.quantity, have[l.id]||0);
          have[l.id] -= cover;
        }
        let q = l.quantity - cover;
        /* 2026-08-15: a warranty SHORTFALL grows the existing line of that exact tier rather than
           adding a second one. Only when no such line exists does it fall through to the add below.
           Before this, kbLines() refused to emit any warranty at all once the cart held one
           (`KB_APPWARR <= 0`), so a shopper who added a light on the main site and then built a
           2-light kit here checked out with ONE unit of cover for two lights. */
        if (q > 0 && kbWarrVid(l.id)){
          const ex = warrLines.find(w => w.vid === l.id);
          if (ex){ ex.qty += q; warrBumps[ex.key] = ex.qty; q = 0; }
        }
        /* 2026-08-13: merge in l.properties (warrPropsFor on a kit line, or _protection_product on
           the KB's own warranty line from warrLinesByBucket) so the checkout-path add carries the
           same site-shaped stamp kbCartSync's background add now uses below. */
        if (q > 0){ items.push({ id: l.id, quantity: q, properties: Object.assign({ _kb: token }, l.properties || {}) }); srcLines.push(l); }
      });
      /* 2026-09-26 cartfix: what is left in have after the kit took its share is surplus; cut it from _kb lines only */
      Object.keys(own).forEach(v => { let cut = Math.max(0, have[v] || 0); own[v].forEach(o => { if (!(cut > 0)) return; const c = Math.min(o.q, cut); stale.push({ key: o.key, q: o.q - c }); cut -= c; }); });
    })
    /* grow existing warranty lines BEFORE the add, so a failure here leaves the cart under-covered
       rather than holding kit lines nobody is covering - and never a double charge either way */
    .then(() => { if (Object.keys(warrBumps).length) wrote = true; })
    .then(() => Object.keys(warrBumps).reduce((chain, key) =>
      chain.then(() => post('/cart/change.js', { id: key, quantity: warrBumps[key] }).catch(()=>{})), Promise.resolve()))
    .then(() => {
      if (!items.length) return null;
      wrote = true;
      return post('/cart/add.js', { items }).catch(err => {
        if (err && err.status === 422) return addSerially();
        throw err;
      });
    })
    /* only now, with the new kit safely in the cart, remove the old copy of it */
    /* 2026-09-26 cartfix: one atomic /cart/update.js for the surplus, and a failure is REPORTED (kbSurplus), so
       kbGoCheckout stays on the page instead of navigating to a checkout that still holds the kit twice */
    .then(() => {
      if (!stale.length) return null;
      const ups = {}; stale.forEach(s => { ups[s.key] = s.q; });
      wrote = true;
      return post('/cart/update.js', { updates: ups }).catch(() => { const e = new Error('kb surplus'); e.kbSurplus = true; throw e; });
    })
    .then(() => kbWarrSettle(req, post, token, wrote ? null : cart0))   /* 2026-09-25: exactly one cover line, at the whole cart's price step */
    .then(() => post('/cart/update.js', { attributes: { 'Source': 'Kit Builder' } }).catch(() => {}))   /* 2026-10-10 audit: a failed attribute tag must never block checkout */
    .then(() => failed.map(f => Object.assign({}, f, { held: ((cart0 && cart0.items) || []).reduce((s, i) => s + (+i.variant_id === +f.id ? (+i.quantity || 0) : 0), 0) })));   /* 2026-10-10 audit: held = units of that variant the cart already has, so checkout clamps instead of cutting the line */
}
function kbGoCheckout(){
  /* 2026-07-30 cart-match: checkout's own merge is about to do the real thing. Clearing the queue is
     not enough - an ALREADY in-flight background sync could add a line after kbSyncCart's snapshot
     and never be swept, doubling it at checkout. kbCoNow makes every not-yet-sent background
     mutation a no-op until we either navigate away or deliberately stay (sold-out path below). */
  /* 2026-09-26 (Claude, cart-fix kb-cover: kb-code-1 / kb-code-2 / kb-desktop-3). ONE merge at a time: kb6's Secure
     checkout had no busy gate, so a double tap ran two merges and could put the kit in the cart twice. And the merge
     no longer CANCELS the background reconcile: it waits for the one in flight, then runs one more on purpose, so a
     part the shopper just binned, or that kb6 just folded into a kit, is cut from the real cart before checkout (the
     ledger rule, target = kit + live - ledger). Only then does kbCoNow hand the cart to kbSyncCart.
     Roll back: restore "kbSyncDirty = false; clearTimeout(kbSyncT); kbCoNow = true;" here and the old try block. */
  if (kbCoGo) return;
  kbCoGo = true; clearTimeout(kbSyncT);
  const c = calc();
  /* 2026-09-28 cart-fix-l kb-later C70: on kb6 the value is kb6's own kit value (the same pre-code figure its tracker sent), not calc()'s old per-kit warranty sum. Roll back: value: +Math.max(0, c.total).toFixed(2), num_items: kbUnits() */
  const v6co = (function () { try { if (window.KB && window.KB.totals && document.getElementById('kb6')) { const t6 = window.KB.totals(); return { v: +Math.max(0, t6.sub + (t6.cartLvl || 0)).toFixed(2), n: t6.count }; } } catch (e) {} return null; })();
  /* 2026-10-07 Joel approved "Search + tracking" (Kit Builder review): + num_parts and kit_value from kb6 (window.__kb6KitParams in
     assets/kb6.js), the same two kit_builder_view_kit carries. Roll back: drop the Object.assign wrapper and its second argument. */
  kbGA('kit_builder_checkout', Object.assign({ value: v6co ? v6co.v : +Math.max(0, c.total).toFixed(2), currency: 'USD', num_items: v6co ? v6co.n : kbUnits() }, (function () { try { return v6co && typeof window.__kb6KitParams === 'function' ? window.__kb6KitParams() : {}; } catch (e) { return {}; } })()));   // [kb-track]
  /* Move the buyer on no matter what, so a stalled request never traps them on the spinner. First of
     {merge resolves, merge rejects, 8s elapses} wins. 8s not the old 1.2s because this is up to four
     serial round trips on mobile where the old stamp was one, and because the timeout is now a safety
     net rather than the normal path. Both failure exits go to /checkout, never to the permalink.
     2026-07-24 (Joel: "this cart page needs to be disabled on the mobile and desktop. hard rule."):
     the failure exits used to go to /cart. That page is retired (snippets/aoam-no-cart-page.liquid)
     and this builder page has no cart drawer to fall back to, so a /cart exit would have bounced
     straight back here and stranded the buyer. /checkout shows the same real cart lines and is what
     they asked for; an empty cart there ends on the storefront home rather than looping. */
  let went = false;
  /* The ring fires inside nav(), not on the press: the in-button wheel already covers the cart-build
     phase, and the sold-out path below deliberately stays on this page. */
  const nav = url => { if (went) return; went = true; if (window.AOAM_LOAD) window.AOAM_LOAD.show(); window.location.href = url; };
  /* the safety net still moves a stalled buyer on, but never in the middle of the merge: it waits for it, up to 45s (2026-10-10 audit) */
  let merging = true; const t0 = Date.now();
  /* 2026-10-10 audit: stay on the page with a toast instead of leaving for a checkout whose cart may not match the screen. Roll back: delete stay and its callers, restore nav('/checkout') in safety and the reject branch. */
  const stay = () => { if (went) return; went = true; kbCoNow = false; kbCoGo = false; kbBusyOff(); kbCartTouch(1); toast('Your cart did not update. Tap checkout again.'); };
  /* 2026-10-10 audit (ask: "ship any fixes/finds (sitewide audit)"): a slow connection can need 5 round trips; wait up to 45s and say so honestly instead of a false "did not update" at 20s that drops the merge's own checkout nav. Roll back: delete slowSaid and the toast branch, restore the 20000 cap. */
  let slowSaid = false;
  const safety = () => { if (went) return; if (merging && Date.now() - t0 < 45000){ if (!slowSaid && Date.now() - t0 >= 20000){ slowSaid = true; toast('Still saving your cart, one moment.'); } setTimeout(safety, 1000); return; } if (merging){ stay(); return; } nav('/checkout'); };
  setTimeout(safety, 8000);
  try {
    Promise.resolve(kbSyncP).catch(() => {})
      .then(() => { kbSyncDirty = true; kbRetry = 1; return kbCartSync(); }).catch(() => {})
      .then(() => { kbSyncDirty = false; clearTimeout(kbSyncT); kbCoNow = true; return kbSyncCart(); })
      .then(failed => {
      merging = false;
      /* 2026-07-28: a sold-out line no longer vanishes in silence. The kit is already merged, so
         stay on the page, drop the dead lines, say which ones, and let them check out again with a
         cart that matches what they see. Only the happy path navigates. */
      if (failed && failed.length){
        if (went) return;
        const names = [], clamped = [];
        failed.forEach(f => {
          /* defect 16: the warranty is a flag, not an S.cart line - the splice below can never
             remove it, so a sold-out warranty looped the toast forever. Drop the flag instead. */
          if (kbWarrVid(f.id)){ if (S.warranty){ S.warranty = false; names.push('Lifetime Warranty Protection'); } return; }
          const i = S.cart.findIndex(l => P(l.h) && P(l.h).vars[l.vi] && P(l.h).vars[l.vi].id === f.id);
          /* 2026-10-10 audit (kb6 qty over stock): when the cart already holds some of this variant, keep what it holds instead of cutting the whole line and calling it sold out */
          if (i >= 0 && +f.held > 0 && +f.held < S.cart[i].qty){ S.cart[i].qty = +f.held; clamped.push('Only ' + f.held + ' of ' + P(S.cart[i].h).title + ' ' + (+f.held === 1 ? 'is' : 'are') + ' available, so your kit has ' + f.held + '. Tap checkout again.'); return; }
          if (i >= 0){ names.push(P(S.cart[i].h).title); S.cart.splice(i, 1); }
          const p = PID(f.id); if (p && !names.length) names.push(p.title);
        });
        went = true;   /* cancel the 8s safety-net nav: we are deliberately staying put */
        kbCoNow = false; kbCoGo = false;   /* 2026-07-30 cart-match: staying on the page, background sync may resume */
        kbBusyOff(); renderAll(); persist();
        toast(clamped.length && !names.length ? clamped[0] : (names[0] || 'An item') + ' just sold out and was removed. Tap checkout again.');
        return;
      }
      /* 2026-10-10 audit (cart half-update): compare the real cart with the screen once before leaving. Fewer goods units than the kit shows = stay and ask for another tap.
         Cover lines are excluded (a failed cover write already rejects in kbWarrSettle); extra lines are allowed (<); a failed read just proceeds. */
      const wantN = S.cart.reduce((s, l) => { const v = P(l.h) && P(l.h).vars[l.vi]; return s + (v && !kbWarrVid(v.id) ? (+l.qty || 0) : 0); }, 0);
      fetch(kbMkt('/cart.js'), { credentials:'same-origin', headers:{ 'Accept':'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null).then(c => {
        if (went) return;
        const n = c && Array.isArray(c.items) ? c.items.reduce((s, i) => s + (kbWarrVid(+i.variant_id) || (i.properties && i.properties._protection_product) ? 0 : (+i.quantity || 0)), 0) : null;
        if (n !== null && n < wantN){ stay(); return; }
        nav('/checkout');
      });
    }, err => {
      merging = false;
      /* 2026-09-26 cartfix: the surplus cut failed, so the cart may hold the kit twice. Stay, let the background sync
         re-read it, and ask for another tap rather than sending the buyer to a doubled checkout. */
      /* 2026-10-10 audit: ANY merge failure stays now (was: only kbSurplus), so a failed kit add, cover write or 429 never lands the buyer on a different cart than the one shown */
      if (!went){ stay(); return; }
      nav('/checkout');
    });
  } catch(_){ nav('/checkout'); }
}
/* 2026-07-28: resolve a product from a variant id, for naming a rejected line in the sold-out toast.
   DATA is keyed by handle, so this walks its values. Only ever called on a failed checkout. */
function PID(vid){
  for (const h in DATA){ const p = DATA[h]; if (p && (p.vars||[]).some(v => v.id === vid)) return p; }
  return null;
}
/* 2026-07-31 warranty QA fixes (defects 14/15/16/17 of the 07-30 audit).
   kbWarrVid: is this variant id one of the two warranty products? Shared test for the checkout
   coverage, the sync classifier and the sold-out recovery below.
   KB_APPWARR: dollars of NON-_kb warranty lines riding in the real cart (the site/app's own adds).
   Those fold into the warranty row + Total instead of the "+N more items" ride note, and checkout
   coverage treats them as covering the builder's warranty want ACROSS tiers, so a cart already
   carrying an app warranty can never be double-charged by the builder toggle. `var`, not `let`:
   calc() reads it and can be called before this line runs on a future refactor - hoisted undefined
   coerces safely, a TDZ throw would kill the page. */
/* 2026-09-25 (Claude): warranty PRICE STEPS (window.AOAM_WARR, snippets/aoam-warr-tiers.liquid). The kit's goods in
   USD pick the step for the row; kbWarrSettle() then makes the REAL cart carry exactly one cover line, at the step of
   the whole cart, right after the kit lands at checkout. Every function here falls back to the old per-light model
   when the steps are unavailable. */
function kbWarrStepsOn(){ return !!(window.AOAM_WARR && window.AOAM_WARR.tiers && window.AOAM_WARR.tiers.length); }
function kbGoodsUsd(){ return Math.max(0, S.cart.reduce(function(s, l){ var p = P(l.h), v = p && p.vars[l.vi]; if (!v || kbWarrVid(v.id)) return s; return s + (+v.p || 0) * (+l.qty || 0); }, 0) - Math.max(0, +window.KB_LINELVL || 0)); }   /* 2026-11-03 cart audit C-002: net of line-level discounts (the pair deal), as aoam-warr-tiers goodsUsd. Roll back: drop the Math.max wrapper and the KB_LINELVL term. */
function kbWarrStepUsd(){ return kbWarrStepsOn() ? window.AOAM_WARR.stepUsd(kbGoodsUsd()) : 0; }
function kbWarrSettle(req, post, token, cart0){
  if (!kbWarrStepsOn()) return Promise.resolve(null);
  var W = window.AOAM_WARR, n0 = kbWarrPickN;
  return (cart0 ? Promise.resolve(cart0) : req('/cart.js', { headers: { 'Accept': 'application/json' } })).then(function(cart){
    var t = W.tier(cart);
    var covers = (cart.items || []).filter(function(i){ return W.isCover(i) && (+i.quantity || 0) > 0; });
    /* a Saber Lab cover line (_sl, its own flat per-saber price) is this order's cover: never stack a step line on it */
    /* 2026-09-26 (Claude, cart-fix kb-cover: kb-code-3 / kb-desktop-2 / cross-cart-1/2). The choice is the site's own
       per-cart flag (kbWarrOptIn), so the builder, the site drawer and checkout read ONE answer. Was
       "S.warranty || covers.length > 0", which charged cover the shopper had removed here and never showed cover
       added on the site. Removing cuts only owned cover (_protection_product / _kb / _sl), never a bought line. */
    var on = kbWarrOptIn(cart);
    var own = function(i){ var p = i.properties || {}; return !!(p._protection_product || p._kb || p._sl); };
    /* 2026-10-05 (Claude, cart audit KB-02): window.KB_COVER6 = the cover this cart holds once settled (USD) and the goods basis
       it was priced on, so kb6's warranty row shows that line's real price (a Saber Lab cover keeps its own flat price) whenever
       its kit matches the cart. Roll back: delete kbCov6 and its calls, and the covFlip lines in kbCartSync. */
    var kbCov6 = function(list, tier){ try { var r6 = cart.currency && cart.currency === 'USD' ? 1 : W.rate(); window.KB_COVER6 = { usd: tier ? W.usdPrice(tier) : Math.round(list.reduce(function(s, i){ return s + W.lineUsdCents(i, r6); }, 0)) / 100, basis: Math.round(W.goodsUsd(cart) * 100) / 100 }; } catch (e) {} };
    if (on && covers.some(function(i){ return !!(i.properties || {})._sl; })) { kbCov6(covers); return n0 === kbWarrPickN ? on : null; }
    var want = !!t && on;
    if (want) kbCov6(null, t); else kbCov6(covers.filter(function(i){ return !own(i); }));   /* 2026-10-05 cart audit KB-02: the step it keeps or adds, or the bought cover a cut leaves. Roll back: delete this line. */
    var kept = null, ups = {};
    covers.forEach(function(i){
      var right = want && !kept && String(i.variant_id) === String(t.id) && (i.properties || {})['Extended Warranty'] === W.DES;
      if (right){ kept = i; if (+i.quantity !== 1) ups[i.key] = 1; } else if (want || own(i)) ups[i.key] = 0;
    });
    var chain = Object.keys(ups).length ? post('/cart/update.js', { updates: ups }) : Promise.resolve();
    return chain.then(function(){
      if (!want || kept) return null;
      /* the site's own line format with no _kb tag, so kbSyncCart never sweeps it and the drawer treats it as its own */
      return post('/cart/add.js', { items: [{ id: t.id, quantity: 1, properties: { 'Extended Warranty': W.DES, '_protection_product': true } }] });
    }).then(function(){ return n0 === kbWarrPickN ? on : null; });
  }).catch(function(e){ if (token !== 'kbsync') throw e; return null; });   /* 2026-10-10 audit: checkout must hear a failed cover write (the background sync, token 'kbsync', still swallows it) */
}
/* 2026-09-26 (Claude, cart-fix kb-cover). kbWarrOptIn is the site's aoamWarrOptIn (snippets/aoam-cart-fix.liquid),
   ported because this layout never loads that file: ONE choice per cart, 'false' = on and 'true' = removed, scoped by
   aoam_warr_cart_token ('pending' binds to the next cart read); with no choice made, a cart that already carries cover
   keeps it and counts as opted in. kbWarrPick is kb6's "+ $X" / Remove, written the way aoamWarrTap writes it, then
   an immediate kbCartSync puts the one cover line in (or takes it out of) the real cart. */
var kbWarrPickN = 0;
function kbWarrOptIn(cart){
  var F = 'warranty_toogle_is_disable_by_user', T = 'aoam_warr_cart_token', v = null, tok = null;
  var has = ((cart && cart.items) || []).some(function(i){ return (+i.quantity || 0) > 0 && ((i.properties || {})._protection_product || kbWarrVid(+i.variant_id)); });
  try { v = localStorage.getItem(F); tok = localStorage.getItem(T); } catch (e) { return !!S.warranty; }
  var ctok = cart && cart.token ? String(cart.token) : '';
  if (!ctok) return v === 'false';
  try {
    if (tok === 'pending'){ localStorage.setItem(T, ctok); tok = ctok; }
    if (v !== null && tok !== ctok){ localStorage.removeItem(F); localStorage.removeItem(T); v = null; }
  } catch (e) {}
  if (v === 'false') return true;
  if (v === 'true') return false;
  if (has){ try { localStorage.setItem(F, 'false'); localStorage.setItem(T, ctok); } catch (e) {} return true; }
  return false;
}
function kbWarrPick(on){
  try { localStorage.setItem('warranty_toogle_is_disable_by_user', on ? 'false' : 'true'); localStorage.setItem('aoam_warr_cart_token', 'pending'); } catch (e) {}
  S.warranty = !!on; kbWarrPickN++;
  kbSyncDirty = true; kbRetry = 0; clearTimeout(kbSyncT); kbSyncT = setTimeout(kbCartSync, 0);
}
function kbWarrVid(id){
  if (window.AOAM_WARR && window.AOAM_WARR.isTierId(id)) return true;   /* 2026-09-25: every price step is warranty */
  return [WARR1, WARR2].some(function(h){ var p = DATA[h]; return p && (p.vars||[]).some(function(v){ return v && v.id === id; }); });
}
var KB_APPWARR = 0;
/* 2026-08-15 (Claude) THE CURRENCY FIREWALL, and it guards ARITHMETIC, not wording.
   KB_APPWARR is built from /cart.js `final_line_price`, which Shopify returns in the shopper's
   PRESENTMENT currency. warrTotalCost() comes out of the baked USD snapshot in
   kit-builder-data.js. Comparing the two with max() only means anything when they are the same
   currency. Outside a USD market they are not, and since CAD, AUD, EUR and GBP are all
   numerically larger than USD at any plausible rate, the presentment figure won that max()
   essentially always and INFLATED both the warranty row and the cart Total.
   This page has no exchange rate and cannot get one, so it REFUSES the comparison rather than
   guessing: in a non-USD market the rig is priced from its own USD need alone. That can never
   UNDER-quote, because warrTotalCost() is the FULL cover the rig needs and not the difference,
   and Shopify charges the real amount at checkout either way.
   The max() itself is NOT the bug and must stay for USD - it is the 2026-08-15 fix for a partial
   warranty pinning the quote at $19.95 forever. This only stops it crossing currencies.
   Gated on IS_USD, not IS_US, deliberately: a country with no dedicated market still presents
   USD, and there the comparison is valid and stays.
   TO ROLL BACK: delete this function and inline KB_APPWARR at its four call sites (calc(),
   warrBlockHTML(), and the two warranty render gates). */
function kbAppWarrComparable(){ return IS_USD ? KB_APPWARR : 0; }
/* 2026-09-28 (Claude, cart-fix kb-money-m C131): kb6 priced the kit from baked prices only, so a discount code already in
   the cart never reached its Subtotal, TOTAL or free-shipping test (TOTAL $96.95 vs checkout $87.95). This keeps the
   order-level discount (items_subtotal_price - total_price, the site drawer's aoamCartLvl) in window.KB_CARTLVL, in USD
   dollars, and kb6 totals() takes it off. Only in a USD cart, for the same reason as the currency firewall above.
   Returns true when it moved. Roll back: delete this function, its two calls in kbCartSync and the re-read there. */
window.KB_CARTLVL = window.KB_CARTLVL || 0;
function kbCartLvlFrom(cart){
  if (!cart || !isFinite(cart.items_subtotal_price) || !isFinite(cart.total_price)) return false;
  var usd = cart.currency ? cart.currency === 'USD' : IS_USD;
  /* 2026-11-03 (Claude, cart audit C-004/G-003, Joel: "lets ship all"): outside USD the discounts were zeroed, so an AUD pair read
     $319.90 while the cart had already taken A$14.43 ($9.95) off. They now convert to USD the way aoam-warr-tiers prices the
     warranty step: each line's discount at that variant's own USD / local ratio (W.lineUsdCents, the custom.warr_usd_cents map),
     else local / Shopify.currency.rate; the order-level part at the rate. No rate available: zero, as before.
     Roll back: delete r6x and wW, and put back usd ? ... : 0 on v and lin. */
  var wW = window.AOAM_WARR, r6x = usd ? 1 : (wW && typeof wW.rate === 'function' ? +wW.rate() : 0);
  var v = r6x > 0 ? Math.round(Math.max(0, cart.items_subtotal_price - cart.total_price) / r6x) / 100 : 0, was = window.KB_CARTLVL || 0;
  window.KB_CARTLVL = v;
  /* 2026-10-19 (Claude, checkout audit KBW-01): also keep the LINE-level discounts (the pair deal from the aoam-discounts
     function: -$9.95 on a second BitWhip kit, -$40 + a free connector on two kits) in window.KB_LINELVL, USD dollars, as
     original_total_price - items_subtotal_price, so kb6 TOTAL matches checkout; KB_LINELVL_T is the discount title.
     The kit saving is compare-at based, not a Shopify discount, so nothing is counted twice.
     Roll back: delete from here to the return and restore: return Math.abs(v - was) > 0.004; */
  var lin = usd && isFinite(cart.original_total_price) ? Math.max(0, cart.original_total_price - cart.items_subtotal_price) / 100 : 0, tl = '';
  if (!usd && r6x > 0) { try { lin = isFinite(cart.original_total_price) ? Math.round(Math.max(0, cart.original_total_price - cart.items_subtotal_price) / r6x) / 100 : 0; } catch (e) { lin = 0; } }   /* 2026-11-03 C-004, see r6x. The pair deal is a USD amount Shopify converts at the rate (A$14.43 = $9.95), so it converts back at the rate; the per-variant price ratio read $9.91. */
  if (lin > 0) { try { var ts = {}; (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var x = a && a.amount > 0 && a.discount_application && a.discount_application.title; if (x) ts[String(x)] = 1; }); }); var tk = Object.keys(ts); tl = tk.length === 1 ? tk[0] : (tk.length ? 'Discounts' : ''); } catch (e) {} }
  var wasL = window.KB_LINELVL || 0, wasT = window.KB_LINELVL_T || '';
  /* 2026-10-25 INTL-1: the real cart weight for kbIntlShipLabel, any currency; a move repaints only outside the US. Roll back: delete these two lines and the wasW term in the return. */
  var wasW = +window.KB_CARTWT || 0;
  if (isFinite(cart.total_weight)) window.KB_CARTWT = +cart.total_weight;
  window.KB_LINELVL = lin; window.KB_LINELVL_T = tl;
  return Math.abs(v - was) > 0.004 || Math.abs(lin - wasL) > 0.004 || tl !== wasT || (!IS_US && Math.abs((+window.KB_CARTWT || 0) - wasW) > 0.5);
}
/* ---- 2026-08-13 warranty rework (Joel: "let the site own all warranty") ----
   snippets/aoam-cart-fix.liquid builds its `desired` warranty coverage from `_warranty_pro_id` +
   `_warranty_pro_des` on ELIGIBLE (non-warranty) cart lines, and its `existing` warranty lines from
   `_protection_product` + an `Extended Warranty` property. A Kit Builder cart carried neither, so a
   shopper who never used the builder's own Secure Checkout got no warranty offer on the main site at
   all. Just stamping `_warranty_pro_id` on KB lines without ALSO tagging the KB's own warranty line
   the same way DOUBLE-CHARGED (the $189.85 incident, July): the site's writer sees an eligible line
   with no matching `existing` entry and POSTs a second warranty line ~700ms after the drawer opens.
   This block makes the KB emit exactly what product-form.liquid (the site's own writer, see line 11)
   would: `_warranty_pro_des` = "<warranty product description | strip_html> <kit product title>",
   verbatim, so `warrDesFor` is the SAME function used to tag both the covered kit line and the KB's
   own warranty line - they can never disagree.
   Selection is PER KIT, not global cart light count (KIT_LIGHTS[h] mirrors the live
   custom.extended_warranty metafield, verified 10/10 against Admin API): a 1-light kit always maps
   to WARR1, a 2-light kit always to WARR2, exactly like the metafield product-form.liquid reads on
   an ordinary PDP add. That is also why bucketing by `_warranty_pro_des` (which embeds the kit
   TITLE) rather than warrCost's old global pair-tiering is correct: two different kit types never
   legitimately merge into one warranty line under the site's own logic, and a single kit of any
   type already prices to the cent either way. */
/* 2026-08-18 (Claude) - Joel's call, asked and answered: "offer cover on it too".
   THE STANDALONE RGB CRITTER WAS THE ONE WARRANTY-ELIGIBLE PRODUCT THIS BUILDER COULD ADD AND
   NEVER COVER. Measured against the Admin API: exactly 13 active products carry
   custom.extended_warranty - the 12 KIT_LIGHTS handles plus the Critter itself - and every gate
   here tested (isKit(h) && KIT_LIGHTS[h]), which is false for the Critter because its DATA entry is
   cat:'core', not a kit. So the identical variant was offered Lifetime Warranty from its own PDP
   and silently never offered it from the builder.
   ONE predicate, used by BOTH warrPropsFor and warrBuckets, because those two are the pair that
   must never disagree: warrPropsFor stamps the COVERED line and warrBuckets builds the COVER line,
   and the site's writer in snippets/aoam-cart-fix.liquid matches them by _warranty_pro_des. If only
   one of them learned about the Critter, the site would see an eligible line with no matching
   existing cover and POST a second warranty line ~700ms after the drawer opens - the July $189.85
   double charge, exactly. Keeping the test in one function is the guard against that.
   The Critter tiers to WARR1 and that is already right: warrVidFor keys on KIT_LIGHTS >= 2, the
   Critter yields 0, and its live metafield points at the $19.95 single-light product (verified on
   the PDP render: _warranty_pro_id 45645998981345, price 1995).
   To roll back: delete warrEligible and restore the two inline (isKit(h) && KIT_LIGHTS[h]) tests,
   and drop the Critter line from KB_WARR_TITLE in templates/page.kit-builder.liquid. */
function warrEligible(h){ return (isKit(h) && !!KIT_LIGHTS[h]) || h === CRITTER; }
function warrVidFor(h){ return (KIT_LIGHTS[h]||0) >= 2 ? WARR2 : WARR1; }
/* 2026-08-15: the bucket key has to BYTE-MATCH what snippets/product-form.liquid writes, and that
   uses Shopify's own `product.title`. KB_DATA's `title` is a DISPLAY name maintained by hand and it
   has drifted: the BitWhip reads "BitWhip Fiber Optic Whip" here against "BitWhip Kit" on Shopify
   (audited 2026-08-15 - 1 of the 13 warranty-eligible products, but that one is the product Joel
   reported). One product then occupies TWO coverage buckets, so a cart that has been through both
   surfaces makes the site's writer zero its own warranty line and add a replacement under the other
   key - churn on the money path for no reason, and a window where the cart is briefly uncovered.
   window.KB_WARR_TITLE is printed by templates/page.kit-builder.liquid straight from Shopify, so it
   cannot drift; P(h).title stays the fallback and stays the display name everywhere else.
   TO ROLL BACK: drop the KB_WARR_TITLE lookup and the emit in the template. */
function warrTitleFor(h){
  var p = P(h);
  return (window.KB_WARR_TITLE && window.KB_WARR_TITLE[h]) || (p && p.title) || '';
}
function warrDesFor(h){
  var wh = warrVidFor(h);
  var base = (window.KB_WARR_DESC && window.KB_WARR_DESC[wh === WARR2 ? 'WARR2' : 'WARR1']) || '';
  return base + ' ' + warrTitleFor(h);
}
/* the site-shaped properties for an eligible non-warranty KIT line, or null. Gated on !kbWarrVid so
   a warranty line is never re-tagged as if it were a covered product. */
function warrPropsFor(h, vid){
  if (kbWarrVid(vid) || !warrEligible(h)) return null;
  var wh = warrVidFor(h), wv = P(wh) && P(wh).vars[0];
  if (!wv || !wv.id) return null;
  return {
    _warranty_pro_id: wv.id,
    _warranty_pro_des: warrDesFor(h),
    _warranty_pro_price: Math.round((wv.p || 0) * 100),   /* KB_DATA vars[].p is DOLLARS; this property is CENTS */
  };
}
/* the KB's own warranty line(s): ONE per _warranty_pro_des bucket, tagged `_protection_product` +
   `Extended Warranty` so aoam-cart-fix.liquid finds it in `existing` and RESIZES it instead of
   adding a second one. A sold-out tier is left out rather than silently substituted (defect 16),
   same guard warrUnits used to carry. */
function warrBuckets(cartArr){
  var buckets = {};   // des -> { vid, price, qty }
  (cartArr || S.cart).forEach(function(l){
    if (!warrEligible(l.h)) return;
    var des = warrDesFor(l.h), wh = warrVidFor(l.h), wv = P(wh) && P(wh).vars[0];
    if (!wv || !wv.id || !wv.a) return;
    if (!buckets[des]) buckets[des] = { vid: wv.id, price: wv.p || 0, qty: 0 };
    buckets[des].qty += l.qty;
  });
  return buckets;
}
function warrLinesByBucket(){
  var buckets = warrBuckets();
  return Object.keys(buckets).map(function(des){
    return { id: buckets[des].vid, quantity: buckets[des].qty,
      properties: { 'Extended Warranty': des, '_protection_product': true } };
  });
}
/* the builder's own running-total price for the warranty row/Total, kept in step with
   warrLinesByBucket so the number quoted pre-checkout matches what checkout actually charges - the
   old warrCost(lightsInCart()) global pair-tiering could diverge across MULTIPLE separate kit types
   (see the BitWhip example in CLAUDE.md), even though it always agreed for a single kit. */
function warrTotalCost(cartArr){
  var buckets = warrBuckets(cartArr), total = 0;
  Object.keys(buckets).forEach(function(des){ total += buckets[des].price * buckets[des].qty; });
  return total;
}
/* 2026-07-30 - Joel: "WHEN SWITCHING BETWEEN THE KIT BUILDER, SABER BUILDER, AND WEBSITE THE CARTS
   SHOULD ALWAYS MATCH WHAT IS INCLUDED". The kit used to live only in localStorage and touch the real
   cart at checkout, so leaving for the site or the Saber Lab showed a cart that disagreed with the
   kit, and cart edits made elsewhere never came back here. kbCartSync() now keeps the kit and the
   live Ajax cart in step both ways, using the same conventions as the Saber Lab's cart sync:
     - Reconcile rule: since the last sync, the kit's own delta AND the cart's outside delta both
       apply (target = kit + live - ledger). So a PDP add appears in the kit, a drawer delete leaves
       the kit too, a kit edit writes through to the real cart, and a completed checkout (cart now
       empty) clears the kit instead of re-showing bought items.
     - The ledger (localStorage aoam-kb-pushed) is the per-variant qty this builder last knew the
       cart to hold; it is how an outside change is told apart from the kit's own.
     - Additions go up as one /cart/add.js batch tagged _kb (the hidden-property convention the
       checkout sweep already reads); reductions go per line key via /cart/change.js, never beyond
       the kit's own numbers. Lines the kit cannot map (apparel, saber parts) are NEVER touched;
       they render under the total via kbRideHTML(), the Saber Lab's "+N more items ride this same
       order" note, so the two builders describe a shared cart the same way.
     - Every request is keepalive so a mid-navigation flight still lands; any failure (offline,
       bot-mitigation 429) just leaves the dirty flag set and retries on the next trigger.
   Triggers: boot, tab return (visibilitychange visible + bfcache pageshow), every kit mutation via
   persist(), and a flush on pagehide/hidden. Delete this block, the kbCartTouch() calls in persist()
   / boot / pageshow, and the kbRideHTML() rows in renderRig/renderDrawer to roll back. */
let KB_RIDE = [];
let kbSyncT = null, kbSyncBusy = false, kbSyncDirty = false, kbSyncSig = '', kbRetry = 0, kbCoNow = false;
let kbSyncP = null, kbCoGo = false;   /* 2026-09-26 cartfix: the in-flight kbCartSync promise, and the checkout re-entry guard */
function kbVidMap(){
  const m = {};
  for (const h in DATA){ const p = DATA[h]; if (!p || !p.vars) continue;
    p.vars.forEach((v,i) => { if (v && v.id) m[v.id] = {h:h, vi:i}; }); }
  /* the warranty products are deliberately NOT synced: the site's warranty app sells the same
     variants with its own line properties and its own quantity rules (verified on stage 2026-07-30:
     2x Lifetime Warranty riding 2 Critters), so folding them into the S.warranty flag mis-rounds
     and then CUTS the app's lines. They ride via KB_RIDE instead; checkout's non-_kb coverage
     already stops a double-add there. */
  [WARR1, WARR2].forEach(h => { const p = DATA[h]; ((p && p.vars)||[]).forEach(v => { if (v && v.id) delete m[v.id]; }); });
  return m;
}
/* 2026-10-05 (Claude, cart audit KB-01; Joel 2026-09-24: "cant we just have the products seemlessly move between carts?").
   A /cart.js line whose variant this catalogue does not know (a product or a variant added to the store after this file and
   kit-builder-data.js were built: the 09-29..10-01 packs, the 10-01 Contact Saber Kit patterns, and every future one) rode in
   KB_RIDE, which kb6 never draws or counts. The builder's TOTAL then understated the cart (measured $159.90 against a $622.80
   checkout) and its Secure checkout wrote the provisional Critter on top. kbX6From gives such a line a RUNTIME entry here, built
   from the cart line itself (title, variant title, image, USD unit price; requires_shipping and gift_card kept for NOSHIP), so
   the ordinary fold, ledger, qty, bin and totals handle it, and kb6 makes the matching row from this entry (cartOnly6 in kb6.js).
   An unknown variant of a known product joins that product, so a kit keeps its lights, warranty stamp and In the box. Warranty
   and cover lines are never synthesised (they stay on the warranty row). The entries are kept in localStorage 'aoam-kb-x6' and
   put back before restore(), because restore() drops a saved line it cannot find and the ledger would then cut that line from
   the real cart on the next sync; kbGoneVids is the safety net if that store is ever lost. Prices: USD carts take the line's
   unit price, other carts window.AOAM_WARR.lineUsdCents (else price / rate), the same USD the warranty step reads.
   Roll back: delete this block and its calls (restore(), the top of kbCartSync's read, x6Moved) and the kbGoneVids lines. */
var kbGoneVids = {}, KB_X6_IMG = 'https://cdn.shopify.com/s/files/1/0018/5483/2692/files/custom_order.png?v=1741821643';
function kbX6Put(h, e){
  if (!h || !e || !Array.isArray(e.vars)) return false;
  let p = DATA[h], moved = false;
  if (!p){ p = DATA[h] = { title: String(e.title || h), cat: 'power', sub: 'power', type: String(e.type || ''), imgs: [String(e.img || KB_X6_IMG)], desc: '', vars: [], vid: null, vids: [], x6: 1 }; if (e.ship === false) p.ship6 = false; if (e.gift) p.gift6 = true; moved = true; }
  e.vars.forEach(v => {
    const id = +v.id; if (!id) return;
    const ex = (p.vars || []).find(x => x && x.id === id);
    if (ex){ if (ex.x6 && Math.abs((+ex.p || 0) - (+v.p || 0)) > 0.004){ ex.p = +v.p || 0; moved = true; } return; }
    const nv = { id: id, t: String(v.t || 'Default Title'), p: +v.p || 0, a: true, x6: 1 };
    if (v.img) nv.img = String(v.img);
    p.vars.push(nv); moved = true;
  });
  return moved;
}
function kbX6Load(){
  let st = null; try { st = JSON.parse(localStorage.getItem('aoam-kb-x6') || 'null'); } catch (e) { st = null; }
  if (!st || typeof st !== 'object') return;
  Object.keys(st).forEach(h => { try { kbX6Put(h, st[h]); } catch (e) {} });
}
function kbX6From(cart){
  const W = window.AOAM_WARR, items = (cart && cart.items) || [];
  const usd = !cart || !cart.currency || cart.currency === 'USD';
  const r = usd ? 1 : ((W && W.rate) ? W.rate() : ((+(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)) || 1));
  const byId = {};
  Object.keys(DATA).forEach(h => { ((DATA[h] && DATA[h].vars) || []).forEach(v => { if (v && v.id) byId[v.id] = v; }); });
  let moved = false;
  items.forEach(it => {
    const vid = +it.variant_id, qn = +it.quantity || 0, h = String(it.handle || '');
    if (!vid || !h || qn <= 0 || kbWarrVid(vid) || (W && W.isCover && W.isCover(it))) return;
    const known = byId[vid];
    if (known && !known.x6) return;
    const unit = +it.original_price || +it.price || 0;
    const cents = usd ? unit : ((W && W.lineUsdCents) ? W.lineUsdCents(it, r) / qn : unit / r);
    if (kbX6Put(h, { title: it.product_title || it.title || h, type: it.product_type || '', img: it.image || '', ship: it.requires_shipping !== false, gift: !!it.gift_card,
      vars: [{ id: vid, t: it.variant_title || 'Default Title', p: Math.round(cents) / 100, img: it.image || '' }] })) moved = true;
  });
  if (moved) window.KB_X6V = (+window.KB_X6V || 0) + 1;
  /* keep what the next page load needs: this cart's lines, the saved kit's and the ledger's (restore() runs before any cart read) */
  const keep = {}, led = kbLedger();
  items.forEach(it => { keep[+it.variant_id] = 1; });
  S.cart.forEach(l => { const pp = P(l.h), v = pp && pp.vars[l.vi]; if (v) keep[v.id] = 1; });
  Object.keys(led).forEach(k => { if (+led[k] > 0) keep[+k] = 1; });
  const store = {}; let n = 0;
  Object.keys(DATA).forEach(h => { const pp = DATA[h]; ((pp && pp.vars) || []).forEach(v => {
    if (!v || !v.x6 || !keep[v.id]) return;
    const o = store[h] = store[h] || { title: pp.title, type: pp.type || '', img: (pp.imgs || [])[0] || '', ship: pp.ship6 !== false, gift: !!pp.gift6, vars: [] };
    o.vars.push({ id: v.id, t: v.t, p: v.p, img: v.img || '' }); n++;
  }); });
  try { if (n) localStorage.setItem('aoam-kb-x6', JSON.stringify(store)); else localStorage.removeItem('aoam-kb-x6'); } catch (e) {}
  return moved;
}
function kbLedger(){ try{ return JSON.parse(localStorage.getItem('aoam-kb-pushed')||'{}')||{}; }catch(e){ return {}; } }
function kbLedgerWrite(o){ try{ localStorage.setItem('aoam-kb-pushed', JSON.stringify(o)); }catch(e){} }
function kbCartTouch(entry){
  /* entry = a fresh look at the page (boot / tab return): always re-read the live cart.
     A mutation tick only syncs when the kit actually changed since the last completed sync. */
  if (!entry && JSON.stringify(kbLines()) === kbSyncSig) return;
  kbSyncDirty = true; kbRetry = 0;
  clearTimeout(kbSyncT); kbSyncT = setTimeout(kbCartSync, entry ? 0 : 600);
}
function kbCartSync(){
  clearTimeout(kbSyncT);
  if (!kbSyncDirty || kbSyncBusy) return;
  kbSyncBusy = true; kbSyncDirty = false;
  const O = { credentials:'same-origin', keepalive:true };
  const post = (url, body) => fetch(kbMkt(url), Object.assign({ method:'POST',
    headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) }, O))
    .then(r => { if (!r.ok) { const e = new Error('kb ' + r.status); e.status = r.status; throw e; } return r.json(); });   /* 2026-10-10 audit: carry the HTTP status so a 422 (stock ceiling) can be told from a 429 or a dropped connection. Was: throw 0 */
  return kbSyncP = fetch('/cart.js', Object.assign({ headers:{'Accept':'application/json'} }, O))
    .then(r => { if (!r.ok) throw 0; return r.json(); })
    .then(cart => {
      let x6Moved = false; try { x6Moved = kbX6From(cart); } catch (e) { console.warn('[kb] runtime cart entries threw', e); }   /* 2026-10-05 cart audit KB-01: see kbX6From. Roll back: delete this line and x6Moved below. */
      const vm = kbVidMap(), led = kbLedger();
      const lvlChanged = kbCartLvlFrom(cart), lvlCode = window.KB_CARTLVL > 0 || window.KB_LINELVL > 0 || ((cart.discount_codes || []).length > 0 && (cart.currency ? cart.currency === 'USD' : IS_USD));   /* 2026-09-28 kb-money-m C131 */
      const lines = {}, ride = [];
      let appWarrCents = 0;
      /* 2026-08-19 orphan warranty sweep - see the block after the target loop below.
         warrCart keeps the LINES, not just their money, because a line cannot be cut from a total.
         rideWarrElig: an unmapped (ride) line that carries site warranty eligibility. */
      const warrCart = [];
      let rideWarrElig = false;
      const kbUnit = {};   /* 2026-09-25 price steps: unit cents per variant, for the surviving-goods test below */
      (cart.items||[]).forEach(it => {
        const vid = +it.variant_id, pr = it.properties || {};
        /* 2026-07-31 warranty QA (defect 15): warranty lines are never ride rows. The builder's own
           _kb warranty IS the S.warranty charge already inside Total (it double-displayed after a
           checkout Back), and a non-_kb (site/app) warranty folds into the warranty row via
           KB_APPWARR instead. Delete this appWarrCents block and the appWarrChanged lines below,
           and KB_APPWARR stays 0 (inert), to roll back. */
        if (kbWarrVid(vid)){
          if (!pr._kb) appWarrCents += (+it.final_line_price||0);
          /* 2026-08-19: OWNERSHIP is decided here, once, on the properties the line really carries.
             _protection_product / _kb / _sl mean AUTO-ADDED cover that follows its product; a
             warranty line carrying none of those is the shopper's own purchase off the warranty PDP
             and is never swept. Same rule aoamIsWarrantyLine applies in aoam-cart-fix.liquid. */
          warrCart.push({ key: it.key, vid: vid, qty: +it.quantity||0, cents: (+it.final_line_price||0),
                          kb: !!pr._kb, sl: !!pr._sl, owned: !!(pr._protection_product || pr._kb || pr._sl) });
          return;
        }
        if ((+it.quantity||0) > 0) kbUnit[vid] = (+it.final_line_price||0) / (+it.quantity||1);
        const vis = Object.keys(pr).some(k => k.charAt(0) !== '_');   /* visible props = app-configured line */
        if (vm[vid]) (lines[vid] = lines[vid]||[]).push({ key: it.key, q: +it.quantity||0, rank: pr._kb ? 0 : (vis ? 2 : 1) });
        else { ride.push({ title: it.title, qty: +it.quantity||1, cents: +it.final_line_price||0 });
               if (pr._warranty_pro_id) rideWarrElig = true; }
      });
      const rideChanged = JSON.stringify(ride) !== JSON.stringify(KB_RIDE);
      KB_RIDE = ride;
      const appWarrWas = KB_APPWARR;   /* 2026-08-19: compared at the END now, because the sweep below can still lower appWarrCents */
      KB_APPWARR = appWarrCents/100;
      /* want{} AFTER the cart pass above, not before it: kbLines() consults KB_APPWARR, and a
         stale value here could drop the builder's own warranty from this sync while stamping a
         matching kbSyncSig - the shortfall would then never self-correct (review item 2, 2026-07-31).
         Only vm-mapped lines take part; kbLines' warranty line is deliberately not in vm. */
      const want = {}; kbLines().forEach(l => { if (vm[l.id]) want[l.id] = (want[l.id]||0) + l.quantity; });
      const vids = {};
      Object.keys(want).forEach(v => vids[v]=1); Object.keys(lines).forEach(v => vids[v]=1);
      Object.keys(led).forEach(v => { if (vm[+v]) vids[v]=1; });
      const adds = [], cuts = [], nextLed = {};
      let kitChanged = false, foldGone = 0;   /* foldGone: kit lines the OUTSIDE cart deleted (see the render note below) */
      let cartWarrElig = rideWarrElig;        /* 2026-08-19: does anything SURVIVING this sync still carry cover? */
      let kbStepCents = 0;   /* 2026-09-25: presentment cents of the kit lines that SURVIVE this sync */
      Object.keys(vids).forEach(vs => {
        const vid = +vs, m = vm[vid];
        if (!m) return;
        const have = (lines[vid]||[]).reduce((s,l)=>s+l.q, 0);
        const w = want[vid]||0, base = kbGoneVids[vid] ? 0 : (led[vid]||0);   /* 2026-10-05 cart audit KB-01: a saved line restore() could not find is not a delete, so the real cart line is folded back instead of cut. Roll back: base = led[vid]||0 and drop the next line. */
        delete kbGoneVids[vid];
        const target = Math.max(0, Math.min(99, w + have - base));
        /* 2026-08-13: stamp _warranty_pro_* here too (warrPropsFor(m.h, vid) - m.h is this vid's
           handle from vm). This is the path that matters most for the original bug report: a kit
           added without ever visiting checkout still reaches the real cart with warranty eligibility
           on it, so the main-site drawer (aoam-cart-fix.liquid) adds the correct single warranty
           line itself the first time it is opened. Warranty variants are never vm-mapped (see
           kbVidMap above), so this loop can never itself add a warranty line - only kit lines. */
        if (target > have) adds.push({ id: vid, quantity: target - have, properties: Object.assign({ _kb: 'kbsync' }, warrPropsFor(m.h, vid) || {}) });
        else if (target < have){
          let cut = have - target;
          /* cut our own _kb lines first, plain lines next, and app-configured lines (visible
             properties, e.g. a PDP warranty add-on) only as the last resort */
          const ranked = (lines[vid]||[]).slice().sort((a,b)=>a.rank-b.rank);
          ranked.forEach(l => { if (!cut) return; const c = Math.min(l.q, cut); cuts.push({ id: l.key, quantity: l.q - c, vid: vid, rm: c }); cut -= c; });
        }
        nextLed[vid] = target;
        if (target > 0) { const kv = P(m.h) && P(m.h).vars[m.vi]; kbStepCents += target * (kbUnit[vid] != null ? kbUnit[vid] : (kv ? +kv.p * 100 * (window.AOAM_WARR ? window.AOAM_WARR.rate() : 1) : 0)); }
        if (target > 0 && warrEligible(m.h)) cartWarrElig = true;   /* 2026-08-19: read the TARGET, not the pre-sync qty */
        if (target !== w){   /* fold the outside change back into the kit's own state */
          kitChanged = true;
          const i = lineIdx(m.h, m.vi);
          if (i >= 0){ if (target > 0) S.cart[i].qty = target; else { S.cart.splice(i,1); foldGone++; } }
          else if (target > 0 && P(m.h).vars[m.vi] && P(m.h).vars[m.vi].a) S.cart.push({ h:m.h, vi:m.vi, qty:target });
          /* 2026-09-26 (Claude, cart-fix kb-lines, kb-code-4): a line the kit REFUSED to fold (baked sold out, but Shopify sold it into the cart)
             is not the kit's, so it must not enter the ledger. Recording it made the next sync read want 0 + have 1 - ledger 1
             = 0 and DELETE it from the real cart on the next tab return or kit edit. Roll back: delete this else. */
          else if (target > 0) delete nextLed[vid];
        }
      });
      /* 2026-08-15 RENDER RACE (CLAUDE.md TOP TODO, evidenced 1 fail in 57 measurements).
         The fold loop above mutates S.cart SYNCHRONOUSLY, the moment /cart.js resolves, but the only
         renderAll() used to sit inside chain.then() below - i.e. after the whole add.js + change.js
         round trip. For the length of those POSTs the drawer kept drawing a row that kbLines() no
         longer carried, so the panel and the checkout permalink disagreed, and a line could be
         SILENTLY deleted from a shopper's kit with no toast at all (restore() announces its
         removals; this path did not). Paint the moment the state changes, and say so.
         The post-chain renderAll() below STAYS: that one reflects the SERVER's answer - ride rows,
         KB_APPWARR, a mutation that failed - which is not known yet here.
         persist() is deliberately NOT called here: it funnels into kbCartTouch(), and kbSyncSig is
         not stamped until the chain resolves, so an early persist would schedule a redundant sync.
         The toast is suppressed on an EMPTY cart because that is the post-checkout clear (see the
         reconcile rule at the top of this block), not an edit the shopper needs telling about.
         Delete this whole if-block to roll back. */
      /* ===== ORPHAN WARRANTY SWEEP (2026-08-19) ==============================================
         Joel, on a Kit Builder cart holding five 18650 batteries: "the lifetime warranty stays
         toggled on after removing products that include it from the cart." His screenshot's own
         arithmetic proves the charge was real and not just a stale row: 49.75 + 6.95 + 19.95 =
         76.65, and the free-shipping bar asked for 29.30 more, i.e. 99 - 69.70.
         WHY IT HAPPENED: on this page a warranty line is only ever GROWN. The read loop above skips
         every warranty vid (they are deliberately absent from kbVidMap, see the note there), the
         checkout path kbSyncCart sweeps only _kb lines, and snippets/aoam-cart-fix.liquid - which
         owns every orphan case on the rest of the store - is not rendered by this page's layout at
         all (measured: window.warrantyInit is undefined here). So once the covered product left the
         cart the cover stayed, and warrBlockHTML's "app" branch then drew it as "Lifetime Warranty
         Added" with the switch DISABLED: a charge the shopper could see, had not asked for, and
         could not remove.
         THE DECISION IS TAKEN HERE, after the target loop, on purpose. cartWarrElig reads each
         line's TARGET quantity, so this is the cart as it will be once this sync's own adds and cuts
         land. Deciding it off the raw read instead would sweep the cover off a kit this very pass is
         about to push. warrTotalCost() is the rig's own want, read after the fold above, so a kit
         still holding a light always keeps its cover.
         ROLLBACK: delete this block, the warrCuts chain below, the warrCart / rideWarrElig /
         cartWarrElig collectors, and restore the one-line appWarrChanged const above. */
      const warrCuts = [];
      const kbStepsGone = kbWarrStepsOn() && !window.AOAM_WARR.forUsd((ride.reduce((s, r) => s + (+r.cents || 0), 0) + kbStepCents) / 100 / window.AOAM_WARR.rate());
      if (kbWarrStepsOn() ? kbStepsGone : (!cartWarrElig && warrTotalCost() <= 0)){
        warrCart.forEach(w => { if (w.owned && w.qty > 0 && !(kbWarrStepsOn() && w.sl)){ warrCuts.push(w); if (!w.kb) appWarrCents -= w.cents; } });
        if (warrCuts.length) KB_APPWARR = appWarrCents/100;   /* paint the row gone in the same beat as the cut */
      }
      const appWarrChanged = KB_APPWARR !== appWarrWas;
      if (kitChanged || warrCuts.length){
        renderAll();
        if (foldGone && S.cart.length) toast(foldGone + ' item' + (foldGone>1?'s':'') + ' removed from your cart elsewhere');
      }
      /* mutFail: vids whose add/cut did NOT land. Their ledger entry must record what the cart
         really holds (pre-mutation), never the intent, or the next sync would read the shortfall as
         an outside deletion and silently drop the line from the kit. With reality in the ledger the
         next sync recomputes the same delta and simply retries. */
      const mutFail = {}, applied = {}, over422 = {};   /* applied: cut quantity that really landed, per vid */
      let chain = Promise.resolve();
      /* 2026-08-19: orphan cover goes FIRST. It is money the shopper is being charged right now for
         nothing, and unlike the kit lines below nothing later in this chain can need it. A failure
         only re-arms the sync; it never strands the cart mid-edit. */
      warrCuts.forEach(w => { chain = chain.then(() => {
        if (kbCoNow){ kbSyncDirty = true; return; }   /* checkout owns the cart now - retry after it */
        return post('/cart/change.js', { id: w.key, quantity: 0 }).catch(() => { kbSyncDirty = true; });
      }); });
      if (adds.length) chain = chain.then(() => {
        if (kbCoNow){ adds.forEach(a => mutFail[a.id] = 1); return; }   /* checkout owns the cart now */
        return post('/cart/add.js', { items: adds }).catch(() =>
          /* the batch is atomic (one bad line 422s all of it): retry one by one so the good lines land */
          adds.reduce((c2, a) => c2.then(() => {
            if (kbCoNow){ mutFail[a.id] = 1; return; }
            return post('/cart/add.js', { items: [a] }).catch(e => { mutFail[a.id] = 1; kbSyncDirty = true; if (e && e.status === 422) over422[a.id] = a.quantity; });   /* 2026-10-10 audit: remember a stock-ceiling refusal so the kit can be clamped to what the cart holds */
          }), Promise.resolve()));
      });
      cuts.forEach(c => { chain = chain.then(() => {
        if (kbCoNow){ mutFail[c.vid] = 1; return; }
        return post('/cart/change.js', { id: c.id, quantity: c.quantity })
          .then(() => { applied[c.vid] = (applied[c.vid]||0) + c.rm; })
          .catch(() => { mutFail[c.vid] = 1; kbSyncDirty = true; });
      }); });
      /* 2026-09-26 (Claude, cart-fix kb-cover: cross-cart-1/2, kb-code-3, kb-desktop-2). The warranty lives in the REAL
         cart the moment it is chosen, and cover already there is adopted: kbWarrSettle keeps exactly one step line (the
         site's format) when kbWarrOptIn says the shopper wants cover, cuts owned cover when they removed it, swaps the
         step as goods move, and hands back the answer, which becomes S.warranty so kb6 shows what /cart.js holds.
         Skipped while checkout owns the cart (kbSyncCart settles it there). Roll back: delete this step and warrFlip. */
      let warrFlip = false, covFlip = false; const cov0 = JSON.stringify(window.KB_COVER6 || null);   /* 2026-10-05 cart audit KB-02: kbWarrSettle may move the settled cover kb6 shows. Roll back: drop covFlip and cov0. */
      chain = chain.then(() => kbCoNow ? null : kbWarrSettle((u, o) => fetch(kbMkt(u), Object.assign({}, o, O)).then(r => { if (!r.ok) throw 0; return r.json(); }), post, 'kbsync', (warrCuts.length || adds.length || cuts.length) ? null : cart))
        .then(w => { if (w != null && !!S.warranty !== w){ S.warranty = w; warrFlip = true; } covFlip = JSON.stringify(window.KB_COVER6 || null) !== cov0; });   /* 2026-10-05 cart audit KB-02: covFlip. Roll back: drop it. */
      /* 2026-10-10 audit (kb6 qty over stock): Shopify refused part of an add with 422 (stock ceiling). Before this the kit kept the
         refused quantity, the next sync retried it forever, and checkout then cut the WHOLE line as "sold out". Read /cart.js once
         and clamp the kit's line to what the cart can hold; the renderAll() below lets kb6's bridge adopt S.cart, so the x3 on screen
         becomes the real number. Only a 422 does this, never a 429 or a dropped connection. Roll back: delete this chain step and over422. */
      chain = chain.then(() => {
        const bad = Object.keys(over422);
        if (!bad.length) return;
        return fetch('/cart.js', Object.assign({ headers:{'Accept':'application/json'} }, O)).then(r => r.ok ? r.json() : null).then(c => {
          if (!c) return;
          const held = {}; (c.items||[]).forEach(it => { held[+it.variant_id] = (held[+it.variant_id]||0) + (+it.quantity||0); });
          const msgs = [];
          bad.forEach(vs => {
            const vid = +vs, m = vm[vid]; if (!m) return;
            const have0 = (lines[vid]||[]).reduce((s,l)=>s+l.q, 0), now = held[vid]||0;
            const i = lineIdx(m.h, m.vi); if (i < 0) return;
            const q = S.cart[i].qty, keep = Math.max(0, Math.min(q, (want[vid]||0) - (have0 + over422[vs] - now)));
            if (keep >= q) return;
            const title = P(m.h).title;
            if (keep > 0){ S.cart[i].qty = keep; msgs.push('Only ' + now + ' of ' + title + ' ' + (now === 1 ? 'is' : 'are') + ' available, so your kit has ' + keep + '.'); }
            else { S.cart.splice(i, 1); msgs.push(title + ' is not available in that quantity, so it was taken out of your kit.'); }
            kitChanged = true;
          });
          if (msgs.length) toast(msgs[0]);
        }).catch(() => {});
      });
      return chain.then(() => {
        /* what the cart REALLY holds for a failed vid: pre-mutation qty minus the cuts that landed */
        Object.keys(mutFail).forEach(v => { nextLed[v] = (lines[v]||[]).reduce((s,l)=>s+l.q, 0) - (applied[v]||0); });
        kbLedgerWrite(nextLed);   /* full rewrite, so a variant that left the catalog cannot linger */
        kbSyncSig = JSON.stringify(kbLines());
        if (kitChanged){ renderAll(); persist(); }
        else if (rideChanged || appWarrChanged || warrFlip || lvlChanged || covFlip || x6Moved) renderAll();   /* 2026-10-05 cart audit KB-01/KB-02: covFlip, x6Moved. Roll back: drop them. */
      }).then(() => {
        /* 2026-09-28 kb-money-m C131: a percentage code moves with the lines this sync just wrote, so a cart carrying a code
           reads /cart.js once more and kb6 repaints if the discount moved. Carts with no code never make this read.
           Roll back: delete this .then. */
        /* 2026-10-19 audit KBW-01: the pair deal is priced by the discount function on the lines this sync just wrote, so a sync that wrote anything re-reads too. Roll back: if (!lvlCode || kbCoNow) return; */
        if ((!lvlCode && !(adds.length || cuts.length || warrCuts.length)) || kbCoNow) return;
        return fetch('/cart.js', Object.assign({ headers:{'Accept':'application/json'} }, O)).then(r => r.ok ? r.json() : null)
          .then(c => { if (c && kbCartLvlFrom(c)) renderAll(); }).catch(() => {});
      });
    })
    .catch(() => { kbSyncDirty = true; })   /* offline or 429 on the read: nothing was touched */
    .then(() => {
      kbSyncBusy = false;
      /* ONE bounded self-retry; after that the next natural trigger (mutation, tab return,
         pagehide) owns it. An open loop here would hammer /cart.js and feed bot mitigation. */
      if (kbSyncDirty && !kbCoNow && kbRetry < 1){ kbRetry++; clearTimeout(kbSyncT); kbSyncT = setTimeout(kbCartSync, 5000); }
    });
}
function kbRideHTML(){
  const n = KB_RIDE.reduce((a,r)=>a+r.qty, 0);
  if (!n) return '';
  const sum = KB_RIDE.reduce((a,r)=>a+r.cents, 0)/100;
  /* 2026-08-15: `sum` is /cart.js `final_line_price`, i.e. PRESENTMENT currency, not the baked
     USD every other number in this footer uses. usdNoteHTML() renders on the line immediately
     above this one and says "Prices shown in USD", which mislabelled precisely the one figure
     that was already in the shopper's own money. Naming it is the whole fix; do not convert it
     and do not strip it. Bare in a USD market, exactly as before. */
  return `<div class="dock-ride">+ ${n} more item${n>1?'s':''} from your store cart ($${sum.toFixed(2)}${IS_USD?'':' '+KB_CUR}) ${n>1?'ride':'rides'} this same order</div>`;
}
addEventListener('pagehide', () => { if (kbSyncDirty) kbCartSync(); });
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden'){ if (kbSyncDirty) kbCartSync(); }
  else kbCartTouch(1);
});
/* 2026-08-18: the site's own bin, verbatim from snippets/cart-page-item.liquid:207 - 13x14 on a
   0 0 13 14 box with a 1px white stroke. This was a 15x15 on a 24x24 box at stroke-width 1.8, which
   read heavier and sat 1px lower than the site's beside the same product title. */
const TRASH_SVG = `<svg class="icon-delete" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.3182 2.66667H0.5M4.79752 5.91667V10.25M8.02066 5.91667V10.25M11.2438 2.66667V12.9583C11.2438 13.102 11.1872 13.2398 11.0865 13.3414C10.9857 13.4429 10.8491 13.5 10.7066 13.5H2.11157C1.9691 13.5 1.83246 13.4429 1.73172 13.3414C1.63098 13.2398 1.57438 13.102 1.57438 12.9583V2.66667M9.09504 2.66667V1.58333C9.09504 1.29602 8.98185 1.02047 8.78036 0.817301C8.57888 0.614137 8.3056 0.5 8.02066 0.5H4.79752C4.51258 0.5 4.2393 0.614137 4.03782 0.817301C3.83633 1.02047 3.72314 1.29602 3.72314 1.58333V2.66667" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
/* 2026-08-12 - Joel: "the -/+ needs to match the layout of the other carts". Byte-for-byte the two
   glyphs the site drawer uses (snippets/aoam-cart-fix.liquid), which kit-builder.css then sizes to
   11x11 and fills white. The builder had been drawing text characters instead, so the same control
   read thinner and smaller than the one in the site drawer. Restore the plain "-" and "+" text in
   the two stepper call sites below to roll back. */
const QTY_MINUS_SVG = `<svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="2" fill="#87F614"/></svg>`;
const QTY_PLUS_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.85714H16V9.14286H0V6.85714Z" fill="#87F614"/><path d="M9.14286 9.99135e-08L9.14286 16H6.85714L6.85714 0L9.14286 9.99135e-08Z" fill="#87F614"/></svg>`;
/* r12: lock + wallet + payment-strip artwork lifted verbatim from the live drawer (antsonamelon.com, 2026-07-13) */
const LOCK_SVG = `<svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5.625H10V3.75C10 2.75544 9.57857 1.80161 8.82843 1.09835C8.07828 0.395088 7.06087 0 6 0C4.93913 0 3.92172 0.395088 3.17157 1.09835C2.42143 1.80161 2 2.75544 2 3.75V5.625H1C0.868657 5.62493 0.738588 5.64913 0.617229 5.69622C0.495869 5.74331 0.385601 5.81236 0.292727 5.89943C0.199854 5.9865 0.126197 6.08988 0.0759689 6.20365C0.0257406 6.31743 -7.43302e-05 6.43937 1.60753e-07 6.5625V14.0625C-7.43302e-05 14.1856 0.0257406 14.3076 0.0759689 14.4213C0.126197 14.5351 0.199854 14.6385 0.292727 14.7256C0.385601 14.8126 0.495869 14.8817 0.617229 14.9288C0.738588 14.9759 0.868657 15.0001 1 15H11C11.1313 15.0001 11.2614 14.9759 11.3828 14.9288C11.5041 14.8817 11.6144 14.8126 11.7073 14.7256C11.8001 14.6385 11.8738 14.5351 11.924 14.4213C11.9743 14.3076 12.0001 14.1856 12 14.0625V6.5625C12.0001 6.43937 11.9743 6.31743 11.924 6.20365C11.8738 6.08988 11.8001 5.9865 11.7073 5.89943C11.6144 5.81236 11.5041 5.74331 11.3828 5.69622C11.2614 5.64913 11.1313 5.62493 11 5.625ZM4 3.75C4 3.25272 4.21071 2.77581 4.58579 2.42417C4.96086 2.07254 5.46957 1.875 6 1.875C6.53043 1.875 7.03914 2.07254 7.41421 2.42417C7.78929 2.77581 8 3.25272 8 3.75V5.625H4V3.75ZM10 13.125H2V7.5H10V13.125Z" fill="black"/></svg>`;
const WALLET_SVGS = `<svg width="113" height="40" viewBox="0 0 113 40" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Shop Pay"><path d="M0 10C0 4.47715 4.47715 0 10 0H103C108.523 0 113 4.47715 113 10V30C113 35.5229 108.523 40 103 40H10C4.47715 40 0 35.5229 0 30V10Z" fill="#3E22AB"/><path fill-rule="evenodd" clip-rule="evenodd" d="M55.349 16.6622C55.979 15.8782 56.9566 15.2282 58.1234 15.2282C60.7433 15.2282 62.807 17.411 62.8053 20.1043C62.8053 22.9105 60.7311 24.9874 58.2426 24.9874C56.9196 24.9874 55.907 24.3058 55.5368 23.737H55.5016V27.859C55.5016 27.884 55.4918 27.9076 55.4743 27.9252C55.4569 27.9428 55.4333 27.9526 55.4086 27.9526H53.0764C53.0514 27.9526 53.0276 27.9429 53.0098 27.9254C52.9922 27.9078 52.9819 27.8841 52.9815 27.859V15.3202C52.9815 15.295 52.9914 15.2707 53.0093 15.2528C53.0271 15.2349 53.0511 15.2249 53.0764 15.2249H55.2559C55.2808 15.2254 55.3043 15.2356 55.3218 15.2534C55.3392 15.2713 55.3489 15.2953 55.3489 15.3202L55.349 16.6622ZM57.9243 22.5977C57.731 22.6038 57.5365 22.5872 57.345 22.5473C56.8632 22.447 56.4223 22.2044 56.0783 21.8505C55.7344 21.4966 55.5031 21.0475 55.4142 20.5606C55.3885 20.4207 55.3751 20.2794 55.3735 20.1386C55.3718 19.9807 55.3849 19.8222 55.4132 19.6654C55.5013 19.1788 55.7313 18.7297 56.0739 18.3753C56.4165 18.0209 56.8564 17.7773 57.3372 17.6755C57.5298 17.6347 57.7253 17.6175 57.92 17.6234C58.2363 17.6273 58.5487 17.6934 58.8399 17.8179C59.1348 17.9441 59.4022 18.1277 59.6264 18.3585C59.8505 18.5892 60.027 18.8622 60.1459 19.1619C60.2646 19.4615 60.3232 19.7819 60.3185 20.1046C60.3237 20.4278 60.2653 20.7491 60.1467 21.0495C60.0281 21.35 59.8517 21.6239 59.6277 21.8557C59.4036 22.0874 59.1362 22.2723 58.8411 22.3996C58.5513 22.5244 58.2398 22.5919 57.9243 22.5977Z" fill="white"/><path d="M40.2084 17.1038C39.6696 15.9664 38.6482 15.2318 37.1093 15.2318C36.6368 15.2401 36.1727 15.3574 35.7526 15.5749C35.3324 15.7922 34.9674 16.104 34.6859 16.4856L34.6298 16.5545V12.0971C34.6298 12.0713 34.6197 12.0466 34.6016 12.0284C34.5835 12.0102 34.5589 12 34.5333 12H32.3573C32.332 12.0005 32.3079 12.011 32.2901 12.029C32.2723 12.0472 32.2625 12.0717 32.2625 12.0971V24.8831C32.2625 24.9084 32.2725 24.9327 32.2903 24.9506C32.308 24.9684 32.3322 24.9785 32.3573 24.9785H34.6876C34.7128 24.9785 34.7372 24.9684 34.7552 24.9507C34.7733 24.9328 34.7836 24.9087 34.784 24.8831V19.4314C34.784 18.3717 35.486 17.6212 36.6091 17.6212C37.8375 17.6212 38.1481 18.6384 38.1481 19.6751V24.8831C38.1481 24.9084 38.158 24.9327 38.1758 24.9506C38.1936 24.9684 38.2177 24.9785 38.2428 24.9785H40.5678C40.5932 24.9785 40.6175 24.9684 40.6355 24.9507C40.6535 24.9328 40.664 24.9087 40.6644 24.8831V19.3643C40.6644 19.1753 40.6644 18.9898 40.6398 18.8098C40.6001 18.2195 40.4538 17.6413 40.2084 17.1038Z" fill="white"/><path d="M28.5721 18.9986C28.5721 18.9986 27.3859 18.7178 26.9488 18.6049C26.5119 18.4918 25.7484 18.2516 25.7484 17.6706C25.7484 17.0897 26.3644 16.9042 26.9892 16.9042C27.614 16.9042 28.3088 17.0561 28.3631 17.7536C28.3653 17.7787 28.3769 17.802 28.3954 17.8191C28.4139 17.8361 28.4381 17.8455 28.4632 17.8455L30.7602 17.8367C30.7737 17.8367 30.7871 17.834 30.7994 17.8285C30.8119 17.823 30.823 17.8152 30.8322 17.8053C30.8414 17.7954 30.8485 17.7837 30.853 17.7708C30.8576 17.758 30.8594 17.7443 30.8583 17.7308C30.7162 15.4985 28.7701 14.7004 26.9749 14.7004C24.8463 14.7004 23.2897 16.1132 23.2897 17.6708C23.2897 18.8081 23.6091 19.8747 26.1202 20.6166C26.5607 20.7455 27.159 20.9132 27.6819 21.0599C28.3102 21.2364 28.6489 21.5032 28.6489 21.9234C28.6489 22.4108 27.947 22.7499 27.2573 22.7499C26.2589 22.7499 25.5499 22.3774 25.492 21.7079C25.489 21.6835 25.4772 21.6609 25.4586 21.6446C25.4403 21.6283 25.4164 21.6195 25.3919 21.6197L23.1001 21.6303C23.0867 21.6303 23.0733 21.633 23.061 21.6383C23.0487 21.6437 23.0375 21.6513 23.0281 21.6611C23.0188 21.6708 23.0114 21.6822 23.0066 21.6949C23.0018 21.7076 22.9996 21.721 23.0001 21.7346C23.1054 23.8415 25.1269 24.9771 27.0116 24.9771C29.8194 24.9771 31.0882 23.3877 31.0882 21.8989C31.0919 21.1991 30.9324 19.6063 28.5721 18.9986Z" fill="white"/><path d="M46.08 14.6772C43.9058 14.6772 42.8214 15.4208 41.951 16.0158L41.9245 16.0336C41.8796 16.0644 41.848 16.1113 41.836 16.1646C41.824 16.218 41.8326 16.2739 41.8595 16.3215L42.7195 17.8119C42.7357 17.8398 42.7576 17.8638 42.7841 17.882C42.8106 17.9003 42.8407 17.9126 42.8722 17.9178C42.9032 17.9234 42.9348 17.922 42.9653 17.9138C42.9957 17.9055 43.0238 17.8906 43.0476 17.8701L43.1162 17.8136C43.5635 17.4357 44.2813 16.9307 46.0185 16.7928C46.9855 16.7152 47.8208 16.9694 48.4366 17.5486C49.114 18.1773 49.5195 19.1928 49.5195 20.2648C49.5195 22.2375 48.3647 23.4772 46.5099 23.502C44.9814 23.4932 43.9549 22.6914 43.9549 21.5063C43.9549 20.8776 44.2374 20.4679 44.7883 20.0582C44.8304 20.0279 44.8602 19.9834 44.8722 19.9327C44.884 19.8821 44.8775 19.8288 44.8533 19.7828L44.0811 18.3135C44.0669 18.2872 44.0478 18.264 44.0244 18.2452C44.0013 18.2264 43.9745 18.2124 43.946 18.2039C43.9169 18.1951 43.8862 18.1926 43.856 18.1967C43.8257 18.2006 43.7966 18.211 43.7706 18.227C42.9038 18.7444 41.8402 19.6909 41.8982 21.5101C41.9683 23.8253 43.8812 25.5932 46.3677 25.6655H46.6626C49.6178 25.5684 51.7516 23.3609 51.7516 20.3674C51.7516 17.6194 49.7616 14.6772 46.08 14.6772Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M67.6153 12.0317H87.5132C88.8866 12.0317 90 13.1521 90 14.5342V25.4977C90 26.8798 88.8866 28 87.5132 28H67.6153C66.2419 28 65.1288 26.8796 65.1288 25.4977V14.5342C65.1288 13.1521 66.2419 12.0317 67.6153 12.0317ZM72.0795 20.7154C73.7395 20.7154 74.9276 19.4968 74.9276 17.789C74.9276 16.09 73.7395 14.8644 72.0795 14.8644H69.1489C69.114 14.8644 69.0805 14.8784 69.0559 14.9031C69.0311 14.9279 69.0173 14.9616 69.0173 14.9967V23.0905C69.0177 23.1255 69.0316 23.1589 69.0564 23.1837C69.081 23.2084 69.1142 23.2225 69.1489 23.223H70.251C70.2861 23.223 70.3194 23.2091 70.3442 23.1843C70.369 23.1595 70.3827 23.1258 70.3827 23.0907V20.8479C70.3827 20.8127 70.3965 20.779 70.4213 20.7542C70.4461 20.7295 70.4794 20.7155 70.5145 20.7155L72.0795 20.7154ZM71.9953 16.0936C72.8973 16.0936 73.5625 16.8107 73.5625 17.789C73.5625 18.7692 72.8973 19.4844 71.9953 19.4844H70.5143C70.4796 19.4844 70.4464 19.4708 70.4218 19.4463C70.397 19.4219 70.383 19.3886 70.3825 19.3538V16.2261C70.383 16.1911 70.3972 16.1577 70.4216 16.133C70.4462 16.1082 70.4794 16.0941 70.5143 16.0936H71.9953ZM75.2523 21.6706C75.2409 21.4088 75.2945 21.1483 75.4086 20.9126C75.5226 20.6769 75.6932 20.4737 75.9051 20.3213C76.3333 19.9981 76.9966 19.8303 77.981 19.7914L79.0251 19.7562V19.4454C79.0251 18.8255 78.611 18.5624 77.946 18.5624C77.281 18.5624 76.8615 18.799 76.7634 19.1859C76.7554 19.2131 76.7388 19.2371 76.7158 19.2538C76.6929 19.2704 76.6652 19.2788 76.637 19.2777H75.6069C75.5879 19.2782 75.5691 19.2745 75.5518 19.2669C75.5343 19.2592 75.5189 19.248 75.5063 19.2337C75.4938 19.2194 75.4845 19.2025 75.479 19.1841C75.4735 19.1658 75.4723 19.1465 75.4753 19.1277C75.6297 18.2093 76.3843 17.5118 77.9935 17.5118C79.7026 17.5118 80.3186 18.3118 80.3186 19.8394V23.0853C80.3189 23.1029 80.3158 23.1203 80.309 23.1366C80.3025 23.1529 80.2928 23.1677 80.2807 23.1802C80.2685 23.1928 80.2539 23.2026 80.2378 23.2094C80.2216 23.2161 80.2045 23.2196 80.187 23.2196H79.1465C79.1291 23.2196 79.1118 23.2161 79.0957 23.2094C79.0797 23.2026 79.0652 23.1928 79.0529 23.1802C79.0407 23.1677 79.0311 23.1529 79.0245 23.1366C79.018 23.1203 79.0147 23.1029 79.015 23.0853V22.8434C79.0167 22.8222 79.0118 22.8009 79.0005 22.7829C78.9893 22.7648 78.9726 22.7509 78.9529 22.7432C78.9331 22.7355 78.9116 22.7343 78.8912 22.7401C78.8707 22.7457 78.8527 22.7578 78.8397 22.7747C78.529 23.1156 78.0237 23.3627 77.2183 23.3627C76.0368 23.366 75.2523 22.7444 75.2523 21.6706ZM79.0251 20.9642V20.7135L77.6741 20.784C76.9616 20.821 76.5457 21.1196 76.5457 21.6211C76.5457 22.075 76.9265 22.3275 77.59 22.3275C78.492 22.3275 79.0253 21.8365 79.0253 20.9659L79.0251 20.9642ZM81.3644 24.7295V25.6742C81.3628 25.7048 81.3714 25.7349 81.389 25.76C81.4064 25.7849 81.4317 25.8033 81.4608 25.8121C81.6444 25.8624 81.8341 25.8856 82.0242 25.8809C83.0331 25.8809 83.9545 25.5101 84.4809 24.0654L86.7973 17.8472C86.804 17.8271 86.8057 17.8058 86.8027 17.7849C86.7996 17.7641 86.7917 17.7442 86.7797 17.7271C86.7675 17.7098 86.7515 17.6957 86.7329 17.686C86.7144 17.6763 86.6938 17.6709 86.6728 17.6706H85.5936C85.5656 17.6703 85.5381 17.6792 85.5155 17.6957C85.4928 17.7122 85.476 17.7355 85.4672 17.7625L84.1914 21.7007C84.1818 21.7266 84.1643 21.7487 84.1419 21.7644C84.1193 21.7801 84.0925 21.7885 84.0651 21.7885C84.0377 21.7885 84.0109 21.7801 83.9883 21.7644C83.9658 21.7487 83.9485 21.7265 83.9387 21.7007L82.4682 17.7519C82.4583 17.7266 82.4412 17.7048 82.4191 17.6894C82.3969 17.6741 82.3706 17.6656 82.3435 17.6655H81.2905C81.2696 17.6658 81.2491 17.6711 81.2305 17.6808C81.212 17.6905 81.1959 17.7047 81.1838 17.7219C81.1716 17.7392 81.1637 17.7589 81.1607 17.7798C81.1576 17.8006 81.1595 17.8219 81.1662 17.842L83.3315 23.4404C83.3421 23.4694 83.3421 23.5014 83.3315 23.5304L83.2631 23.7475C83.1833 24.0171 83.016 24.2517 82.7877 24.4141C82.5596 24.5764 82.284 24.657 82.0049 24.6429C81.8429 24.6428 81.6814 24.6274 81.5222 24.597C81.5029 24.5934 81.4831 24.594 81.4641 24.599C81.4451 24.604 81.4273 24.6131 81.4124 24.6258C81.3973 24.6385 81.3851 24.6544 81.3768 24.6722C81.3686 24.6901 81.3642 24.7097 81.3644 24.7295Z" fill="white"/></svg><svg width="112" height="40" viewBox="0 0 112 40" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="PayPal"><path d="M0 10C0 4.47715 4.47715 0 10 0H102C107.523 0 112 4.47715 112 10V30C112 35.5229 107.523 40 102 40H10C4.47715 40 0 35.5229 0 30V10Z" fill="#FEC43A"/><path d="M46.922 14.8019H42.9377C42.6651 14.8019 42.4332 14.9934 42.3907 15.2537L40.7792 25.1327C40.7472 25.3276 40.9033 25.5033 41.1078 25.5033H43.0099C43.2826 25.5033 43.5145 25.3118 43.557 25.051L43.9916 22.3865C44.0336 22.1257 44.266 21.9341 44.5381 21.9341H45.7994C48.424 21.9341 49.9387 20.7061 50.3343 18.2725C50.5125 17.2078 50.3418 16.3713 49.8262 15.7854C49.26 15.1421 48.2556 14.8019 46.922 14.8019ZM47.3817 18.41C47.1638 19.7924 46.0715 19.7924 45.0152 19.7924H44.414L44.8358 17.2106C44.8608 17.0546 45.0007 16.9397 45.1638 16.9397H45.4393C46.1588 16.9397 46.8376 16.9397 47.1883 17.3363C47.3974 17.5729 47.4615 17.9244 47.3817 18.41Z" fill="#253B80"/><path d="M58.8319 18.3655H56.9239C56.7614 18.3655 56.621 18.4804 56.5959 18.6364L56.5115 19.1524L56.378 18.9654C55.965 18.3857 55.0439 18.192 54.1246 18.192C52.0162 18.192 50.2154 19.736 49.8647 21.902C49.6823 22.9825 49.9416 24.0156 50.5755 24.7361C51.1569 25.3986 51.9888 25.6746 52.9786 25.6746C54.6775 25.6746 55.6195 24.6184 55.6195 24.6184L55.5345 25.131C55.5024 25.327 55.6586 25.5028 55.8619 25.5028H57.5805C57.8537 25.5028 58.0844 25.3113 58.1276 25.0504L59.1587 18.7361C59.1914 18.5418 59.0358 18.3655 58.8319 18.3655ZM56.1724 21.9561C55.9883 23.0101 55.1231 23.7176 54.0197 23.7176C53.4657 23.7176 53.0229 23.5458 52.7386 23.2202C52.4566 22.8968 52.3494 22.4366 52.4392 21.924C52.611 20.879 53.4907 20.1484 54.5773 20.1484C55.1191 20.1484 55.5595 20.3225 55.8496 20.6509C56.1404 20.9827 56.2557 21.4457 56.1724 21.9561Z" fill="#253B80"/><path d="M68.9934 18.3655H67.0761C66.8932 18.3655 66.7213 18.4533 66.6176 18.6004L63.9733 22.3668L62.8524 18.7474C62.7819 18.5209 62.5657 18.3655 62.321 18.3655H60.4369C60.208 18.3655 60.0489 18.5818 60.1218 18.7902L62.2337 24.7829L60.2482 27.493C60.0921 27.7065 60.2494 28 60.5191 28H62.4341C62.6158 28 62.7859 27.9144 62.8891 27.7702L69.2661 18.8696C69.4187 18.6567 69.262 18.3655 68.9934 18.3655Z" fill="#253B80"/><path d="M75.3413 14.8019H71.3564C71.0844 14.8019 70.8525 14.9934 70.8099 15.2537L69.1985 25.1327C69.1665 25.3276 69.3226 25.5033 69.5259 25.5033H71.5708C71.7607 25.5033 71.9233 25.3693 71.953 25.1868L72.4103 22.3865C72.4523 22.1257 72.6847 21.9341 72.9568 21.9341H74.2175C76.8427 21.9341 78.3568 20.7061 78.753 18.2725C78.9318 17.2078 78.76 16.3713 78.2444 15.7854C77.6787 15.1421 76.6749 14.8019 75.3413 14.8019ZM75.801 18.41C75.5837 19.7924 74.4913 19.7924 73.4345 19.7924H72.8339L73.2562 17.2106C73.2813 17.0546 73.4199 16.9397 73.5837 16.9397H73.8592C74.5781 16.9397 75.2574 16.9397 75.6082 17.3363C75.8173 17.5729 75.8808 17.9244 75.801 18.41Z" fill="#179BD7"/><path d="M87.2506 18.3655H85.3438C85.1801 18.3655 85.0409 18.4804 85.0164 18.6364L84.9319 19.1524L84.7979 18.9654C84.3849 18.3857 83.4644 18.192 82.5451 18.192C80.4367 18.192 78.6365 19.736 78.2857 21.902C78.104 22.9825 78.3621 24.0156 78.9959 24.7361C79.5785 25.3986 80.4093 25.6746 81.3991 25.6746C83.0979 25.6746 84.04 24.6184 84.04 24.6184L83.9549 25.131C83.9229 25.327 84.079 25.5028 84.2835 25.5028H86.0015C86.2736 25.5028 86.5055 25.3113 86.548 25.0504L87.5798 18.7361C87.6112 18.5418 87.4551 18.3655 87.2506 18.3655ZM84.5911 21.9561C84.4082 23.0101 83.5419 23.7176 82.4384 23.7176C81.8856 23.7176 81.4416 23.5458 81.1573 23.2202C80.8753 22.8968 80.7693 22.4366 80.8579 21.924C81.0309 20.879 81.9094 20.1484 82.996 20.1484C83.5378 20.1484 83.9782 20.3225 84.2683 20.6509C84.5602 20.9827 84.6756 21.4457 84.5911 21.9561Z" fill="#179BD7"/><path d="M89.5 15.0728L87.8647 25.1327C87.8326 25.3276 87.9888 25.5033 88.1921 25.5033H89.8362C90.1094 25.5033 90.3413 25.3118 90.3832 25.051L91.9958 15.1725C92.0279 14.9776 91.8717 14.8013 91.6684 14.8013H89.8274C89.6649 14.8019 89.5251 14.9168 89.5 15.0728Z" fill="#179BD7"/><path d="M24.2331 27.4232L24.5378 25.5518L23.8591 25.5366H20.6181L22.8704 11.7278C22.8774 11.6861 22.9001 11.6473 22.9333 11.6197C22.9665 11.5921 23.0091 11.5768 23.0534 11.5768H28.518C30.3322 11.5768 31.5842 11.9419 32.2379 12.6624C32.5443 13.0004 32.7395 13.3536 32.8339 13.7423C32.9329 14.1501 32.9346 14.6374 32.8379 15.2317L32.8309 15.2751V15.6559L33.1374 15.8237C33.3955 15.9561 33.6005 16.1077 33.7578 16.2812C34.02 16.5702 34.1895 16.9374 34.2612 17.3729C34.3352 17.8207 34.3107 18.3536 34.1895 18.957C34.0497 19.651 33.8237 20.2554 33.5184 20.75C33.2376 21.2057 32.8799 21.5837 32.4552 21.8767C32.0497 22.1549 31.5679 22.3662 31.0232 22.5014C30.4953 22.6343 29.8935 22.7014 29.2335 22.7014H28.8082C28.5041 22.7014 28.2087 22.8073 27.9768 22.9971C27.7444 23.1909 27.5906 23.4557 27.5434 23.7452L27.5113 23.9136L26.973 27.2119L26.9485 27.333C26.9421 27.3713 26.9311 27.3905 26.9148 27.4034C26.9002 27.4153 26.8792 27.4232 26.8588 27.4232H24.2331Z" fill="#253B80"/><path d="M33.4275 15.319C33.4112 15.4198 33.3926 15.5229 33.3716 15.6288C32.6509 19.2065 30.1854 20.4424 27.0365 20.4424H25.4332C25.0481 20.4424 24.7236 20.7128 24.6636 21.0801L23.8428 26.114L23.6103 27.5409C23.5713 27.782 23.7635 27.9994 24.0152 27.9994H26.8588C27.1956 27.9994 27.4816 27.7628 27.5346 27.4417L27.5626 27.302L28.098 24.0167L28.1324 23.8365C28.1848 23.5142 28.4714 23.2777 28.8082 23.2777H29.2335C31.9885 23.2777 34.1453 22.1961 34.7756 19.0662C35.039 17.7588 34.9026 16.667 34.2059 15.8992C33.995 15.6677 33.7334 15.4756 33.4275 15.319Z" fill="#179BD7"/><path d="M32.6736 15.0283C32.5635 14.9973 32.4499 14.9692 32.3334 14.9438C32.2163 14.919 32.0963 14.8971 31.9728 14.8779C31.5405 14.8103 31.0669 14.7782 30.5594 14.7782H26.2762C26.1708 14.7782 26.0706 14.8013 25.9809 14.843C25.7834 14.9348 25.6366 15.1156 25.601 15.337L24.6898 20.9173L24.6636 21.0801C24.7236 20.7128 25.0481 20.4424 25.4332 20.4424H27.0365C30.1854 20.4424 32.6509 19.2065 33.3716 15.6288C33.3931 15.5229 33.4112 15.4198 33.4275 15.319C33.2452 15.2255 33.0477 15.1455 32.835 15.0773C32.7826 15.0604 32.7284 15.0441 32.6736 15.0283Z" fill="#222D65"/><path d="M25.601 15.337C25.6366 15.1156 25.7834 14.9343 25.9809 14.843C26.0712 14.8013 26.1708 14.7788 26.2762 14.7788H30.5594C31.0669 14.7788 31.5405 14.8109 31.9728 14.8785C32.0963 14.8976 32.2163 14.919 32.3334 14.9438C32.4499 14.9692 32.5635 14.9973 32.6736 15.0283C32.7284 15.0441 32.782 15.061 32.835 15.0773C33.0477 15.1455 33.2452 15.2255 33.4275 15.319C33.6419 13.9969 33.4263 13.0967 32.687 12.2816C31.872 11.3842 30.401 11 28.5186 11H23.0539C22.6694 11 22.3414 11.2704 22.282 11.6382L20.0058 25.589C19.961 25.865 20.1812 26.114 20.469 26.114H23.8428L24.6898 20.9173L25.601 15.337Z" fill="#253B80"/></svg><svg width="112" height="40" viewBox="0 0 112 40" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Google Pay"><path d="M0 10C0 4.47715 4.47715 0 10 0H102C107.523 0 112 4.47715 112 10V30C112 35.5229 107.523 40 102 40H10C4.47715 40 0 35.5229 0 30V10Z" fill="white"/><path d="M54.9966 19.7252V26.1581H52.9347V10.2488H58.2955C59.6014 10.2488 60.8385 10.733 61.8007 11.6322C62.7629 12.4623 63.244 13.7073 63.244 15.0216C63.244 16.3358 62.7629 17.5117 61.8007 18.4109C60.8385 19.3102 59.6701 19.7943 58.2955 19.7943L54.9966 19.7252ZM54.9966 12.1856V17.7192H58.433C59.189 17.7192 59.945 17.4425 60.4261 16.8892C61.5258 15.8516 61.5258 14.1224 60.4948 13.0848L60.4261 13.0156C59.8763 12.4623 59.189 12.1164 58.433 12.1856H54.9966Z" fill="#5F6368"/><path d="M67.9863 14.9524C69.4983 14.9524 70.6667 15.3674 71.5601 16.1975C72.4536 17.0275 72.866 18.1343 72.866 19.5177V26.1581H70.9416V24.6363H70.8729C70.0481 25.8814 68.8797 26.5039 67.5052 26.5039C66.3368 26.5039 65.3058 26.1581 64.4811 25.4663C63.7251 24.7746 63.244 23.8062 63.244 22.7687C63.244 21.662 63.6564 20.7627 64.4811 20.071C65.3058 19.3793 66.4742 19.1026 67.8488 19.1026C69.0859 19.1026 70.0481 19.3102 70.8041 19.7943V19.3102C70.8041 18.6184 70.5292 17.9267 69.9794 17.5117C69.4296 17.0275 68.7423 16.7508 67.9863 16.7508C66.8179 16.7508 65.9244 17.235 65.3058 18.2034L63.5189 17.0967C64.6186 15.6441 66.0619 14.9524 67.9863 14.9524ZM65.3746 22.8379C65.3746 23.3912 65.6495 23.8754 66.0619 24.1521C66.543 24.498 67.0928 24.7055 67.6426 24.7055C68.4674 24.7055 69.2921 24.3596 69.9107 23.7371C70.5979 23.1145 70.9416 22.3537 70.9416 21.5236C70.323 21.0394 69.4296 20.7627 68.2612 20.7627C67.4364 20.7627 66.7491 20.9703 66.1993 21.3853C65.6495 21.7311 65.3746 22.2153 65.3746 22.8379Z" fill="#5F6368"/><path d="M84 15.2983L77.1959 31H75.134L77.677 25.5355L73.2096 15.3674H75.4089L78.6392 23.1837H78.7079L81.8694 15.3674H84V15.2983Z" fill="#5F6368"/><path d="M46.8179 18.3418C46.8179 17.7192 46.7491 17.0967 46.6804 16.4742H38.0893V20.0019H42.9691C42.7629 21.1086 42.1443 22.1462 41.1821 22.7687V25.0513H44.1375C45.8557 23.4604 46.8179 21.1086 46.8179 18.3418Z" fill="#4285F4"/><path d="M38.0893 27.2648C40.5636 27.2648 42.6254 26.4347 44.1375 25.0513L41.1821 22.7687C40.3574 23.3221 39.3265 23.6679 38.0893 23.6679C35.7526 23.6679 33.6907 22.077 33.0034 19.8635H29.9794V22.2153C31.5601 25.328 34.6529 27.2648 38.0893 27.2648Z" fill="#34A853"/><path d="M33.0034 19.8635C32.5911 18.7568 32.5911 17.5117 33.0034 16.3358V13.984H29.9794C28.6735 16.5433 28.6735 19.5868 29.9794 22.2153L33.0034 19.8635Z" fill="#FBBC04"/><path d="M38.0893 12.6006C39.3952 12.6006 40.6323 13.0848 41.5945 13.984L44.2062 11.3555C42.5567 9.83377 40.3574 8.93455 38.1581 9.00372C34.7216 9.00372 31.5601 10.9405 30.0481 14.0532L33.0722 16.405C33.6907 14.1915 35.7526 12.6006 38.0893 12.6006Z" fill="#EA4335"/></svg>`;
/* r27 (critique W6): the wallet marks were dead clicks at the money moment — each is now a link into
   the same secure-checkout permalink (the live Shopify checkout offers these exact wallets) */
const WALLET_LABELS = ['Shop Pay','PayPal','Google Pay'];
function walletRow(){
  return WALLET_SVGS.split('</svg>').filter(s => s.trim()).map((s,i) =>
    `<button type="button" class="wgo" aria-label="Pay with ${WALLET_LABELS[i]||'express checkout'} via Secure Checkout" onclick="walletGo(event)">${s}</svg></button>`).join('');
}
function walletGo(ev){
  if (!S.cart.length){ ev.preventDefault(); return; }
  ev.preventDefault();
  /* 2026-07-28: the wallet marks had no busy state at all, so they read as dead for up to 8s and
     invited the second tap that doubled the kit. Same gate and same spinner as the lime button. */
  if (kbBusy) return;
  kbBusyOn(ev.currentTarget || (ev.target && ev.target.closest && ev.target.closest('.wgo')), '');
  kbGoCheckout();   // [kb-track] stamp the cart before the wallet hop
}
/* live-drawer-style rig row: variant image if we have one, per-option meta lines, price left / stepper right, trash remove */
function rigRowHTML(l, i){
  const p = P(l.h), v = lv(l), ax = axes(l.h);
  const inc = isKit(l.h) ? kitIncludes(l.h, v) : null;   /* 2026-07-31 kit-overlap: kit rows list their contents */
  let meta = '';
  if (v.t && v.t !== 'Default Title'){
    const parts = ax && ax.length > 1 ? v.t.split(' / ') : [v.t];
    meta = parts.map((val,k)=>`<div class="variant">${ax && ax[k] ? esc(ax[k].name)+': ' : ''}${esc(val)}</div>`).join('');
  }
  /* 2026-08-11 (Joel: "the layout of the cart in the kit builder and saber builder does not match
     what the main site has. we want to use the formatting of the main site drawer."). The desktop rig
     panel was the last cart on this page still using its own compact .row/.step grammar (88px image,
     14px title, bold 14.5px price, detached steppers), so KB desktop disagreed with KB mobile AND with
     the site drawer. This now emits the SAME DOM as renderDrawer(), which kit-builder.css already
     styles from the drawer's measurements. Handlers are unchanged: dropLine/decItem/incItem stay
     index-based, which is correct for the rig panel. To roll back, restore this block and the
     .rmeta line above it, and un-delete the .row/.step CSS. */
  return `<div class="cart__item_wrp"><div class="cart__item">
    <div class="cart__image"><img class="cart-item__image" src="${CDN((v.img || p.imgs[0]), inc && inc.labels.length ? 320 : 300)}" alt=""></div>
    <div class="cart-item__details text-left">
      <div class="cart-item__title">
      <div class="cart-title-remove-btn"><a class="cart-item__name">${esc(p.title)}</a>
        <button class="cart__remove" aria-label="Remove ${esc(p.title)} from kit" onclick="dropLine(${i})">${TRASH_SVG}</button>
      </div>
      <div class="cart-item__variants">${meta}${inc && inc.labels.length ? `<div class="rinc" data-aoam-rinc="1"><b>Includes</b> ${inc.labels.map(esc).join(' · ')}</div>` : ''}</div>
      </div>
      ${/* 2026-08-18 - the site's row structure, from snippets/cart-page-item.liquid:198-305.
        TWO things, and the second only works because of the first.
        (a) .cart-item__title wraps the title/remove row TOGETHER WITH .cart-item__variants. The site
            sets display:grid on it (widget-minicart.css:36). Without the wrapper the variant lines
            were a third child of the details column and drifted away from the title they describe.
        (b) the price/stepper row is .cart-item__sub, NOT .cart__item-sub. The site's rule
            "​.cart-item__details .cart-item__sub {margin-top:0!important; flex-direction:row-reverse}"
            (widget-minicart.css:26) could never match the old name - and row-reverse is why the
            source order below is QTY FIRST, PRICE SECOND while the shopper sees price on the left.
            Emitting the old price-first order under the new class would have silently mirrored the
            row. The old name also collided with the .cart__item-sub the summary rows now carry. */''}
      <div class="cart-item__sub">
        <span class="js-qty__wrapper"><button aria-label="Less" onclick="decItem(${i})">${QTY_MINUS_SVG}</button><span class="js-qty__num">${l.qty}</span><button aria-label="More" onclick="incItem(${i})">${QTY_PLUS_SVG}</button></span>
        <span class="cart-item__price money">${money(v.p)}</span>
      </div>
    </div></div></div>`;
}
function renderRig(){
  const c = calc(), lt = lightsInCart(), wp = warrProd(), m = kitMatch(), items = gearQty();
  const m2 = kitMatchRev(), showRev = !!(m2 && S.km2Dismiss !== m2.key);   /* r28: guard outranks the upsell — never both */
  const ov = ovMatch();   /* 2026-07-31 kit-overlap: a mistake-warning outranks both save banners */
  /* r45 (Joel: "upsell should always show here", screenshot circling the void under a 1-item cart).
     r42's gate was `... && $('hub').hidden && $('stagedetail').hidden` and it was a RENDER-ORDER RACE,
     not a wrong condition. On a real desktop add, renderRig() runs while the sheet is STILL OPEN
     (traced: hub.hidden=true but sd.hidden=FALSE, cart=1 -> gate false -> no strip). r38's post-add
     auto-close then hides the sheet WITHOUT re-rendering the panel, so the DOM ends up satisfying every
     condition while the HTML was built when it did not. Net effect: the r42 panel strip never rendered
     on a real add at any viewport — it only showed if some later interaction happened to re-render.
     It passed r42/r44 QA only because those scripts called renderAll() themselves after the DOM settled,
     i.e. they tested a state real clicking cannot reach.
     Reading DOM flags to decide markup is the bug; this now depends on state only. r42's stated reason
     for the gate (protect the r33 dock fold when a sheet is open) was never a real risk either: .rigdock
     is a SIBLING of .leftscroll, not a child (r27 made it a real flex footer), so panel content cannot
     move it — proven by control, 900px into the panel leaves dock bottom identical.
     The drawer strip (renderDrawer) stays unconditional. */
  const showStrip = S.cart.length > 0 && !isMobile();
  const rows = S.cart.length ? S.cart.map((l,i)=>rigRowHTML(l,i)).join('')
    : `<div class="empty"><img src="${CDN(CRITTER_IMG,120)}" alt=""><span><b>Your kit is empty</b>Tap any tile to preview it on the Critter, then add it to your kit.<button class="empty-add" onclick="addCritter(this)">Start with the light · ${money(P(CRITTER).vars[0].p)}</button></span></div>`;
  /* r6: panel mirrors the live drawer's list zone (ship meter, item cards, upsells); everything
     from Subtotal down lives in the dock's footer panel since r16 */
  /* 2026-08-18: everything this panel draws is the site drawer's markup, so it is wrapped in the
     site's own container class and picks up widget-minicart.css directly. display:contents keeps
     .rigpanel's flex column intact - the wrapper exists for selector matching only. */
  $('rigpanel').innerHTML = `
    <div class="site-header__drawers-container block-mincart" style="display:contents">
    <div class="titlerow"><h2>Your Kit <em>· ${items} ITEM${items===1?'':'S'}</em></h2></div>
    ${S.cart.length && IS_US ? `<div class="meters">${shipMeterHTML(c)}</div>` : ''}
    <div class="rows">${rows}</div>
    ${needsLight() ? nlHTML() : ''}
    ${needsHolder() ? bhHTML() : ''}
    ${needsConnector() ? tcHTML() : ''}
    ${ov ? ovHTML(ov) : showRev ? km2HTML(m2) : m && S.kmDismiss!==m.key ? kmHTML(m,false) : ''}
    ${showStrip ? stripHTML() : ''}
    </div>`;
  renderKitBar();   /* 2026-08-06: the cart's own surface (see renderStage). Idempotent, so calling it
                        from both render paths is free and neither can leave the bar stale. */
  tickRigShip(c);   /* r38: drive the Saber-style ship-meter ticker now that #rigShipTxt exists in the panel */
  /* r8 (Joel): the whole summary lives in the sticky dock so checkout never scrolls out of view */
  /* r16 (Joel): dock = the live drawer footer verbatim, same markup/classes as #dfoot inside the
     rounded panel (subtotal, shipping, warranty, 32px total, lime checkout, wallets, USP; still
     the 2-part USP with no free-shipping wording per the locked r9 rule, and no protonote) */
  /* 2026-08-18: same wrapper as the panel above, plus the .cart__footer element the site nests its
     footer panel in - widget-minicart.css:68 and :71 key the dock's padding and its rounded #0f0f0f
     card off that pair, and neither could reach here before. */
  $('rigdock').innerHTML = `
    <div class="site-header__drawers-container block-mincart" style="display:contents">
    ${S.cart.length && needsLight() ? `<div class="dock-nl">Nothing in this kit can glow yet. <button onclick="addCritter(this)">Add the RGB Critter BT</button></div>` : ''}
    ${S.cart.length && lightReady() ? lightReadyHTML() : ''}
    <div class="cart__footer"><div class="cart__footer-inner">
      ${kbSummaryHTML(c, items, lt, wp, false)}
      ${/* 2026-08-12 - Joel, on the trust row under the wallets: "remove this from the kit builder
            cart". Same call he made on the main site drawer on 2026-08-11, where the row is deleted
            in snippets/drawer-cart.liquid and its rules left inert in assets/widget-minicart.css.
            The .usp rules in kit-builder.css are likewise left in place, so this file alone is the
            rollback. All three claims still reach the shopper: shipping through the Shipping row
            above, returns and Oregon assembly on every product page.
            ROLLBACK: put back a div.usp here holding three spans, "Designed &amp; assembled in
            Oregon", "Free US Shipping $" + SHIP_FREE + "+", "Free US Returns". */''}
    </div></div></div>`;
}
/* 2026-07-28: roughly 24 users a week build a priced kit and leave against 14 who check out, and
   nothing on the page ever asked for an address. Deliberately a quiet text link under checkout,
   not a competing button: the job is to catch the ones already leaving, not to slow anyone down. */
/* ============================ AOAM KB CART SUMMARY 2026-08-18 (Claude) ============================
   Joel: "everything about this section in the kit builder should match the main site ... how do we
   link the main site with this section so any changes apply to both?"

   ONE copy of the summary rows for BOTH Kit Builder surfaces. Until now the desktop dock (renderRig)
   and the phone drawer (renderDrawer) each carried a hand-typed copy of these rows, and they HAD
   already drifted: the Secure Checkout button spelled its attributes in a different order in each.
   Everything from Subtotal to the email link is now written once, and the only genuine difference
   between the two surfaces, the warranty block's drawer flag, is the single parameter. Change a row
   here and both Kit Builder surfaces change together. There is nothing left to keep in step by hand.

   THE LINK TO THE MAIN SITE IS CSS, NOT MARKUP, AND THAT IS DELIBERATE. Every class below is the
   site drawer's own, and both surfaces render inside .site-header__drawers-container, so
   assets/widget-minicart.css drives them directly: its ".site-header__drawers-container .x" rules
   are (0,2,0) and beat kit-builder.css's bare (0,1,0) copies. Measured live 2026-08-18, the card's
   padding on this page is the SITE's 17/20/13, not this page's own 15/18/7. So a styling change to
   the site cart lands here with nothing to re-copy, which is the 90% case.
   The ROWS cannot share one source with the site: the site renders them in Liquid from cart.* at
   request time and this page renders them in JS from builder state, and the site's footer also draws
   six rows the Kit Builder deliberately does not (ship-to selector, discount box, terms checkbox,
   duties notice, card strip, checkout spinner). Cloning the site's markup would drag all six in.
   Two sources, one per rendering model, is the honest floor.
   ROLLBACK: paste this body back inline at both call sites and delete the function. */
/* 2026-09-16 (Claude) - Joel: "do this always in all carts. Ships next day / 4.7 · 900+ reviews /
   Oregon assembled". Replaces the OR PAY WITH divider + walletRow() badges under Secure Checkout.
   Same markup as snippets/aoam-trust-row.liquid on the site drawer; keep the copy in step. walletRow(),
   walletGo() and the AOAM KB PAY TOGGLE block are left in place and now idle (nothing renders a
   .devider-text), so rollback is putting the two removed lines back where kbTrustRowHTML() is called. */
/* 2026-09-16 (Claude) - arrive-by Option B: first badge "Ships next day" -> "30-day returns", in step with snippets/aoam-trust-row.liquid. */
function kbTrustRowHTML(){
  return '<div class="aoam-trust-row">'
    + '<span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h11a5 5 0 010 10h-4"/></svg>30-day&nbsp;returns</span>'
    + '<span><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3 6.5 7 .8-5.2 4.8 1.4 7L12 17.6 5.8 21l1.4-7L2 9.3l7-.8z"/></svg>4.7 &middot; 900+&nbsp;reviews</span>'
    + '<span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>Designed&nbsp;in&nbsp;Oregon</span>'
    + '</div>';
}
function kbSummaryHTML(c, items, lt, wp, inDrawer){
  return `
    ${/* the site's summary rows carry BOTH classes, "cart__item-sub cart__item-row", and ~14 of
           widget-minicart.css's rules are written ".cart__item-sub.cart__item-row", which needs
           both. Without cart__item-sub the site's 18px/500 type, its row rhythm and its TOTAL
           padding all miss, and kit-builder.css's copies fill in. */''}
    <div class="cart__item-sub cart__item-row"><div class="subtotal">Subtotal <span class="cart-inner-count">(${items} Item${items===1?'':'s'}):</span></div><div class="money">${money(Math.max(0,c.gearSub))}</div></div>
    ${c.bonus>0?`<div class="cart__item-sub cart__item-row cart-item__savings"><div>You Saved (10% gear bonus):</div><div class="money">−${money(c.bonus)}</div></div>`:''}
    ${/* the site's own shipping value, from snippets/drawer-cart.liquid. It nests the link inside a
           .aoam-ship-value flex box so a struck was-price can sit beside it. */''}
    <div class="cart__item-sub cart__item-row cart-shipping__details text-center"><p class="subtotal">Shipping:</p><span class="aoam-ship-value">${shipWasHTML(c)}<a class="shipping_link ${IS_US&&c.shipBase>=SHIP_FREE?'free-shipping-active':''}" href="/checkout">${shipValueText(c)}</a></span></div>
    ${/* 2026-09-16 (Claude) - Joel approved arrive-by Option B: "Get it by" under Shipping, from snippets/aoam-eta.liquid (rendered by layout/kit-builder.liquid). Empty when the kit holds a made-to-order blade or the shopper is outside the US. Delete this line to roll back. */''}
    ${(window.AOAM_ETA && S.cart.length) ? window.AOAM_ETA.kbHTML(S.cart.map(l => l.h)) : ''}
    ${(warrTotalCost()>0 || kbAppWarrComparable()>0) ? warrBlockHTML(lt, wp, inDrawer) : ''}
    <div class="cart__item-sub cart__item-row cart__item--subtotal"><div class="subtotal">Total</div><div class="subtotal-price money">${money(Math.max(0,c.totalDue))}${IS_USD?'':' USD'}</div></div>
    ${usdNoteHTML()}
    ${kbRideHTML()}
    ${/* the site wraps checkout + divider + wallets in one
           .cart__item-row.cart__checkout-wrapper.payment-buttons row and puts an <s class="lock-icon">
           around the padlock. Without the wrapper the button loses the site's 16px/20px outer margin
           and the row's zero padding. */''}
    <div class="cart__item-row cart__checkout-wrapper payment-buttons">
    <button type="button" class="btn-cart__checkout ${S.cart.length?'':'disabled'}" onclick="checkoutGo(this,event)" ${S.cart.length?'':'aria-disabled="true"'}><s class="lock-icon">${LOCK_SVG}</s><span class="text">Secure Checkout</span></button>
    ${kbTrustRowHTML()}
    </div>
    ${S.cart.length ? emailKitLinkHTML() : ''}
    ${/* 2026-08-12 - Joel, on the trust row under the wallets: "remove this from the kit builder
          cart". Same call he made on the site drawer on 2026-08-11. ROLLBACK: a div.usp here holding
          three spans, "Designed &amp; assembled in Oregon", "Free US Shipping $" + SHIP_FREE + "+",
          "Free US Returns". */''}
    `;
}
/* ========================== END AOAM KB CART SUMMARY 2026-08-18 ========================== */
/* 2026-08-19, Joel approved off the abandonment read: over the 13 clean days to 2026-08-18, 80
   sessions (72 people) left the builder with a COMPLETE kit assembled, about 6 a day against a
   $223.61 Kit Builder AOV, while this save route was used in 4 sessions. It was a 12px underlined
   text link at the very bottom of the cart footer, under the wallet row, which is not an action a
   shopper sees. Promoted to a bordered pill with a positive label; the old copy led with
   "Not ready?", which invites leaving rather than saving. Same onclick, same emailMeKit path, so
   nothing downstream changed. NOTE the mobile rule in kit-builder.css is UNTOUCHED and this stays
   hidden under 749px, per Joel 2026-08-16 ("remove this from mobile cart it is taking up too much
   space"). That is ~68% of Kit Builder sessions and it is his call, raised separately, NOT quietly
   reversed here. Restore the one-line button and the .emailkit rule to roll back. */
function emailKitLinkHTML(){
  return `<button type="button" class="emailkit" onclick="emailMeKit()">Save this kit for&nbsp;later</button>`;
}
/* 2026-08-06 dead-click audit (fix 5). #bbar ("View Kit" + running kit total) has been
   display:none since the 7-20 change, and NOTHING ever showed it again - yet renderBar kept writing
   #bb-tot and #bb-sub on every single mutation, so the free-shipping progress string was rendered to
   nobody for weeks. Once the drawer closes, mobile has no persistent checkout affordance left except
   an 18px header glyph, and mobile is 73% of this page's traffic. Wired rather than deleted, per that
   traffic split. Rules: show only on mobile, only with something in the kit, and never while a sheet
   or the drawer owns the screen (the drawer has its own checkout, the sheet has its own footer, and
   setSheetA11y already inerts #bbar). body.has-bbar reserves the space so the bar cannot cover the
   last grid row and pushes the kit-match toast above it. Restore the original 5-line body and drop
   .bbar.on / body.has-bbar from the CSS to roll back. */
function renderBar(){
  const c = calc(), items = gearQty();
  $('bb-tot').textContent = money(Math.max(0,c.totalDue));
  /* 2026-08-15: no free-shipping progress line for non-US, see the KB_GEO block by SHIP_FREE */
  $('bb-sub').innerHTML = items
    ? !IS_US ? `${items} item${items===1?'':'s'}` : `${items} item${items===1?'':'s'} · ` + (c.shipBase>=SHIP_FREE ? '<b>free US shipping ✓</b>' : `<b>${money(SHIP_FREE-Math.max(0,c.shipBase))}</b> from free shipping`)
    : 'Kit is empty. Tap a tile';
  const bb = $('bbar'); if (!bb) return;
  const show = items > 0 && isMobile()
    && !document.body.classList.contains('sheet-open')
    && !document.body.classList.contains('drawer-open');
  bb.classList.toggle('on', show);
  bb.setAttribute('aria-hidden', show ? 'false' : 'true');
  document.body.classList.toggle('has-bbar', show);
}
function renderKtoast(){
  const m = kitMatch(), m2 = kitMatchRev();
  const kt = $('ktoast');
  const showRev = !!(m2 && S.km2Dismiss !== m2.key);   /* r28: guard outranks the upsell here too */
  const ov = ovMatch();   /* 2026-07-31 kit-overlap: outranks both, same as the rig panel */
  if ((ov || showRev || (m && S.kmDismiss!==m.key)) && isMobile() && !document.body.classList.contains('sheet-open')){
    kt.hidden = false; kt.innerHTML = ov ? ovHTML(ov) : showRev ? km2HTML(m2) : kmHTML(m,true);
  } else { kt.hidden = true; kt.innerHTML=''; }
}
/* 2026-08-15: this price stays BARE in a non-USD market, and that is deliberate, not an oversight.
   It is a 15px glance figure in a 44px header button (.cartbtn .cprice), not a number anyone commits
   money against; " USD" would crowd the button at every width for no decision it informs. The
   currency is named where it is acted on - the drawer and rig-dock Total rows, and the kb-usd note
   under each.
   #bb-tot is left bare for a DIFFERENT and better reason, and the first draft of this comment got it
   wrong by claiming the .bbar was display:none (it is not: .bbar.on{display:flex} at kit-builder.css
   :1430 is live on mobile, which is 73% of this page). The real reason is that neither .bbar button
   reaches checkout - both call openDrawer() - so a phone shopper cannot commit money without the
   drawer, and its Total and note are what they see when they do. Suffixing a 17px lime figure in a
   61px fixed bar would cost width at 320px for a number nobody buys from. */
function renderHeaderTotal(){
  const c = calc();
  const items = gearQty();
  const cc = $('cartcnt'), pr = $('cartprice');
  if (items > 0){ cc.style.display=''; cc.textContent = items; if(pr) pr.textContent = money(Math.max(0,c.totalDue)); }
  else { cc.style.display='none'; if(pr) pr.textContent=''; }
}

/* cart drawer (live replica; adds are drawer-only, never /cart navigation) */
function optLines(h, t){
  if (t === 'Default Title') return [];
  const names = OPTS[h], parts = t.split(' / ');
  if (names && parts.length === names.length) return parts.map((p,i)=>names[i]+': '+p);
  return [t];
}
/* 2026-08-15 - Joel, mobile screenshot with the drawer's right edge circled: "add a green slider here
   so customer knows they can go up and down". The drawer's item list scrolls and nothing said so:
   iOS Safari draws NO persistent scrollbar (overlay bars fade within a second of a touch and
   ::-webkit-scrollbar styling does not bring them back there), and the desktop bar was
   scrollbar-color:#333 on black, i.e. invisible. So this is a real element, not a styled scrollbar,
   and it is the same on every device.
   It rides inside .cart__scrollable as position:sticky/top:8px with height 0, which pins it to the
   scrollport while its absolutely positioned thumb is offset by transform - no reflow per frame.
   The native bar is hidden in CSS so the two can never both show. Injected from here rather than
   added to templates/page.kit-builder.liquid so the whole change stays in the two asset files.
   Delete kbRail/kbSyncRail, the call in renderDrawer, the scroll+resize binds and the .kb-srail CSS
   to roll back (and restore .cart__scrollable's scrollbar-width:thin). */
let railBound = false;
function kbRail(){
  const sc = document.querySelector('#header_minicart .cart__scrollable');
  if (!sc) return null;
  let rail = sc.querySelector('.kb-srail');
  if (!rail){
    rail = document.createElement('div');
    rail.className = 'kb-srail'; rail.setAttribute('aria-hidden','true');
    rail.innerHTML = '<i></i>';
    sc.insertBefore(rail, sc.firstChild);
  }
  if (!railBound){
    railBound = true;
    sc.addEventListener('scroll', kbSyncRail, {passive:true});
    /* 2026-08-15 (adversarial review): kbShortDrawer runs here too, not just kbSyncRail. It had
       THREE call sites (both openDrawer paths and the --kb-consent writer) and none of them was
       resize, so a rotation re-measured the rail against a .kb-short flag still computed for the
       previous orientation - the two could never agree after a viewport change. Pre-existing, but
       the rail is what makes the disagreement visible, so it is fixed here. */
    window.addEventListener('resize', () => { kbShortDrawer(); kbSyncRail(); });
  }
  return rail;
}
function kbSyncRail(){
  const sc = document.querySelector('#header_minicart .cart__scrollable');
  const rail = kbRail(); if (!sc || !rail) return;
  const th = rail.querySelector('i'); if (!th) return;
  const vh = sc.clientHeight, sh = sc.scrollHeight, over = sh - vh;
  /* .kb-short turns the WHOLE drawer into the scroller and leaves this one overflow:visible, so
     there is nothing here to indicate - see SHORT_DRAWER_MIN. */
  if (over < 12 || document.getElementById('header_minicart').classList.contains('kb-short')){
    rail.style.display = 'none'; return;
  }
  rail.style.display = '';
  const trackH = Math.max(0, vh - 16);
  rail.style.setProperty('--kb-track', trackH + 'px');
  const thumbH = Math.max(28, Math.round(trackH * vh / sh));
  const maxTop = Math.max(0, trackH - thumbH);
  const top = Math.round(maxTop * (sc.scrollTop / over));
  th.style.height = thumbH + 'px';
  th.style.transform = 'translateY(' + Math.max(0, Math.min(maxTop, top)) + 'px)';
}
function renderDrawer(){
  const c = calc();
  /* r27 (critique W3): show the VARIANT's photo when it has one — the generic product shot next to
     "Size: 140 Fibers" read as a wrong-item scare (AOAM photography bakes spec text into corners) */
  const ls = S.cart.map((l,i) => ({img:(lv(l).img || P(l.h).imgs[0]), nm:P(l.h).title, opts:optLines(l.h, lv(l).t), pr:lv(l).p*l.qty, unit:lv(l).p, qty:l.qty, h:l.h, vi:l.vi, i,
    inc: isKit(l.h) ? kitIncludes(l.h, lv(l)) : null}));   /* 2026-07-31 kit-overlap: kit rows list their contents */
  const items = gearQty();
  $('dcount').textContent = items;
  $('dunit').textContent = items === 1 ? 'item' : 'items';   /* r27: no more "1 ITEMS" on the drawer's debut */
  /* r9: no threshold-pressure copy on an EMPTY cart — the meter starts with the first item */
  /* 2026-08-15: !IS_US hides the meter outright - no $99 threshold exists outside the US, the same
     call the site drawer makes on .progress-wrapper. See the KB_GEO block by SHIP_FREE. */
  /* 2026-08-18 - Joel: "identically match the main site cart". This is now the same shape
     snippets/drawer-cart.liquid renders, and the same three states:
       under the threshold  -> "Add $X more to get <strong>free shipping</strong>" plus the track
       at or above it       -> NOTHING, wrapper carries the boolean hidden attribute
       outside the US       -> nothing (no $99 threshold exists there)
     The "Free shipping unlocked" band the KB used to paint here was deleted from the site on
     2026-08-17 at Joel's request. #dprogress is the WRAPPER now (see the template), so writing ''
     genuinely empties it and widget-minicart.css's :not(:has(.block-progress__bar)) rule collapses
     it, instead of leaving an empty dark strip.
     The track is the site's span.dot driven by --theme-progress-left, not an <i style="width">. */
  {
    const showBar = IS_US && c.shipBase < SHIP_FREE;
    const wrap = $('dprogress');
    wrap.innerHTML = !showBar ? '' : `<div class="block-progress__bar">
      <p data-message>Add ${money(SHIP_FREE - Math.max(0,c.shipBase))} more to get <strong>free shipping</strong></p>
      <div class="progress" style="--theme-progress-left:${Math.min(100, Math.max(0,c.shipBase)/SHIP_FREE*100)}%"><span class="dot"></span></div>
    </div>`;
    wrap.toggleAttribute('hidden', !showBar);
  }
  const m = kitMatch(), m2 = kitMatchRev(), showRev = !!(m2 && S.km2Dismiss !== m2.key);
  const dov = ovMatch();   /* 2026-07-31 kit-overlap */
  $('dbanners').innerHTML = (dov ? ovHTML(dov) : '') + (needsLight() ? nlHTML() : '') + (needsHolder() ? bhHTML() : '') + (needsConnector() ? tcHTML() : '') + (lightReady() ? lightReadyHTML() : '') + (dov ? '' : showRev ? km2HTML(m2) : m && S.kmDismiss!==m.key ? kmHTML(m,false) : '');
  const empty = ls.length === 0;
  $('dls').innerHTML = empty
    ? `<div class="header-cart__empty show" style="display:block;padding:40px 18px;text-align:center">
         <div style="font-size:18px;font-weight:700;text-transform:uppercase;color:#fff">Your kit is empty</div>
         <div style="font-size:14px;color:#959595;margin:4px 0 16px">Tap any tile to gear up</div>
         <button class="btn btn-p" style="min-height:44px" onclick="closeDrawerUI()">Build My Kit</button>
       </div>`
    : ls.map(l=>`<div class="cart__item_wrp"><div class="cart__item">
    <div class="cart__image"><img class="cart-item__image" src="${CDN(l.img, l.inc && l.inc.labels.length ? 320 : 300)}" alt=""></div>
    <div class="cart-item__details text-left">
      <div class="cart-item__title">
      <div class="cart-title-remove-btn"><a class="cart-item__name">${esc(l.nm)}</a>
        <button class="cart__remove" aria-label="Remove ${esc(l.nm)} from kit" onclick="dropLine(${l.i})">${TRASH_SVG}</button>
      </div>
      <div class="cart-item__variants">${l.opts.map(o=>`<div class="variant">${esc(o)}</div>`).join('')}${l.inc && l.inc.labels.length ? `<div class="rinc" data-aoam-rinc="1"><b>Includes</b> ${l.inc.labels.map(esc).join(' · ')}</div>` : ''}</div>
      </div>
      <div class="cart-item__sub">
        <span class="js-qty__wrapper"><button aria-label="Less" onclick="decVar('${l.h}',${l.vi})">${QTY_MINUS_SVG}</button><span class="js-qty__num">${l.qty}</span><button aria-label="More" onclick="addItem('${l.h}',${l.vi},1,null)">${QTY_PLUS_SVG}</button></span>
        <span class="cart-item__price money">${money(l.unit)}</span>
      </div>
    </div></div></div>`).join('');
  /* 2026-08-18: the rail moved out of #dls into its own #dstrip so it can be pushed to the bottom
     of the scrollport when the list is short (Joel: "i want the upsell to be just above the pricing
     section"). Order on screen is unchanged - #dstrip is #dls next sibling. */
  $('dstrip').innerHTML = empty ? '' : stripHTML();
  const lt = lightsInCart(), wp = warrProd();
  $('dfoot').innerHTML = `
    ${kbSummaryHTML(c, items, lt, wp, true)}
    ${/* 2026-08-12 - Joel: "remove this from the kit builder cart". The drawer footer half of the
          same removal, see the note in the rigdock above for the rollback markup. */''}
    `;
  /* the list just changed height, so the scroll indicator has to be re-measured after it, not before */
  requestAnimationFrame(kbSyncRail);
}
/* 2026-07-28 audit: the drawer never locked the page behind it, unlike the detail sheet which has
   used body.sheet-open{overflow:hidden} since it was built. On a phone the drawer is the full 100vw,
   so a swipe past the end of the item list, or anywhere on its header or footer, chain-scrolled the
   catalog underneath, and Keep Building then dropped the shopper at a random position instead of
   where they left off. Same pattern, same place in the lifecycle, including the popstate close path.
   Delete the two body.drawer-open toggles and the CSS rule to roll back. */
/* 2026-08-15 (Claude) SHORT DRAWER. Measured on a 390x844 phone with Shopify's own cookie-consent
   banner up: #shopify-pc__banner is 391px tall, 46% of the screen. The mobile rule
   #header_minicart{bottom:var(--kb-consent)} then cuts the drawer to 453px, and the footer alone is
   363px, so .cart__scrollable was left at SIXTEEN pixels and the item the shopper had just added
   painted outside it. That is the whole of "the product disappears on a phone".
   The drawer layout itself is NOT at fault, which is why the obvious flex fix was wrong: with the
   banner dismissed the same drawer measures 844 tall, a 342px list, one row fully visible and
   checkout at y=673. So this touches nothing in the normal case. It only tags a drawer too short to
   hold one row AND its footer, and the CSS then scrolls the WHOLE column instead of nesting a
   crushed scroller inside a footer that does not fit either.
   SHORT_DRAWER_MIN = header 79 + meter 40 + one 136px row + footer 363, rounded down to 600.
   Re-measure it if the footer ever gains or loses a row. Driven from BOTH openDrawer paths and
   from the --kb-consent writer near the end of this file, which already observes the banner
   appearing and being dismissed - that is the one thing that resizes the drawer with no resize event.
   Delete this block, its three call sites and the #header_minicart.kb-short rules in
   assets/kit-builder.css to roll back. */
const SHORT_DRAWER_MIN = 600;
function kbShortDrawer(){
  const d = $('header_minicart'); if (!d) return;
  d.classList.toggle('kb-short', d.getBoundingClientRect().height < SHORT_DRAWER_MIN);
}
function openDrawer(){
  /* 2026-08-15: an add made from the product sheet owns the open itself, AFTER the sheet's history
     entry is popped - see sdAdd. addItem's own r9 drawer intro would fire first and strand it.
     drawerIntro is still marked done so the intro is not owed twice. */
  if (sdAddArmed){ drawerIntro = true; return; }
  const mc = $('header_minicart');
  if (mc.classList.contains('js-drawer-open')){ renderDrawer(); kbShortDrawer(); kbSyncRail(); return; }   /* already open: refresh, don't steal focus */
  history.pushState({layer:'drawer'}, '');   /* swipe-back closes the drawer */
  renderDrawer(); $('dback').classList.add('open'); mc.classList.add('js-drawer-open');
  document.body.classList.add('drawer-open');
  /* 2026-08-18 (Joel: "there is a green circle around the X"): focus the DIALOG, not the close
     button - see the comment in templates/page.kit-builder.liquid. */
  $('header_minicart').focus({preventScroll:true});
  renderBar();   /* 2026-08-06 fix 5: the sticky bottom bar steps aside while the drawer owns the screen */
  kbShortDrawer();   /* 2026-08-15: tag a drawer too short to hold a row plus its footer */
  requestAnimationFrame(kbSyncRail);   /* after the open transition has laid the column out */
}
function closeDrawer(){ $('dback').classList.remove('open'); $('header_minicart').classList.remove('js-drawer-open');
  document.body.classList.remove('drawer-open'); renderBar(); }   /* 2026-08-06 fix 5: ...and comes back after it closes */

/* media renderer */
function mediaHTML(m, act = true){ /* act=false: rail slide that isn't in view yet — no autoplay, lazy image */
  if (!m) return '';
  if (m.type === 'v'){
    if (m.src.includes('youtube')) return `<iframe loading="lazy" src="${m.src}" allow="autoplay; encrypted-media" allowfullscreen title="Product video"></iframe>`;
    return `<video src="${m.src}" ${m.poster?`poster="${CDN(m.poster,500)}"`:''} muted ${act?'autoplay':''} loop playsinline preload="metadata" onclick="this.paused?this.play():this.pause()"></video>`;
  }
  return `<img src="${CDN(m.src,500)}" ${act?'':'loading="lazy"'} alt="">`;
}

/* keyboard: Escape layering (drawer → owner picker → detail) */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape'){
    if (!$('leavepop').hidden) closeLeavePop();
    else if (!$('warrpop').hidden) closeWarrPopUI();
    else if ($('header_minicart').classList.contains('js-drawer-open')) closeDrawerUI();
    else if (!$('opicker').hidden) closeOwnPickerUI();
    else if (S.sel) closeStageUI(true);
  }
  if (e.key === '/' && document.activeElement !== $('search')){ e.preventDefault(); $('search').focus(); }
});

/* toast / persist (v13 key, owner gear persisted) */
let toastT;
function toast(msg){ const t = $('toast'); t.textContent = msg; t.classList.add('show');
  clearTimeout(toastT); toastT = setTimeout(()=>t.classList.remove('show'), 2200); }
/* 2026-07-28 audit. A saved line stored only the variant INDEX (vi), which is a position in
   kit-builder-data.js, not an identity. Regenerating that file (which the 07-28 availability fix
   does, and every future price or variant change will) can reorder or insert a variant, and a
   returning shopper's saved "24 Inch" line then restores as whatever now sits at that index: a
   different size at a different price, passing every guard and flowing into checkout unnoticed.
   The variant id is already in DATA and is stable, so it is written alongside vi and wins on
   restore; vi stays for backward compatibility with saves made before today. Delete the `v:` field
   and the vid re-resolve block to roll back. */
function persist(){ try{ localStorage.setItem('aoam-rig-v13', JSON.stringify({
  c: S.cart.map(l => { const v = P(l.h) && P(l.h).vars[l.vi]; return {h:l.h, vi:l.vi, qty:l.qty, v: v ? v.id : 0}; }),
  w:S.warranty, o:S.own })); }catch(e){}
  kbCartTouch(); }   /* 2026-07-30 cart-match: every kit mutation funnels through persist, so this one call keeps the real cart in step */
function restore(){
  try { kbX6Load(); } catch (e) {}   /* 2026-10-05 cart audit KB-01: the runtime cart entries first (see kbX6From), or a saved line for them is dropped and its ledger cuts the real cart line. Roll back: delete this line. */
  try{
    const d = JSON.parse(localStorage.getItem('aoam-rig-v13')||'null'); if (!d) { try { localStorage.setItem('aoam-kb-optin-v1', '1'); } catch (e) {} return; }   /* 2026-09-24: nothing saved, nothing to migrate; mark it so a kit saved later keeps its warranty choice */
    S.warranty = !!d.w;
    /* 2026-09-24 (Claude): a kit saved before the opt-in change carries the old on-by-default, not a choice the
       shopper made, so it is cleared exactly once per browser. A choice made after today survives reloads. */
    try { if (localStorage.getItem('aoam-kb-optin-v1') !== '1') { S.warranty = false; localStorage.setItem('aoam-kb-optin-v1', '1'); } } catch (e) {}
    if (GEAR_ON && d.o && Array.isArray(d.o.gear)) S.own = {on: !!d.o.on && d.o.gear.length>0, gear: d.o.gear};   /* r37: with the gear filter off, a stale saved gear state must not silently re-filter the catalog */
    const dropped = [], gone = [];
    S.cart = (d.c||[]).filter(l => {
      if (!l || typeof l.h !== 'string') return false;
      /* r9: clamp stale/corrupt saves — an un-clamped qty/vi flows into calc() as NaN and into the checkout permalink */
      l.vi = Number(l.vi); l.qty = Math.min(99, Math.max(1, parseInt(l.qty, 10) || 1));
      const p = P(l.h);
      if (!p){ gone.push(l.h); if (l.v) kbGoneVids[+l.v] = 1; return false; }   /* 2026-10-05 cart audit KB-01: kbGoneVids, see kbX6From. Roll back: drop the kbGoneVids write. */   /* handle no longer in the catalog: say so, do not vanish */
      /* identity beats position: re-point vi at whatever index now holds the saved variant id */
      if (l.v){
        const byId = p.vars.findIndex(v => v.id === l.v);
        if (byId >= 0) l.vi = byId;
        else { dropped.push(p.title); kbGoneVids[+l.v] = 1; return false; }   /* 2026-10-05 cart audit KB-01: kbGoneVids, see kbX6From. Roll back: drop the kbGoneVids write. */   /* that exact variant is gone from the catalog */
      }
      const ok = Number.isInteger(l.vi) && p.vars[l.vi] && p.vars[l.vi].a;
      if (!ok) dropped.push(p.title); return ok; });
    if (dropped.length) setTimeout(()=>toast(dropped.length + ' saved item(s) now sold out, removed'), 600);
    else if (gone.length) setTimeout(()=>toast(gone.length + ' saved item(s) are no longer sold, removed'), 600);
  }catch(e){}
}

/* boot */
function renderVault(){ renderModeBars(); renderSubchips(); renderGrid(); }
function renderAll(){
  /* Warranty coverage tracks the kit, in two passes, and the ORDER MATTERS.
     DROP first: when the covered light leaves the kit, or the warranty variant is sold out, the flag
     clears (2026-07-31 warranty QA defect 16; restore the bare lightsInCart()===0 check to roll back
     that half). ARM second: 2026-08-11, Joel - "not all areas of the site have the warranty
     automatically added". Every layout/theme.liquid page is opt-OUT via aoam-cart-fix.liquid, but
     that snippet is never rendered on this layout, so the builder was the one surface still opt-IN.
     The arm re-applies the same default here, honouring the same decline records (aoamWarrDeclined).
     This supersedes the old "never silently re-arms" rule, which described an opt-IN surface; the
     row is always visibly checked and priced inside Total whenever the flag is armed, so nothing is
     charged silently.
     WHY THIS IS AN ARM AND NOT A CHANGED DEFAULT: setting `warranty:true` on the S literal does
     NOTHING. The builder boots with an empty kit, so the DROP above clears it on the very first
     renderAll (boot: restore(); buildHub(); playHubIntro(); renderTabs(); renderAll();) and nothing
     re-arms it. It has to be re-evaluated per render.
     WHY IT CANNOT DOUBLE-ADD: S.warranty is a boolean, not a counter. The builder's warranty reaches
     the real cart at exactly one place, kbLines(), which pushes a fixed quantity:1 gated on
     KB_APPWARR <= 0 - so a warranty already in the cart from the site's own app suppresses the
     builder's push entirely and shows that charge instead (defect 14). kbVidMap() deletes both
     warranty variant ids from the sync map, so kbCartSync never adds, cuts or reconciles a warranty
     line. There is no additive path here to reintroduce.
     WHY IT IS ALWAYS VISIBLE: both row render gates are (lt > 0 || KB_APPWARR > 0) with
     lt = lightsInCart(), the same condition as the arm, so the flag can never be armed while the row
     is off screen.
     Delete the single arm line to return the builder to opt-in. */
  if (S.warranty && (kbWarrStepsOn() ? kbWarrStepUsd() === 0 : (warrTotalCost() === 0 || !(warrProd().vars[0] && warrProd().vars[0].a)))) S.warranty = false;   /* 2026-09-25: with price steps it drops only below the first step ($25), not when no light is in the kit */   /* 2026-08-18: warrTotalCost(), not lightsInCart(). The case that drove this was a cart of standalone Critters, which had lights but no priceable bucket and armed the flag over a $0.00 row; later the same day the Critter became warranty-eligible (see warrEligible above), so that particular cart now HAS a bucket and arms legitimately on the next line. The test stays because it is the right shape regardless: never arm a warranty the cart cannot price. */
  if (false /* 2026-09-24 (Claude): opt-in again. This arm re-applied the old on-by-default on every render; Joel turned that off after customers said it was switched on for them. Delete "false &&" to roll back. */ && !S.warranty && warrTotalCost() > 0 && !aoamWarrDeclined() && warrProd().vars[0] && warrProd().vars[0].a) S.warranty = true;   /* 2026-07-31 warranty QA (defect 16): also drops when the warranty variant itself is sold out. Restore the bare lightsInCart()===0 check to roll back */
  renderHub(); renderStage(); renderHeaderTotal(); renderRig(); renderBar(); renderKtoast(); renderVault();
  renderGuide();   /* 2026-07-31 guided strip: cart state drives the step ticks */
  if (S.sel && !$('stagedetail').hidden) sdSync();
  if ($('header_minicart').classList.contains('js-drawer-open')) renderDrawer();
}
let searchT;   /* r9: debounced — a full grid rebuild per keystroke was janky on mid-range phones */
$('search').addEventListener('input', () => { clearTimeout(searchT); searchT = setTimeout(() => { closeStage(false); renderVault(); }, 120); });
$('dback').addEventListener('click', closeDrawerUI);
/* r38: the desktop "cart owns the column" rule is gated on isMobile(), so recompute the hub/cart
   state whenever the viewport crosses the 900px breakpoint. */
matchMedia('(max-width:900px)').addEventListener('change', () => { renderStage(); renderBar(); });   /* 2026-08-06 fix 5: the bottom bar is mobile-only, so it has to re-evaluate on the same crossing */
$('dclose').addEventListener('click', closeDrawerUI);
/* r8 (Joel): on desktop the rig panel IS the cart, always on screen — opening the drawer clone over
   it would stack two identical carts. Cart button scrolls to + flashes the panel instead.
   Mobile keeps the drawer (no rig panel there). */
/* 2026-08-06 dead-click audit (fix 4, revised). Opening the drawer on desktop was tried and REVERTED:
   measured at 1280x800 and 1440x900, the .dback backdrop goes to opacity 1 (rgba(0,0,0,.6)) and covers
   100% of the rig panel, so the click dimmed the whole builder in order to show a second copy of a cart
   that was already fully on screen - exactly the "two identical carts" the r8 note above rules out.
   The real defect was that focusRig produced NO perceptible change when the panel was already in view:
   scrollIntoView on a visible element is a no-op and the old .flash was a single 0.9s border fade.
   It now skips the pointless scroll, pulses a 3-beat ring, and pulses the running total, so the click
   always reads as "your kit is over here". Restore the 3-line body to roll back. */
function focusRig(){
  const rp = $('rigpanel');
  const r = rp.getBoundingClientRect();
  const fullyInView = r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  if (!fullyInView) rp.scrollIntoView({behavior:'smooth', block:'start'});
  rp.classList.remove('flash'); void rp.offsetWidth; rp.classList.add('flash');
  const tot = $('rigtot') || $('cartprice');
  if (tot){ tot.classList.remove('pulse'); void tot.offsetWidth; tot.classList.add('pulse'); }
}
/* 2026-08-06 dead-click audit (fix 4, revised): mobile opens the drawer, desktop stays on the rig panel
   per the r8 note above, but focusRig now gives unmistakable feedback (see its comment). */
$('cartbtn').addEventListener('click', () => isMobile() ? openDrawer() : focusRig());
$('opback').addEventListener('click', closeOwnPickerUI);
/* r8 (Joel): a stray menu click shouldn't yank a customer out of a build in progress.
   Empty rig = navigate straight (nothing to lose). Items in rig = confirm, with the
   save reassurance (cart persists in localStorage, so leaving really is safe). */
function closeLeavePop(){ $('leavepop').hidden = true; }
/* r9: gate extended to BACK TO SITE. r18: site menu gone. r19: the logo links home too, same gate */
/* r39: delegated (was a load-time querySelectorAll) so the dynamically-rendered saber door tile + sheet link
   route through the same gate. Saber targets read as leaving to a sibling BUILDER; backsite/logo say "the main site". */
document.addEventListener('click', e => {
  const a = e.target.closest ? e.target.closest('a.backsite, a.logo, a.saberlink, a.saberdoor, a.sabersheet') : null;
  if (!a) return;
  if (!S.cart.length) return;   /* empty rig: navigate straight, nothing to lose (cart persists in localStorage either way) */
  const saber = a.matches('a.saberlink, a.saberdoor, a.sabersheet');
  e.preventDefault();
  $('lv-go').href = a.href;
  $('lv-go').textContent = saber ? 'Continue to the Saber Lab' : 'Continue to the main site';
  $('leavepop').hidden = false;
  $('leavepop').querySelector('.btn-p').focus();
});
/* 2026-08-06 dead-click audit (fix 10). The template shipped the pill with href="#" and this line
   removed it at boot because SABER_URL is "", so every single visitor was served a live-looking,
   fully styled, clickable Saber Lab pill that did nothing for the whole pre-hydration window (~1.9s
   on cold-cache Slow-4G). The pill is no longer in templates/page.kit-builder.liquid at all; it is
   built here, and only when SABER_URL actually holds a URL. The steady state is byte-identical to
   what shoppers see today (no pill), so there is no visual change - only the dead window closes.
   The r39 auto-margin handoff is unaffected: .backsite already owns the right-edge push while the
   Saber Lab is dark, and the .saberlink CSS is untouched and applies the moment SABER_URL is set.
   Restore the pill markup in the template and this one-liner to roll back. */
/* 2026-08-06: deploy-order safety. This JS and templates/page.kit-builder.liquid must ship together,
   but a push can land out of order or one file can fail. If the OLD template is still being served it
   still ships <a class="saberlink" href="#">, and without this sweep the dead pill would become
   PERMANENT rather than briefly visible - the exact opposite of fix 10. Measured on the live page with
   only the new JS substituted: the dead pill survived. So strip any href="#" pill first, always. */
document.querySelectorAll('a.saberlink[href="#"], a.saberlink:not([href])').forEach(el => el.remove());
if (SABER_URL){
  const bs = document.querySelector('a.backsite');
  if (bs && !document.querySelector('a.saberlink')){
    const a = document.createElement('a');
    a.className = 'saberlink'; a.href = SABER_URL;
    a.setAttribute('aria-label','Open the Saber Lab');
    a.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M7 17L17 7M8 7h9v10"/></svg><span class="sb-label">Saber Lab</span><span class="sb-short">Saber</span>';
    bs.parentNode.insertBefore(a, bs);
  }
}
/* 2026-08-06 dead-click audit (fix 7). With DATA = {} the old boot did not merely render an empty
   catalog - renderRig's empty state and renderGuide both read P(CRITTER).vars[0].p, so renderAll()
   THREW and left the page half-built with no message at all. Boot now branches: a missing catalog
   gets the explicit failure card and the kb_data_missing event, and the render pipeline that depends
   on DATA is never entered. Everything below this block is DATA-independent and still runs either
   way. Restore the single unguarded line to roll back. */
if (!KB_DATA_OK){
  kbDataFail();
} else {
  restore(); buildHub(); playHubIntro(); renderTabs(); renderAll();
  kbCartTouch(1);   /* 2026-07-30 cart-match: reconcile the restored kit against the live cart on every entry */
}
if (!GEAR_ON){ const gc = $('gearchip'); if (gc) gc.style.display = 'none'; S.own = {on:false, gear:[]}; }   /* r37: hide the "Fits my gear" chip (inline display:none — the .gearchip class sets display:flex, which overrides the [hidden] attribute) and clear any filter state */
history.replaceState({base:1}, '');   /* base history marker; layers (drawer/sheet/picker) push on top of it */
kbGA('kit_builder_open');   // [kb-track] funnel entry — fired once per builder load
/* ?own=1 — durable owner-mode entry, works with zero localStorage (in-app WebView safe) */
if (GEAR_ON && new URLSearchParams(location.search).get('own') === '1'){ openOwnPicker(); }

/* AOAM kbp deep-link 2026-07-20 */
(function(){
  try {
    var params = new URLSearchParams(location.search);
    var kit = params.get('kit');
    if (!kit) return;                 /* no ?kit= param -> behaviour byte-for-byte unchanged */
    kit = String(kit).trim().toLowerCase();
    if (!kit) return;
    if (document.getElementById('kb6')) return;   /* 2026-10-05 (Claude, cart audit KB-05): kb6 owns ?kit= now (kb6.js boot opens the kit); this hidden builder opening its own stage as well pushed a dead history entry on phones. Roll back: delete this line. */

    /* Homepage promo hands off one of these four kit handles. KB_DATA is keyed by product
       handle (identity map) and each entry carries .cat, so the target tab is derived from
       KB_DATA at run time; this allow-map is the explicit fallback / documentation of the
       four handles the promo section passes and the tab each opens on. */
    var KBP_KITS = {
      'bitwhip-fiber-optic-whip-prop': 'kits',
      'light-painting-photography-kit-for-beginners': 'kits',
      'fiber-optic-costume-kit-app-controllable': 'kits',
      'double-bitwhip-light-whip': 'kits'
    };

    var start = Date.now(), TIMEOUT = 5000, STEP = 150;

    function ready(){
      var d = window.KB_DATA;
      return !!(d && d[kit] &&
        typeof window.openStage === 'function' &&
        typeof window.setCat === 'function' &&
        document.getElementById('grid'));
    }

    function go(){
      var d = window.KB_DATA;
      if (!d || !d[kit]) return;      /* unknown handle -> silent no-op, never guesses */
      var cat = (d[kit] && d[kit].cat) || KBP_KITS[kit] || 'kits';
      /* 1) switch to the kit's category tab (re-renders its tile into #grid) */
      try { window.setCat(cat); } catch(e){}
      /* 2) open the kit's existing detail sheet/overlay. Navigation only: openStage never
            mutates the cart/selection (addItem is the only add path, and we do not call it). */
      try { window.openStage(kit); } catch(e){}
      /* 3) scroll the freshly rendered (now .sel) tile into view */
      try {
        var sel = '.tile[data-h="' + ((window.CSS && CSS.escape) ? CSS.escape(kit) : kit) + '"]';
        var doScroll = function(){
          try {
            var tile = document.querySelector(sel);
            if (tile && tile.scrollIntoView) tile.scrollIntoView({block:'center', inline:'nearest'});
          } catch(e){}
        };
        if (window.requestAnimationFrame) requestAnimationFrame(doScroll); else doScroll();
      } catch(e){}
    }

    (function poll(){
      try {
        if (ready()) { go(); return; }
        if (Date.now() - start < TIMEOUT) setTimeout(poll, STEP);
      } catch(e){}
    })();
  } catch(e){}
})();

/* 2026-07-23 build marker. Forces a new asset version stamp so the storefront picks up the
   preload=none / mobile-intro-skip / idle-deferred-starburst changes. Safe to delete. */

/* ============================================================================================
   2026-07-23 step-level funnel tracking. Joel: "do whats best just go".

   The problem this solves: before today the builder reported only two things, kit_builder_add
   and kit_builder_checkout. Over the first 5 days that read 148 users -> 12 added -> 4 checkout
   -> 1 order. So we could see that 136 of 148 people left without adding anything, but we had
   no idea WHERE they gave up. Never found a category? Searched and got nothing? Opened a
   product and backed out? All invisible.

   Everything below is additive instrumentation. It wraps the existing functions instead of
   editing them, so no builder logic changes and deleting this whole block is a clean rollback.
   Wrapping works because kit-builder.js is a classic script, so its top-level declarations are
   global-object properties (the 2026-07-20 kbp deep-link block above already relies on this).

   Every handler is individually try/caught and every wrapper calls the original FIRST and
   returns its value, so a analytics fault can never take the page down with it.
   ============================================================================================ */
(function(){
  var ga = function(n, p){ try { kbGA(n, p); } catch(_){} };
  var wrap = function(name, before, after){
    try {
      var orig = window[name];
      if (typeof orig !== 'function') return;
      window[name] = function(){
        var pre; try { pre = before && before.apply(null, arguments); } catch(_){}
        var out = orig.apply(this, arguments);
        try { after && after(pre, arguments); } catch(_){}
        return out;
      };
    } catch(_){}
  };

  /* furthest point reached, so an abandon event says how deep they got rather than just "left" */
  var STEPS = { open:1, browse:2, detail:3, add:4, kit:5, checkout:6 };
  var furthest = 'open', searched = false, viewedDetail = false, checkingOut = false;
  var bump = function(s){ if ((STEPS[s]||0) > (STEPS[furthest]||0)) furthest = s; };
  /* 2026-10-07 Joel approved "Search + tracking" (Kit Builder review): none of the functions wrapped below run on kb6, so every
     kit_builder_abandon read furthest_step "open" (68 of 68). kb6's tracker (assets/kb6.js, STEP6) reports its steps here;
     'search' and 'detail' also set the two flags the abandon carries. Delete this line to roll back. */
  window.kbFunnelStep = function(s){ try { if (s === 'search') { searched = true; s = 'browse'; } if (s === 'detail') viewedDetail = true; bump(s); } catch(_){} };

  var titleOf = function(h){ try { return P(h).title; } catch(_){ return String(h||''); } };
  var value   = function(){ try { return +Math.max(0, calc().total).toFixed(2); } catch(_){ return 0; } };
  var units   = function(){ try { return kbUnits(); } catch(_){ return 0; } };

  /* which category they browse, and how many get tried before the first add */
  var tabs = 0;
  wrap('setCat', null, function(_, args){
    tabs++; bump('browse');
    ga('kit_builder_tab', { category: String(args[0]||''), tabs_viewed: tabs });
  });

  /* did they open a product at all: the single biggest blind spot in the old funnel */
  wrap('openStage',
    function(){ try { return S.sel; } catch(_){ return null; } },
    function(prevSel, args){
      var h = args[0];
      if (prevSel === h) return;            /* openStage early-returns when already selected */
      bump('detail'); viewedDetail = true;
      ga('kit_builder_detail_view', { item: titleOf(h), category: (function(){ try { return S.cat; } catch(_){ return ''; } })() });
    });

  /* removals: what people put in and then think better of */
  wrap('dropLine',
    function(i){ try { return S.cart[i] ? titleOf(S.cart[i].h) : null; } catch(_){ return null; } },
    function(t){ if (t) ga('kit_builder_remove', { item: t, num_items: units(), how: 'trash' }); });
  wrap('decItem',
    function(i){ try { var l = S.cart[i]; return l ? { t: titleOf(l.h), last: l.qty <= 1 } : null; } catch(_){ return null; } },
    function(p){ if (p && p.last) ga('kit_builder_remove', { item: p.t, num_items: units(), how: 'decrement' }); });

  /* who declares their existing gear, and what they own */
  wrap('ownApply', null, function(){
    try { ga('kit_builder_gear_filter', { gear: (S.own.gear||[]).join('|'), gear_count: (S.own.gear||[]).length }); } catch(_){}
  });

  /* Search, debounced well past the 120ms grid rebuild so the result count is the settled one.
     results:0 is the valuable case: it is a customer telling us what they wanted and we did not
     show them. Repeat terms are suppressed so holding a key down cannot spam the property. */
  try {
    var box = $('search'), t, last = '';
    if (box) box.addEventListener('input', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        try {
          var q = (box.value||'').trim();
          if (q.length < 2 || q === last) return;
          last = q; searched = true; bump('browse');
          ga('kit_builder_search', { search_term: q.toLowerCase(), results: document.querySelectorAll('#grid .tile').length });
        } catch(_){}
      }, 700);
    });
  } catch(_){}

  /* reaching the kit/cart surface is its own step: intent to buy, before the checkout click */
  try {
    var seenKit = false;
    ['openDrawer','focusRig'].forEach(function(fn){
      wrap(fn, null, function(){
        if (seenKit) return; seenKit = true; bump('kit');
        ga('kit_builder_view_kit', { num_items: units(), value: value(), currency: 'USD' });
      });
    });
  } catch(_){}

  /* every route to checkout, not just kbGoCheckout.
     2026-07-24: dropped the `a.` qualifiers. The dock Secure Checkout and the wallet marks used to be
     <a href="<permalink>"> and are now <button>, so `a.btn-cart__checkout, a.wgo` silently stopped
     matching and this bump would have gone quiet. Class-only matches both shapes. Restore the `a.`
     prefixes only if those controls ever go back to being links. */
  try {
    document.addEventListener('click', function(e){
      try {
        if (!e.target.closest) return;
        if (e.target.closest('.btn-cart__checkout, .wgo, .bb-view')) { checkingOut = true; bump('checkout'); }
      } catch(_){}
    }, true);
  } catch(_){}
  wrap('kbGoCheckout', null, function(){ checkingOut = true; bump('checkout'); });

  /* Abandonment. Fires once, on the way out, only when there is a kit worth money and the buyer
     never headed for checkout. transport beacon so it survives the unload. pagehide rather than
     unload because iOS Safari does not reliably fire unload. */
  try {
    var sent = false;
    var abandon = function(){
      if (sent || checkingOut) return;
      var n = units(); if (!n) return;
      sent = true;
      ga('kit_builder_abandon', {
        num_items: n, value: value(), currency: 'USD',
        furthest_step: furthest, step_index: STEPS[furthest] || 0,
        viewed_detail: viewedDetail, searched: searched,
        transport_type: 'beacon'
      });
    };
    addEventListener('pagehide', abandon);
    /* 2026-07-28 audit: on iOS, backgrounding the browser fires visibilitychange-hidden but NOT
       pagehide, so a shopper who checks Instagram mid-build and comes back to buy was permanently
       counted as an abandoner, and GA4 cannot retract a beacon. Dropping the visibilitychange hook
       would undercount instead (a backgrounded tab the OS kills never fires pagehide), so it stays
       and a paired return event is emitted, letting analysis net the two out. */
    var returned = false;
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'hidden'){ abandon(); return; }
      if (!sent || returned) return;
      returned = true;
      ga('kit_builder_return', { num_items: units(), value: value(), currency: 'USD', furthest_step: furthest });
    });
  } catch(_){}
})();

/* ============================================================================================
   2026-07-25 consent-banner clearance. Measures Shopify's cookie consent banner and publishes
   its height as --kb-consent so the bottom-pinned surfaces can clear it. Full diagnosis is in
   the matching block at the end of assets/kit-builder.css. The banner is never hidden or
   covered, it is consent UI; this only moves our own controls out from under it. Delete both
   blocks to roll back.
   ============================================================================================ */
(function(){
  try {
    var SEL = '#shopify-pc__banner';
    var root = document.documentElement;
    var last = -1;

    function height(){
      var b = document.querySelector(SEL);
      if (!b) return 0;
      var s = getComputedStyle(b);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) < 0.05) return 0;
      var r = b.getBoundingClientRect();
      /* Only a banner actually pinned to the bottom of the viewport can bury our controls. */
      if (r.height < 1 || r.bottom < window.innerHeight - 2) return 0;
      return Math.ceil(r.height);
    }

    function apply(){
      var h = height();
      if (h === last) return;
      last = h;
      root.style.setProperty('--kb-consent', h + 'px');
      /* 2026-08-15: the banner appearing or being dismissed is the one thing that changes the
         drawer's height without a resize event, so re-tag it here. Guarded because this IIFE can
         run before kbShortDrawer is declared. */
      /* 2026-08-15 (adversarial review): kbSyncRail added beside it. This writer is the ONLY thing
         that resizes the drawer without a resize event, so without this the scroll rail keeps the
         display + --kb-track + thumb geometry it computed for the PREVIOUS height. Concretely: the
         shopper accepts the consent banner with the drawer open, the drawer grows from 453px to
         844px, kbShortDrawer correctly drops .kb-short - and the rail stays display:none until they
         scroll, which is the one moment the indicator existed to pre-empt. */
      try { kbShortDrawer(); kbSyncRail(); } catch (e) {}
    }

    /* apply() reads getBoundingClientRect, which forces layout. The observer below watches the
       whole body, and tickShipLeft rewrites #rigShipTxt on every animation frame for up to
       900ms after a cart change, so an unthrottled observer would measure on most of those
       frames. Coalesce to at most one measurement per tick.

       Deliberately setTimeout and NOT requestAnimationFrame: rAF does not fire while the tab is
       backgrounded or the WebView is not compositing, which would strand pending at true and
       freeze --kb-consent at its last value forever. Caught in testing, where the banner was
       hidden and the variable stayed at 391px because the rAF callback never ran. */
    var pending = false;
    function schedule(){
      if (pending) return;
      pending = true;
      setTimeout(function(){ pending = false; apply(); }, 16);
    }

    apply();
    addEventListener('resize', schedule);
    addEventListener('orientationchange', schedule);

    /* The banner is injected late and removed the moment consent is given, so watch for both. */
    if (window.MutationObserver){
      new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, attributes:true,
        attributeFilter:['style','class','hidden']});
    }
    /* Belt and braces for the first few seconds, in case the banner arrives before body is watched. */
    var t = 0, iv = setInterval(function(){ apply(); if (++t > 20) clearInterval(iv); }, 250);
  } catch(e){ /* never break the builder */ }
})();

/* ============================================================================================
   2026-07-28 KLAVIYO CAPTURE. Two features, one shared popover, all client-side.

   Why: GA4 for 2026-07-23..28 shows roughly 24 users built a priced kit and left against 14 who
   checked out, worst on paid traffic (google/cpc 13 abandoners to 4 checkouts), and nothing on the
   page ever asked for an address. Separately, NOTIFY ME on a sold-out item was a stub that toasted
   "we'll email you" while collecting and recording nothing, which is a promise the site could not
   keep. Both are demand we were watching walk away.

   Public key K7W3iX only, the same key the storefront's Klaviyo embed already exposes; no private
   key is ever in theme JS. The email lives only in the POST body, never in a URL (hard rule, same
   as the Saber Lab's "Email me this build" which this mirrors).

   NOTHING SENDS until Joel approves the email content and takes the Klaviyo flow out of DRAFT,
   per the standing never-publish-an-email-without-confirmation rule. Until then the profile and
   the event still land, so the demand is captured from today rather than lost.
   Delete this whole block, the notifyMe body above and the Email-me buttons to roll back.
   ============================================================================================ */
const KL_KEY = 'K7W3iX';
const KL_REV = '2025-01-15';
const KL_LIST = 'X86fdq';   /* list "Kit Builder Kits (Claude)"; metric "Kit Builder Email Kit" = UvmNeZ,
                               flow "Kit Builder - Email Me This Kit (Claude)" = TJYK48, left DRAFT */
/* 2026-08-18 (Claude). Klaviyo's client API cannot be reached from a browser right now: it
   requires a 'revision' header, that forces a CORS preflight, and their preflight answers
   'access-control-allow-methods: OPTIONS' with no POST. Their onsite script is already loaded on
   this page, and its queue needs no preflight. Prefer it; keep the client API as the fallback.
   TO ROLL BACK: restore the klPost('events', ...) call in kbEmailKit. */
/* 2026-08-18 (Claude). Klaviyo's LEGACY browser endpoint, and it is the one that is MEASURED
   to work: GET /api/track?data=<base64 json> answers 200 with body "1", and carries
   access-control-allow-origin for this store. It is a SIMPLE GET, so no preflight exists to
   be refused - which is the whole reason the client API cannot be used from a browser today.
   Returns a promise of true/false, so unlike the onsite queue a failure is actually visible. */
function klLegacyTrack(metric, props, email) {
  try {
    const payload = { token: KL_KEY, event: metric,
      customer_properties: { '$email': email }, properties: props || {} };
    const enc = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    return fetch('https://a.klaviyo.com/api/track?data=' + encodeURIComponent(enc), { keepalive: true })
      .then(function (r) { return r.text(); })
      .then(function (t) { return String(t).trim() === '1'; })
      .catch(function () { return false; });
  } catch (e) { return Promise.resolve(false); }
}
function kbKlTrack(metric, props, email){
  /* Onsite identify only; the legacy call sends the event. Two sends would mean two emails. */
  try {
    const k = window.klaviyo;
    if (k && typeof k.push === 'function' && email) k.push(['identify', { '$email': email }]);
  } catch(e){ /* identity is a nice-to-have, never the send */ }
  return klLegacyTrack(metric, props, email).then(ok => ok ? true :
    klPost('events', { data:{ type:'event', attributes:{
      properties: props,
      metric:{ data:{ type:'metric', attributes:{ name: metric } } },
      profile:{ data:{ type:'profile', attributes:{ email: email } } }
    } } }));
}
function klPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KL_KEY, {
    method:'POST', keepalive:true,
    headers:{ 'Content-Type':'application/json', 'revision':KL_REV },
    body: JSON.stringify(body)
  }).then(r => { if (!r.ok && r.status !== 202) throw new Error(path + ' ' + r.status); return true; });
}
/* Shopify variants are addressed in Klaviyo's catalog as $shopify:::$default:::<variantId> */
/* 2026-08-18 (Claude). The Kit Builder's "notify me" capture, repaired the same way the site
   cart and the PDP notify form were tonight: the event goes out on klLegacyTrack (GET /api/track,
   a simple request with no preflight, measured working), and the native back-in-stock subscription
   below is kept as the fallback for the day Klaviyo's client-API CORS is fixed.
   'Back In Stock Requested' is the exact metric name the Klaviyo metric VLrMve and the segment
   "Back In Stock Requested (Claude)" are built on. Change this string and you orphan both.
   Resolves TRUE only when something actually recorded the request, so the toast can be honest. */
function kbNotifyRequest(email, v, p){
  const props = {
    VariantId: (v && v.id) || '',
    ProductHandle: (p && p.h) || '',
    ProductTitle: (p && p.title) || '',
    VariantTitle: (v && v.t) || '',
    PageUrl: location.href,
    Source: 'Kit Builder'
  };
  return klLegacyTrack('Back In Stock Requested', props, email)
    .then(ok => ok ? true : kbBackInStock(email, v && v.id).then(() => true, () => false))
    .catch(() => false);
}
function kbBackInStock(email, variantId){
  if (!variantId) return Promise.reject(new Error('no variant'));
  return klPost('back-in-stock-subscriptions', { data:{ type:'back-in-stock-subscription', attributes:{
    channels:['EMAIL'],
    profile:{ data:{ type:'profile', attributes:{ email: email } } }
  }, relationships:{ variant:{ data:{ type:'catalog-variant', id:'$shopify:::$default:::' + variantId } } } } });
}
/* The EVENT is what triggers the flow. A profile property alone cannot re-fire it, so a shopper
   who emails themselves two different kits gets two emails rather than one. */
function kbEmailKit(email){
  const c = calc(), n = kbUnits();
  /* ?rig=, not ?kit=: the homepage promo already owns ?kit= for a single-handle deep link */
  const url = location.origin + location.pathname + '?rig=' + encodeURIComponent(
    S.cart.map(l => { const v = P(l.h) && P(l.h).vars[l.vi]; return l.h + ':' + (v ? v.id : 0) + ':' + l.qty; }).join(','))
    + (S.warranty && ((typeof kbWarrStepsOn === 'function' && kbWarrStepsOn()) || lightsInCart() > 0) ? '&w=1' : '');   /* 2026-09-28 cart-fix-l low-kb C76: with price steps cover is offered on any order over $25, not only with a light. Roll back: S.warranty && lightsInCart() > 0 */   /* defect 17: KitTotal includes the warranty, so the rebuild link must restore it too */
  /* 2026-08-12 (Claude, Joel: "redesign this cart link email to match our style", then yes to the
     Kit Builder twin). The redesigned Klaviyo template renders one row per part, so the lines have
     to travel on the event. Same row shape as the site cart drawer's, so both emails share one
     template design. Capped at 12 rows so a huge rig cannot bloat the payload. KitBonus and
     KitWarranty are sent separately because KitTotal is gearSub minus the display-only 10% bonus
     plus warranty, so the rows alone would not add up to it. The template falls back to the count
     and the total when KitLines is absent, so events already in flight still render.
     NOT called Items - Klaviyo collapses a list of dicts under that legacy name into "1x Title"
     and the template then renders one row per CHARACTER. See drawer-cart.liquid, 2026-08-19.
     ROLLBACK: drop KitLines, KitBonus and KitWarranty from props and delete this comment. */
  const rows = S.cart.slice(0, 12).map(l => {
    const v = (P(l.h) && P(l.h).vars[l.vi]) || null;
    const img = (v && v.img) || (P(l.h) && P(l.h).imgs && P(l.h).imgs[0]) || '';
    return {
      title: (P(l.h) && P(l.h).title) || l.h,
      variant: v ? optLines(l.h, v.t).join(' / ') : '',
      qty: l.qty,
      price: money((v ? v.p : 0) * l.qty),
      image: img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=160' : ''
    };
  });
  const props = { KitUrl: url, KitTotal: usdMoney(Math.max(0, c.total)), KitItems: n, KitLines: rows,
    KitBonus: c.bonus > 0 ? money(c.bonus) : '', KitWarranty: c.warr > 0 ? money(c.warr) : '',
    /* 2026-08-17 (Claude) This email is the ONE surface no on-page note can ever follow, so the
       total carries its own label (usdMoney above). Rows, bonus and warranty stay bare: they are
       sub-figures of a total that now names the currency, and 12 rows of '$29.95 USD' would fight
       the row design Joel signed off on 2026-08-12. KitCurrencyNote is a ready-made sentence the
       Klaviyo template can print with no further code change - empty string for a US shopper, so
       dropping {{ event.KitCurrencyNote }} into the template is safe today. */
    KitCurrency: KB_CUR,
    KitCurrencyNote: IS_USD ? '' : 'Prices shown in USD. You will be charged in ' + KB_CUR + ' at checkout.' };
  /* 2026-08-18 (Claude): sends through Klaviyo's onsite queue, because their client API's CORS
     preflight allows OPTIONS only and every browser POST to it now throws "Failed to fetch".
     See the full note beside klTrack in snippets/drawer-cart.liquid. */
  const ev = kbKlTrack('Kit Builder Email Kit', props, email);
  if (!KL_LIST) return ev;
  return ev.then(() => klPost('subscriptions', { data:{ type:'subscription', attributes:{
    profile:{ data:{ type:'profile', attributes:{ email: email,
      properties:{ 'Kit Builder Total': props.KitTotal, 'Kit Builder Items': n } } } }
  }, relationships:{ list:{ data:{ type:'list', id: KL_LIST } } } } })
    .catch(()=>true));   /* the event is the one that matters; a list-add hiccup must not fail the send */
}
/* one small popover, reused by both features. Focus-trapped enough to be usable, Escape closes. */
let klPopEl = null;
function kbMailPop(o){
  kbMailClose();
  const prev = (()=>{ try { return localStorage.getItem('aoam-kb-mail') || ''; } catch(e){ return ''; } })();
  const d = document.createElement('div');
  d.className = 'klpop-wrap';
  d.innerHTML = `<div class="klpop-back" onclick="kbMailClose()"></div>
    <div class="klpop" role="dialog" aria-modal="true" aria-label="${esc(o.title)}">
      <button class="klpop-x" type="button" aria-label="Close" onclick="kbMailClose()">&#10005;</button>
      <h3>${esc(o.title)}</h3>
      <p>${esc(o.sub || '')}</p>
      <input id="klmail" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com"
        value="${esc(prev)}" aria-label="Your email address">
      <div class="klpop-err" id="klerr" hidden></div>
      <button class="btn btn-p klpop-go" type="button" id="klgo">${esc(o.cta)}</button>
      <small>We'll only use this for what you asked for. No spam.</small>
    </div>`;
  document.body.appendChild(d);
  klPopEl = d;
  const inp = d.querySelector('#klmail'), go = d.querySelector('#klgo'), err = d.querySelector('#klerr');
  const fail = m => { err.hidden = false; err.textContent = m; go.disabled = false; go.textContent = o.cta; };
  const submit = () => {
    const email = (inp.value||'').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('That does not look like an email address.');
    err.hidden = true; go.disabled = true; go.textContent = 'Sending…';
    try { localStorage.setItem('aoam-kb-mail', email); } catch(e){}
    o.send(email).then(() => { kbMailClose(); }, () => fail('That did not go through. Try again in a moment.'));
  };
  go.addEventListener('click', submit);
  inp.addEventListener('keydown', e => { if (e.key === 'Enter'){ e.preventDefault(); submit(); } });
  setTimeout(()=>{ try { inp.focus(); if (prev) inp.select(); } catch(e){} }, 30);
}
function kbMailClose(){ if (klPopEl){ klPopEl.remove(); klPopEl = null; } }
document.addEventListener('keydown', e => { if (e.key === 'Escape' && klPopEl) kbMailClose(); });
/* called from the kit drawer and the desktop dock */
/* The other half of kbEmailKit's link: ?rig=handle:variantId:qty,... rebuilds the kit on arrival.
   Variant IDS, never indexes, for the same reason persist() now stores them. Runs only when the
   param is present, so a normal load is unchanged, and it never overwrites a kit already in
   progress without saying so. NEVER auto-loads anything the shopper did not ask for. */
(function(){
  try {
    var raw = new URLSearchParams(location.search).get('rig');
    if (!raw) return;
    var wantW = new URLSearchParams(location.search).get('w') === '1';
    /* 2026-10-10 audit kb-rig-url: drop rig and w from the address bar once read (like the site cart's ?rc=), so a refresh does not re-run the restore or pop the replace-your-kit box. replaceState keeps history.state and any utm params. Roll back: delete this line. */
    try { var q0 = new URLSearchParams(location.search); q0.delete('rig'); q0.delete('w'); var s0 = q0.toString(); history.replaceState(history.state, '', location.pathname + (s0 ? '?' + s0 : '') + location.hash); } catch (e0) {}   /* defect 17: the emailed total included the warranty */
    var start = Date.now();
    (function poll(){
      try {
        if (!window.KB_DATA || typeof window.renderAll !== 'function' || !document.getElementById('grid')){
          if (Date.now() - start < 5000) setTimeout(poll, 150);
          return;
        }
        var lines = [];
        String(raw).split(',').forEach(function(part){
          var bits = part.split(':');
          var p = window.KB_DATA[bits[0]]; if (!p) return;
          /* 2026-08-13 warranty rework hardening: a crafted ?rig= URL could push a warranty handle
             straight into S.cart, where it renders as an ordinary +/- stepper line and is ALSO
             double-counted against S.warranty/warrLinesByBucket (nothing here ever filtered `sub`).
             Warranty is only ever added via the S.warranty flag, never as a cart line. */
          if (p.sub === 'warranty') return;
          var vid = Number(bits[1]) || 0;
          var vi = (p.vars||[]).findIndex(function(v){ return v.id === vid; });
          if (vi < 0 || !p.vars[vi].a) return;
          lines.push({ h: bits[0], vi: vi, qty: Math.min(99, Math.max(1, parseInt(bits[2],10) || 1)) });
        });
        if (!lines.length) return;
        /* never silently overwrite work in progress: a shopper with a restored kit who opens an old
           emailed link gets asked, not clobbered. An empty kit loads straight in. */
        /* 2026-10-10 audit kb-rig-url: when the kit already matches the link (a reload after persist()), do not ask; just make sure the cover the link carried is on. Roll back: delete this block. */
        var sameKit = S.cart.length === lines.length && lines.every(function(l){ return S.cart.some(function(c){ return c.h === l.h && c.vi === l.vi && c.qty === l.qty; }); });
        if (sameKit){
          if (wantW && !S.warranty){ if (typeof kbWarrStepsOn === 'function' && kbWarrStepsOn() && typeof kbWarrPick === 'function') kbWarrPick(true); else S.warranty = true; renderAll(); persist(); }
          toast('Your emailed kit is already loaded.');
          return;
        }
        if (S.cart.length && !confirm('Load the kit from your email? This replaces the ' +
            gearQty() + ' item' + (gearQty()===1?'':'s') + ' already in your kit.')) return;
        S.cart = lines;
        if (wantW){ if (typeof kbWarrStepsOn === 'function' && kbWarrStepsOn() && typeof kbWarrPick === 'function') kbWarrPick(true); else S.warranty = true; }   /* 2026-09-28 cart-fix-l low-kb C76: with price steps the cover is the real cart's, read off the per-cart opt-in flag, so a bare S.warranty was undone by the next kbCartSync. The link carries the shopper's own earlier choice. Roll back: if (wantW) S.warranty = true; */   /* renderAll's legal guard still drops it when no light made it back */
        renderAll(); persist();
        toast('Your emailed kit is loaded. ' + lines.length + ' item' + (lines.length===1?'':'s') + ' restored.');
      } catch(e){}
    })();
  } catch(e){}
})();
function emailMeKit(){
  if (!S.cart.length){ toast('Add something to your kit first'); return; }
  kbMailPop({
    title: 'Email me this kit',
    sub: kbUnits() + (kbUnits()===1?' item · ':' items · ') + usdMoney(Math.max(0, calc().total)) + '. We\'ll send a link that rebuilds it.',
    cta: 'Send me the link',
    send: email => kbEmailKit(email).then(() => {
      /* 2026-09-28 cart-fix-l kb-later C70: kb6 value, as at checkout. Roll back: num_items: kbUnits(), value: +Math.max(0, calc().total).toFixed(2) */
      const v6em = (function () { try { if (window.KB && window.KB.totals && document.getElementById('kb6')) { const t6 = window.KB.totals(); return { v: +Math.max(0, t6.sub + (t6.cartLvl || 0)).toFixed(2), n: t6.count }; } } catch (e) {} return null; })();
      kbGA('kit_builder_email_kit', { num_items: v6em ? v6em.n : kbUnits(), value: v6em ? v6em.v : +Math.max(0, calc().total).toFixed(2), currency:'USD' });
      toast('Sent. Check your inbox for the link back to this kit.');
    })
  });
}

/* 2026-08-06 dead-click audit (fix 6). Hand control back from the pre-hydration stubs installed by the
   inline script in templates/page.kit-builder.liquid. By this point every top-level function
   declaration above has already replaced its stub on window (global declaration instantiation happens
   before this script's first statement runs), so draining here replays any tap the shopper made during
   the deferred-script window against the REAL functions. It also clears html.kb-booting and cancels the
   inline watchdog. Guarded so kit-builder.js still runs standalone if the template block is rolled
   back. Delete this block and the inline script to roll back. */
try { if (typeof window.__kbDrain === 'function') window.__kbDrain(); }
catch(e){ try { document.documentElement.classList.remove('kb-booting','kb-pending'); } catch(e2){} }


/* 2026-08-10 - Joel, on the COMPLETE YOUR KIT strip: "theres no option to navigate those other than
   the bottom scroller. check the main site for more features in this".
   The main site rail already had three things this one did not, all added there on 2026-08-10 and
   ported here verbatim (assets/aoam-upsell-card.js): prev and next arrows that appear only while
   there is somewhere to go in that direction, a step that keeps ONE card of context rather than
   paging a clean screenful (which is how you stay oriented in a rail of product photos), and mouse
   drag to pan. The visible lime scroll bar is the CSS half, in kit-builder.css.
   Wiring re-runs on every cart change because both hosts rebuild their strip with innerHTML, so a
   childList observer on those two elements is enough and no document-wide observer is needed.
   Delete this block, the .cyscroller markup in stripHTML() and the .cynav / scrollbar rules in
   kit-builder.css to roll back. */
(function(){
  function cyStep(strip){
    const card = strip.querySelector('.axc');   /* 2026-08-18: was .cycard */
    if (!card) return Math.round(strip.clientWidth * .8);
    const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
    const one = card.getBoundingClientRect().width + gap;
    const fit = Math.floor((strip.clientWidth + gap) / one);
    return Math.round(Math.max(1, fit - 1) * one);
  }
  /* the cards carry a product photo, and an <img> is natively draggable, so a press-and-pull would
     start an HTML5 drag and the browser would stop sending pointermove before the 7px threshold.
     dragstart is cancelled in JS rather than with -webkit-user-drag because Firefox ignores that. */
  function cyPanDown(e, host){
    if (e.button !== 0) return;
    const sx = e.clientX, sy = e.clientY, s0 = host.scrollLeft, pid = e.pointerId;
    let panning = false;
    const swallow = ev => { ev.stopPropagation(); ev.preventDefault(); };
    host.classList.add('cy-panning');
    const move = e2 => {
      if (e2.pointerId !== pid) return;
      if (!panning){
        if (Math.hypot(e2.clientX - sx, e2.clientY - sy) <= 7) return;
        panning = true;
        document.body.style.cursor = 'grabbing';
        try { host.setPointerCapture(pid); } catch(err){}
        host.addEventListener('click', swallow, true);
      }
      host.scrollLeft = s0 - (e2.clientX - sx);
    };
    const up = e2 => {
      if (e2 && e2.pointerId !== undefined && e2.pointerId !== pid) return;
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      host.classList.remove('cy-panning');
      document.body.style.cursor = '';
      try { host.releasePointerCapture(pid); } catch(err){}
      if (panning) setTimeout(() => host.removeEventListener('click', swallow, true), 0);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }
  function cyWire(){
    document.querySelectorAll('.axc-strip').forEach(strip => {   /* 2026-08-18: was .cygrid */
      if (strip.dataset.cyWired) return;
      strip.dataset.cyWired = '1';
      strip.addEventListener('dragstart', e => e.preventDefault());
      strip.addEventListener('pointerdown', e => {
        if (e.pointerType && e.pointerType !== 'mouse') return;   /* touch already pans natively */
        cyPanDown(e, strip);
      });
      /* 2026-08-18: the site rail has no arrows at any width, so stripHTML no longer emits the
         .cynavs pair and this resolves to null on every pass. Left in place, not deleted, because it
         is also what would wire them back up if Joel ever wants them - see the .cynav rules still in
         this file's CSS. */
      const rail = strip.closest('.axc-rail');
      const wrap = rail && rail.querySelector('.cynavs');
      if (!wrap) return;
      const prev = wrap.querySelector('.cynav--prev'), next = wrap.querySelector('.cynav--next');
      if (!prev || !next) return;
      const sync = () => {
        const max = strip.scrollWidth - strip.clientWidth;
        /* 2px, not 0: a fractional card width leaves sub-pixel slack at either end that is not scroll */
        const scrollable = max > 2;
        /* the PAIR hides when there is nothing to scroll at all; at an end of travel the chip is
           only disabled, because hiding one of a mounted pair shifts the other sideways */
        wrap.hidden = !scrollable;
        prev.disabled = !scrollable || strip.scrollLeft <= 2;
        next.disabled = !scrollable || strip.scrollLeft >= max - 2;
      };
      const go = dir => {
        const d = cyStep(strip) * dir;
        if (typeof strip.scrollBy === 'function') strip.scrollBy({left: d, behavior: 'smooth'});
        else strip.scrollLeft += d;
      };
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      strip.addEventListener('scroll', sync, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(strip);
      else window.addEventListener('resize', sync);
      sync();
      /* the drawer measures 0 wide until it has finished sliding in, so one late re-measure */
      setTimeout(sync, 400);
    });
  }
  function cyObserve(){
    ['dls','dstrip','rigpanel'].forEach(id => {
      const el = document.getElementById(id);
      if (!el || el.dataset.cyObserved) return;
      el.dataset.cyObserved = '1';
      new MutationObserver(cyWire).observe(el, {childList: true});
    });
    cyWire();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cyObserve);
  else cyObserve();
  setTimeout(cyObserve, 1500);   /* belt and braces if either host is built after DOMContentLoaded */
})();

/* ============================ AOAM KB PAY TOGGLE 2026-09-15 (Claude) ============================
   Joel, picking from the Kit Builder UX audit: "Show total plus Secure Checkout while shopping,
   expand the express-pay marks only when they are finishing."

   WHY A CLICK AND NOT A HOVER. Hover was the obvious implementation and it is wrong here. #rigdock
   is a flex footer under .leftscroll, so expanding the wallet grid grows the dock UPWARD and every
   row inside it, Secure Checkout included, rises by ~40px. On hover that means a payment button
   sliding out from under a cursor that never asked for it. A click owns its own motion.

   WHY THE LISTENERS ARE DELEGATED ON document. renderRig() rewrites $('rigdock').innerHTML on every
   cart mutation, so anything bound to .devider-text itself dies on the next add. The open/closed
   state lives as a class on #rigdock, which is NOT replaced by that assignment, so it survives every
   re-render for free; only the ARIA attributes need re-stamping, which is what the observer does.

   The choice persists per browser, so a shopper who opened the wallets once does not have to keep
   reopening them. localStorage is wrapped because it throws in private mode on some iOS builds, and
   this must never be the thing that breaks a checkout dock.

   Paired with the "--- 6. the desktop dock" block at the end of assets/kit-builder.css. Delete both
   or neither: the CSS alone leaves the wallets permanently unreachable.
   ================================================================================================ */
(function(){
  var KEY = 'kbPayOpen', started = 0;
  function dock(){ return document.getElementById('rigdock'); }
  function hit(t){ return t && t.closest ? t.closest('#rigdock .devider-text') : null; }
  function sync(){
    var d = dock(); if (!d) return;
    var lbl = d.querySelector('.devider-text');
    if (lbl) lbl.setAttribute('aria-expanded', d.classList.contains('pay-open') ? 'true' : 'false');
  }
  function stamp(){
    var d = dock(); if (!d) return;
    var lbl = d.querySelector('.devider-text');
    if (!lbl || lbl.getAttribute('data-kb-pay')) return;   /* guard: setting the id below mutates the
                                                              subtree and re-enters this observer */
    lbl.setAttribute('data-kb-pay', '1');
    lbl.setAttribute('role', 'button');
    lbl.setAttribute('tabindex', '0');
    var list = d.querySelector('.payment-icon-list');
    if (list){ list.id = 'kb-paylist'; lbl.setAttribute('aria-controls', 'kb-paylist'); }
    sync();
  }
  function toggle(){
    var d = dock(); if (!d) return;
    d.classList.toggle('pay-open');
    var open = d.classList.contains('pay-open');
    try { localStorage.setItem(KEY, open ? '1' : '0'); } catch(e){}
    sync();
    try { if (typeof kbGA === 'function') kbGA('kb_pay_toggle', { open: open ? 1 : 0 }); } catch(e){}
  }
  document.addEventListener('click', function(e){ if (hit(e.target)) toggle(); });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!hit(e.target)) return;
    e.preventDefault();
    toggle();
  });
  function start(){
    if (started) return;
    var d = dock(); if (!d) return;
    started = 1;
    try { if (localStorage.getItem(KEY) === '1') d.classList.add('pay-open'); } catch(e){}
    try { new MutationObserver(stamp).observe(d, { childList:true, subtree:true }); } catch(e){}
    stamp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  setTimeout(start, 1500);   /* the dock is built by renderRig, which can land after DOMContentLoaded */
})();
